namespace GeniuzPOS.Texts {

    declare namespace Db {

        namespace Administration {

            namespace CsPara {
                export const BizAddressLine1: string;
                export const BizAddressLine2: string;
                export const BizAddressLine3: string;
                export const BizName: string;
                export const BizNameEn: string;
                export const BizType: string;
                export const BranchNameDesc: string;
                export const BranchNameDescEn: string;
                export const BranchNo: string;
                export const BuildingName: string;
                export const BuildingNameEn: string;
                export const BuildingNo: string;
                export const BuildingNoEn: string;
                export const City: string;
                export const CityEn: string;
                export const CountryCode: string;
                export const CreateBy: string;
                export const CreateDate: string;
                export const District: string;
                export const DistrictEn: string;
                export const Email: string;
                export const ErpCompCode: string;
                export const FaxId: string;
                export const Id: string;
                export const LastUpdate: string;
                export const PostalCode: string;
                export const Province: string;
                export const ProvinceEn: string;
                export const RegId: string;
                export const SlowMoveItenDate: string;
                export const StreetName: string;
                export const StreetNameEn: string;
                export const TaxId: string;
                export const TaxInvAddrLine1: string;
                export const TaxInvAddrLine2: string;
                export const TaxInvAddrLine3: string;
                export const TaxInvName: string;
                export const TelId: string;
                export const UpdateBy: string;
                export const VatFg: string;
            }

            namespace CsVatCode {
                export const FullName: string;
                export const Id: string;
                export const VatCode: string;
                export const VatRate: string;
            }

            namespace CsVatType {
                export const FullName: string;
                export const Id: string;
                export const VatType: string;
                export const VatTypeDesc: string;
            }

            namespace Language {
                export const Id: string;
                export const LanguageId: string;
                export const LanguageName: string;
            }

            namespace PoApprovalGroup {
                export const ApprGroupCode: string;
                export const ApprGroupName: string;
                export const CreateBy: string;
                export const CreateDate: string;
                export const Id: string;
                export const LastUpdate: string;
                export const UpdateBy: string;
            }

            namespace PsBizTypes {
                export const BizType: string;
                export const BizTypeName: string;
                export const Id: string;
            }

            namespace PsConfig {
                export const ConfigCode: string;
                export const ConfigDate: string;
                export const ConfigId: string;
                export const ConfigTypeId: string;
                export const Description: string;
                export const IsActive: string;
                export const LastUpdate: string;
                export const ShopId: string;
                export const UpdateBy: string;
            }

            namespace PsConfigType {
                export const ConfigTypeId: string;
                export const ConfigTypeName: string;
                export const Description: string;
                export const IsActive: string;
            }

            namespace PsFuncKbMapKeyCode {
                export const Id: string;
                export const KbMapKeyCode: string;
                export const KbMapKeyName: string;
            }

            namespace PsFuncKbMapShiftCode {
                export const Id: string;
                export const KbMapShiftCode: string;
                export const KbMapShiftName: string;
            }

            namespace PsFuncLevel {
                export const FunLevel: string;
                export const FunLevelName: string;
                export const Id: string;
            }

            namespace PsPara {
                export const AllowSaleOverStock: string;
                export const BackOfficeUpLoadURL: string;
                export const BranchName: string;
                export const ChargeVatRate: string;
                export const CountLockSignInWrongPassInDay: string;
                export const CreateBy: string;
                export const CreateDate: string;
                export const DiscRoundMethod: string;
                export const EjournalFg: string;
                export const Id: string;
                export const ItemOnRecptMethod: string;
                export const LastUpdate: string;
                export const NoOfRecptCopy: string;
                export const PointRedeemOneBaht: string;
                export const PosProcessMode: string;
                export const PosScreenType: string;
                export const PrintOrderFg: string;
                export const PrintQueueFg: string;
                export const PromptPayLink: string;
                export const PsParaDefault1: string;
                export const PsParaDefault2: string;
                export const PsParaFullName: string;
                export const QRCodeAccount: string;
                export const ReceiptPrinterType: string;
                export const RecptFootMesg1: string;
                export const RecptFootMesg10: string;
                export const RecptFootMesg2: string;
                export const RecptFootMesg3: string;
                export const RecptFootMesg4: string;
                export const RecptFootMesg5: string;
                export const RecptFootMesg6: string;
                export const RecptFootMesg7: string;
                export const RecptFootMesg8: string;
                export const RecptFootMesg9: string;
                export const RecptFootMesgFontSize: string;
                export const RecptFootMesgTextAlign: string;
                export const RecptHeadMesg1: string;
                export const RecptHeadMesg2: string;
                export const RecptHeadMesg3: string;
                export const RecptHeadMesg4: string;
                export const RecptHeadMesg5: string;
                export const RecptHeadMesg6: string;
                export const RecptHeadMesgFontSize: string;
                export const RecptHeadMesgTextAlign: string;
                export const RecptNoBarcodeFg: string;
                export const RecptSumItemQtyFg: string;
                export const SalesDocFg: string;
                export const SalesVatType: string;
                export const SelectSellingPriceFg: string;
                export const ShopAddress: string;
                export const ShopLogoOnFrontScreen: string;
                export const ShopLogoOnReceipt: string;
                export const ShopName: string;
                export const ShopRegAddressLine1: string;
                export const ShopRegAddressLine2: string;
                export const ShopRegAddressLine3: string;
                export const ShopRegId: string;
                export const ShopRegName: string;
                export const ShopTaxId: string;
                export const TaxInvoiceDateFg: string;
                export const UpdateBy: string;
                export const WeightBarcodePrefix: string;
            }

            namespace PsPosFunc {
                export const CreateBy: string;
                export const CreateDate: string;
                export const FunLevel: string;
                export const FuncDesc: string;
                export const FuncId: string;
                export const FuncKeyLable: string;
                export const FuncUsage: string;
                export const Id: string;
                export const KbMapKeyCode: string;
                export const KbMapShiftCode: string;
                export const LastUpdate: string;
                export const RowNumber: string;
                export const UpdateBy: string;
            }

            namespace PsPosProcessMode {
                export const Id: string;
                export const PosProcessMode: string;
                export const PosProcessModeName: string;
            }

            namespace PsPosScreenType {
                export const Id: string;
                export const PosScreenType: string;
                export const PosScreenTypeName: string;
            }

            namespace PsSalesVatTypes {
                export const Id: string;
                export const SalesVatType: string;
                export const SalesVatTypeName: string;
            }

            namespace Role {
                export const RoleId: string;
                export const RoleKey: string;
                export const RoleName: string;
            }

            namespace RolePermission {
                export const PermissionKey: string;
                export const RoleId: string;
                export const RolePermissionId: string;
                export const RoleRoleName: string;
            }

            namespace SysGroup {
                export const CreateBy: string;
                export const CreateDate: string;
                export const Id: string;
                export const LastUpdate: string;
                export const SysGroup: string;
                export const SysGroupDesc: string;
                export const UpdateBy: string;
            }

            namespace SysPara {
                export const CreateBy: string;
                export const CreateDate: string;
                export const Id: string;
                export const LastUpdate: string;
                export const SysDesc: string;
                export const SysFg: string;
                export const SysFgDesc: string;
                export const SysGroup: string;
                export const SysGroup1: string;
                export const SysGroupCreateBy: string;
                export const SysGroupCreateDate: string;
                export const SysGroupLastUpdate: string;
                export const SysGroupSysGroupDesc: string;
                export const SysGroupUpdateBy: string;
                export const SysName: string;
                export const UpdateBy: string;
            }

            namespace Translation {
                export const CustomText: string;
                export const EntityPlural: string;
                export const Key: string;
                export const OverrideConfirmation: string;
                export const SaveChangesButton: string;
                export const SourceLanguage: string;
                export const SourceText: string;
                export const TargetLanguage: string;
                export const TargetText: string;
            }

            namespace User {
                export const ApprGroupCode: string;
                export const CheckPasswordUpdate: string;
                export const DisplayName: string;
                export const Email: string;
                export const ImpersonationToken: string;
                export const InsertDate: string;
                export const InsertUserId: string;
                export const IsActive: string;
                export const LastDirectoryUpdate: string;
                export const MobilePhoneNumber: string;
                export const MobilePhoneVerified: string;
                export const Password: string;
                export const PasswordChangeDate: string;
                export const PasswordConfirm: string;
                export const PasswordHash: string;
                export const PasswordSalt: string;
                export const Roles: string;
                export const ShopId: string;
                export const Source: string;
                export const TwoFactorAuth: string;
                export const UpdateDate: string;
                export const UpdateUserId: string;
                export const UserActive: string;
                export const UserErrorStampFg: string;
                export const UserId: string;
                export const UserImage: string;
                export const Username: string;
            }

            namespace UserApprovalRole {
                export const ApprGroupCode: string;
                export const Id: string;
                export const UserId: string;
            }

            namespace UserPermission {
                export const Granted: string;
                export const PermissionKey: string;
                export const User: string;
                export const UserId: string;
                export const UserPermissionId: string;
                export const Username: string;
            }

            namespace UserRole {
                export const RoleId: string;
                export const User: string;
                export const UserId: string;
                export const UserRoleId: string;
                export const Username: string;
            }
        }

        namespace AdvPromo {

            namespace Adv05Hd {
                export const EndPromoDate: string;
                export const EndPromoTime: string;
                export const ItemExList: string;
                export const ItemList: string;
                export const PPtype: string;
                export const PmDesc: string;
                export const PmExtCode: string;
                export const PmGroupDesc: string;
                export const PmGroupId: string;
                export const PmId: string;
                export const PmType: string;
                export const PmTypeDesc: string;
                export const PromoApproveFg: string;
                export const PromoCampName: string;
                export const PromoCampaign: string;
                export const PromoCust: string;
                export const PromoCustFg: string;
                export const PromoDay: string;
                export const PromoDayFg: string;
                export const PromoShop: string;
                export const PromoShopFg: string;
                export const PromoStatus: string;
                export const PromoTimeFg: string;
                export const StartPromoDate: string;
                export const StartPromoTime: string;
                export const VenderSharing: string;
            }

            namespace Adv05ItemDetail {
                export const AssortFg: string;
                export const BrandCode: string;
                export const BrandName: string;
                export const CatCode: string;
                export const CatName: string;
                export const DiscPc: string;
                export const EndPromoDate: string;
                export const Id: string;
                export const ItemType: string;
                export const Normalprice: string;
                export const PPtype: string;
                export const PluCode: string;
                export const PluShortDesc: string;
                export const PmGroupId: string;
                export const PmId: string;
                export const PmType: string;
                export const PmTypeDesc: string;
                export const PromotionPrice: string;
                export const Remark: string;
                export const SkuCode: string;
                export const StartPromoDate: string;
                export const StyleId: string;
                export const StyleName: string;
                export const SubCat1Code: string;
                export const SubCat1Name: string;
                export const SubCat2Code: string;
                export const SubCat2Name: string;
                export const SupplCode: string;
                export const SupplName: string;
            }

            namespace Adv05ItemDetails {
                export const AssortFg: string;
                export const BrandCode: string;
                export const BrandName: string;
                export const CatCode: string;
                export const CatName: string;
                export const DiscPc: string;
                export const EndPromoDate: string;
                export const Id: string;
                export const ItemType: string;
                export const ListFg: string;
                export const Normalprice: string;
                export const PPtype: string;
                export const PluCode: string;
                export const PluShortDesc: string;
                export const PmDesc: string;
                export const PmExtCode: string;
                export const PmGroupId: string;
                export const PmId: string;
                export const PmStepNo: string;
                export const PmType: string;
                export const PmTypeDesc: string;
                export const PromotionPrice: string;
                export const Remark: string;
                export const SkuCode: string;
                export const StartPromoDate: string;
                export const StyleCode: string;
                export const StyleName: string;
                export const SubCat1Code: string;
                export const SubCat1Name: string;
                export const SubCat2Code: string;
                export const SubCat2Name: string;
                export const SupplCode: string;
                export const SupplName: string;
            }

            namespace Adv05ItemDt {
                export const AssortFg: string;
                export const BrandCode: string;
                export const BrandName: string;
                export const CatCode: string;
                export const CatName: string;
                export const DiscPc: string;
                export const Id: string;
                export const ItemType: string;
                export const Normalprice: string;
                export const PPtype: string;
                export const PluCode: string;
                export const PluShortDesc: string;
                export const PmGroupId: string;
                export const PmId: string;
                export const PmType: string;
                export const PmTypeDesc: string;
                export const PromotionPrice: string;
                export const Remark: string;
                export const SkuCode: string;
                export const StyleId: string;
                export const StyleName: string;
                export const SubCat1Code: string;
                export const SubCat1Name: string;
                export const SubCat2Code: string;
                export const SubCat2Name: string;
                export const SupplCode: string;
                export const SupplName: string;
            }

            namespace Adv05ItemExDTs {
                export const BrandCode: string;
                export const BrandName: string;
                export const CatCode: string;
                export const CatName: string;
                export const EndPromoDate: string;
                export const Id: string;
                export const PluCode: string;
                export const PluShortDesc: string;
                export const PmGroupId: string;
                export const PmId: string;
                export const PmType: string;
                export const SellUnitPrice1: string;
                export const SkuCode: string;
                export const StartPromoDate: string;
                export const StyleCode: string;
                export const StyleName: string;
                export const SubCat1Code: string;
                export const SubCat1Name: string;
                export const SubCat2Code: string;
                export const SubCat2Name: string;
                export const SupplCode: string;
                export const SupplName: string;
            }

            namespace Adv05ItemExDt {
                export const BrandCode: string;
                export const BrandName: string;
                export const CatCode: string;
                export const CatName: string;
                export const EndPromoDate: string;
                export const Id: string;
                export const ItemType: string;
                export const PluCode: string;
                export const PluShortDesc: string;
                export const PmGroupId: string;
                export const PmId: string;
                export const PmType: string;
                export const SellUnitPrice1: string;
                export const SkuCode: string;
                export const StartPromoDate: string;
                export const StyleId: string;
                export const StyleName: string;
                export const SubCat1Code: string;
                export const SubCat1Name: string;
                export const SubCat2Code: string;
                export const SubCat2Name: string;
                export const SupplCode: string;
                export const SupplName: string;
            }

            namespace AdvancedPromoReport {
                export const EndPromoDate: string;
                export const EndPromoTime: string;
                export const ItemExList: string;
                export const ItemList: string;
                export const PPtype: string;
                export const PmDesc: string;
                export const PmExtCode: string;
                export const PmGroupDesc: string;
                export const PmGroupId: string;
                export const PmId: string;
                export const PmType: string;
                export const PmTypeDesc: string;
                export const PromoApproveFg: string;
                export const PromoCampName: string;
                export const PromoCampaign: string;
                export const PromoCust: string;
                export const PromoCustFg: string;
                export const PromoDay: string;
                export const PromoDayFg: string;
                export const PromoShop: string;
                export const PromoShopFg: string;
                export const PromoStatus: string;
                export const PromoTimeFg: string;
                export const StartPromoDate: string;
                export const StartPromoTime: string;
                export const VenderSharing: string;
            }

            namespace LookupAvPromoCouponTypes {
                export const CouponType: string;
                export const CouponTypeLookup: string;
                export const CpName: string;
                export const CpNameF: string;
                export const EndBillPmType: string;
                export const Id: string;
            }

            namespace LookupPromoId {
                export const PmId: string;
            }

            namespace PsAdvPromoHd {
                export const ActiveBy: string;
                export const Activedate: string;
                export const ApproveBy: string;
                export const Approvedate: string;
                export const CreateBy: string;
                export const CreateDate: string;
                export const EndPromoDate: string;
                export const EndPromoTime: string;
                export const Id: string;
                export const PmGroupDesc: string;
                export const PmGroupId: string;
                export const PromoApproveFg: string;
                export const PromoCampName: string;
                export const PromoCampaign: string;
                export const PromoCustFg: string;
                export const PromoDay: string;
                export const PromoDayFg: string;
                export const PromoMb: string;
                export const PromoShop: string;
                export const PromoShopFg: string;
                export const PromoStatus: string;
                export const PromoTimeFg: string;
                export const StartPromoDate: string;
                export const StartPromoTime: string;
                export const UpdateBy: string;
                export const UpdateDate: string;
                export const VenderSharing: string;
            }

            namespace PsAdvPromoHd1 {
                export const ActiveBy: string;
                export const Activedate: string;
                export const ApproveBy: string;
                export const Approvedate: string;
                export const CreateBy: string;
                export const CreateDate: string;
                export const EndPromoDate: string;
                export const EndPromoTime: string;
                export const Id: string;
                export const ItemExList: string;
                export const ItemList: string;
                export const PmGroupDesc: string;
                export const PmGroupId: string;
                export const PromoApproveFg: string;
                export const PromoCampName: string;
                export const PromoCampaign: string;
                export const PromoCustFg: string;
                export const PromoDay: string;
                export const PromoDayFg: string;
                export const PromoMb: string;
                export const PromoShop: string;
                export const PromoShopFg: string;
                export const PromoStatus: string;
                export const PromoTimeFg: string;
                export const StartPromoDate: string;
                export const StartPromoTime: string;
                export const UpdateBy: string;
                export const UpdateDate: string;
                export const VenderSharing: string;
            }

            namespace PsAdvPromoHd2 {
                export const ActiveBy: string;
                export const Activedate: string;
                export const ApproveBy: string;
                export const Approvedate: string;
                export const CreateBy: string;
                export const CreateDate: string;
                export const EndPromoDate: string;
                export const EndPromoTime: string;
                export const Id: string;
                export const Item2ExList: string;
                export const Item2List: string;
                export const PmGroupDesc: string;
                export const PmGroupId: string;
                export const PromoApproveFg: string;
                export const PromoCampName: string;
                export const PromoCampaign: string;
                export const PromoCustFg: string;
                export const PromoDay: string;
                export const PromoDayFg: string;
                export const PromoMb: string;
                export const PromoShop: string;
                export const PromoShopFg: string;
                export const PromoStatus: string;
                export const PromoTimeFg: string;
                export const StartPromoDate: string;
                export const StartPromoTime: string;
                export const UpdateBy: string;
                export const UpdateDate: string;
                export const VenderSharing: string;
            }

            namespace PsAdvPromoHd3 {
                export const ActiveBy: string;
                export const Activedate: string;
                export const ApproveBy: string;
                export const Approvedate: string;
                export const CreateBy: string;
                export const CreateDate: string;
                export const EndPromoDate: string;
                export const EndPromoTime: string;
                export const Id: string;
                export const Item3ExList: string;
                export const Item3List: string;
                export const PmGroupDesc: string;
                export const PmGroupId: string;
                export const PromoApproveFg: string;
                export const PromoCampName: string;
                export const PromoCampaign: string;
                export const PromoCustFg: string;
                export const PromoDay: string;
                export const PromoDayFg: string;
                export const PromoMb: string;
                export const PromoShop: string;
                export const PromoShopFg: string;
                export const PromoStatus: string;
                export const PromoTimeFg: string;
                export const StartPromoDate: string;
                export const StartPromoTime: string;
                export const UpdateBy: string;
                export const UpdateDate: string;
                export const VenderSharing: string;
            }

            namespace PsAdvPromoHd4 {
                export const ActiveBy: string;
                export const Activedate: string;
                export const ApproveBy: string;
                export const Approvedate: string;
                export const CreateBy: string;
                export const CreateDate: string;
                export const EndPromoDate: string;
                export const EndPromoTime: string;
                export const Id: string;
                export const Item4ExList: string;
                export const Item4List: string;
                export const PmGroupDesc: string;
                export const PmGroupId: string;
                export const PromoApproveFg: string;
                export const PromoCampName: string;
                export const PromoCampaign: string;
                export const PromoCustFg: string;
                export const PromoDay: string;
                export const PromoDayFg: string;
                export const PromoMb: string;
                export const PromoShop: string;
                export const PromoShopFg: string;
                export const PromoStatus: string;
                export const PromoTimeFg: string;
                export const StartPromoDate: string;
                export const StartPromoTime: string;
                export const UpdateBy: string;
                export const UpdateDate: string;
                export const VenderSharing: string;
            }

            namespace PsAdvPromoHd5 {
                export const ActiveBy: string;
                export const Activedate: string;
                export const ApproveBy: string;
                export const Approvedate: string;
                export const CreateBy: string;
                export const CreateDate: string;
                export const EndPromoDate: string;
                export const EndPromoTime: string;
                export const Id: string;
                export const Item5ExList: string;
                export const Item5List: string;
                export const PmGroupDesc: string;
                export const PmGroupId: string;
                export const PromoApproveFg: string;
                export const PromoCampName: string;
                export const PromoCampaign: string;
                export const PromoCustFg: string;
                export const PromoDay: string;
                export const PromoDayFg: string;
                export const PromoMb: string;
                export const PromoShop: string;
                export const PromoShopFg: string;
                export const PromoStatus: string;
                export const PromoTimeFg: string;
                export const StartPromoDate: string;
                export const StartPromoTime: string;
                export const UpdateBy: string;
                export const UpdateDate: string;
                export const VenderSharing: string;
            }

            namespace PsAdvPromoHd6 {
                export const ActiveBy: string;
                export const Activedate: string;
                export const ApproveBy: string;
                export const Approvedate: string;
                export const CreateBy: string;
                export const CreateDate: string;
                export const EndPromoDate: string;
                export const EndPromoTime: string;
                export const Id: string;
                export const Item6ExList: string;
                export const Item6List: string;
                export const PmGroupDesc: string;
                export const PmGroupId: string;
                export const PromoApproveFg: string;
                export const PromoCampName: string;
                export const PromoCampaign: string;
                export const PromoCustFg: string;
                export const PromoDay: string;
                export const PromoDayFg: string;
                export const PromoMb: string;
                export const PromoShop: string;
                export const PromoShopFg: string;
                export const PromoStatus: string;
                export const PromoTimeFg: string;
                export const StartPromoDate: string;
                export const StartPromoTime: string;
                export const UpdateBy: string;
                export const UpdateDate: string;
                export const VenderSharing: string;
            }

            namespace PsAdvPromoHd9 {
                export const ActiveBy: string;
                export const Activedate: string;
                export const ApproveBy: string;
                export const Approvedate: string;
                export const CreateBy: string;
                export const CreateDate: string;
                export const EndPromoDate: string;
                export const EndPromoTime: string;
                export const Id: string;
                export const Item9ExList: string;
                export const Item9List: string;
                export const PmGroupDesc: string;
                export const PmGroupId: string;
                export const PromoApproveFg: string;
                export const PromoCampName: string;
                export const PromoCampaign: string;
                export const PromoCustFg: string;
                export const PromoDay: string;
                export const PromoDayFg: string;
                export const PromoMb: string;
                export const PromoShop: string;
                export const PromoShopFg: string;
                export const PromoStatus: string;
                export const PromoTimeFg: string;
                export const StartPromoDate: string;
                export const StartPromoTime: string;
                export const UpdateBy: string;
                export const UpdateDate: string;
                export const VenderSharing: string;
            }

            namespace PsAdvPromoHdAct {
                export const ActiveBy: string;
                export const Activedate: string;
                export const ApproveBy: string;
                export const Approvedate: string;
                export const CreateBy: string;
                export const CreateDate: string;
                export const EndPromoDate: string;
                export const EndPromoTime: string;
                export const Id: string;
                export const Item2ExList: string;
                export const Item2List: string;
                export const Item3ExList: string;
                export const Item3List: string;
                export const Item4ExList: string;
                export const Item4List: string;
                export const Item5ExList: string;
                export const Item5List: string;
                export const Item6ExList: string;
                export const Item6List: string;
                export const Item9ExList: string;
                export const Item9List: string;
                export const ItemExList: string;
                export const ItemList: string;
                export const PmGroupDesc: string;
                export const PmGroupId: string;
                export const PromoApproveFg: string;
                export const PromoCampName: string;
                export const PromoCampaign: string;
                export const PromoCustFg: string;
                export const PromoDay: string;
                export const PromoDayFg: string;
                export const PromoMb: string;
                export const PromoShop: string;
                export const PromoShopFg: string;
                export const PromoStatus: string;
                export const PromoTimeFg: string;
                export const StartPromoDate: string;
                export const StartPromoTime: string;
                export const UpdateBy: string;
                export const UpdateDate: string;
                export const VenderSharing: string;
            }

            namespace PsAdvPromoHdApp {
                export const ActiveBy: string;
                export const Activedate: string;
                export const ApproveBy: string;
                export const Approvedate: string;
                export const CreateBy: string;
                export const CreateDate: string;
                export const EndPromoDate: string;
                export const EndPromoTime: string;
                export const Id: string;
                export const Item2ExList: string;
                export const Item2List: string;
                export const Item3ExList: string;
                export const Item3List: string;
                export const Item4ExList: string;
                export const Item4List: string;
                export const Item5ExList: string;
                export const Item5List: string;
                export const Item6ExList: string;
                export const Item6List: string;
                export const Item9ExList: string;
                export const Item9List: string;
                export const ItemExList: string;
                export const ItemList: string;
                export const PmGroupDesc: string;
                export const PmGroupId: string;
                export const PromoApproveFg: string;
                export const PromoCampName: string;
                export const PromoCampaign: string;
                export const PromoCustFg: string;
                export const PromoDay: string;
                export const PromoDayFg: string;
                export const PromoMb: string;
                export const PromoShop: string;
                export const PromoShopFg: string;
                export const PromoStatus: string;
                export const PromoTimeFg: string;
                export const StartPromoDate: string;
                export const StartPromoTime: string;
                export const UpdateBy: string;
                export const UpdateDate: string;
                export const VenderSharing: string;
            }

            namespace PsAdvPromoItem {
                export const Amt: string;
                export const AssortFg: string;
                export const BrandCode: string;
                export const BuncleQty: string;
                export const BundleExPrice: string;
                export const BundleItemNo: string;
                export const BundleUnitPrice: string;
                export const CatCode: string;
                export const CouponAgeDay: string;
                export const CouponGiftDesc: string;
                export const CouponType: string;
                export const CreateBy: string;
                export const CreateDate: string;
                export const DiscAmt: string;
                export const DiscPc: string;
                export const DiscPc1: string;
                export const DiscPc2: string;
                export const DiscPc3: string;
                export const DiscPc4: string;
                export const EndBillPmType: string;
                export const FreeLpFg: string;
                export const FreeQty: string;
                export const Id: string;
                export const ItemType: string;
                export const LineItemNo: string;
                export const ListFg: string;
                export const LpPrice: string;
                export const NpcsOrBundlePrice: string;
                export const PluCode: string;
                export const PmDesc: string;
                export const PmExtCode: string;
                export const PmGroupId: string;
                export const PmId: string;
                export const PmOrder: string;
                export const PmStepNo: string;
                export const PmType: string;
                export const Price1: string;
                export const Price2: string;
                export const Price3: string;
                export const Price4: string;
                export const Qty: string;
                export const StyleCode: string;
                export const SubCat1Code: string;
                export const SubCat2Code: string;
                export const SupplCode: string;
                export const UpdateBy: string;
                export const UpdateDate: string;
            }

            namespace PsAdvPromoItem2 {
                export const Amt: string;
                export const AssortFg: string;
                export const BrandCode: string;
                export const BuncleQty: string;
                export const BundleExPrice: string;
                export const BundleItemNo: string;
                export const BundleUnitPrice: string;
                export const CatCode: string;
                export const CouponAgeDay: string;
                export const CouponGiftDesc: string;
                export const CouponType: string;
                export const CreateBy: string;
                export const CreateDate: string;
                export const DiscAmt: string;
                export const DiscPc: string;
                export const DiscPc1: string;
                export const DiscPc2: string;
                export const DiscPc3: string;
                export const DiscPc4: string;
                export const EndBillPmType: string;
                export const FreeLpFg: string;
                export const FreeQty: string;
                export const Id: string;
                export const ItemType: string;
                export const LineItemNo: string;
                export const ListFg: string;
                export const LpPrice: string;
                export const NpcsOrBundlePrice: string;
                export const PluCode: string;
                export const PmDesc: string;
                export const PmExtCode: string;
                export const PmGroupId: string;
                export const PmId: string;
                export const PmOrder: string;
                export const PmStepNo: string;
                export const PmType: string;
                export const Price1: string;
                export const Price2: string;
                export const Price3: string;
                export const Price4: string;
                export const Qty: string;
                export const StyleCode: string;
                export const SubCat1Code: string;
                export const SubCat2Code: string;
                export const SupplCode: string;
                export const UpdateBy: string;
                export const UpdateDate: string;
            }

            namespace PsAdvPromoItem2Exempt {
                export const BrandCode: string;
                export const CatCode: string;
                export const CreateBy: string;
                export const CreateDate: string;
                export const Id: string;
                export const ItemType: string;
                export const LineItemNo: string;
                export const ListFg: string;
                export const PluCode: string;
                export const PmDesc: string;
                export const PmExtCode: string;
                export const PmGroupId: string;
                export const PmId: string;
                export const PmOrder: string;
                export const PmStepNo: string;
                export const PmType: string;
                export const StyleCode: string;
                export const SubCat1Code: string;
                export const SubCat2Code: string;
                export const SupplCode: string;
                export const UpdateBy: string;
                export const UpdateDate: string;
            }

            namespace PsAdvPromoItem3 {
                export const Amt: string;
                export const AssortFg: string;
                export const BrandCode: string;
                export const BuncleQty: string;
                export const BundleExPrice: string;
                export const BundleItemNo: string;
                export const BundleUnitPrice: string;
                export const CatCode: string;
                export const CouponAgeDay: string;
                export const CouponGiftDesc: string;
                export const CouponType: string;
                export const CreateBy: string;
                export const CreateDate: string;
                export const DiscAmt: string;
                export const DiscPc: string;
                export const DiscPc1: string;
                export const DiscPc2: string;
                export const DiscPc3: string;
                export const DiscPc4: string;
                export const EndBillPmType: string;
                export const FreeLpFg: string;
                export const FreeQty: string;
                export const Id: string;
                export const ItemType: string;
                export const LineItemNo: string;
                export const ListFg: string;
                export const LpPrice: string;
                export const NpcsOrBundlePrice: string;
                export const PluCode: string;
                export const PmDesc: string;
                export const PmExtCode: string;
                export const PmGroupId: string;
                export const PmId: string;
                export const PmOrder: string;
                export const PmStepNo: string;
                export const PmType: string;
                export const Price1: string;
                export const Price2: string;
                export const Price3: string;
                export const Price4: string;
                export const Qty: string;
                export const StyleCode: string;
                export const SubCat1Code: string;
                export const SubCat2Code: string;
                export const SupplCode: string;
                export const UpdateBy: string;
                export const UpdateDate: string;
            }

            namespace PsAdvPromoItem3Exempt {
                export const BrandCode: string;
                export const CatCode: string;
                export const CreateBy: string;
                export const CreateDate: string;
                export const Id: string;
                export const ItemType: string;
                export const LineItemNo: string;
                export const ListFg: string;
                export const PluCode: string;
                export const PmDesc: string;
                export const PmExtCode: string;
                export const PmGroupId: string;
                export const PmId: string;
                export const PmOrder: string;
                export const PmStepNo: string;
                export const PmType: string;
                export const StyleCode: string;
                export const SubCat1Code: string;
                export const SubCat2Code: string;
                export const SupplCode: string;
                export const UpdateBy: string;
                export const UpdateDate: string;
            }

            namespace PsAdvPromoItem4 {
                export const Amt: string;
                export const AssortFg: string;
                export const BrandCode: string;
                export const BuncleQty: string;
                export const BundleExPrice: string;
                export const BundleItemNo: string;
                export const BundleUnitPrice: string;
                export const CatCode: string;
                export const CouponAgeDay: string;
                export const CouponGiftDesc: string;
                export const CouponType: string;
                export const CreateBy: string;
                export const CreateDate: string;
                export const DiscAmt: string;
                export const DiscPc: string;
                export const DiscPc1: string;
                export const DiscPc2: string;
                export const DiscPc3: string;
                export const DiscPc4: string;
                export const EndBillPmType: string;
                export const FreeLpFg: string;
                export const FreeQty: string;
                export const Id: string;
                export const ItemType: string;
                export const LineItemNo: string;
                export const ListFg: string;
                export const LpPrice: string;
                export const NpcsOrBundlePrice: string;
                export const PluCode: string;
                export const PmDesc: string;
                export const PmExtCode: string;
                export const PmGroupId: string;
                export const PmId: string;
                export const PmOrder: string;
                export const PmStepNo: string;
                export const PmType: string;
                export const Price1: string;
                export const Price2: string;
                export const Price3: string;
                export const Price4: string;
                export const Qty: string;
                export const StyleCode: string;
                export const SubCat1Code: string;
                export const SubCat2Code: string;
                export const SupplCode: string;
                export const UpdateBy: string;
                export const UpdateDate: string;
            }

            namespace PsAdvPromoItem4Exempt {
                export const BrandCode: string;
                export const CatCode: string;
                export const CreateBy: string;
                export const CreateDate: string;
                export const Id: string;
                export const ItemType: string;
                export const LineItemNo: string;
                export const ListFg: string;
                export const PluCode: string;
                export const PmDesc: string;
                export const PmExtCode: string;
                export const PmGroupId: string;
                export const PmId: string;
                export const PmOrder: string;
                export const PmStepNo: string;
                export const PmType: string;
                export const StyleCode: string;
                export const SubCat1Code: string;
                export const SubCat2Code: string;
                export const SupplCode: string;
                export const UpdateBy: string;
                export const UpdateDate: string;
            }

            namespace PsAdvPromoItem5 {
                export const Amt: string;
                export const AssortFg: string;
                export const BrandCode: string;
                export const BuncleQty: string;
                export const BundleExPrice: string;
                export const BundleItemNo: string;
                export const BundleUnitPrice: string;
                export const CatCode: string;
                export const CouponAgeDay: string;
                export const CouponGiftDesc: string;
                export const CouponType: string;
                export const CreateBy: string;
                export const CreateDate: string;
                export const DiscAmt: string;
                export const DiscPc: string;
                export const DiscPc1: string;
                export const DiscPc2: string;
                export const DiscPc3: string;
                export const DiscPc4: string;
                export const EndBillPmType: string;
                export const FreeLpFg: string;
                export const FreeQty: string;
                export const Id: string;
                export const ItemType: string;
                export const LineItemNo: string;
                export const ListFg: string;
                export const LpPrice: string;
                export const NpcsOrBundlePrice: string;
                export const PluCode: string;
                export const PmDesc: string;
                export const PmExtCode: string;
                export const PmGroupId: string;
                export const PmId: string;
                export const PmOrder: string;
                export const PmStepNo: string;
                export const PmType: string;
                export const Price1: string;
                export const Price2: string;
                export const Price3: string;
                export const Price4: string;
                export const Qty: string;
                export const StyleCode: string;
                export const SubCat1Code: string;
                export const SubCat2Code: string;
                export const SupplCode: string;
                export const UpdateBy: string;
                export const UpdateDate: string;
            }

            namespace PsAdvPromoItem5Exempt {
                export const BrandCode: string;
                export const CatCode: string;
                export const CreateBy: string;
                export const CreateDate: string;
                export const Id: string;
                export const ItemType: string;
                export const LineItemNo: string;
                export const ListFg: string;
                export const PluCode: string;
                export const PmDesc: string;
                export const PmExtCode: string;
                export const PmGroupId: string;
                export const PmId: string;
                export const PmOrder: string;
                export const PmStepNo: string;
                export const PmType: string;
                export const StyleCode: string;
                export const SubCat1Code: string;
                export const SubCat2Code: string;
                export const SupplCode: string;
                export const UpdateBy: string;
                export const UpdateDate: string;
            }

            namespace PsAdvPromoItem6 {
                export const Amt: string;
                export const AssortFg: string;
                export const BrandCode: string;
                export const BuncleQty: string;
                export const BundleExPrice: string;
                export const BundleItemNo: string;
                export const BundleUnitPrice: string;
                export const CatCode: string;
                export const CouponAgeDay: string;
                export const CouponGiftDesc: string;
                export const CouponType: string;
                export const CreateBy: string;
                export const CreateDate: string;
                export const DiscAmt: string;
                export const DiscPc: string;
                export const DiscPc1: string;
                export const DiscPc2: string;
                export const DiscPc3: string;
                export const DiscPc4: string;
                export const EndBillPmType: string;
                export const FreeLpFg: string;
                export const FreeQty: string;
                export const Id: string;
                export const ItemType: string;
                export const LineItemNo: string;
                export const ListFg: string;
                export const LpPrice: string;
                export const NpcsOrBundlePrice: string;
                export const PluCode: string;
                export const PmDesc: string;
                export const PmExtCode: string;
                export const PmGroupId: string;
                export const PmId: string;
                export const PmOrder: string;
                export const PmStepNo: string;
                export const PmType: string;
                export const Price1: string;
                export const Price2: string;
                export const Price3: string;
                export const Price4: string;
                export const Qty: string;
                export const StyleCode: string;
                export const SubCat1Code: string;
                export const SubCat2Code: string;
                export const SupplCode: string;
                export const UpdateBy: string;
                export const UpdateDate: string;
            }

            namespace PsAdvPromoItem6Exempt {
                export const BrandCode: string;
                export const CatCode: string;
                export const CreateBy: string;
                export const CreateDate: string;
                export const Id: string;
                export const ItemType: string;
                export const LineItemNo: string;
                export const ListFg: string;
                export const PluCode: string;
                export const PmDesc: string;
                export const PmExtCode: string;
                export const PmGroupId: string;
                export const PmId: string;
                export const PmOrder: string;
                export const PmStepNo: string;
                export const PmType: string;
                export const StyleCode: string;
                export const SubCat1Code: string;
                export const SubCat2Code: string;
                export const SupplCode: string;
                export const UpdateBy: string;
                export const UpdateDate: string;
            }

            namespace PsAdvPromoItem9 {
                export const Amt: string;
                export const AssortFg: string;
                export const BrandCode: string;
                export const BuncleQty: string;
                export const BundleExPrice: string;
                export const BundleItemNo: string;
                export const BundleUnitPrice: string;
                export const CatCode: string;
                export const CouponAgeDay: string;
                export const CouponGiftDesc: string;
                export const CouponType: string;
                export const CouponTypeLookup: string;
                export const CreateBy: string;
                export const CreateDate: string;
                export const DiscAmt: string;
                export const DiscPc: string;
                export const DiscPc1: string;
                export const DiscPc2: string;
                export const DiscPc3: string;
                export const DiscPc4: string;
                export const EndBillPmType: string;
                export const FreeLpFg: string;
                export const FreeQty: string;
                export const Id: string;
                export const ItemType: string;
                export const LineItemNo: string;
                export const ListFg: string;
                export const LpPrice: string;
                export const NpcsOrBundlePrice: string;
                export const PluCode: string;
                export const PmDesc: string;
                export const PmExtCode: string;
                export const PmGroupId: string;
                export const PmId: string;
                export const PmOrder: string;
                export const PmStepNo: string;
                export const PmType: string;
                export const Price1: string;
                export const Price2: string;
                export const Price3: string;
                export const Price4: string;
                export const Qty: string;
                export const StyleCode: string;
                export const SubCat1Code: string;
                export const SubCat2Code: string;
                export const SupplCode: string;
                export const UpdateBy: string;
                export const UpdateDate: string;
            }

            namespace PsAdvPromoItem9Exempt {
                export const BrandCode: string;
                export const CatCode: string;
                export const CreateBy: string;
                export const CreateDate: string;
                export const Id: string;
                export const ItemType: string;
                export const LineItemNo: string;
                export const ListFg: string;
                export const PluCode: string;
                export const PmDesc: string;
                export const PmExtCode: string;
                export const PmGroupId: string;
                export const PmId: string;
                export const PmOrder: string;
                export const PmStepNo: string;
                export const PmType: string;
                export const StyleCode: string;
                export const SubCat1Code: string;
                export const SubCat2Code: string;
                export const SupplCode: string;
                export const UpdateBy: string;
                export const UpdateDate: string;
            }

            namespace PsAdvPromoItemExempt {
                export const BrandCode: string;
                export const CatCode: string;
                export const CreateBy: string;
                export const CreateDate: string;
                export const Id: string;
                export const ItemType: string;
                export const LineItemNo: string;
                export const ListFg: string;
                export const PluCode: string;
                export const PmDesc: string;
                export const PmExtCode: string;
                export const PmGroupId: string;
                export const PmId: string;
                export const PmOrder: string;
                export const PmStepNo: string;
                export const PmType: string;
                export const StyleCode: string;
                export const SubCat1Code: string;
                export const SubCat2Code: string;
                export const SupplCode: string;
                export const UpdateBy: string;
                export const UpdateDate: string;
            }

            namespace PsAdvPromoType {
                export const CreateBy: string;
                export const CreateDate: string;
                export const Id: string;
                export const PmType: string;
                export const PmTypeDesc: string;
                export const PmTypeOrder: string;
                export const UpdateBy: string;
                export const UpdateDate: string;
            }

            namespace PsPromoAvDays {
                export const Id: string;
                export const PmGroupId: string;
                export const PromoDay: string;
            }

            namespace PsPromoAvMb {
                export const Id: string;
                export const MbType: string;
                export const PmGroupId: string;
            }

            namespace PsPromoAvShop {
                export const Id: string;
                export const PmGroupId: string;
                export const ShopId: string;
            }

            namespace PsPromoCampaign {
                export const CreateBy: string;
                export const CreateDate: string;
                export const FullName: string;
                export const Id: string;
                export const PromoCampName: string;
                export const PromoCampaign: string;
                export const UpdateBy: string;
                export const UpdateDate: string;
            }

            namespace PsPromoType {
                export const Condition: string;
                export const CreateBy: string;
                export const CreateDate: string;
                export const Id: string;
                export const PPtype: string;
                export const PmType: string;
                export const PmTypeDesc: string;
                export const UpdateBy: string;
                export const UpdateDate: string;
            }

            namespace Report_Adv01 {
                export const FullName: string;
                export const PluCode: string;
                export const PluShortDesc: string;
                export const PmGroupId: string;
                export const PmId: string;
                export const PromoCampaign: string;
                export const PromoDisc: string;
                export const SalesAmtAfterPromo: string;
                export const SalesAmtBeforePromo: string;
                export const SalesQty: string;
                export const ShopFullName: string;
                export const ShopId: string;
                export const ShopName: string;
            }

            namespace Report_Adv02 {
                export const FullName: string;
                export const PluCode: string;
                export const PluShortDesc: string;
                export const PmGroupId: string;
                export const PmId: string;
                export const PromoCampaign: string;
                export const PromoDisc: string;
                export const SalesAmtAfterPromo: string;
                export const SalesAmtBeforePromo: string;
                export const SalesQty: string;
            }

            namespace Report_Adv03 {
                export const PmGroupId: string;
                export const PmId: string;
                export const PromoCampaign: string;
                export const PromoDisc: string;
                export const SalesAmtAfterPromo: string;
                export const SalesAmtBeforePromo: string;
                export const SalesQty: string;
                export const ShopFullName: string;
                export const ShopId: string;
                export const ShopName: string;
            }

            namespace Report_Adv04 {
                export const PmGroupId: string;
                export const PmId: string;
                export const PromoCampaign: string;
                export const PromoDisc: string;
                export const SalesAmtAfterPromo: string;
                export const SalesAmtBeforePromo: string;
                export const SalesQty: string;
            }

            namespace VwAdvPromoBasicAndAdvActiveByPlu {
                export const EndPromoDate: string;
                export const EndPromoTime: string;
                export const Id: string;
                export const PluCode: string;
                export const PmGroupDesc: string;
                export const PmGroupId: string;
                export const PmId: string;
                export const PmType: string;
                export const PromoCampaign: string;
                export const PromoCust: string;
                export const PromoCustFg: string;
                export const PromoDay: string;
                export const PromoDayFg: string;
                export const PromoShop: string;
                export const PromoShopFg: string;
                export const PromoStatus: string;
                export const PromoTimeFg: string;
                export const PromoType: string;
                export const StartPromoDate: string;
                export const StartPromoTime: string;
                export const VenderSharing: string;
            }
        }

        namespace CustomReport {

            namespace ReportCusAging {
                export const AvgSaleAmt: string;
                export const BrandName: string;
                export const Category1: string;
                export const Category2: string;
                export const Category3: string;
                export const CostPriceExVat: string;
                export const HistorySaleAmt: string;
                export const Id: string;
                export const P1CostValue: string;
                export const P1Qty: string;
                export const P1TotalToStock: string;
                export const P2CostValue: string;
                export const P2Qty: string;
                export const P2TotalToStock: string;
                export const P3CostValue: string;
                export const P3Qty: string;
                export const P3TotalToStock: string;
                export const P4CostValue: string;
                export const P4Qty: string;
                export const P4TotalToStock: string;
                export const P5CostValue: string;
                export const P5Qty: string;
                export const P5TotalToStock: string;
                export const PluCode: string;
                export const RetailPrice: string;
                export const SkuCode: string;
                export const SkuDesc: string;
                export const SumCostValue: string;
                export const SumOnHandQty: string;
                export const SumRetailPrice: string;
                export const SuplierName: string;
                export const SupplierId: string;
            }

            namespace ReportCusPromotionSale {
                export const Category1: string;
                export const Category2: string;
                export const Category3: string;
                export const DateMonth: string;
                export const DateSale: string;
                export const DateYear: string;
                export const Id: string;
                export const ItemName: string;
                export const NetSaleExVat: string;
                export const OnHandQty: string;
                export const PluCode: string;
                export const PromoId: string;
                export const PromoName: string;
                export const PromoperiodFrom: string;
                export const PromoperiodTo: string;
                export const SalesQty: string;
                export const SkuCode: string;
                export const SupplierCode: string;
                export const SupplierName: string;
            }

            namespace ReportCusSaleComparison {
                export const BrandName: string;
                export const Category1: string;
                export const Category2: string;
                export const Category3: string;
                export const Id: string;
                export const LwNetGpAmount: string;
                export const LwNetGr: string;
                export const LwNetSalesExVat: string;
                export const LwQtySold: string;
                export const PcVarianceNetGpAmount: string;
                export const PcVarianceNetSalesExVat: string;
                export const PcVarianceQtySold: string;
                export const PluCode: string;
                export const PluDesc: string;
                export const ShopName: string;
                export const SupPlierName: string;
                export const SupplierId: string;
                export const TwNetGpAmount: string;
                export const TwNetGr: string;
                export const TwNetSalesExVat: string;
                export const TwQtySold: string;
                export const VarianceNetGpAmount: string;
                export const VarianceNetGr: string;
                export const VarianceNetSalesExVat: string;
                export const VarianceQtySold: string;
            }

            namespace ReportCusSaleReport {
                export const AvgPrice: string;
                export const BrandName: string;
                export const Category1: string;
                export const Category2: string;
                export const Category3: string;
                export const CostOfGoods: string;
                export const DisCount: string;
                export const DiscountBill: string;
                export const DiscountCom: string;
                export const DiscountMb: string;
                export const DiscountSum: string;
                export const DiscountSup: string;
                export const ExPrice: string;
                export const GrossMargin: string;
                export const GrossPc: string;
                export const Id: string;
                export const NetGp: string;
                export const NetGpVender: string;
                export const NetMargin: string;
                export const NetSale: string;
                export const NetSalesExVat: string;
                export const OnHandQty: string;
                export const PluCode: string;
                export const QtySold: string;
                export const SkuCode: string;
                export const SkuDesc: string;
                export const SupplierId: string;
                export const SupplierName: string;
                export const VatAmt: string;
            }

            namespace ReportCusStockOnHand {
                export const AvgSaleAmt: string;
                export const BrandName: string;
                export const Category1: string;
                export const Category2: string;
                export const Category3: string;
                export const CostAmount: string;
                export const HistorySaleAmt: string;
                export const Id: string;
                export const OnHandQty: string;
                export const PluCode: string;
                export const SellPrice1: string;
                export const SkuCode: string;
                export const SkuDesc: string;
                export const StkUnit: string;
                export const SuplierName: string;
                export const SupplierId: string;
            }

            namespace ReportCustomerSurvey {
                export const Choice: string;
                export const ChoiceId: string;
                export const DtList: string;
                export const Id: string;
                export const Qty: string;
                export const Question: string;
                export const SurveyCode: string;
            }

            namespace ReportCustomerSurveyTranDt {
                export const Choice: string;
                export const ChoiceId: string;
                export const CreateBy: string;
                export const DocNo: string;
                export const MbId: string;
                export const PosId: string;
                export const ShopId: string;
                export const SurveyCode: string;
            }
        }

        namespace Customer {

            namespace CsCustGroup {
                export const CreateBy: string;
                export const CreateDate: string;
                export const CustGroupCode: string;
                export const CustGroupName: string;
                export const FullName: string;
                export const Id: string;
                export const LastUpdate: string;
                export const UpdateBy: string;
            }

            namespace CsCustomer {
                export const Address: string;
                export const Amphur: string;
                export const ContactName: string;
                export const Country: string;
                export const CreateBy: string;
                export const CreateDate: string;
                export const CusRemark: string;
                export const CusTel: string;
                export const CustCode: string;
                export const CustGroupCode: string;
                export const CustGroupName: string;
                export const CustName: string;
                export const CustRegAdd1: string;
                export const CustRegAdd2: string;
                export const CustRegAdd3: string;
                export const CustRegAddress: string;
                export const CustRegAmphur: string;
                export const CustRegCountry: string;
                export const CustRegName: string;
                export const CustRegProvince: string;
                export const CustRegTumbol: string;
                export const CustRegZipCode: string;
                export const CustTaxId: string;
                export const Email: string;
                export const Id: string;
                export const LastUpdate: string;
                export const Province: string;
                export const SaleMemo: string;
                export const SalesmanId: string;
                export const SalesmanName: string;
                export const ShipAddLine1: string;
                export const ShipAddLine2: string;
                export const ShipAddLine3: string;
                export const ShipAddress: string;
                export const ShipAmphur: string;
                export const ShipCountry: string;
                export const ShipName: string;
                export const ShipProvince: string;
                export const ShipTumbol: string;
                export const ShipZipCode: string;
                export const Tumbol: string;
                export const UpdateBy: string;
                export const ZipCode: string;
            }

            namespace Report_1106Customer {
                export const Address: string;
                export const Amphur: string;
                export const ContactName: string;
                export const Country: string;
                export const CreateBy: string;
                export const CreateDate: string;
                export const CusRemark: string;
                export const CusTel: string;
                export const CustCode: string;
                export const CustGroupCode: string;
                export const CustGroupName: string;
                export const CustName: string;
                export const CustRegAdd1: string;
                export const CustRegAdd2: string;
                export const CustRegAdd3: string;
                export const CustRegAddress: string;
                export const CustRegAmphur: string;
                export const CustRegCountry: string;
                export const CustRegName: string;
                export const CustRegProvince: string;
                export const CustRegTumbol: string;
                export const CustRegZipCode: string;
                export const CustTaxId: string;
                export const Email: string;
                export const Id: string;
                export const LastUpdate: string;
                export const Province: string;
                export const SaleMemo: string;
                export const SalesmanId: string;
                export const SalesmanName: string;
                export const ShipAddLine1: string;
                export const ShipAddLine2: string;
                export const ShipAddLine3: string;
                export const ShipAddress: string;
                export const ShipAmphur: string;
                export const ShipCountry: string;
                export const ShipName: string;
                export const ShipProvince: string;
                export const ShipTumbol: string;
                export const ShipZipCode: string;
                export const Tumbol: string;
                export const UpdateBy: string;
                export const ZipCode: string;
            }
        }

        namespace InitialData {

            namespace IcWhs {
                export const CreateBy: string;
                export const CreateDate: string;
                export const FullName: string;
                export const Id: string;
                export const LastUpdate: string;
                export const ShopFullName: string;
                export const ShopId: string;
                export const UpdateBy: string;
                export const WhsId: string;
                export const WhsName: string;
                export const WhsType: string;
            }

            namespace PsCashCouponType {
                export const CashCouponName: string;
                export const CashCouponType: string;
                export const CashCouponValue: string;
                export const CashCouponValueType: string;
                export const CreateBy: string;
                export const CreateDate: string;
                export const EndDate: string;
                export const Id: string;
                export const IsActive: string;
                export const LastUpdate: string;
                export const PartnerCompensateAmt: string;
                export const PartnerCompensatePc: string;
                export const ProdImageLink: string;
                export const StartDate: string;
                export const UpdateBy: string;
            }

            namespace PsCashCouponTypeSerial {
                export const CashCouponType: string;
                export const CreateBy: string;
                export const CreateDate: string;
                export const Id: string;
                export const IsActive: string;
                export const Serial: string;
                export const Used: string;
            }

            namespace PsCashier {
                export const CashierId: string;
                export const CashierLevel: string;
                export const CashierName: string;
                export const CashierPassword: string;
                export const CreateBy: string;
                export const CreateDate: string;
                export const Id: string;
                export const LastUpdate: string;
                export const UpdateBy: string;
            }

            namespace PsConnectEdcBank {
                export const CreateBy: string;
                export const CreateDate: string;
                export const EdcBank: string;
                export const EdcBankName: string;
                export const Id: string;
                export const LastUpdate: string;
                export const Remark: string;
                export const UpdateBy: string;
            }

            namespace PsConnectEdcPort {
                export const ConnectEdcPort: string;
                export const CreateBy: string;
                export const CreateDate: string;
                export const Id: string;
                export const LastUpdate: string;
                export const Remark: string;
                export const UpdateBy: string;
            }

            namespace PsCorperateMessage {
                export const ActiveBy: string;
                export const Activedate: string;
                export const CreateBy: string;
                export const CreateDate: string;
                export const Desc: string;
                export const EndDate: string;
                export const EndTime: string;
                export const Id: string;
                export const StartDate: string;
                export const StartTime: string;
                export const Status: string;
                export const TimeFg: string;
                export const Topic: string;
                export const UpdateBy: string;
                export const UpdateDate: string;
            }

            namespace PsCorperateMessageReciept {
                export const ActiveBy: string;
                export const Activedate: string;
                export const CreateBy: string;
                export const CreateDate: string;
                export const Desc: string;
                export const EndDate: string;
                export const EndTime: string;
                export const FontSize: string;
                export const Id: string;
                export const Image: string;
                export const StartDate: string;
                export const StartTime: string;
                export const Status: string;
                export const TextAlign: string;
                export const TimeFg: string;
                export const UpdateBy: string;
                export const UpdateDate: string;
            }

            namespace PsCreditCard {
                export const CreateBy: string;
                export const CreateDate: string;
                export const CreditCardName: string;
                export const CreditCardType: string;
                export const Id: string;
                export const IsActive: string;
                export const LastUpdate: string;
                export const ProdImageLink: string;
                export const UpdateBy: string;
            }

            namespace PsCurrency {
                export const CreateBy: string;
                export const CreateDate: string;
                export const CurrencyCode: string;
                export const CurrencyName: string;
                export const Id: string;
                export const IsActive: string;
                export const LastUpdate: string;
                export const ProdImageLink: string;
                export const UpdateBy: string;
            }

            namespace PsCustomerSurvey {
                export const ActiveBy: string;
                export const Activedate: string;
                export const CreateBy: string;
                export const CreateDate: string;
                export const DtList: string;
                export const EndDate: string;
                export const EndTime: string;
                export const Id: string;
                export const PosFg: string;
                export const PosId: string;
                export const Question: string;
                export const StartDate: string;
                export const StartTime: string;
                export const Status: string;
                export const SurveyCode: string;
                export const TimeFg: string;
                export const UpdateBy: string;
                export const UpdateDate: string;
            }

            namespace PsCustomerSurveyDt {
                export const Choice: string;
                export const ChoiceId: string;
                export const CreateBy: string;
                export const CreateDate: string;
                export const LineNo: string;
                export const Status: string;
                export const SurveyCode: string;
                export const UpdateBy: string;
                export const UpdateDate: string;
            }

            namespace PsCustomerSurveyPos {
                export const Id: string;
                export const PosId: string;
                export const SurveyCode: string;
            }

            namespace PsDebitCard {
                export const CreateBy: string;
                export const CreateDate: string;
                export const DebitCardName: string;
                export const DebitCardType: string;
                export const Id: string;
                export const IsActive: string;
                export const LastUpdate: string;
                export const ProdImageLink: string;
                export const UpdateBy: string;
            }

            namespace PsDiscCouponType {
                export const CreateBy: string;
                export const CreateDate: string;
                export const CustFg: string;
                export const DayFg: string;
                export const DiscCouponName: string;
                export const DiscCouponType: string;
                export const DiscCouponValue: string;
                export const DiscCouponValueType: string;
                export const EndDate: string;
                export const Id: string;
                export const IsActive: string;
                export const ItemOrBillFg: string;
                export const LastUpdate: string;
                export const PartnerCompensatePc: string;
                export const ProdImageLink: string;
                export const PromoDay: string;
                export const PromoMb: string;
                export const PromoShop: string;
                export const ShopFg: string;
                export const StartDate: string;
                export const UpdateBy: string;
            }

            namespace PsDiscCouponTypeDays {
                export const DiscCouponType: string;
                export const Id: string;
                export const PromoDay: string;
            }

            namespace PsDiscCouponTypeItem {
                export const BrandCode: string;
                export const CatCode: string;
                export const CreateBy: string;
                export const CreateDate: string;
                export const DiscCouponType: string;
                export const Id: string;
                export const ListFg: string;
                export const PluCode: string;
                export const StyleCode: string;
                export const SubCat1Code: string;
                export const SubCat2Code: string;
                export const SupplCode: string;
                export const UpdateBy: string;
                export const UpdateDate: string;
            }

            namespace PsDiscCouponTypeItemExt {
                export const BrandCode: string;
                export const CatCode: string;
                export const CreateBy: string;
                export const CreateDate: string;
                export const DiscCouponType: string;
                export const Id: string;
                export const ListFg: string;
                export const PluCode: string;
                export const StyleCode: string;
                export const SubCat1Code: string;
                export const SubCat2Code: string;
                export const SupplCode: string;
                export const UpdateBy: string;
                export const UpdateDate: string;
            }

            namespace PsDiscCouponTypeMb {
                export const DiscCouponType: string;
                export const Id: string;
                export const MbType: string;
            }

            namespace PsDiscCouponTypeSerial {
                export const CreateBy: string;
                export const CreateDate: string;
                export const DiscCouponType: string;
                export const Id: string;
                export const IsActive: string;
                export const Serial: string;
                export const Used: string;
            }

            namespace PsDiscCouponTypeShop {
                export const DiscCouponType: string;
                export const Id: string;
                export const ShopId: string;
            }

            namespace PsExchangeRate {
                export const CreateBy: string;
                export const CreateDate: string;
                export const CurrencyCode: string;
                export const EffectiveDate: string;
                export const ExchangeRate: string;
                export const Id: string;
                export const LastUpdate: string;
                export const UpdateBy: string;
            }

            namespace PsOtherPayment {
                export const CreateBy: string;
                export const CreateDate: string;
                export const Id: string;
                export const IsActive: string;
                export const LastUpdate: string;
                export const OtherPaymentName: string;
                export const OtherPaymentType: string;
                export const ProdImageLink: string;
                export const UpdateBy: string;
            }

            namespace PsPanelGroupButton {
                export const BgColor: string;
                export const CreateBy: string;
                export const CreateDate: string;
                export const DtList: string;
                export const GroupButtonId: string;
                export const GroupButtonImage: string;
                export const GroupButtonLabel: string;
                export const Id: string;
                export const LastUpdate: string;
                export const TouchPanelType: string;
                export const TxtColor: string;
                export const TxtFontSize: string;
                export const UpdateBy: string;
            }

            namespace PsPanelItemButton {
                export const BgColor: string;
                export const CreateBy: string;
                export const CreateDate: string;
                export const GroupButtonId: string;
                export const Id: string;
                export const ItemButtonId: string;
                export const ItemButtonImage: string;
                export const ItemButtonLabel: string;
                export const LastUpdate: string;
                export const LinkCode: string;
                export const LinkCodeFg: string;
                export const TouchPanelType: string;
                export const TxtColor: string;
                export const TxtFontSize: string;
                export const UpdateBy: string;
                export const UrlUpload: string;
            }

            namespace PsPosPrinter {
                export const CreateBy: string;
                export const CreateDate: string;
                export const Id: string;
                export const LastUpdate: string;
                export const PrinterId: string;
                export const PrinterName: string;
                export const UpdateBy: string;
            }

            namespace PsPosStation {
                export const AutoChargeFg: string;
                export const AutoChargeRate: string;
                export const CashierPosFg: string;
                export const Connect2ndDispFg: string;
                export const ConnectDrawerFg: string;
                export const ConnectEdcFg: string;
                export const ConnectEdcPort: string;
                export const ConnectPrinterFg: string;
                export const ConnectRfidReaderFg: string;
                export const ConnectVfdFg: string;
                export const CreateBy: string;
                export const CreateDate: string;
                export const EdcBank: string;
                export const EjournalFg: string;
                export const Id: string;
                export const ItemOnRecptMethod: string;
                export const LastReceiptRunNo: string;
                export const LastRefundRunNo: string;
                export const LastUpdate: string;
                export const MandatoryMemberFg: string;
                export const MandatorySalesmanFg: string;
                export const MaxCashInDrawer: string;
                export const NoOfRecptCopy: string;
                export const PosId: string;
                export const PosPermitNo: string;
                export const PosScreenType: string;
                export const PosTouchPanelId: string;
                export const PrintOrderFg: string;
                export const PrintQueueFg: string;
                export const PromptPayLink: string;
                export const PsParaDefault1: string;
                export const PsParaDefault2: string;
                export const QRCodeAccount: string;
                export const ReceiptPrinterType: string;
                export const RecptFootMesg1: string;
                export const RecptFootMesg10: string;
                export const RecptFootMesg2: string;
                export const RecptFootMesg3: string;
                export const RecptFootMesg4: string;
                export const RecptFootMesg5: string;
                export const RecptFootMesg6: string;
                export const RecptFootMesg7: string;
                export const RecptFootMesg8: string;
                export const RecptFootMesg9: string;
                export const RecptFootMesgFontSize: string;
                export const RecptFootMesgTextAlign: string;
                export const RecptHeadMesg1: string;
                export const RecptHeadMesg2: string;
                export const RecptHeadMesg3: string;
                export const RecptHeadMesg4: string;
                export const RecptHeadMesg5: string;
                export const RecptHeadMesg6: string;
                export const RecptHeadMesgFontSize: string;
                export const RecptHeadMesgTextAlign: string;
                export const RecptNoBarcodeFg: string;
                export const RecptSumItemQtyFg: string;
                export const SalesDocFg: string;
                export const SalesVatType: string;
                export const SelectSellingPriceFg: string;
                export const SellingPriceNo: string;
                export const ShopFullName: string;
                export const ShopId: string;
                export const ShopLogoOnFrontScreen: string;
                export const ShopLogoOnReceipt: string;
                export const UpdateBy: string;
                export const WhsId: string;
            }

            namespace PsPosTouchPanelType {
                export const CreateBy: string;
                export const CreateDate: string;
                export const Id: string;
                export const LastUpdate: string;
                export const POSScreenType: string;
                export const TouchPanelDesc: string;
                export const TouchPanelType: string;
                export const UpdateBy: string;
            }

            namespace PsPriceOverrideReason {
                export const CreateBy: string;
                export const CreateDate: string;
                export const Id: string;
                export const IsActive: string;
                export const LastUpdate: string;
                export const PriceOverrideId: string;
                export const PriceOverrideReason: string;
                export const Remark: string;
                export const UpdateBy: string;
            }

            namespace PsPurposeReason {
                export const CreateBy: string;
                export const CreateDate: string;
                export const DocType: string;
                export const FullName: string;
                export const Id: string;
                export const LastUpdate: string;
                export const Purpose: string;
                export const PurposeCode: string;
                export const Remark: string;
                export const UpdateBy: string;
            }

            namespace PsQRPromptPay {
                export const CreateBy: string;
                export const CreateDate: string;
                export const Id: string;
                export const IsActive: string;
                export const LastUpdate: string;
                export const ProdImageLink: string;
                export const QRPromptPayName: string;
                export const QRPromptPayType: string;
                export const UpdateBy: string;
                export const paymentChannel: string;
            }

            namespace PsRefundReason {
                export const CreateBy: string;
                export const CreateDate: string;
                export const Id: string;
                export const LastUpdate: string;
                export const PurposeCode: string;
                export const RefundFg: string;
                export const RefundId: string;
                export const RefundReason: string;
                export const Remark: string;
                export const TaxRefundReasonId: string;
                export const UpdateBy: string;
            }

            namespace PsSalesman {
                export const CreateBy: string;
                export const CreateDate: string;
                export const Id: string;
                export const LastUpdate: string;
                export const SalesmanGroup: string;
                export const SalesmanGroupDesc: string;
                export const SalesmanIDName: string;
                export const SalesmanId: string;
                export const SalesmanName: string;
                export const UpdateBy: string;
            }

            namespace PsSalesmanGroup {
                export const CreateBy: string;
                export const CreateDate: string;
                export const Id: string;
                export const LastUpdate: string;
                export const SalesmanGroup: string;
                export const SalesmanGroupDesc: string;
                export const UpdateBy: string;
            }

            namespace PsShop {
                export const BranchName: string;
                export const BranchNameDesc: string;
                export const BranchNameDescEn: string;
                export const BranchNameEN: string;
                export const BranchTaxCode: string;
                export const CreateBy: string;
                export const CreateDate: string;
                export const Email: string;
                export const ErpChannel: string;
                export const ErpStore: string;
                export const Id: string;
                export const LastUpdate: string;
                export const PromptPayLink: string;
                export const QRCodeAccount: string;
                export const ShopAddress: string;
                export const ShopAddressEN: string;
                export const ShopBuildingName: string;
                export const ShopBuildingNameEn: string;
                export const ShopBuildingNo: string;
                export const ShopBuildingNoEn: string;
                export const ShopCity: string;
                export const ShopCityEn: string;
                export const ShopCountryCode: string;
                export const ShopDistrict: string;
                export const ShopDistrictEn: string;
                export const ShopFullName: string;
                export const ShopGroupId: string;
                export const ShopGroupName: string;
                export const ShopId: string;
                export const ShopName: string;
                export const ShopNameEN: string;
                export const ShopPostalCode: string;
                export const ShopProvince: string;
                export const ShopProvinceEn: string;
                export const ShopRegAddressLine1: string;
                export const ShopRegAddressLine2: string;
                export const ShopRegAddressLine3: string;
                export const ShopRegId: string;
                export const ShopRegName: string;
                export const ShopStreetName: string;
                export const ShopStreetNameEn: string;
                export const ShopTaxId: string;
                export const ShopTypeId: string;
                export const ShopTypeName: string;
                export const TelId: string;
                export const UpdateBy: string;
            }

            namespace PsShopGroup {
                export const CreateBy: string;
                export const CreateDate: string;
                export const Id: string;
                export const LastUpdate: string;
                export const ShopGroupFullName: string;
                export const ShopGroupId: string;
                export const ShopGroupName: string;
                export const UpdateBy: string;
            }

            namespace PsShopType {
                export const CreateBy: string;
                export const CreateDate: string;
                export const Id: string;
                export const LastUpdate: string;
                export const ShopTypeFullName: string;
                export const ShopTypeId: string;
                export const ShopTypeName: string;
                export const UpdateBy: string;
            }

            namespace Vexchange {
                export const CurrencyCode: string;
                export const EffectiveDate: string;
                export const ExchangeRate: string;
                export const Id: string;
            }
        }

        namespace Inventory {

            namespace IcPara {
                export const Cus_CostCenter: string;
                export const Cus_ProfitCenter: string;
                export const IcFg: string;
                export const Id: string;
                export const PostSequenceFg: string;
                export const Stkmedthod: string;
            }

            namespace IcStkAdjCode {
                export const Id: string;
                export const StkAdjCode: string;
                export const StkAdjDesc: string;
                export const StkAdjType: string;
                export const StkAdjcodeName: string;
            }

            namespace IcStkmedthod {
                export const Id: string;
                export const Stkmedthod: string;
                export const StkmedthodName: string;
            }

            namespace IcStockAdjustIn {
                export const AdjFg: string;
                export const AdjustInDtList: string;
                export const CancelFg: string;
                export const CreateBy: string;
                export const CreateDate: string;
                export const DocDate: string;
                export const DocNo: string;
                export const Id: string;
                export const LastUpdate: string;
                export const PostFg: string;
                export const RefDocNo1: string;
                export const RefDocNo2: string;
                export const Remark: string;
                export const StkAdjCode: string;
                export const StkAdjcodeName: string;
                export const StockFrom: string;
                export const SysDocNo: string;
                export const UpdateBy: string;
                export const WhsId: string;
                export const WhsName: string;
            }

            namespace IcStockAdjustInDt {
                export const AdjFg: string;
                export const CostValue: string;
                export const ExpDate: string;
                export const Id: string;
                export const ItemRemark: string;
                export const LineItemNo: string;
                export const PurUnit: string;
                export const PurUnitPrice: string;
                export const PurUnitRatio: string;
                export const Qty: string;
                export const Remark: string;
                export const SkuCode: string;
                export const SysDocNo: string;
                export const UnitChange: string;
                export const UnitCost: string;
            }

            namespace IcStockAdjustOut {
                export const AdjFg: string;
                export const AdjustOutDtList: string;
                export const CancelFg: string;
                export const CreateBy: string;
                export const CreateDate: string;
                export const DocDate: string;
                export const DocNo: string;
                export const Id: string;
                export const LastUpdate: string;
                export const PostFg: string;
                export const RefDocNo1: string;
                export const RefDocNo2: string;
                export const Remark: string;
                export const StkAdjCode: string;
                export const StkAdjcodeName: string;
                export const StockTo: string;
                export const SysDocNo: string;
                export const UpdateBy: string;
                export const WhsId: string;
                export const WhsName: string;
            }

            namespace IcStockAdjustOutDt {
                export const AdjFg: string;
                export const CostValue: string;
                export const ExpDate: string;
                export const Id: string;
                export const ItemRemark: string;
                export const LineItemNo: string;
                export const PurUnit: string;
                export const PurUnitPrice: string;
                export const PurUnitRatio: string;
                export const Qty: string;
                export const Remark: string;
                export const SkuCode: string;
                export const SysDocNo: string;
                export const UnitChange: string;
                export const UnitCost: string;
            }

            namespace IcStockApproveDisassemble {
                export const ApproveBy: string;
                export const ApproveDate: string;
                export const ApproveFg: string;
                export const CalDtQtyFg: string;
                export const CallAssemDocFg: string;
                export const CancelFg: string;
                export const CreateBy: string;
                export const CreateDate: string;
                export const DocDate: string;
                export const DocNo: string;
                export const ExpDate: string;
                export const IcStockApproveDisassembleDtList: string;
                export const Id: string;
                export const LastUpdate: string;
                export const PostDate: string;
                export const PostFg: string;
                export const RefDocNo1: string;
                export const RefDocNo2: string;
                export const Remark: string;
                export const SetItemCode: string;
                export const SetQty: string;
                export const SysDocNo: string;
                export const UpdateBy: string;
                export const WhsItem: string;
                export const WhsSet: string;
            }

            namespace IcStockApproveDisassembleDt {
                export const CostValue: string;
                export const ExpDate: string;
                export const Id: string;
                export const LineItemNo: string;
                export const PluCode: string;
                export const PluDesc: string;
                export const Qty: string;
                export const QtyUse: string;
                export const Remark: string;
                export const SellUnitRatio: string;
                export const SetItemQty: string;
                export const SetQty: string;
                export const SkuCode: string;
                export const SkuQty: string;
                export const SysDocNo: string;
                export const UnitCost: string;
            }

            namespace IcStockApproveDt {
                export const CostValue: string;
                export const QtyCount: string;
                export const QtyDif: string;
                export const QtyOnhand: string;
                export const SkuCode: string;
                export const SkuDesc: string;
                export const StkUnit: string;
                export const SysDocNo: string;
                export const UnitCost: string;
                export const WhsId: string;
            }

            namespace IcStockApproveHd {
                export const ApproveBy: string;
                export const ApproveDate: string;
                export const ApproveFg: string;
                export const CancelFg: string;
                export const CreateBy: string;
                export const CreateDate: string;
                export const IcStockCountTranList: string;
                export const Id: string;
                export const LastUpdate: string;
                export const PostDate: string;
                export const PostFg: string;
                export const RefDocNo: string;
                export const Remark: string;
                export const StockCountCode: string;
                export const StockCountDate: string;
                export const StockCountDesc: string;
                export const SysDocNo: string;
                export const UpdateBy: string;
                export const WhsId: string;
                export const WhsName: string;
            }

            namespace IcStockApproveSetAssemble {
                export const ApproveBy: string;
                export const ApproveDate: string;
                export const ApproveFg: string;
                export const CalDtQtyFg: string;
                export const CallSetItemFg: string;
                export const CancelFg: string;
                export const CreateBy: string;
                export const CreateDate: string;
                export const DocDate: string;
                export const DocNo: string;
                export const ExpDate: string;
                export const IcStockApproveSetAssembleDtList: string;
                export const Id: string;
                export const LastUpdate: string;
                export const PostDate: string;
                export const PostFg: string;
                export const RefDocNo1: string;
                export const RefDocNo2: string;
                export const Remark: string;
                export const SetItemCode: string;
                export const SetQty: string;
                export const SysDocNo: string;
                export const UpdateBy: string;
                export const UseFg: string;
                export const WhsItem: string;
                export const WhsSet: string;
            }

            namespace IcStockApproveSetAssembleDt {
                export const CostValue: string;
                export const ExpDate: string;
                export const Id: string;
                export const LineItemNo: string;
                export const PluCode: string;
                export const PluDesc: string;
                export const Qty: string;
                export const Remark: string;
                export const SellUnitRatio: string;
                export const SetItemQty: string;
                export const SetQty: string;
                export const SkuCode: string;
                export const SkuQty: string;
                export const SysDocNo: string;
                export const UnitCost: string;
            }

            namespace IcStockBacProcessing {
                export const CreateBy: string;
                export const CreateDate: string;
                export const FinishDate: string;
                export const Id: string;
                export const PosOrIcProcessing: string;
                export const PostFg: string;
                export const PostSequenceFg: string;
                export const ProcessedTranCount: string;
                export const TotalDocCount: string;
                export const TotalTranCount: string;
            }

            namespace IcStockCountCode {
                export const ApproveBy: string;
                export const ApproveDate: string;
                export const ApproveFg: string;
                export const CancelFg: string;
                export const CreateBy: string;
                export const CreateDate: string;
                export const IcStockCountTranList: string;
                export const Id: string;
                export const LastUpdate: string;
                export const PostDate: string;
                export const PostFg: string;
                export const RefDocNo: string;
                export const Remark: string;
                export const StockCountCode: string;
                export const StockCountDate: string;
                export const StockCountDesc: string;
                export const SysDocNo: string;
                export const UpdateBy: string;
                export const WhsId: string;
                export const WhsName: string;
            }

            namespace IcStockCountTran {
                export const CreateBy: string;
                export const CreateDate: string;
                export const Id: string;
                export const ItemRemark: string;
                export const LastUpdate: string;
                export const LineItemNo: string;
                export const PluCode: string;
                export const PurUnitPrice: string;
                export const PurUnitRatio: string;
                export const QtyCount: string;
                export const QtyOnhand: string;
                export const SellUnit: string;
                export const SellUnitRatio: string;
                export const SkuCode: string;
                export const StkCostValue: string;
                export const StkQtyCount: string;
                export const SysDocNo: string;
                export const UnitCost: string;
                export const UpdateBy: string;
            }

            namespace IcStockDisassemble {
                export const ApproveBy: string;
                export const ApproveDate: string;
                export const ApproveFg: string;
                export const CalDtQtyFg: string;
                export const CallAssemDocFg: string;
                export const CancelFg: string;
                export const CreateBy: string;
                export const CreateDate: string;
                export const DocDate: string;
                export const DocNo: string;
                export const ExpDate: string;
                export const IcStockDisassembleDtList: string;
                export const Id: string;
                export const LastUpdate: string;
                export const PostDate: string;
                export const PostFg: string;
                export const RefDocNo1: string;
                export const RefDocNo2: string;
                export const Remark: string;
                export const SetItemCode: string;
                export const SetQty: string;
                export const SysDocNo: string;
                export const UpdateBy: string;
                export const WhsItem: string;
                export const WhsSet: string;
            }

            namespace IcStockDisassembleDt {
                export const CostValue: string;
                export const ExpDate: string;
                export const Id: string;
                export const LineItemNo: string;
                export const PluCode: string;
                export const PluDesc: string;
                export const Qty: string;
                export const QtyUse: string;
                export const Remark: string;
                export const SellUnitRatio: string;
                export const SetItemQty: string;
                export const SetQty: string;
                export const SkuCode: string;
                export const SkuQty: string;
                export const SysDocNo: string;
                export const UnitCost: string;
            }

            namespace IcStockEomProcessing {
                export const CostCount: string;
                export const CreateBy: string;
                export const CreateDate: string;
                export const EndDate: string;
                export const EndId: string;
                export const FinishDate: string;
                export const Id: string;
                export const LastMonthEomId: string;
                export const LineNoProcess: string;
                export const MonthProcess: string;
                export const PostFg: string;
                export const PostSequenceFg: string;
                export const QtyCount: string;
                export const SkuCount: string;
                export const StartDate: string;
                export const StartId: string;
                export const TranCount: string;
                export const UseFg: string;
                export const YearProcess: string;
            }

            namespace IcStockReceive {
                export const CancelFg: string;
                export const CreateBy: string;
                export const CreateDate: string;
                export const DocDate: string;
                export const DocNo: string;
                export const Id: string;
                export const LastUpdate: string;
                export const PostFg: string;
                export const ReceiveDtList: string;
                export const RefDocNo1: string;
                export const RefDocNo2: string;
                export const Remark: string;
                export const StockFrom: string;
                export const SupplName: string;
                export const SysDocNo: string;
                export const UpdateBy: string;
                export const WhsId: string;
                export const WhsName: string;
            }

            namespace IcStockReceiveDt {
                export const CostValue: string;
                export const ExpDate: string;
                export const Id: string;
                export const ItemRemark: string;
                export const LastPurPrice: string;
                export const LineItemNo: string;
                export const PILineId: string;
                export const PIRefFg: string;
                export const PurUnit: string;
                export const PurUnitPrice: string;
                export const PurUnitRatio: string;
                export const Qty: string;
                export const QtyUse: string;
                export const Remark: string;
                export const SkuCode: string;
                export const StkQty: string;
                export const SysDocNo: string;
                export const UnitChange: string;
                export const UnitCost: string;
                export const UseFg: string;
            }

            namespace IcStockReturnIn {
                export const CancelFg: string;
                export const CheckQty: string;
                export const CreateBy: string;
                export const CreateDate: string;
                export const CustName: string;
                export const DocDate: string;
                export const DocNo: string;
                export const Id: string;
                export const LastUpdate: string;
                export const PostFg: string;
                export const RefDocNo1: string;
                export const RefDocNo2: string;
                export const Remark: string;
                export const ReturnInDtList: string;
                export const StockFrom: string;
                export const SysDocNo: string;
                export const UpdateBy: string;
                export const WhsId: string;
                export const WhsName: string;
            }

            namespace IcStockReturnInDt {
                export const CostValue: string;
                export const ExpDate: string;
                export const GRLineId: string;
                export const GRRefFg: string;
                export const Id: string;
                export const ItemRemark: string;
                export const LineItemNo: string;
                export const PurUnit: string;
                export const PurUnitPrice: string;
                export const PurUnitRatio: string;
                export const Qty: string;
                export const Remark: string;
                export const SkuCode: string;
                export const StkQty: string;
                export const SysDocNo: string;
                export const UnitChange: string;
                export const UnitCost: string;
            }

            namespace IcStockReturnOut {
                export const CancelFg: string;
                export const CheckQty: string;
                export const CreateBy: string;
                export const CreateDate: string;
                export const DocDate: string;
                export const DocNo: string;
                export const Id: string;
                export const LastUpdate: string;
                export const PostFg: string;
                export const RefDocNo1: string;
                export const RefDocNo2: string;
                export const Remark: string;
                export const ReturnOutDtList: string;
                export const StockTo: string;
                export const SupplName: string;
                export const SysDocNo: string;
                export const UpdateBy: string;
                export const WhsId: string;
                export const WhsName: string;
            }

            namespace IcStockReturnOutDt {
                export const CostValue: string;
                export const ExpDate: string;
                export const GRLineId: string;
                export const GRRefFg: string;
                export const Id: string;
                export const ItemRemark: string;
                export const LineItemNo: string;
                export const PurUnit: string;
                export const PurUnitPrice: string;
                export const PurUnitRatio: string;
                export const Qty: string;
                export const QtyUse: string;
                export const Remark: string;
                export const SkuCode: string;
                export const StkQty: string;
                export const SysDocNo: string;
                export const UnitChange: string;
                export const UnitCost: string;
            }

            namespace IcStockSetAssemble {
                export const ApproveBy: string;
                export const ApproveDate: string;
                export const ApproveFg: string;
                export const CalDtQtyFg: string;
                export const CallSetItemFg: string;
                export const CancelFg: string;
                export const CreateBy: string;
                export const CreateDate: string;
                export const DocDate: string;
                export const DocNo: string;
                export const ExpDate: string;
                export const IcStockSetAssembleDtList: string;
                export const Id: string;
                export const LastUpdate: string;
                export const PostDate: string;
                export const PostFg: string;
                export const QtyUse: string;
                export const RefDocNo1: string;
                export const RefDocNo2: string;
                export const Remark: string;
                export const SetItemCode: string;
                export const SetName: string;
                export const SetQty: string;
                export const SysDocNo: string;
                export const UpdateBy: string;
                export const UseFg: string;
                export const WhsItem: string;
                export const WhsSet: string;
            }

            namespace IcStockSetAssembleDt {
                export const CostValue: string;
                export const ExpDate: string;
                export const Id: string;
                export const LineItemNo: string;
                export const PluCode: string;
                export const PluDesc: string;
                export const Qty: string;
                export const QtyUse: string;
                export const Remark: string;
                export const SellUnitRatio: string;
                export const SetItemQty: string;
                export const SetQty: string;
                export const SkuCode: string;
                export const SkuQty: string;
                export const SysDocNo: string;
                export const UnitCost: string;
            }

            namespace IcStockSku {
                export const CreateBy: string;
                export const CreateDate: string;
                export const Id: string;
                export const LastUpdate: string;
                export const QtyOnhand: string;
                export const SkuCode: string;
                export const StockCostValue: string;
                export const UpdateBy: string;
            }

            namespace IcStockSold {
                export const CancelFg: string;
                export const CreateBy: string;
                export const CreateDate: string;
                export const CustName: string;
                export const DocDate: string;
                export const DocNo: string;
                export const Id: string;
                export const LastUpdate: string;
                export const PostFg: string;
                export const RefDocNo1: string;
                export const RefDocNo2: string;
                export const Remark: string;
                export const SoldDtList: string;
                export const StockTo: string;
                export const SysDocNo: string;
                export const UpdateBy: string;
                export const WhsId: string;
                export const WhsName: string;
            }

            namespace IcStockSoldDt {
                export const CostValue: string;
                export const ExpDate: string;
                export const Id: string;
                export const ItemRemark: string;
                export const LineItemNo: string;
                export const PurUnit: string;
                export const PurUnitPrice: string;
                export const PurUnitRatio: string;
                export const Qty: string;
                export const QtyUse: string;
                export const Remark: string;
                export const SkuCode: string;
                export const StkQty: string;
                export const SysDocNo: string;
                export const UnitChange: string;
                export const UnitCost: string;
                export const UseFg: string;
            }

            namespace IcStockTran {
                export const CostValue: string;
                export const CreateBy: string;
                export const CreateDate: string;
                export const DocDate: string;
                export const DocNo: string;
                export const Id: string;
                export const LastUpdate: string;
                export const PostFg: string;
                export const Qty: string;
                export const RefDocNo1: string;
                export const RefDocNo2: string;
                export const SkuCode: string;
                export const SysDocNo: string;
                export const TranDate: string;
                export const TranTime: string;
                export const TranType: string;
                export const TranTypeDesc: string;
                export const UpdateBy: string;
                export const WhsId: string;
            }

            namespace IcStockTransfer {
                export const CancelFg: string;
                export const ConcatRefDocNo2: string;
                export const ConcatWhsIdFm: string;
                export const CreateBy: string;
                export const CreateDate: string;
                export const DocDate: string;
                export const DocNo: string;
                export const Id: string;
                export const LastUpdate: string;
                export const PostFg: string;
                export const RefDocNo1: string;
                export const RefDocNo2: string;
                export const Remark: string;
                export const SysDocNo: string;
                export const TransferDtList: string;
                export const UpdateBy: string;
                export const WhsIdFm: string;
                export const WhsIdTo: string;
            }

            namespace IcStockTransferDt {
                export const CostValue: string;
                export const ExpDate: string;
                export const Id: string;
                export const ItemRemark: string;
                export const LineItemNo: string;
                export const PurUnit: string;
                export const PurUnitPrice: string;
                export const PurUnitRatio: string;
                export const Qty: string;
                export const Remark: string;
                export const SkuCode: string;
                export const SupplItemCode: string;
                export const SysDocNo: string;
                export const UnitChange: string;
                export const UnitCost: string;
            }

            namespace IcStockWhs {
                export const CreateBy: string;
                export const CreateDate: string;
                export const Id: string;
                export const LastUpdate: string;
                export const QtyOnhand: string;
                export const SkuCode: string;
                export const SkuWhsIdCode: string;
                export const StockCostValue: string;
                export const UpdateBy: string;
            }

            namespace IcTranType {
                export const Id: string;
                export const TranTypeDesc: string;
                export const TranTypeNo: string;
            }

            namespace LookupIcGrForTranferLookup {
                export const DocNo: string;
                export const RefDocNo2: string;
                export const SysDocNo: string;
                export const WhsIdFm: string;
            }

            namespace LookupIcGrLookup {
                export const DocNo: string;
                export const StockTo: string;
                export const SysDocNo: string;
            }

            namespace LookupIcSoLookup {
                export const DocNo: string;
                export const StockFrom: string;
                export const SysDocNo: string;
            }
        }

        namespace InventoryReport {

            namespace IcReport01 {
                export const BrandCode: string;
                export const BrandName: string;
                export const CatCode: string;
                export const CatName: string;
                export const ColorId: string;
                export const ColorName: string;
                export const ConsignFg: string;
                export const Id: string;
                export const MatTypeId: string;
                export const MatTypeName: string;
                export const QtyOnHand: string;
                export const SizeId: string;
                export const SizeName: string;
                export const SkuCode: string;
                export const SkuDesc: string;
                export const SkuEnDesc: string;
                export const StkUnit: string;
                export const StockCostValue: string;
                export const StockFg: string;
                export const StyleId: string;
                export const StyleName: string;
                export const SubCat1Code: string;
                export const SubCat1Name: string;
                export const SubCat2Code: string;
                export const SubCat2Name: string;
                export const SupplId: string;
                export const SupplName: string;
                export const TasteId: string;
                export const TasteName: string;
            }

            namespace IcReport01_V {
                export const BrandCode: string;
                export const BrandName: string;
                export const CatCode: string;
                export const CatName: string;
                export const ColorId: string;
                export const ColorName: string;
                export const ConsignFg: string;
                export const Id: string;
                export const MatTypeId: string;
                export const MatTypeName: string;
                export const QtyOnHand: string;
                export const SizeId: string;
                export const SizeName: string;
                export const SkuCode: string;
                export const SkuDesc: string;
                export const SkuEnDesc: string;
                export const StkUnit: string;
                export const StockCostValue: string;
                export const StockFg: string;
                export const StyleId: string;
                export const StyleName: string;
                export const SubCat1Code: string;
                export const SubCat1Name: string;
                export const SubCat2Code: string;
                export const SubCat2Name: string;
                export const SupplId: string;
                export const SupplName: string;
                export const TasteId: string;
                export const TasteName: string;
            }

            namespace IcReport02 {
                export const BrandCode: string;
                export const BrandName: string;
                export const CatCode: string;
                export const CatName: string;
                export const ColorId: string;
                export const ColorName: string;
                export const ConsignFg: string;
                export const Id: string;
                export const MatTypeId: string;
                export const MatTypeName: string;
                export const QtyOnhand: string;
                export const ShopGroupId: string;
                export const ShopId: string;
                export const ShopName: string;
                export const ShopTypeId: string;
                export const SizeId: string;
                export const SizeName: string;
                export const SkuCode: string;
                export const SkuDesc: string;
                export const SkuEnDesc: string;
                export const StkUnit: string;
                export const StockCostValue: string;
                export const StockFg: string;
                export const StyleId: string;
                export const StyleName: string;
                export const SubCat1Code: string;
                export const SubCat1Name: string;
                export const SubCat2Code: string;
                export const SubCat2Name: string;
                export const SupplId: string;
                export const SupplName: string;
                export const TasteId: string;
                export const TasteName: string;
                export const WhsId: string;
                export const WhsName: string;
                export const WhsType: string;
            }

            namespace IcReport02_V {
                export const BrandCode: string;
                export const BrandName: string;
                export const CatCode: string;
                export const CatName: string;
                export const ColorId: string;
                export const ColorName: string;
                export const ConsignFg: string;
                export const Id: string;
                export const MatTypeId: string;
                export const MatTypeName: string;
                export const QtyOnhand: string;
                export const ShopGroupId: string;
                export const ShopId: string;
                export const ShopName: string;
                export const ShopTypeId: string;
                export const SizeId: string;
                export const SizeName: string;
                export const SkuCode: string;
                export const SkuDesc: string;
                export const SkuEnDesc: string;
                export const StkUnit: string;
                export const StockCostValue: string;
                export const StockFg: string;
                export const StyleId: string;
                export const StyleName: string;
                export const SubCat1Code: string;
                export const SubCat1Name: string;
                export const SubCat2Code: string;
                export const SubCat2Name: string;
                export const SupplId: string;
                export const SupplName: string;
                export const TasteId: string;
                export const TasteName: string;
                export const WhsId: string;
                export const WhsName: string;
                export const WhsType: string;
            }

            namespace IcReport04 {
                export const GroupCode: string;
                export const GroupName: string;
                export const Grouptype: string;
                export const Id: string;
                export const QtyOnHand: string;
                export const StockCostValue: string;
            }

            namespace IcReport04_V {
                export const GroupCode: string;
                export const GroupName: string;
                export const Grouptype: string;
                export const Id: string;
                export const QtyOnHand: string;
                export const StockCostValue: string;
            }

            namespace IcReport05 {
                export const BrandCode: string;
                export const BrandName: string;
                export const CatCode: string;
                export const CatName: string;
                export const ColorId: string;
                export const ColorName: string;
                export const ConsignFg: string;
                export const DateMonth: string;
                export const DateYear: string;
                export const EomIn: string;
                export const GroupType: string;
                export const IcAdjIn: string;
                export const IcAdjOut: string;
                export const IcReceive: string;
                export const IcReturnIn: string;
                export const IcReturnOut: string;
                export const IcSold: string;
                export const IcTranIn: string;
                export const IcTranOut: string;
                export const Id: string;
                export const MatTypeId: string;
                export const MatTypeName: string;
                export const ShopGroupId: string;
                export const ShopGroupName: string;
                export const ShopId: string;
                export const ShopName: string;
                export const ShopTypeId: string;
                export const ShopTypeName: string;
                export const SizeId: string;
                export const SizeName: string;
                export const SkuCode: string;
                export const SkuDesc: string;
                export const StockFg: string;
                export const StyleId: string;
                export const StyleName: string;
                export const SubCat1Code: string;
                export const SubCat1Name: string;
                export const SubCat2Code: string;
                export const SubCat2Name: string;
                export const SumOut: string;
                export const SupplId: string;
                export const SupplName: string;
                export const TasteId: string;
                export const TasteName: string;
                export const WhsId: string;
                export const WhsName: string;
                export const WhsType: string;
            }

            namespace IcReport05All {
                export const BrandCode: string;
                export const BrandName: string;
                export const CatCode: string;
                export const CatName: string;
                export const ColorId: string;
                export const ColorName: string;
                export const ConsignFg: string;
                export const DateMonth: string;
                export const DateYear: string;
                export const EomIn: string;
                export const GroupType: string;
                export const IcAdjIn: string;
                export const IcAdjOut: string;
                export const IcReceive: string;
                export const IcReturnIn: string;
                export const IcReturnOut: string;
                export const IcSold: string;
                export const Id: string;
                export const MatTypeId: string;
                export const MatTypeName: string;
                export const SizeId: string;
                export const SizeName: string;
                export const SkuCode: string;
                export const SkuDesc: string;
                export const StockFg: string;
                export const StyleId: string;
                export const StyleName: string;
                export const SubCat1Code: string;
                export const SubCat1Name: string;
                export const SubCat2Code: string;
                export const SubCat2Name: string;
                export const SumOut: string;
                export const SupplId: string;
                export const SupplName: string;
                export const TasteId: string;
                export const TasteName: string;
            }

            namespace IcReport06 {
                export const ArticleSeasonCode: string;
                export const ArticleSeasonName: string;
                export const BrandCode: string;
                export const BrandName: string;
                export const BrandTypeCode: string;
                export const BrandTypeName: string;
                export const CatCode: string;
                export const CatName: string;
                export const ColorId: string;
                export const ColorName: string;
                export const ConceptCode: string;
                export const ConceptName: string;
                export const ConsignFg: string;
                export const Id: string;
                export const MatTypeId: string;
                export const MatTypeName: string;
                export const MaxStockQty: string;
                export const MinStockQty: string;
                export const PurLeadTime: string;
                export const QtyOnhand: string;
                export const ReorderQty: string;
                export const SizeId: string;
                export const SizeName: string;
                export const SkuCode: string;
                export const SkuDesc: string;
                export const SkuEnDesc: string;
                export const StkUnit: string;
                export const StockFg: string;
                export const StyleId: string;
                export const StyleName: string;
                export const SubCat1Code: string;
                export const SubCat1Name: string;
                export const SubCat2Code: string;
                export const SubCat2Name: string;
                export const SupplId: string;
                export const SupplName: string;
                export const TasteId: string;
                export const TasteName: string;
            }

            namespace IcReport07Sku {
                export const CostAdd: string;
                export const CostBalance: string;
                export const CostDel: string;
                export const DocDate: string;
                export const Id: string;
                export const QtyAdd: string;
                export const QtyBalance: string;
                export const QtyDel: string;
                export const RefDocNo1: string;
                export const RowRunNo: string;
                export const SkuCode: string;
                export const SysDocNo: string;
                export const TranDate: string;
                export const TranType: string;
            }

            namespace IcReport07SkuWhs {
                export const CostAdd: string;
                export const CostBalance: string;
                export const CostDel: string;
                export const DocDate: string;
                export const Id: string;
                export const QtyAdd: string;
                export const QtyBalance: string;
                export const QtyDel: string;
                export const RefDocNo1: string;
                export const RowRunNo: string;
                export const ShopId: string;
                export const SkuCode: string;
                export const SysDocNo: string;
                export const TranDate: string;
                export const TranType: string;
                export const WhsId: string;
            }

            namespace IcReport08 {
                export const BrandCode: string;
                export const BrandName: string;
                export const CatCode: string;
                export const CatName: string;
                export const ColorId: string;
                export const ColorName: string;
                export const ConsignFg: string;
                export const Countt: string;
                export const DtList: string;
                export const Id: string;
                export const MatTypeId: string;
                export const MatTypeName: string;
                export const QtyOnhand: string;
                export const SizeId: string;
                export const SizeName: string;
                export const SkuCode: string;
                export const SkuDesc: string;
                export const SkuEnDesc: string;
                export const StyleId: string;
                export const StyleName: string;
                export const SubCat1Code: string;
                export const SubCat1Name: string;
                export const SubCat2Code: string;
                export const SubCat2Name: string;
                export const SupplId: string;
                export const SupplName: string;
                export const TasteId: string;
                export const TasteName: string;
            }

            namespace IcReport08Dt {
                export const CreateBy: string;
                export const CreateDate: string;
                export const Id: string;
                export const LotNo: string;
                export const SerailNo: string;
                export const ShopGroupId: string;
                export const ShopId: string;
                export const ShopName: string;
                export const ShopTypeId: string;
                export const SkuCode: string;
                export const Status: string;
                export const WhsId: string;
                export const WhsName: string;
                export const WhsType: string;
            }

            namespace IcReportEom {
                export const BrandCode: string;
                export const BrandName: string;
                export const CatCode: string;
                export const CatName: string;
                export const ColorId: string;
                export const ColorName: string;
                export const ConsignFg: string;
                export const CostOnhand: string;
                export const DateMonth: string;
                export const DateYear: string;
                export const DtList: string;
                export const EndDate: string;
                export const Id: string;
                export const MatTypeId: string;
                export const MatTypeName: string;
                export const QtyOnhand: string;
                export const SizeId: string;
                export const SizeName: string;
                export const SkuCode: string;
                export const SkuDesc: string;
                export const SkuEnDesc: string;
                export const StyleId: string;
                export const StyleName: string;
                export const SubCat1Code: string;
                export const SubCat1Name: string;
                export const SubCat2Code: string;
                export const SubCat2Name: string;
                export const SupplId: string;
                export const SupplName: string;
                export const TasteId: string;
                export const TasteName: string;
            }

            namespace IcReportWhsEom {
                export const CostOnhand: string;
                export const EndDate: string;
                export const Id: string;
                export const QtyOnhand: string;
                export const ShopGroupId: string;
                export const ShopId: string;
                export const ShopName: string;
                export const ShopTypeId: string;
                export const SkuCode: string;
                export const WhsId: string;
                export const WhsName: string;
                export const WhsType: string;
            }
        }

        namespace LogManage {

            namespace LogApiPath {
                export const ApiDesc: string;
                export const ApiPath: string;
                export const CreatedBy: string;
                export const CreatedDate: string;
                export const Id: string;
                export const Paramiter: string;
                export const Path: string;
                export const UpdateBy: string;
                export const UpdateDate: string;
            }

            namespace LogJson {
                export const ApiPath: string;
                export const CreatedBy: string;
                export const CreatedDate: string;
                export const Id: string;
                export const LogData: string;
                export const LogMessage: string;
                export const LogType: string;
            }

            namespace LogRefund {
                export const Cashier: string;
                export const CheckDoc: string;
                export const CreateDate: string;
                export const DocNo: string;
                export const FlagReceipt: string;
                export const Id: string;
                export const PosId: string;
                export const RefDocNo: string;
                export const ShiftId: string;
                export const ShopId: string;
            }

            namespace LogUserLockErrorPassword {
                export const DisplayName: string;
                export const Email: string;
                export const ShopId: string;
                export const UserErrorStampFg: string;
                export const UserId: string;
                export const Username: string;
            }

            namespace LogUserPasswordChangeDate {
                export const DisplayName: string;
                export const Email: string;
                export const PasswordChangeDate: string;
                export const ShopId: string;
                export const UserId: string;
                export const Username: string;
            }
        }

        namespace Lookups {

            namespace CusImportOrLocal {
                export const CusImportOrLocal: string;
                export const LookupName: string;
            }

            namespace CusProductSalesBeforeFlag {
                export const CusProductSalesBeforeFlag: string;
                export const LookupName: string;
            }

            namespace CusProductSalesBeforeReferFlag {
                export const CusProductSalesBeforeReferFlag: string;
                export const LookupName: string;
            }

            namespace CusProductTypeNbp {
                export const CusProductTypeNbp: string;
                export const NbpName: string;
            }

            namespace LookupBgColor {
                export const BgColor: string;
                export const BgColorName: string;
                export const Id: string;
            }

            namespace LookupBrand {
                export const BrandCode: string;
                export const BrandName: string;
                export const CreateBy: string;
                export const CreateDate: string;
                export const Id: string;
                export const LastUpdate: string;
                export const UpdateBy: string;
            }

            namespace LookupCategory {
                export const CatCode: string;
                export const CatName: string;
            }

            namespace LookupIcStockSetAssemblePostedunuse {
                export const Name: string;
                export const SysDocNo: string;
            }

            namespace LookupPostranHd {
                export const AllItemCharge: string;
                export const AllItemDiscount: string;
                export const BillCharge: string;
                export const BillDiscount: string;
                export const CashierId: string;
                export const CreateBy: string;
                export const CreateDate: string;
                export const DocAmt: string;
                export const DocDate: string;
                export const DocNo: string;
                export const DocTime: string;
                export const Factor: string;
                export const GrossSales: string;
                export const Id: string;
                export const LastUpdate: string;
                export const MbId: string;
                export const NetSales: string;
                export const NetSalesExVat: string;
                export const NetSalesNonVat: string;
                export const NetSalesNormal: string;
                export const NetSalesPromo: string;
                export const PosId: string;
                export const ReceiveCash: string;
                export const ReceiveCashCd: string;
                export const ReceiveCoupon: string;
                export const ReceiveCreditCd: string;
                export const ReceiveDebitCd: string;
                export const ReceiveOthers: string;
                export const ReceivePoint: string;
                export const RefDocNo: string;
                export const RoundAdjust: string;
                export const SalesVatType: string;
                export const SalesmanId: string;
                export const UpdateBy: string;
                export const Vat: string;
                export const VatOfCharge: string;
                export const VatOfNetSales: string;
            }

            namespace LookupSubCategory1 {
                export const SubCat1Code: string;
                export const SubCat1Name: string;
            }

            namespace LookupSubCategory2 {
                export const SubCat2Code: string;
                export const SubCat2Name: string;
            }

            namespace LookupSupplier {
                export const ConsignFg: string;
                export const ConsignGp: string;
                export const ContactName: string;
                export const CreateBy: string;
                export const CreateDate: string;
                export const Id: string;
                export const LastUpdate: string;
                export const SupplAddress: string;
                export const SupplId: string;
                export const SupplName: string;
                export const SupplRegAddress: string;
                export const SupplRegName: string;
                export const SupplTaxId: string;
                export const SupplType: string;
                export const SupplierShortName: string;
                export const UpdateBy: string;
            }

            namespace LookupTxtColor {
                export const Id: string;
                export const TxtColor: string;
                export const TxtColorName: string;
            }

            namespace PsPosShiftStatus {
                export const FullName: string;
                export const ShiftStatus: string;
                export const ShiftStatusDesc: string;
            }

            namespace SysCountry {
                export const CounShowCode: string;
                export const CounTinent: string;
                export const CountryCode: string;
                export const CountryName: string;
                export const CreateBy: string;
                export const CreateDate: string;
                export const Id: string;
                export const LastUpdate: string;
                export const NationName: string;
                export const UpdateBy: string;
            }

            namespace SysPara {
                export const CreateBy: string;
                export const CreateDate: string;
                export const Id: string;
                export const LastUpdate: string;
                export const SysDesc: string;
                export const SysFg: string;
                export const SysFgDesc: string;
                export const SysGroup: string;
                export const SysName: string;
                export const UpdateBy: string;
            }

            namespace VpoSparam {
                export const AllowSaleOverStock: string;
                export const AutoChargeFg: string;
                export const AutoChargeRate: string;
                export const BizAddressLine1: string;
                export const BizAddressLine2: string;
                export const BizAddressLine3: string;
                export const BizName: string;
                export const BizType: string;
                export const BranchName: string;
                export const CashPayRoundMethod: string;
                export const CashierPosFg: string;
                export const ChargeVatRate: string;
                export const Connect2ndDispFg: string;
                export const ConnectDrawerFg: string;
                export const ConnectEdcFg: string;
                export const ConnectPrinterFg: string;
                export const ConnectRfidReaderFg: string;
                export const ConnectVfdFg: string;
                export const DiscRoundMethod: string;
                export const EjournalFg: string;
                export const Email: string;
                export const FaxId: string;
                export const Id: string;
                export const ItemOnRecptMethod: string;
                export const LastReceiptRunNo: string;
                export const LastRefundRunNo: string;
                export const MandatoryMemberFg: string;
                export const MandatorySalesmanFg: string;
                export const MaxCashInDrawer: string;
                export const MbDiscMethod: string;
                export const NoOfRecptCopy: string;
                export const PointRedeemOneBaht: string;
                export const PosId: string;
                export const PosPermitNo: string;
                export const PosProcessMode: string;
                export const PosScreenType: string;
                export const PosTouchPanelId: string;
                export const PrintOrderFg: string;
                export const PrintQueueFg: string;
                export const PromptPayLink: string;
                export const PsParaDefault1: string;
                export const PsParaDefault2: string;
                export const QrCodeAccount: string;
                export const ReceiptPrinterType: string;
                export const RecptFootMesg1: string;
                export const RecptFootMesg10: string;
                export const RecptFootMesg2: string;
                export const RecptFootMesg3: string;
                export const RecptFootMesg4: string;
                export const RecptFootMesg5: string;
                export const RecptFootMesg6: string;
                export const RecptFootMesg7: string;
                export const RecptFootMesg8: string;
                export const RecptFootMesg9: string;
                export const RecptHeadMesg1: string;
                export const RecptHeadMesg2: string;
                export const RecptHeadMesg3: string;
                export const RecptHeadMesg4: string;
                export const RecptHeadMesg5: string;
                export const RecptHeadMesg6: string;
                export const RecptNoBarcodeFg: string;
                export const RecptSumItemQtyFg: string;
                export const RegId: string;
                export const SalesDocFg: string;
                export const SalesVatType: string;
                export const SelectSellingPriceFg: string;
                export const SellingPriceNo: string;
                export const ShopAddress: string;
                export const ShopGroupId: string;
                export const ShopId: string;
                export const ShopLogoOnFrontScreen: string;
                export const ShopLogoOnReceipt: string;
                export const ShopName: string;
                export const ShopRegAddressLine1: string;
                export const ShopRegAddressLine2: string;
                export const ShopRegAddressLine3: string;
                export const ShopRegId: string;
                export const ShopRegName: string;
                export const ShopTaxId: string;
                export const ShopTypeId: string;
                export const TaxId: string;
                export const TaxInvAddrLine1: string;
                export const TaxInvAddrLine2: string;
                export const TaxInvAddrLine3: string;
                export const TaxInvName: string;
                export const TelId: string;
                export const VatFg: string;
                export const WeightBarcodePrefix: string;
                export const WhsId: string;
            }

            namespace VpsPaymenType {
                export const Code: string;
                export const Detail: string;
                export const Name: string;
                export const Paytype: string;
                export const Pcamt: string;
                export const Pcpc: string;
                export const Value: string;
                export const Valuetype: string;
            }

            namespace VwApprovalGroup {
                export const ApprGroupCode: string;
                export const ApprGroupName: string;
                export const CreateBy: string;
                export const CreateDate: string;
                export const Id: string;
                export const LastUpdate: string;
                export const UpdateBy: string;
            }

            namespace VwArticle {
                export const ArticleSeasonCode: string;
                export const ArticleSeasonName: string;
                export const CreateBy: string;
                export const CreateDate: string;
                export const FullName: string;
                export const Id: string;
                export const LastUpdate: string;
                export const UpdateBy: string;
            }

            namespace VwBrandType {
                export const BrandTypeCode: string;
                export const BrandTypeName: string;
                export const CreateBy: string;
                export const CreateDate: string;
                export const FullName: string;
                export const Id: string;
                export const IsActive: string;
                export const LastUpdate: string;
                export const UpdateBy: string;
            }

            namespace VwCashier {
                export const CashierId: string;
                export const CashierName: string;
                export const FullName: string;
                export const Id: string;
            }

            namespace VwConcept {
                export const ConceptCode: string;
                export const ConceptName: string;
                export const CreateBy: string;
                export const CreateDate: string;
                export const FullName: string;
                export const Id: string;
                export const IsActive: string;
                export const LastUpdate: string;
                export const UpdateBy: string;
            }

            namespace VwDashboardPage {
                export const DayCount: string;
                export const DaynNetSale: string;
                export const LowStock: string;
                export const MonthCount: string;
                export const MonthNetSale: string;
                export const ShopId: string;
                export const SlowMoveAll: string;
            }

            namespace VwIcWhs {
                export const CreateBy: string;
                export const CreateDate: string;
                export const Id: string;
                export const LastUpdate: string;
                export const NameProperty: string;
                export const ShopId: string;
                export const UpdateBy: string;
                export const WhsId: string;
                export const WhsName: string;
                export const WhsType: string;
            }

            namespace VwPluLookupSetItem {
                export const PluCode: string;
                export const PluDesc: string;
                export const PluFullCode: string;
                export const PluShortDesc: string;
                export const SellUnit: string;
                export const SellUnitPrice1: string;
            }

            namespace VwPosFunc {
                export const FullName: string;
                export const FunLevel: string;
                export const FuncDesc: string;
                export const FuncId: string;
                export const FuncUsage: string;
                export const Id: string;
            }

            namespace VwPosStation {
                export const AutoChargeFg: string;
                export const AutoChargeRate: string;
                export const CashierPosFg: string;
                export const Connect2ndDispFg: string;
                export const ConnectDrawerFg: string;
                export const ConnectEdcFg: string;
                export const ConnectEdcPort: string;
                export const ConnectPrinterFg: string;
                export const ConnectRfidReaderFg: string;
                export const ConnectVfdFg: string;
                export const CreateBy: string;
                export const CreateDate: string;
                export const EdcBank: string;
                export const EjournalFg: string;
                export const Id: string;
                export const ItemOnRecptMethod: string;
                export const LastReceiptRunNo: string;
                export const LastRefundRunNo: string;
                export const LastUpdate: string;
                export const MandatoryMemberFg: string;
                export const MandatorySalesmanFg: string;
                export const MaxCashInDrawer: string;
                export const NoOfRecptCopy: string;
                export const PosId: string;
                export const PosPermitNo: string;
                export const PosScreenType: string;
                export const PosTouchPanelId: string;
                export const PrintOrderFg: string;
                export const PrintQueueFg: string;
                export const PromptPayLink: string;
                export const PsParaDefault1: string;
                export const PsParaDefault2: string;
                export const QrCodeAccount: string;
                export const ReceiptPrinterType: string;
                export const RecptFootMesg1: string;
                export const RecptFootMesg10: string;
                export const RecptFootMesg2: string;
                export const RecptFootMesg3: string;
                export const RecptFootMesg4: string;
                export const RecptFootMesg5: string;
                export const RecptFootMesg6: string;
                export const RecptFootMesg7: string;
                export const RecptFootMesg8: string;
                export const RecptFootMesg9: string;
                export const RecptFootMesgFontSize: string;
                export const RecptFootMesgTextAlign: string;
                export const RecptHeadMesg1: string;
                export const RecptHeadMesg2: string;
                export const RecptHeadMesg3: string;
                export const RecptHeadMesg4: string;
                export const RecptHeadMesg5: string;
                export const RecptHeadMesg6: string;
                export const RecptHeadMesgFontSize: string;
                export const RecptHeadMesgTextAlign: string;
                export const RecptNoBarcodeFg: string;
                export const RecptSumItemQtyFg: string;
                export const SalesDocFg: string;
                export const SalesVatType: string;
                export const SelectSellingPriceFg: string;
                export const SellingPriceNo: string;
                export const ShopId: string;
                export const ShopLogoOnFrontScreen: string;
                export const ShopLogoOnReceipt: string;
                export const UpdateBy: string;
                export const WhsId: string;
            }

            namespace VwPsPara {
                export const AllowSaleOverStock: string;
                export const BackOfficeUpLoadUrl: string;
                export const BranchName: string;
                export const CashPayRoundMethod: string;
                export const ChargeVatRate: string;
                export const CreateBy: string;
                export const CreateDate: string;
                export const DiscRoundMethod: string;
                export const EjournalFg: string;
                export const Id: string;
                export const ItemOnRecptMethod: string;
                export const LastUpdate: string;
                export const MbDiscMethod: string;
                export const NoOfRecptCopy: string;
                export const PointRedeemOneBaht: string;
                export const PosProcessMode: string;
                export const PosScreenType: string;
                export const PrintOrderFg: string;
                export const PrintQueueFg: string;
                export const PromptPayLink: string;
                export const PsParaDefault1: string;
                export const PsParaDefault2: string;
                export const QrCodeAccount: string;
                export const ReceiptPrinterType: string;
                export const RecptFootMesg1: string;
                export const RecptFootMesg10: string;
                export const RecptFootMesg2: string;
                export const RecptFootMesg3: string;
                export const RecptFootMesg4: string;
                export const RecptFootMesg5: string;
                export const RecptFootMesg6: string;
                export const RecptFootMesg7: string;
                export const RecptFootMesg8: string;
                export const RecptFootMesg9: string;
                export const RecptFootMesgFontSize: string;
                export const RecptFootMesgTextAlign: string;
                export const RecptHeadMesg1: string;
                export const RecptHeadMesg2: string;
                export const RecptHeadMesg3: string;
                export const RecptHeadMesg4: string;
                export const RecptHeadMesg5: string;
                export const RecptHeadMesg6: string;
                export const RecptHeadMesgFontSize: string;
                export const RecptHeadMesgTextAlign: string;
                export const RecptNoBarcodeFg: string;
                export const RecptSumItemQtyFg: string;
                export const SalesDocFg: string;
                export const SalesVatType: string;
                export const SelectSellingPriceFg: string;
                export const ShopAddress: string;
                export const ShopLogoOnFrontScreen: string;
                export const ShopLogoOnReceipt: string;
                export const ShopName: string;
                export const ShopRegAddressLine1: string;
                export const ShopRegAddressLine2: string;
                export const ShopRegAddressLine3: string;
                export const ShopRegId: string;
                export const ShopRegName: string;
                export const ShopTaxId: string;
                export const TaxInvoiceDateFg: string;
                export const UpdateBy: string;
                export const WeightBarcodePrefix: string;
            }

            namespace VwSkuLookupPurchase {
                export const ConsignFg: string;
                export const ConsignGp: string;
                export const FullName: string;
                export const LastPurPrice: string;
                export const MaxOrderQty: string;
                export const MinOrderQty: string;
                export const PurUnit: string;
                export const PurUnitPrice: string;
                export const PurUnitRatio: string;
                export const SkuCode: string;
                export const SkuDesc: string;
                export const StkUnit: string;
                export const SupplierId: string;
            }

            namespace VwSupplItem {
                export const SupplItemCode: string;
            }

            namespace VwUser {
                export const DisplayName: string;
                export const ShopId: string;
                export const UserId: string;
                export const Username: string;
            }

            namespace VwUsername {
                export const CheckPasswordUpdate: string;
                export const DisplayName: string;
                export const Email: string;
                export const InsertDate: string;
                export const InsertUserId: string;
                export const IsActive: string;
                export const LastDirectoryUpdate: string;
                export const MobilePhoneNumber: string;
                export const MobilePhoneVerified: string;
                export const PasswordChangeDate: string;
                export const PasswordHash: string;
                export const PasswordSalt: string;
                export const ShopId: string;
                export const Source: string;
                export const SupplCode: string;
                export const TwoFactorAuth: string;
                export const UpdateDate: string;
                export const UpdateUserId: string;
                export const UserActive: string;
                export const UserErrorStampFg: string;
                export const UserId: string;
                export const UserImage: string;
                export const Username: string;
            }

            namespace VwcsPara {
                export const BizAddressLine1: string;
                export const BizAddressLine2: string;
                export const BizAddressLine3: string;
                export const BizName: string;
                export const BizNameEn: string;
                export const BizType: string;
                export const BranchNameDesc: string;
                export const BranchNameDescEn: string;
                export const BranchNo: string;
                export const BuildingName: string;
                export const BuildingNameEn: string;
                export const BuildingNo: string;
                export const BuildingNoEn: string;
                export const City: string;
                export const CityEn: string;
                export const CountryCode: string;
                export const CreateBy: string;
                export const CreateDate: string;
                export const District: string;
                export const DistrictEn: string;
                export const Email: string;
                export const ErpCompCode: string;
                export const FaxId: string;
                export const Id: string;
                export const LastUpdate: string;
                export const PostalCode: string;
                export const Province: string;
                export const ProvinceEn: string;
                export const RegId: string;
                export const SlowMoveItenDate: string;
                export const StreetName: string;
                export const StreetNameEn: string;
                export const TaxId: string;
                export const TaxInvAddrLine1: string;
                export const TaxInvAddrLine2: string;
                export const TaxInvAddrLine3: string;
                export const TaxInvName: string;
                export const TelId: string;
                export const UpdateBy: string;
                export const VatFg: string;
            }

            namespace VwpsShop {
                export const BranchName: string;
                export const BranchNameDesc: string;
                export const BranchNameDescEn: string;
                export const BranchNameEn: string;
                export const BranchTaxCode: string;
                export const CreateBy: string;
                export const CreateDate: string;
                export const Email: string;
                export const ErpChannel: string;
                export const ErpStore: string;
                export const Id: string;
                export const LastUpdate: string;
                export const PromptPayLink: string;
                export const QrCodeAccount: string;
                export const ShopAddress: string;
                export const ShopAddressEn: string;
                export const ShopBuildingName: string;
                export const ShopBuildingNameEn: string;
                export const ShopBuildingNo: string;
                export const ShopBuildingNoEn: string;
                export const ShopCity: string;
                export const ShopCityEn: string;
                export const ShopCountryCode: string;
                export const ShopDistrict: string;
                export const ShopDistrictEn: string;
                export const ShopFullName: string;
                export const ShopGroupId: string;
                export const ShopId: string;
                export const ShopName: string;
                export const ShopNameEn: string;
                export const ShopPostalCode: string;
                export const ShopProvince: string;
                export const ShopProvinceEn: string;
                export const ShopRegAddressLine1: string;
                export const ShopRegAddressLine2: string;
                export const ShopRegAddressLine3: string;
                export const ShopRegId: string;
                export const ShopRegName: string;
                export const ShopStreetName: string;
                export const ShopStreetNameEn: string;
                export const ShopTaxId: string;
                export const ShopTypeId: string;
                export const TelId: string;
                export const UpdateBy: string;
            }

            namespace VwpsShopGroup {
                export const CreateBy: string;
                export const CreateDate: string;
                export const Id: string;
                export const LastUpdate: string;
                export const ShopGroupId: string;
                export const ShopGroupName: string;
                export const UpdateBy: string;
            }

            namespace VwpsShopType {
                export const CreateBy: string;
                export const CreateDate: string;
                export const Id: string;
                export const LastUpdate: string;
                export const ShopTypeId: string;
                export const ShopTypeName: string;
                export const UpdateBy: string;
            }
        }

        namespace Member {

            namespace LookupMember {
                export const ApplyShopId: string;
                export const CreateBy: string;
                export const CreateDate: string;
                export const Id: string;
                export const LastUpdate: string;
                export const MbAccumPoint: string;
                export const MbAddress: string;
                export const MbAmphur: string;
                export const MbApplyDate: string;
                export const MbBirthDay: string;
                export const MbCardStatus: string;
                export const MbCardType: string;
                export const MbEmail: string;
                export const MbExpireDate: string;
                export const MbExpirePointDate: string;
                export const MbGender: string;
                export const MbId: string;
                export const MbLineAddr1: string;
                export const MbLineAddr2: string;
                export const MbLineAddr3: string;
                export const MbMemo: string;
                export const MbNameE: string;
                export const MbNameT: string;
                export const MbNation: string;
                export const MbNearlyExpirePoint: string;
                export const MbOccupation: string;
                export const MbPhoto: string;
                export const MbPid: string;
                export const MbProvince: string;
                export const MbRace: string;
                export const MbTelNo: string;
                export const MbTumbol: string;
                export const MbType: string;
                export const MbZipCode: string;
                export const UpdateBy: string;
            }

            namespace MbAmphurLookup {
                export const MbAmphur: string;
                export const MbProvince: string;
                export const MbTumbol: string;
            }

            namespace MbProvinceLookup {
                export const MbAmphur: string;
                export const MbProvince: string;
                export const MbTumbol: string;
            }

            namespace MbReport01 {
                export const AllItemCharge: string;
                export const AllItemDiscount: string;
                export const DtList: string;
                export const GrossSales: string;
                export const Id: string;
                export const MbAccumPoint: string;
                export const MbAddress: string;
                export const MbAmphur: string;
                export const MbBirthDay: string;
                export const MbCardStatus: string;
                export const MbGender: string;
                export const MbId: string;
                export const MbMemo: string;
                export const MbNameE: string;
                export const MbNameT: string;
                export const MbNation: string;
                export const MbOccupation: string;
                export const MbProvince: string;
                export const MbRace: string;
                export const MbTumbol: string;
                export const MbType: string;
                export const MbZipCode: string;
                export const MemberTypeDesc: string;
                export const NetSales: string;
                export const NetSalesExVat: string;
                export const PluDtList: string;
                export const VatOfCharge: string;
                export const VatOfNetSales: string;
            }

            namespace MbReport01_Dt {
                export const AllItemCharge: string;
                export const AllItemDiscount: string;
                export const DocDate: string;
                export const DocNo: string;
                export const GrossSales: string;
                export const Id: string;
                export const MbId: string;
                export const NetSales: string;
                export const NetSalesExVat: string;
                export const PluDtList: string;
                export const ReCash: string;
                export const ReCashCard: string;
                export const ReCoupon: string;
                export const ReCreditCd: string;
                export const ReCurrency: string;
                export const ReDebitCd: string;
                export const ReOther: string;
                export const RePoint: string;
                export const ReQr: string;
                export const ShopId: string;
                export const ShopName: string;
                export const VatOfCharge: string;
                export const VatOfNetSales: string;
            }

            namespace MbReport02_ {
                export const LastUpdate: string;
                export const MbAccumPoint: string;
                export const MbAddress: string;
                export const MbAmphur: string;
                export const MbApplyDate: string;
                export const MbBirthDay: string;
                export const MbCardStatus: string;
                export const MbCardType: string;
                export const MbEmail: string;
                export const MbExpireDate: string;
                export const MbExpirePointDate: string;
                export const MbGender: string;
                export const MbId: string;
                export const MbMemo: string;
                export const MbNameE: string;
                export const MbNameT: string;
                export const MbNation: string;
                export const MbNearlyExpirePoint: string;
                export const MbOccupation: string;
                export const MbPhoto: string;
                export const MbPid: string;
                export const MbProvince: string;
                export const MbRace: string;
                export const MbTelNo: string;
                export const MbTumbol: string;
                export const MbType: string;
                export const MbZipCode: string;
                export const UpdateBy: string;
            }

            namespace MbReportSaleByDate {
                export const AllItemCharge: string;
                export const AllItemDiscount: string;
                export const CountDocNo: string;
                export const DocDate: string;
                export const GrossSales: string;
                export const Id: string;
                export const MbAccumPoint: string;
                export const MbAddress: string;
                export const MbAmphur: string;
                export const MbBirthDay: string;
                export const MbCardStatus: string;
                export const MbGender: string;
                export const MbId: string;
                export const MbMemo: string;
                export const MbNameE: string;
                export const MbNameT: string;
                export const MbNation: string;
                export const MbOccupation: string;
                export const MbProvince: string;
                export const MbRace: string;
                export const MbTumbol: string;
                export const MbType: string;
                export const MbZipCode: string;
                export const MemberTypeDesc: string;
                export const NetSales: string;
                export const NetSalesExVat: string;
                export const VatOfCharge: string;
                export const VatOfNetSales: string;
            }

            namespace MbReport_01_Dt_ {
                export const AllocatedBillDiscount: string;
                export const ChargeAmt: string;
                export const ChargePc: string;
                export const CreateBy: string;
                export const CreateDate: string;
                export const DiscCouponNo: string;
                export const DiscCouponType: string;
                export const DiscPc: string;
                export const Discamt: string;
                export const DocNo: string;
                export const ExPrice: string;
                export const Id: string;
                export const ItemCharge: string;
                export const ItemDesc: string;
                export const ItemDiscount: string;
                export const ItemNetExprice: string;
                export const ItemNetSales: string;
                export const ItemPromoFg: string;
                export const ItemPromoId: string;
                export const ItemVat: string;
                export const ItemVatRate: string;
                export const ItemVatType: string;
                export const LastUpdate: string;
                export const LineItemNo: string;
                export const LineItemType: string;
                export const PluCode: string;
                export const PosFg: string;
                export const PromoId: string;
                export const Qty: string;
                export const QtyRefund: string;
                export const RefLineItemNo: string;
                export const SellUnit: string;
                export const SerialNo: string;
                export const UnitPrice: string;
                export const UpdateBy: string;
            }

            namespace MbReport_01_Dt_Plu {
                export const AllItemDiscount: string;
                export const DocDate: string;
                export const DocNo: string;
                export const DtList: string;
                export const GrossSales: string;
                export const Id: string;
                export const MbId: string;
                export const NetSales: string;
                export const NetSalesExVat: string;
                export const PluCode: string;
                export const PluDesc: string;
                export const Qty: string;
                export const ShopId: string;
                export const ShopName: string;
                export const VatOfNetSales: string;
            }

            namespace MbTumbolLookup {
                export const MbAmphur: string;
                export const MbProvince: string;
                export const MbTumbol: string;
            }

            namespace PsMeberStatus {
                export const Id: string;
                export const MbCardStatuName: string;
                export const MbCardStatus: string;
            }

            namespace PsMember {
                export const ApplyShopId: string;
                export const CreateBy: string;
                export const CreateDate: string;
                export const FullNameMb: string;
                export const Id: string;
                export const LastUpdate: string;
                export const MbAccumPoint: string;
                export const MbAddress: string;
                export const MbAmphur: string;
                export const MbApplyDate: string;
                export const MbBirthDay: string;
                export const MbCardStatus: string;
                export const MbCardType: string;
                export const MbEmail: string;
                export const MbExpireDate: string;
                export const MbExpirePointDate: string;
                export const MbGender: string;
                export const MbId: string;
                export const MbLineAddr1: string;
                export const MbLineAddr2: string;
                export const MbLineAddr3: string;
                export const MbMemo: string;
                export const MbNameE: string;
                export const MbNameT: string;
                export const MbNation: string;
                export const MbNearlyExpirePoint: string;
                export const MbOccupation: string;
                export const MbPhoto: string;
                export const MbPid: string;
                export const MbProvince: string;
                export const MbRace: string;
                export const MbTelNo: string;
                export const MbTumbol: string;
                export const MbType: string;
                export const MbZipCode: string;
                export const UpdateBy: string;
            }

            namespace PsMemberGender {
                export const Id: string;
                export const MbGender: string;
                export const MbGenderName: string;
            }

            namespace PsMemberType {
                export const CreateBy: string;
                export const CreateDate: string;
                export const Id: string;
                export const LastUpdate: string;
                export const MbDiscPs: string;
                export const MbPriceFg: string;
                export const MemberType: string;
                export const MemberTypeDesc: string;
                export const SellUnitPriceNo: string;
                export const UpdateBy: string;
            }

            namespace ReportMemberCondition {
                export const CreateBy: string;
                export const CreateDate: string;
                export const FullNameMb: string;
                export const Id: string;
                export const LastUpdate: string;
                export const MbAccumPoint: string;
                export const MbAddress: string;
                export const MbAmphur: string;
                export const MbApplyDate: string;
                export const MbBirthDay: string;
                export const MbCardStatus: string;
                export const MbCardType: string;
                export const MbEmail: string;
                export const MbExpireDate: string;
                export const MbExpirePointDate: string;
                export const MbGender: string;
                export const MbId: string;
                export const MbLineAddr1: string;
                export const MbLineAddr2: string;
                export const MbLineAddr3: string;
                export const MbMemo: string;
                export const MbNameE: string;
                export const MbNameT: string;
                export const MbNation: string;
                export const MbNearlyExpirePoint: string;
                export const MbOccupation: string;
                export const MbPhoto: string;
                export const MbPid: string;
                export const MbProvince: string;
                export const MbRace: string;
                export const MbTelNo: string;
                export const MbTumbol: string;
                export const MbType: string;
                export const MbZipCode: string;
                export const UpdateBy: string;
            }
        }

        namespace Points {

            namespace MemberType {
                export const CreateBy: string;
                export const CreateDate: string;
                export const DtList: string;
                export const Id: string;
                export const LastUpdate: string;
                export const MbDiscPs: string;
                export const MbPriceFg: string;
                export const MemberType: string;
                export const MemberTypeDesc: string;
                export const SellUnitPriceNo: string;
                export const UpdateBy: string;
            }

            namespace PrPointCampaign {
                export const CreateBy: string;
                export const CreateDate: string;
                export const DowId: string;
                export const DowName: string;
                export const Id: string;
                export const LastUpdate: string;
                export const MemberType: string;
                export const OnePointbyAmt: string;
                export const PointRedeemOneBaht: string;
                export const UpdateBy: string;
            }

            namespace PrPointRedeemItem {
                export const CreateBy: string;
                export const CreateDate: string;
                export const EndDate: string;
                export const Id: string;
                export const LastUpdate: string;
                export const NoOfPoint: string;
                export const PluCode: string;
                export const PluName: string;
                export const StartDate: string;
                export const UpdateBy: string;
            }
        }

        namespace PosShift {

            namespace LogFuctionLvApp {
                export const AppCashier: string;
                export const AppCashierLv: string;
                export const CashierLv: string;
                export const CreateBy: string;
                export const CreateDate: string;
                export const FuncId: string;
                export const Id: string;
                export const LastUpdate: string;
                export const PosId: string;
                export const Remark: string;
                export const ShiftId: string;
                export const UnlockFor: string;
                export const UpdateBy: string;
            }

            namespace LookupLastPassportDataforVatRefund {
                export const Addressno: string;
                export const City: string;
                export const Country: string;
                export const District: string;
                export const Email: string;
                export const FristName: string;
                export const LastName: string;
                export const Nation: string;
                export const Passport: string;
                export const Province: string;
                export const Street: string;
                export const ZipCode: string;
            }

            namespace LookupPostrandtsale {
                export const AllocatedBillDiscount: string;
                export const AllocatedBillDiscountVat: string;
                export const BasePrice: string;
                export const ChargeAmt: string;
                export const ChargePc: string;
                export const CreateBy: string;
                export const CreateDate: string;
                export const DiscCouponNo: string;
                export const DiscCouponType: string;
                export const DiscPc: string;
                export const Discamt: string;
                export const DocNo: string;
                export const ErpAutoGenStamp: string;
                export const ExPrice: string;
                export const GpPc: string;
                export const Id: string;
                export const ItemCharge: string;
                export const ItemDesc: string;
                export const ItemDiscount: string;
                export const ItemNetExprice: string;
                export const ItemNetSales: string;
                export const ItemPromoFg: string;
                export const ItemPromoId: string;
                export const ItemVat: string;
                export const ItemVatRate: string;
                export const ItemVatType: string;
                export const LastUpdate: string;
                export const LineItemNo: string;
                export const LineItemType: string;
                export const PluCode: string;
                export const PosFg: string;
                export const PromoId: string;
                export const Qty: string;
                export const QtyRefund: string;
                export const RefLineItemNo: string;
                export const SerialNo: string;
                export const UnitPrice: string;
                export const UpdateBy: string;
                export const VenderSharing: string;
            }

            namespace LookupPostranhdrefundtax {
                export const AllItemCharge: string;
                export const AllItemDiscount: string;
                export const BillCharge: string;
                export const BillDiscount: string;
                export const CashierId: string;
                export const CreateBy: string;
                export const CreateDate: string;
                export const DocAmt: string;
                export const DocDate: string;
                export const DocNo: string;
                export const DocTime: string;
                export const DpType: string;
                export const ErpAutoGenStamp: string;
                export const Factor: string;
                export const GrossSales: string;
                export const Id: string;
                export const LastUpdate: string;
                export const MbId: string;
                export const NetSales: string;
                export const NetSalesExVat: string;
                export const NetSalesNonVat: string;
                export const NetSalesNormal: string;
                export const NetSalesPromo: string;
                export const PosId: string;
                export const PostFg: string;
                export const ReceiveCash: string;
                export const ReceiveCashCd: string;
                export const ReceiveCoupon: string;
                export const ReceiveCreditCd: string;
                export const ReceiveDebitCd: string;
                export const ReceiveOthers: string;
                export const ReceivePoint: string;
                export const RefDocNo: string;
                export const RefundFg: string;
                export const RoundAdjust: string;
                export const SalesVatType: string;
                export const SalesmanId: string;
                export const ShopId: string;
                export const UpdateBy: string;
                export const Vat: string;
                export const VatOfCharge: string;
                export const VatOfNetSales: string;
            }

            namespace LookupPostranhdsale {
                export const CashierId: string;
                export const DocDate: string;
                export const DocNo: string;
                export const DocTime: string;
                export const Factor: string;
                export const Id: string;
                export const MbId: string;
                export const PosId: string;
                export const RefDocNo: string;
                export const SalesVatType: string;
                export const SalesmanId: string;
                export const ShopId: string;
            }

            namespace LookupRecieptforVatRefund {
                export const DocNo: string;
                export const PropertyName: string;
                export const ShopId: string;
            }

            namespace LookupTaxInvoiceforVatRefund {
                export const DocNo: string;
                export const PropertyName: string;
                export const RefDocNo: string;
                export const ShopId: string;
            }

            namespace PaymentType {
                export const CreateBy: string;
                export const CreateDate: string;
                export const Id: string;
                export const LastUpdate: string;
                export const PaymentName: string;
                export const PaymentType: string;
                export const UpdateBy: string;
            }

            namespace PosTranDisc {
                export const ChargeAmt: string;
                export const ChargePc: string;
                export const CreateBy: string;
                export const CreateDate: string;
                export const DiscCouponNo: string;
                export const DiscCouponType: string;
                export const DiscPc: string;
                export const Discamt: string;
                export const DocNo: string;
                export const Id: string;
                export const LastUpdate: string;
                export const LineItemNo: string;
                export const LineItemType: string;
                export const PromoId: string;
                export const UpdateBy: string;
            }

            namespace PosTranDt {
                export const AllocatedBillDiscount: string;
                export const AllocatedBillDiscountVat: string;
                export const ChargeAmt: string;
                export const ChargePc: string;
                export const CreateBy: string;
                export const CreateDate: string;
                export const DiscCouponNo: string;
                export const DiscCouponType: string;
                export const DiscPc: string;
                export const Discamt: string;
                export const DocNo: string;
                export const ExPrice: string;
                export const GpPc: string;
                export const Id: string;
                export const ItemCharge: string;
                export const ItemDesc: string;
                export const ItemDiscount: string;
                export const ItemNetExprice: string;
                export const ItemNetSales: string;
                export const ItemPromoFg: string;
                export const ItemPromoId: string;
                export const ItemVat: string;
                export const ItemVatRate: string;
                export const ItemVatType: string;
                export const LastUpdate: string;
                export const LineItemNo: string;
                export const LineItemType: string;
                export const PluCode: string;
                export const PosFg: string;
                export const PromoId: string;
                export const Qty: string;
                export const QtyRefund: string;
                export const RefLineItemNo: string;
                export const SerialNo: string;
                export const UnitPrice: string;
                export const UpdateBy: string;
                export const VenderSharing: string;
            }

            namespace PosTranHd {
                export const AllItemCharge: string;
                export const AllItemDiscount: string;
                export const BillCharge: string;
                export const BillDiscount: string;
                export const CashierId: string;
                export const CreateBy: string;
                export const CreateDate: string;
                export const DocAmt: string;
                export const DocDate: string;
                export const DocNo: string;
                export const DocTime: string;
                export const Factor: string;
                export const GrossSales: string;
                export const Id: string;
                export const LastUpdate: string;
                export const MbId: string;
                export const NetSales: string;
                export const NetSalesExVat: string;
                export const NetSalesNonVat: string;
                export const NetSalesNormal: string;
                export const NetSalesPromo: string;
                export const PosId: string;
                export const PostFg: string;
                export const ReceiveCash: string;
                export const ReceiveCashCd: string;
                export const ReceiveCoupon: string;
                export const ReceiveCreditCd: string;
                export const ReceiveDebitCd: string;
                export const ReceiveOthers: string;
                export const ReceivePoint: string;
                export const RefDocNo: string;
                export const RefundFg: string;
                export const RefundId: string;
                export const RoundAdjust: string;
                export const SalesVatType: string;
                export const SalesmanId: string;
                export const ShopId: string;
                export const UpdateBy: string;
                export const Vat: string;
                export const VatOfCharge: string;
                export const VatOfNetSales: string;
            }

            namespace PosTranRecv {
                export const CreateBy: string;
                export const CreateDate: string;
                export const CurrencyAmt: string;
                export const CurrencyCode: string;
                export const DocNo: string;
                export const ExchangeRate: string;
                export const Id: string;
                export const LastUpdate: string;
                export const LineItemNo: string;
                export const LineItemType: string;
                export const PaymentType: string;
                export const PointBurn: string;
                export const ReceiptAmt: string;
                export const RefNo: string;
                export const RefType: string;
                export const UpdateBy: string;
            }

            namespace PsEndDayCashier {
                export const Amt: string;
                export const CashBag: string;
                export const CashierId: string;
                export const CreateDate: string;
                export const EndCountId: string;
                export const EndShift: string;
                export const Id: string;
                export const ShopId: string;
                export const StartCountId: string;
                export const StartShift: string;
            }

            namespace PsPosMoneyCount {
                export const BagCode: string;
                export const CashierId: string;
                export const CountDate: string;
                export const CountId: string;
                export const CountType: string;
                export const CreateBy: string;
                export const CreateDate: string;
                export const CusWsFlg: string;
                export const Id: string;
                export const InTime: string;
                export const LastUpdate: string;
                export const PosId: string;
                export const Remark: string;
                export const ShopId: string;
                export const TenderAmt: string;
                export const TenderCode: string;
                export const TenderName: string;
                export const TenderQty: string;
                export const TenderRate: string;
                export const TenderType: string;
                export const TypeCb: string;
                export const UpdateBy: string;
            }

            namespace PsPosShiftControl {
                export const BegCash: string;
                export const CashBalance: string;
                export const CashIn: string;
                export const CashOut: string;
                export const CashSales: string;
                export const CashierId: string;
                export const Charge: string;
                export const CountCancel: string;
                export const CountCashIn: string;
                export const CountCashOut: string;
                export const CountOpenDrawer: string;
                export const CountRefund: string;
                export const CountVoid: string;
                export const CreateBy: string;
                export const CreateDate: string;
                export const Deiscount: string;
                export const EndReceiptNo: string;
                export const EndRefundNo: string;
                export const GrossAmt: string;
                export const Id: string;
                export const LastUpdate: string;
                export const NetSales: string;
                export const PosId: string;
                export const RecvByCash: string;
                export const RecvByCashCd: string;
                export const RecvByCoupon: string;
                export const RecvByCreditCd: string;
                export const RecvByDebitCd: string;
                export const RecvByOthers: string;
                export const RecvByPoint: string;
                export const RoundReceive: string;
                export const ShiftStatus: string;
                export const ShopFullName: string;
                export const ShopId: string;
                export const SingInDate: string;
                export const SingInTime: string;
                export const SingOutDate: string;
                export const SingOutTime: string;
                export const StartReceiptNo: string;
                export const StartRefundNo: string;
                export const TotalCashInAmt: string;
                export const TotalCashOutamt: string;
                export const TotalRefundAmt: string;
                export const TotalVoidAmt: string;
                export const UpdateBy: string;
            }

            namespace PsPosShiftControlView {
                export const BegCash: string;
                export const CashBalance: string;
                export const CashIn: string;
                export const CashOut: string;
                export const CashSales: string;
                export const CashierId: string;
                export const Charge: string;
                export const CountCancel: string;
                export const CountCashIn: string;
                export const CountCashOut: string;
                export const CountOpenDrawer: string;
                export const CountRefund: string;
                export const CountVoid: string;
                export const CreateBy: string;
                export const CreateDate: string;
                export const Deiscount: string;
                export const EndReceiptNo: string;
                export const EndRefundNo: string;
                export const GrossAmt: string;
                export const Id: string;
                export const LastUpdate: string;
                export const NetSales: string;
                export const PosId: string;
                export const RecvByCash: string;
                export const RecvByCashCd: string;
                export const RecvByCoupon: string;
                export const RecvByCreditCd: string;
                export const RecvByCurrency: string;
                export const RecvByDebitCd: string;
                export const RecvByOthers: string;
                export const RecvByPoint: string;
                export const RecvByQr: string;
                export const RoundReceive: string;
                export const ShiftStatus: string;
                export const ShopFullName: string;
                export const ShopId: string;
                export const SingInDate: string;
                export const SingInTime: string;
                export const SingOutDate: string;
                export const SingOutTime: string;
                export const StartReceiptNo: string;
                export const StartRefundNo: string;
                export const TotalCashInAmt: string;
                export const TotalCashOutamt: string;
                export const TotalRefundAmt: string;
                export const TotalVoidAmt: string;
                export const UpdateBy: string;
            }

            namespace PsPriceOverrideTran {
                export const CashierId: string;
                export const CreateBy: string;
                export const CreateDate: string;
                export const DocNo: string;
                export const Id: string;
                export const MgrCashierId: string;
                export const OverridePrice: string;
                export const PluCode: string;
                export const PluDesc: string;
                export const PosId: string;
                export const PriceOverrideId: string;
                export const Qty: string;
                export const UnitPrice: string;
            }

            namespace PsQueue {
                export const Id: string;
                export const LastQueueNo: string;
                export const ShopId: string;
                export const TodayDate: string;
            }

            namespace PsTaxInvoiceAddress {
                export const CreateBy: string;
                export const CreateDate: string;
                export const CusTaxTypeFg: string;
                export const Id: string;
                export const LastUpdate: string;
                export const LookupName: string;
                export const MbId: string;
                export const TaxBranchName: string;
                export const TaxBranchNo: string;
                export const TaxCountryCode: string;
                export const TaxEmail: string;
                export const TaxId: string;
                export const TaxInvAddressLine1: string;
                export const TaxInvAddressLine2: string;
                export const TaxInvAddressLine3: string;
                export const TaxInvName: string;
                export const TaxPostalCode: string;
                export const TelNo: string;
                export const UpdateBy: string;
            }

            namespace PsTaxInvoiceDt {
                export const AllocatedBillDiscount: string;
                export const AllocatedBillDiscountVat: string;
                export const CreateBy: string;
                export const CreateDate: string;
                export const DocNo: string;
                export const DocType: string;
                export const ExPrice: string;
                export const Id: string;
                export const ItemCharge: string;
                export const ItemDescription: string;
                export const ItemDiscount: string;
                export const ItemExVat: string;
                export const ItemNetExprice: string;
                export const ItemNetSales: string;
                export const ItemNetSales2: string;
                export const ItemPromoFg: string;
                export const ItemVatAmt: string;
                export const ItemVatAmt2: string;
                export const LastUpdate: string;
                export const LineItemNo: string;
                export const PluCode: string;
                export const Qty: string;
                export const SalesVatType: string;
                export const SellUnit: string;
                export const SerialNo: string;
                export const UnitPrice: string;
                export const UpdateBy: string;
                export const VatRate: string;
                export const VatType: string;
            }

            namespace PsTaxInvoiceHd {
                export const CancelFg: string;
                export const ChargeAmt: string;
                export const ConcatRefDocNo1: string;
                export const CreateBy: string;
                export const CreateDate: string;
                export const CusTaxTypeFg: string;
                export const DiscountAmt: string;
                export const DocDate: string;
                export const DocNo: string;
                export const DocType: string;
                export const DtList: string;
                export const ErpAutoGenStamp: string;
                export const GrossAmt: string;
                export const Id: string;
                export const LastUpdate: string;
                export const MbId: string;
                export const NetAmt: string;
                export const NetSalesExVat: string;
                export const NetSalesNonVat: string;
                export const NetSalesNormal: string;
                export const NewTaxInvoiceAmt: string;
                export const NoOfPrint: string;
                export const PostFg: string;
                export const PurposeCode: string;
                export const PurposeRemark: string;
                export const RefDocDate: string;
                export const RefDocNo: string;
                export const RefTaxInvoice: string;
                export const RefTaxInvoiceAmt: string;
                export const RefTaxInvoiceDate: string;
                export const RefundFg: string;
                export const RefundId: string;
                export const Remark: string;
                export const SalesVatType: string;
                export const ShopId: string;
                export const SumDisChargeAmt: string;
                export const TaxBranchName: string;
                export const TaxBranchNo: string;
                export const TaxCountryCode: string;
                export const TaxEmail: string;
                export const TaxId: string;
                export const TaxInvAddressLine1: string;
                export const TaxInvAddressLine2: string;
                export const TaxInvAddressLine3: string;
                export const TaxInvName: string;
                export const TaxInvNameId: string;
                export const TaxInvoiceAmt: string;
                export const TaxInvoiceAmtDiff: string;
                export const TaxPostalCode: string;
                export const TelNo: string;
                export const UpdateBy: string;
                export const VatAmt: string;
            }

            namespace PsVatRefund {
                export const Addressno: string;
                export const ArriveDate: string;
                export const BookNo: string;
                export const City: string;
                export const ConfigPrint: string;
                export const Country: string;
                export const CreateBy: string;
                export const CreateDate: string;
                export const DepartureDate: string;
                export const District: string;
                export const DocDate: string;
                export const DocNo: string;
                export const DtList: string;
                export const Email: string;
                export const FlightNo: string;
                export const FristName: string;
                export const Id: string;
                export const IssueByDate: string;
                export const IssueName: string;
                export const LastName: string;
                export const LastUpdate: string;
                export const Nation: string;
                export const No: string;
                export const Offline: string;
                export const Passport: string;
                export const PayVatAmount: string;
                export const Province: string;
                export const RefFg: string;
                export const RefNo: string;
                export const Remark: string;
                export const RoundedVatRefund: string;
                export const ShopId: string;
                export const Status: string;
                export const Street: string;
                export const Total: string;
                export const UpdateBy: string;
                export const Vat: string;
                export const VatRateNo: string;
                export const ZipCode: string;
            }

            namespace PsVatRefundDt {
                export const Amt: string;
                export const Cancel: string;
                export const DocNo: string;
                export const Id: string;
                export const ItemId: string;
                export const ItemNo: string;
                export const ItemVat: string;
                export const PluCode: string;
                export const PluDesc: string;
                export const Qty: string;
                export const RefInv: string;
                export const RefTaxNo: string;
            }

            namespace PsVatRefundPrintingPara {
                export const CreateBy: string;
                export const CreateDate: string;
                export const FromCode: string;
                export const Id: string;
                export const LastUpdate: string;
                export const P1DetailAddressFontSize: string;
                export const P1DetailAddressPHeight: string;
                export const P1DetailAddressPaddingLeft: string;
                export const P1DetailAddressPaddingTop: string;
                export const P1DetailEmailFontSize: string;
                export const P1DetailEmailPHeight: string;
                export const P1DetailEmailPaddingLeft: string;
                export const P1DetailEmailPaddingTop: string;
                export const P1DetailLeftHeight: string;
                export const P1DetailLeftTableC1Width: string;
                export const P1DetailLeftTableC2Width: string;
                export const P1DetailLeftTableC3Width: string;
                export const P1DetailLeftTableC4Width: string;
                export const P1DetailLeftTableC5PeddingRight: string;
                export const P1DetailLeftTableC5Width: string;
                export const P1DetailLeftTablePaddingLeft: string;
                export const P1DetailLeftTablePaddingTop: string;
                export const P1DetailLeftTableRowHeight: string;
                export const P1DetailLeftWidth: string;
                export const P1DetailLine2CityPaddingLeft: string;
                export const P1DetailLine2CityPaddingWidth: string;
                export const P1DetailLine2CountyPaddingLeft: string;
                export const P1DetailLine2FontSize: string;
                export const P1DetailLine2PHeight: string;
                export const P1DetailLine2PaddingTop: string;
                export const P1DetailLine2PostcodePaddingLeft: string;
                export const P1DetailLine2PostcodePaddingWidth: string;
                export const P1DetailPhonenumberFontSize: string;
                export const P1DetailPhonenumberPHeight: string;
                export const P1DetailPhonenumberPaddingLeft: string;
                export const P1DetailPhonenumberPaddingTop: string;
                export const P1DetailRightPaddingTop: string;
                export const P1DetailRightWidth: string;
                export const P1FooterLeftHeight: string;
                export const P1FooterLeftWidth: string;
                export const P1FooterPageNext: string;
                export const P1FooterPagetoFontSize: string;
                export const P1FooterPagetoHeight: string;
                export const P1FooterPagetoPaddingButtom: string;
                export const P1FooterPagetoPaddingLeft: string;
                export const P1FooterPagetoWidth: string;
                export const P1FooterSumFontSize: string;
                export const P1FooterSumPeddingRight: string;
                export const P1FooterSumWidth: string;
                export const P1HeaderHeight: string;
                export const P1HeaderLeftAddNoFontSize: string;
                export const P1HeaderLeftAddNoHeight: string;
                export const P1HeaderLeftAddNoPaddingLeft: string;
                export const P1HeaderLeftAddNoWidth: string;
                export const P1HeaderLeftBranchFontSize: string;
                export const P1HeaderLeftBranchHeight: string;
                export const P1HeaderLeftBranchPaddingLeft: string;
                export const P1HeaderLeftBranchPaddingRight: string;
                export const P1HeaderLeftBranchSpacing: string;
                export const P1HeaderLeftCompanyNameFontSize: string;
                export const P1HeaderLeftCompanyNamePaddingLeft: string;
                export const P1HeaderLeftDistrictFontSize: string;
                export const P1HeaderLeftDistrictHeight: string;
                export const P1HeaderLeftDistrictPaddingLeft: string;
                export const P1HeaderLeftDistrictWidth: string;
                export const P1HeaderLeftProviceFontSize: string;
                export const P1HeaderLeftProvicePaddingLeft: string;
                export const P1HeaderLeftShopTaxIdFontSize: string;
                export const P1HeaderLeftShopTaxIdHeight: string;
                export const P1HeaderLeftShopTaxIdPaddingLeft: string;
                export const P1HeaderLeftShopTaxIdPaddingRight: string;
                export const P1HeaderLeftShopTaxIdSpacing: string;
                export const P1HeaderLeftStreetFontSize: string;
                export const P1HeaderLeftStreetPaddingLeft: string;
                export const P1HeaderLeftTelnoFontSize: string;
                export const P1HeaderLeftTelnoHeight: string;
                export const P1HeaderLeftTelnoPaddingLeft: string;
                export const P1HeaderLeftWidth: string;
                export const P1HeaderRightDateFontSize: string;
                export const P1HeaderRightDateHeight: string;
                export const P1HeaderRightDateLeftMmyyWidth: string;
                export const P1HeaderRightDateLeftPaddingLeft: string;
                export const P1HeaderRightDateLeftWidth: string;
                export const P1HeaderRightDatePaddingTop: string;
                export const P1HeaderRightDateRightMmyyWidth: string;
                export const P1HeaderRightDateRightPaddingLeft: string;
                export const P1HeaderRightDateRightWidth: string;
                export const P1HeaderRightNationFontSize: string;
                export const P1HeaderRightNationHeight: string;
                export const P1HeaderRightNationPaddingLeft: string;
                export const P1HeaderRightPaddingTop: string;
                export const P1HeaderRightPassnoFontSize: string;
                export const P1HeaderRightPassnoHeight: string;
                export const P1HeaderRightPassnoPaddingLeft: string;
                export const P1HeaderRightTNameFontSize: string;
                export const P1HeaderRightTNameHeight: string;
                export const P1HeaderRightTNamePaddingLeft: string;
                export const P1HeaderRightWidth: string;
                export const P1Height: string;
                export const P1PaddingLeft: string;
                export const P1PaddingTop: string;
                export const P1Width: string;
                export const P2DetailC1Width: string;
                export const P2DetailC2PaddingLeft: string;
                export const P2DetailC2Width: string;
                export const P2DetailC3PaddingLeft: string;
                export const P2DetailC3Width: string;
                export const P2DetailC4PaddingLeft: string;
                export const P2DetailC4Width: string;
                export const P2DetailC5PaddingRight: string;
                export const P2DetailC5Width: string;
                export const P2DetailHeight: string;
                export const P2DetailPaddingLeft: string;
                export const P2DetailPaddingRight: string;
                export const P2DetailPaddingTop: string;
                export const P2DetailRowHeight: string;
                export const P2DetailWidth: string;
                export const P2FooterHeight: string;
                export const P2FooterLeft: string;
                export const P2FooterPageNext: string;
                export const P2FooterSumPaddingRight: string;
                export const P2FooterWidth: string;
                export const P2HeaderBookNoHeight: string;
                export const P2HeaderBookNoPaddingButtom: string;
                export const P2HeaderBookNoPaddingLeft: string;
                export const P2HeaderBookNoWidth: string;
                export const P2HeaderBranchHeight: string;
                export const P2HeaderBranchPaddingLeft: string;
                export const P2HeaderBranchPaddingRigth: string;
                export const P2HeaderBranchSpacing: string;
                export const P2HeaderNoPaddingLeft: string;
                export const P2HeaderSaleFontSize: string;
                export const P2HeaderSaleHeight: string;
                export const P2HeaderSalePaddingButtom: string;
                export const P2HeaderSalePaddingLeft: string;
                export const P2HeaderTaxBranchFontSize: string;
                export const P2HeaderTaxBranchHeight: string;
                export const P2HeaderTaxHeight: string;
                export const P2HeaderTaxPaddingLeft: string;
                export const P2HeaderTaxPaddingRigth: string;
                export const P2HeaderTaxSpacing: string;
                export const P2Height: string;
                export const P2PaddingLeft: string;
                export const P2PaddingRight: string;
                export const P2PaddingTop: string;
                export const P2PageAllPaddingLeft: string;
                export const P2PageHeight: string;
                export const P2PageLeft: string;
                export const P2PageNoHeight: string;
                export const P2PageNowFontSize: string;
                export const P2PageNowPaddingLeft: string;
                export const P2PageNowWidth: string;
                export const P2StartHeight: string;
                export const P2Width: string;
                export const UpdateBy: string;
            }

            namespace PsVatRefundRate {
                export const CreateBy: string;
                export const CreateDate: string;
                export const Id: string;
                export const LastUpdate: string;
                export const PurchaseFrom: string;
                export const PurchaseTo: string;
                export const RefundFg: string;
                export const RefundPc: string;
                export const RoundedRefund: string;
                export const UpdateBy: string;
                export const VatRateNo: string;
            }

            namespace ReportRecvbyCashierbyDate {
                export const CashierId: string;
                export const CashierName: string;
                export const CountTime: string;
                export const CreateDate: string;
                export const CurrencyCode: string;
                export const Id: string;
                export const PaymentName: string;
                export const PaymentType: string;
                export const PointBurn: string;
                export const ReceiptAmt: string;
                export const RefType: string;
            }

            namespace ReportSaleTax {
                export const DocDate: string;
                export const DocType: string;
                export const EndDocNo: string;
                export const ExVatAmt: string;
                export const Id: string;
                export const NonVatAmt: string;
                export const PosId: string;
                export const PosPermitNo: string;
                export const StartDocNo: string;
                export const TotalAmt: string;
                export const VatAmt: string;
            }

            namespace ReportSaleTaxTreeTax {
                export const BranchName: string;
                export const BuyerName: string;
                export const DocAmt: string;
                export const DocDate: string;
                export const DocType: string;
                export const EndDocNo: string;
                export const ExVatAmt: string;
                export const HdDtFg: string;
                export const Id: string;
                export const NonVatAmt: string;
                export const PosId: string;
                export const PosPermitNo: string;
                export const RefRecieptNo: string;
                export const StartDocNo: string;
                export const TaxId: string;
                export const TaxInvoiceNo: string;
                export const TotalAmt: string;
                export const VatAmt: string;
            }

            namespace ReportVatRefund {
                export const BookNo: string;
                export const DocDate: string;
                export const FristName: string;
                export const Id: string;
                export const No: string;
                export const Passport: string;
                export const PayVatAmount: string;
                export const Remark: string;
                export const RowNo: string;
                export const Total: string;
            }
        }

        namespace PriceChange {

            namespace ActivePriceChange {
                export const ActiveBy: string;
                export const Activedate: string;
                export const ApproveBy: string;
                export const ApproveFg: string;
                export const Approvedate: string;
                export const BrandCode: string;
                export const CatCode: string;
                export const ColorId: string;
                export const CreateBy: string;
                export const CreateDate: string;
                export const EffectiveDate: string;
                export const Id: string;
                export const LastUpdate: string;
                export const MatTypeId: string;
                export const PluCode: string;
                export const PluName: string;
                export const PostFg: string;
                export const SellUnitPrice1: string;
                export const SellUnitPrice1Fg: string;
                export const SellUnitPrice2: string;
                export const SellUnitPrice2Fg: string;
                export const SellUnitPrice3: string;
                export const SellUnitPrice3Fg: string;
                export const SellUnitPrice4: string;
                export const SellUnitPrice4Fg: string;
                export const SellUnitPrice5: string;
                export const SellUnitPrice5Fg: string;
                export const SellUnitPrice6: string;
                export const SellUnitPrice6Fg: string;
                export const SizeId: string;
                export const SkuCode: string;
                export const StyleId: string;
                export const SubCat1Code: string;
                export const SubCat2Code: string;
                export const TasteId: string;
                export const UpdateBy: string;
            }

            namespace AddPriceChange {
                export const ApproveFg: string;
                export const CreateBy: string;
                export const CreateDate: string;
                export const EffectiveDate: string;
                export const Id: string;
                export const LastUpdate: string;
                export const PluCode: string;
                export const PluName: string;
                export const PostFg: string;
                export const SellUnitPrice1: string;
                export const SellUnitPrice1Fg: string;
                export const SellUnitPrice2: string;
                export const SellUnitPrice2Fg: string;
                export const SellUnitPrice3: string;
                export const SellUnitPrice3Fg: string;
                export const SellUnitPrice4: string;
                export const SellUnitPrice4Fg: string;
                export const SellUnitPrice5: string;
                export const SellUnitPrice5Fg: string;
                export const SellUnitPrice6: string;
                export const SellUnitPrice6Fg: string;
                export const UpdateBy: string;
            }

            namespace ApprovePriceChange {
                export const ActiveBy: string;
                export const Activedate: string;
                export const ApproveBy: string;
                export const ApproveFg: string;
                export const Approvedate: string;
                export const BrandCode: string;
                export const CatCode: string;
                export const ColorId: string;
                export const CreateBy: string;
                export const CreateDate: string;
                export const EffectiveDate: string;
                export const Id: string;
                export const LastUpdate: string;
                export const MatTypeId: string;
                export const PluCode: string;
                export const PluName: string;
                export const PostFg: string;
                export const SellUnitPrice1: string;
                export const SellUnitPrice1Fg: string;
                export const SellUnitPrice2: string;
                export const SellUnitPrice2Fg: string;
                export const SellUnitPrice3: string;
                export const SellUnitPrice3Fg: string;
                export const SellUnitPrice4: string;
                export const SellUnitPrice4Fg: string;
                export const SellUnitPrice5: string;
                export const SellUnitPrice5Fg: string;
                export const SellUnitPrice6: string;
                export const SellUnitPrice6Fg: string;
                export const SizeId: string;
                export const SkuCode: string;
                export const StyleId: string;
                export const SubCat1Code: string;
                export const SubCat2Code: string;
                export const SupplierId: string;
                export const TasteId: string;
                export const UpdateBy: string;
            }
        }

        namespace Product {

            namespace CsArticleSeason {
                export const ArticleSeasonCode: string;
                export const ArticleSeasonName: string;
                export const CreateBy: string;
                export const CreateDate: string;
                export const FullName: string;
                export const Id: string;
                export const LastUpdate: string;
                export const UpdateBy: string;
            }

            namespace CsBrand {
                export const BrandCode: string;
                export const BrandName: string;
                export const CreateBy: string;
                export const CreateDate: string;
                export const FullName: string;
                export const Id: string;
                export const LastUpdate: string;
                export const UpdateBy: string;
            }

            namespace CsBrandType {
                export const BrandTypeCode: string;
                export const BrandTypeName: string;
                export const CreateBy: string;
                export const CreateDate: string;
                export const FullName: string;
                export const Id: string;
                export const IsActive: string;
                export const LastUpdate: string;
                export const UpdateBy: string;
            }

            namespace CsCategory {
                export const CatCode: string;
                export const CatName: string;
                export const CreateBy: string;
                export const CreateDate: string;
                export const FullCatName: string;
                export const Id: string;
                export const LastUpdate: string;
                export const UpdateBy: string;
            }

            namespace CsColor {
                export const ColorId: string;
                export const ColorName: string;
                export const CreateBy: string;
                export const CreateDate: string;
                export const FullName: string;
                export const Id: string;
                export const LastUpdate: string;
                export const UpdateBy: string;
            }

            namespace CsConcept {
                export const ConceptCode: string;
                export const ConceptName: string;
                export const CreateBy: string;
                export const CreateDate: string;
                export const FullName: string;
                export const Id: string;
                export const IsActive: string;
                export const LastUpdate: string;
                export const UpdateBy: string;
            }

            namespace CsDocType {
                export const CODE: string;
                export const CreateBy: string;
                export const CreateDate: string;
                export const DocGroup: string;
                export const DocName: string;
                export const DocPrefix: string;
                export const DocType: string;
                export const FullName: string;
                export const Id: string;
                export const LastUpdate: string;
                export const UpdateBy: string;
            }

            namespace CsMatType {
                export const CreateBy: string;
                export const CreateDate: string;
                export const FullName: string;
                export const Id: string;
                export const LastUpdate: string;
                export const MatTypeId: string;
                export const MatTypeName: string;
                export const UpdateBy: string;
            }

            namespace CsPlu {
                export const ActiveRepFg: string;
                export const ActiveSellFg: string;
                export const ColorId: string;
                export const ColorName: string;
                export const ConceptCode: string;
                export const CreateBy: string;
                export const CreateDate: string;
                export const DeliverCost: string;
                export const Id: string;
                export const IsActive: string;
                export const LastUpdate: string;
                export const MatTypeId: string;
                export const MatTypeName: string;
                export const PluCode: string;
                export const PluDesc: string;
                export const PluName: string;
                export const PluShortDesc: string;
                export const PluType: string;
                export const SellUnit: string;
                export const SellUnitPrice1: string;
                export const SellUnitPrice2: string;
                export const SellUnitPrice3: string;
                export const SellUnitPrice4: string;
                export const SellUnitPrice5: string;
                export const SellUnitPrice6: string;
                export const SellUnitRatio: string;
                export const SizeId: string;
                export const SizeName: string;
                export const SkuCode: string;
                export const SkuDesc: string;
                export const StyleId: string;
                export const StyleName: string;
                export const TasteId: string;
                export const TasteName: string;
                export const UpdateBy: string;
            }

            namespace CsSize {
                export const CreateBy: string;
                export const CreateDate: string;
                export const FullName: string;
                export const Id: string;
                export const LastUpdate: string;
                export const SizeId: string;
                export const SizeName: string;
                export const UpdateBy: string;
            }

            namespace CsSku {
                export const ActiveFg: string;
                export const ActivePurFg: string;
                export const ActiveRepFg: string;
                export const ActiveSellFg: string;
                export const ArticleSeasonCode: string;
                export const BrandCode: string;
                export const BrandName: string;
                export const BrandTypeCode: string;
                export const CatCode: string;
                export const CatName: string;
                export const ColorId: string;
                export const ColorName: string;
                export const ConceptCode: string;
                export const ConsignFg: string;
                export const ConsignGp: string;
                export const CreateBy: string;
                export const CreateDate: string;
                export const CusImportOrLocal: string;
                export const CusProductSalesBeforeFlag: string;
                export const CusProductSalesBeforeRefer: string;
                export const CusProductSalesBeforeReferFlag: string;
                export const CusProductTypeNbp: string;
                export const ExpDate: string;
                export const Id: string;
                export const LastPurPrice: string;
                export const LastStockCostUnit: string;
                export const LastUpdate: string;
                export const MarketDate: string;
                export const MatTypeId: string;
                export const MatTypeName: string;
                export const MaxOrderQty: string;
                export const MaxStockQty: string;
                export const MinOrderQty: string;
                export const MinStockQty: string;
                export const NonAllowtoDiscountFg: string;
                export const PluDtList: string;
                export const ProdImageLink: string;
                export const ProductCpComponent: string;
                export const ProductCpDesc1: string;
                export const ProductCpDesc2: string;
                export const ProductCpHowToUse: string;
                export const ProductCpWarning: string;
                export const ProductType: string;
                export const PurLeadTime: string;
                export const PurUnit: string;
                export const PurUnitPrice: string;
                export const PurUnitRatio: string;
                export const PurVatCode: string;
                export const PurVatType: string;
                export const QtyOnhand: string;
                export const SetItemFg: string;
                export const ShelfLifeTime: string;
                export const SizeId: string;
                export const SizeName: string;
                export const SkuCode: string;
                export const SkuDesc: string;
                export const SkuEnDesc: string;
                export const SkuName: string;
                export const StkUnit: string;
                export const StockCostValue: string;
                export const StockFg: string;
                export const StyleId: string;
                export const StyleName: string;
                export const SubCat1Code: string;
                export const SubCat1Name: string;
                export const SubCat2Code: string;
                export const SubCat2Name: string;
                export const SupplItemCode: string;
                export const SupplName: string;
                export const SupplierId: string;
                export const TasteId: string;
                export const TasteName: string;
                export const UnitList: string;
                export const UpdateBy: string;
                export const VatCode: string;
                export const VatRate: string;
                export const VatType: string;
                export const VatTypeDesc: string;
            }

            namespace CsStyle {
                export const CreateBy: string;
                export const CreateDate: string;
                export const FullName: string;
                export const Id: string;
                export const LastUpdate: string;
                export const StyleId: string;
                export const StyleName: string;
                export const UpdateBy: string;
            }

            namespace CsSubCategory1 {
                export const CatCode: string;
                export const CreateBy: string;
                export const CreateDate: string;
                export const FullName: string;
                export const Id: string;
                export const LastUpdate: string;
                export const SubCat1Code: string;
                export const SubCat1Name: string;
                export const UpdateBy: string;
            }

            namespace CsSubCategory2 {
                export const CatCode: string;
                export const CreateBy: string;
                export const CreateDate: string;
                export const FullName: string;
                export const Id: string;
                export const LastUpdate: string;
                export const SubCat1Code: string;
                export const SubCat2Code: string;
                export const SubCat2Name: string;
                export const UpdateBy: string;
            }

            namespace CsTaste {
                export const CreateBy: string;
                export const CreateDate: string;
                export const FullName: string;
                export const Id: string;
                export const LastUpdate: string;
                export const TasteId: string;
                export const TasteName: string;
                export const UpdateBy: string;
            }

            namespace CsUnit {
                export const CreateBy: string;
                export const CreateDate: string;
                export const FullName: string;
                export const Id: string;
                export const LastUpdate: string;
                export const UnitId: string;
                export const UnitName: string;
                export const UpdateBy: string;
            }

            namespace PluDt {
                export const ActiveRepFg: string;
                export const ActiveSellFg: string;
                export const ColorId: string;
                export const ColorName: string;
                export const ConceptCode: string;
                export const CreateBy: string;
                export const CreateDate: string;
                export const DeliverCost: string;
                export const Id: string;
                export const IsActive: string;
                export const LastUpdate: string;
                export const MatTypeId: string;
                export const MatTypeName: string;
                export const PluCode: string;
                export const PluDesc: string;
                export const PluName: string;
                export const PluShortDesc: string;
                export const PluType: string;
                export const SellUnit: string;
                export const SellUnitPrice1: string;
                export const SellUnitPrice2: string;
                export const SellUnitPrice3: string;
                export const SellUnitPrice4: string;
                export const SellUnitPrice5: string;
                export const SellUnitPrice6: string;
                export const SellUnitRatio: string;
                export const SizeId: string;
                export const SizeName: string;
                export const SkuCode: string;
                export const StyleId: string;
                export const StyleName: string;
                export const TasteId: string;
                export const TasteName: string;
                export const UpdateBy: string;
            }

            namespace PsSetItem {
                export const CalDtFg: string;
                export const CreateBy: string;
                export const CreateDate: string;
                export const FinishDate: string;
                export const Id: string;
                export const LastUpdate: string;
                export const PsSetItemDtList: string;
                export const SetItemCode: string;
                export const SetItemName: string;
                export const SetItemShortName: string;
                export const SetItemUnit: string;
                export const SetName: string;
                export const SetPrice: string;
                export const StartDate: string;
                export const UpdateBy: string;
            }

            namespace PsSetItemDt {
                export const CreateBy: string;
                export const CreateDate: string;
                export const Id: string;
                export const LastUpdate: string;
                export const LineItemNo: string;
                export const NormalUnitPrice: string;
                export const PluCode: string;
                export const PluDesc: string;
                export const Qty: string;
                export const SetItemCode: string;
                export const SetPrice: string;
                export const SetUnitPrice: string;
                export const Unit: string;
                export const UpdateBy: string;
            }

            namespace QryMaster {
                export const BrandCode: string;
                export const CatCode: string;
                export const ColorId: string;
                export const ConsignFg: string;
                export const Id: string;
                export const MatTypeId: string;
                export const SizeId: string;
                export const SkuCode: string;
                export const SkuDesc: string;
                export const SkuEnDesc: string;
                export const StockFg: string;
                export const StyleId: string;
                export const SubCat1Code: string;
                export const SubCat2Code: string;
                export const SupplierId: string;
                export const TasteId: string;
                export const UrlReport: string;
                export const VatType: string;
            }

            namespace ReportExportV1 {
                export const BrandId: string;
                export const Category: string;
                export const ColorId: string;
                export const ConsignFg: string;
                export const ConsignGp: string;
                export const CreateBy: string;
                export const CreateDate: string;
                export const CusProductSalesBeforeFlag: string;
                export const CusProductSalesBeforeRefer: string;
                export const CusProductSalesBeforeReferFlag: string;
                export const CusProductTypeNbp: string;
                export const DeliverCost: string;
                export const Id: string;
                export const MatTypeId: string;
                export const MaxStockQty: string;
                export const MinStockQty: string;
                export const NonAllowtoDiscountFg: string;
                export const PluDesc: string;
                export const ProductCpComponent: string;
                export const ProductCpDesc1: string;
                export const ProductCpDesc2: string;
                export const ProductCpHowToUse: string;
                export const ProductCpWarning: string;
                export const PurLeadTime: string;
                export const PurUnit: string;
                export const PurUnitPrice: string;
                export const PurUnitRatio: string;
                export const SellUnitPrice1: string;
                export const SellUnitPrice2: string;
                export const SellUnitPrice3: string;
                export const SellUnitPrice4: string;
                export const SellUnitPrice5: string;
                export const SellUnitPrice6: string;
                export const SetItemFg: string;
                export const SizeId: string;
                export const SkuCode: string;
                export const SkuDesc: string;
                export const StkUnit: string;
                export const StockFg: string;
                export const StyleId: string;
                export const Subcategory1: string;
                export const Subcategory2: string;
                export const SupplId: string;
                export const SupplItemCode: string;
                export const TasteId: string;
                export const VatCode: string;
                export const VatType: string;
            }

            namespace SkuHd {
                export const ActiveFg: string;
                export const ActivePurFg: string;
                export const ActiveRepFg: string;
                export const ActiveSellFg: string;
                export const ArticleSeasonCode: string;
                export const BrandCode: string;
                export const BrandName: string;
                export const BrandTypeCode: string;
                export const CatCode: string;
                export const CatName: string;
                export const ColorId: string;
                export const ColorName: string;
                export const ConceptCode: string;
                export const ConsignFg: string;
                export const ConsignGp: string;
                export const CreateBy: string;
                export const CreateDate: string;
                export const CusImportOrLocal: string;
                export const CusProductSalesBeforeFlag: string;
                export const CusProductSalesBeforeRefer: string;
                export const CusProductSalesBeforeReferFlag: string;
                export const CusProductTypeNbp: string;
                export const ExpDate: string;
                export const Id: string;
                export const LastPurPrice: string;
                export const LastStockCostUnit: string;
                export const LastUpdate: string;
                export const MarketDate: string;
                export const MatTypeId: string;
                export const MatTypeName: string;
                export const MaxOrderQty: string;
                export const MaxStockQty: string;
                export const MinOrderQty: string;
                export const MinStockQty: string;
                export const NonAllowtoDiscountFg: string;
                export const PluDtList: string;
                export const ProdImageLink: string;
                export const ProductCpComponent: string;
                export const ProductCpDesc1: string;
                export const ProductCpDesc2: string;
                export const ProductCpHowToUse: string;
                export const ProductCpWarning: string;
                export const ProductType: string;
                export const PurLeadTime: string;
                export const PurUnit: string;
                export const PurUnitPrice: string;
                export const PurUnitRatio: string;
                export const PurVatCode: string;
                export const PurVatType: string;
                export const QtyOnhand: string;
                export const SetItemFg: string;
                export const ShelfLifeTime: string;
                export const SizeId: string;
                export const SizeName: string;
                export const SkuCode: string;
                export const SkuDesc: string;
                export const SkuEnDesc: string;
                export const SkuName: string;
                export const StkUnit: string;
                export const StockCostValue: string;
                export const StockFg: string;
                export const StyleId: string;
                export const StyleName: string;
                export const SubCat1Code: string;
                export const SubCat1Name: string;
                export const SubCat2Code: string;
                export const SubCat2Name: string;
                export const SupplItemCode: string;
                export const SupplName: string;
                export const SupplierId: string;
                export const TasteId: string;
                export const TasteName: string;
                export const UpdateBy: string;
                export const VatCode: string;
                export const VatRate: string;
                export const VatType: string;
                export const VatTypeDesc: string;
            }
        }

        namespace Purchase {

            namespace ListAppCnrtv {
                export const ApproveDate: string;
                export const CreditNoteNo: string;
                export const DocDate: string;
                export const ItemTypeFg: string;
                export const LastApprove: string;
                export const NetTotalInVat: string;
                export const RefDocNo1: string;
                export const RefDocNo2: string;
                export const Remark: string;
                export const SendForAppfg: string;
                export const ShipId: string;
                export const SupplierId: string;
                export const SysDocNo: string;
                export const WaitApprove: string;
                export const WaitLv: string;
            }

            namespace ListAppCreditNote {
                export const ApproveDate: string;
                export const CreditNoteNo: string;
                export const DocDate: string;
                export const ItemTypeFg: string;
                export const LastApprove: string;
                export const NetTotalInVat: string;
                export const RefDocNo1: string;
                export const RefDocNo2: string;
                export const Remark: string;
                export const SendForAppfg: string;
                export const ShipId: string;
                export const SupplierId: string;
                export const SysDocNo: string;
                export const WaitApprove: string;
                export const WaitLv: string;
            }

            namespace ListAppInvoiceReceive {
                export const ApproveDate: string;
                export const DocDate: string;
                export const ItemTypeFg: string;
                export const LastApprove: string;
                export const NetTotalInVat: string;
                export const PurIvNo: string;
                export const RefDocNo1: string;
                export const RefDocNo2: string;
                export const Remark: string;
                export const SendForAppfg: string;
                export const ShipId: string;
                export const SupplierId: string;
                export const SysDocNo: string;
                export const WaitApprove: string;
                export const WaitLv: string;
            }

            namespace ListAppPurInvoice {
                export const ApproveDate: string;
                export const DocDate: string;
                export const ItemTypeFg: string;
                export const LastApprove: string;
                export const NetTotalInVat: string;
                export const PurIvNo: string;
                export const RefDocNo1: string;
                export const RefDocNo2: string;
                export const Remark: string;
                export const SendForAppfg: string;
                export const ShipId: string;
                export const SupplierId: string;
                export const SysDocNo: string;
                export const WaitApprove: string;
                export const WaitLv: string;
            }

            namespace ListAppPurOrder {
                export const ApproveDate: string;
                export const DocDate: string;
                export const DocNo: string;
                export const LastApprove: string;
                export const NetTotalInVat: string;
                export const PoTypeFg: string;
                export const RefDocNo1: string;
                export const RefDocNo2: string;
                export const Remark: string;
                export const SendForAppfg: string;
                export const ShipId: string;
                export const SupplierId: string;
                export const SysDocNo: string;
                export const WaitApprove: string;
                export const WaitLv: string;
            }

            namespace ListAppPurRequest {
                export const ApproveDate: string;
                export const DocDate: string;
                export const DocNo: string;
                export const LastApprove: string;
                export const NetTotalInVat: string;
                export const PrTypeFg: string;
                export const RefDocNo1: string;
                export const RefDocNo2: string;
                export const Remark: string;
                export const SendForAppfg: string;
                export const ShipId: string;
                export const SupplierId: string;
                export const SysDocNo: string;
                export const WaitApprove: string;
                export const WaitLv: string;
            }

            namespace ListLastAppPurOrder {
                export const AppDate: string;
                export const ApproveBy: string;
                export const DisplayName: string;
                export const SysDocNo: string;
            }

            namespace LookupCnforCnrtv {
                export const SupplierId: string;
                export const SysDocNo: string;
            }

            namespace LookupPIforIr {
                export const SupplierId: string;
                export const SysDocNo: string;
            }

            namespace PoApproval {
                export const ApprGroupCode: string;
                export const CreateBy: string;
                export const CreateDate: string;
                export const DocName: string;
                export const DocType: string;
                export const Id: string;
                export const LastUpdate: string;
                export const Level: string;
                export const Mininum: string;
                export const UpdateBy: string;
            }

            namespace PoApprovalTran {
                export const AppActiveFg: string;
                export const ApprGroupCode: string;
                export const ApprGroupName: string;
                export const ApproveBy: string;
                export const ApproveDate: string;
                export const ApproveFg: string;
                export const DocAmt: string;
                export const DocType: string;
                export const Id: string;
                export const Level: string;
                export const SysDocNo: string;
            }

            namespace PoBank {
                export const BankAccount: string;
                export const BankId: string;
                export const BankName: string;
                export const BankShortName: string;
                export const CreateBy: string;
                export const CreateDate: string;
                export const Id: string;
                export const LastUpdate: string;
                export const UpdateBy: string;
            }

            namespace PoCNRTV {
                export const ApproveBy: string;
                export const ApproveDate: string;
                export const ApproveFg: string;
                export const ApproveLv: string;
                export const BalanceAmt: string;
                export const BankId: string;
                export const BranchCode: string;
                export const CancelFg: string;
                export const CashOrTermfg: string;
                export const CheckQty: string;
                export const ChequeDate: string;
                export const ChequeNo: string;
                export const ConcatRefDocNo1: string;
                export const CreateBy: string;
                export const CreateDate: string;
                export const CreditNotetype: string;
                export const CreditTerm: string;
                export const CurrencyAmt: string;
                export const CurrencyCode: string;
                export const CusCurrencyAmt: string;
                export const CusCurrencyCode: string;
                export const CusExchangeRate: string;
                export const CusNetAmt: string;
                export const CusNetAmtDiff: string;
                export const CusPurInvoiceAmt: string;
                export const CusVatAmt: string;
                export const CusVatDiff: string;
                export const DepositAmt: string;
                export const DiscAmt: string;
                export const DiscText: string;
                export const DocDate: string;
                export const DtList: string;
                export const DueDate: string;
                export const ErPfg: string;
                export const ExchangeRate: string;
                export const ExciseTaxAmt: string;
                export const Id: string;
                export const LastDateStatusChange: string;
                export const LastUpdate: string;
                export const NetAmt: string;
                export const NetExVat: string;
                export const NetTotalInVat: string;
                export const POTypeFg: string;
                export const PayTermCode: string;
                export const PaymentAmt: string;
                export const PaymentBeforeDisc: string;
                export const PaymentDicsAmt: string;
                export const PaymentDicsRemark: string;
                export const PaymentNetAmt: string;
                export const PaymentRefNo: string;
                export const PaymentType: string;
                export const PostDate: string;
                export const PostFg: string;
                export const Postby: string;
                export const PurInvoiceAmt: string;
                export const PurIvNo: string;
                export const ReceiptAmt: string;
                export const RefDocNo1: string;
                export const RefDocNo2: string;
                export const RefType: string;
                export const Refuse: string;
                export const RejectFg: string;
                export const Remark: string;
                export const SalesVatTypes: string;
                export const SendForAppfg: string;
                export const ShipDate: string;
                export const ShipId: string;
                export const ShopId: string;
                export const SupplName: string;
                export const SupplierId: string;
                export const SysDocNo: string;
                export const TaxInvoiceDate: string;
                export const TaxInvoiceNo: string;
                export const TaxInvoiceRef: string;
                export const TotalAmt: string;
                export const UpdateBy: string;
                export const UseFg: string;
                export const VatAmt: string;
                export const VatCode: string;
                export const VatFg: string;
                export const VatRate: string;
                export const WhsId: string;
                export const WhtAmt: string;
            }

            namespace PoCNRTVApp {
                export const AppList: string;
                export const ApproveBy: string;
                export const ApproveDate: string;
                export const ApproveFg: string;
                export const ApproveLv: string;
                export const BalanceAmt: string;
                export const BankId: string;
                export const CancelFg: string;
                export const CashOrTermfg: string;
                export const CheckQty: string;
                export const ChequeDate: string;
                export const ChequeNo: string;
                export const CreateBy: string;
                export const CreateDate: string;
                export const CreditNotetype: string;
                export const CurrencyAmt: string;
                export const CurrencyCode: string;
                export const CusCurrencyAmt: string;
                export const CusCurrencyCode: string;
                export const CusExchangeRate: string;
                export const CusNetAmt: string;
                export const CusNetAmtDiff: string;
                export const CusPurInvoiceAmt: string;
                export const CusVatAmt: string;
                export const CusVatDiff: string;
                export const DepositAmt: string;
                export const DiscAmt: string;
                export const DiscText: string;
                export const DocDate: string;
                export const DtList: string;
                export const DueDate: string;
                export const ErPfg: string;
                export const ExchangeRate: string;
                export const ExciseTaxAmt: string;
                export const Id: string;
                export const LastDateStatusChange: string;
                export const LastUpdate: string;
                export const NetAmt: string;
                export const NetExVat: string;
                export const NetTotalInVat: string;
                export const POTypeFg: string;
                export const PayTermCode: string;
                export const PaymentAmt: string;
                export const PaymentBeforeDisc: string;
                export const PaymentDicsAmt: string;
                export const PaymentDicsRemark: string;
                export const PaymentNetAmt: string;
                export const PaymentRefNo: string;
                export const PaymentType: string;
                export const PostDate: string;
                export const PostFg: string;
                export const Postby: string;
                export const PurInvoiceAmt: string;
                export const PurIvNo: string;
                export const ReceiptAmt: string;
                export const RefDocNo1: string;
                export const RefDocNo2: string;
                export const RefType: string;
                export const Refuse: string;
                export const RejectFg: string;
                export const Remark: string;
                export const SalesVatTypes: string;
                export const SendForAppfg: string;
                export const ShipDate: string;
                export const ShipId: string;
                export const ShopId: string;
                export const SupplierId: string;
                export const SysDocNo: string;
                export const TaxInvoiceDate: string;
                export const TaxInvoiceNo: string;
                export const TaxInvoiceRef: string;
                export const TotalAmt: string;
                export const UpdateBy: string;
                export const UseFg: string;
                export const VatAmt: string;
                export const VatCode: string;
                export const VatFg: string;
                export const VatRate: string;
                export const WhsId: string;
                export const WhtAmt: string;
            }

            namespace PoCNRTVDt {
                export const AlocalteDiscAmt: string;
                export const BeforeDiscAmt: string;
                export const DiscAmt: string;
                export const DiscText: string;
                export const ExpDate: string;
                export const Id: string;
                export const ItemAmt: string;
                export const ItemExVatAmt: string;
                export const ItemExciseTaxAmt: string;
                export const ItemNetAmt: string;
                export const ItemNetCostValue: string;
                export const ItemVatAmt: string;
                export const LastPurUnitPrice: string;
                export const LineItemNo: string;
                export const PiLineId: string;
                export const PiRefDocNo: string;
                export const PurUnit: string;
                export const PurUnitPrice: string;
                export const PurUnitRatio: string;
                export const Qty: string;
                export const QtyUse: string;
                export const Remark: string;
                export const SalesVatTypes: string;
                export const ShopId: string;
                export const SkuCode: string;
                export const SkuDesc: string;
                export const StkQty: string;
                export const SupplierId: string;
                export const SysDocNo: string;
                export const UnitChange: string;
                export const UnitCost: string;
                export const UseFg: string;
                export const VatCode: string;
                export const VatRate: string;
                export const VatType: string;
                export const WhsId: string;
            }

            namespace PoCreditNote {
                export const ApproveBy: string;
                export const ApproveDate: string;
                export const ApproveFg: string;
                export const ApproveLv: string;
                export const BalanceAmt: string;
                export const BankId: string;
                export const BranchCode: string;
                export const CancelFg: string;
                export const CashOrTermfg: string;
                export const CheckQty: string;
                export const ChequeDate: string;
                export const ChequeNo: string;
                export const ConcatRefDocNo1: string;
                export const CreateBy: string;
                export const CreateDate: string;
                export const CreditNotetype: string;
                export const CreditTerm: string;
                export const CurrencyAmt: string;
                export const CurrencyCode: string;
                export const CusCurrencyAmt: string;
                export const CusCurrencyCode: string;
                export const CusExchangeRate: string;
                export const CusNetAmt: string;
                export const CusNetAmtDiff: string;
                export const CusPurInvoiceAmt: string;
                export const CusVatAmt: string;
                export const CusVatDiff: string;
                export const DepositAmt: string;
                export const DiscAmt: string;
                export const DiscText: string;
                export const DocDate: string;
                export const DtList: string;
                export const DueDate: string;
                export const ErPfg: string;
                export const ExchangeRate: string;
                export const ExciseTaxAmt: string;
                export const Id: string;
                export const LastDateStatusChange: string;
                export const LastUpdate: string;
                export const NetAmt: string;
                export const NetExVat: string;
                export const NetTotalInVat: string;
                export const POTypeFg: string;
                export const PayTermCode: string;
                export const PaymentAmt: string;
                export const PaymentBeforeDisc: string;
                export const PaymentDicsAmt: string;
                export const PaymentDicsRemark: string;
                export const PaymentNetAmt: string;
                export const PaymentRefNo: string;
                export const PaymentType: string;
                export const PostDate: string;
                export const PostFg: string;
                export const Postby: string;
                export const PurInvoiceAmt: string;
                export const PurIvNo: string;
                export const ReceiptAmt: string;
                export const RefDocNo1: string;
                export const RefDocNo2: string;
                export const RefInvoiceAmt: string;
                export const RefType: string;
                export const Refuse: string;
                export const RejectFg: string;
                export const Remark: string;
                export const SalesVatTypes: string;
                export const SendForAppfg: string;
                export const ShipDate: string;
                export const ShipId: string;
                export const ShopId: string;
                export const SupplName: string;
                export const SupplierId: string;
                export const SysDocNo: string;
                export const TaxInvoiceDate: string;
                export const TaxInvoiceNo: string;
                export const TaxInvoiceRef: string;
                export const TotalAmt: string;
                export const UpdateBy: string;
                export const UseFg: string;
                export const VatAmt: string;
                export const VatCode: string;
                export const VatFg: string;
                export const VatRate: string;
                export const WhsId: string;
                export const WhtAmt: string;
            }

            namespace PoCreditNoteApp {
                export const AppList: string;
                export const ApproveBy: string;
                export const ApproveDate: string;
                export const ApproveFg: string;
                export const ApproveLv: string;
                export const BalanceAmt: string;
                export const BankId: string;
                export const CancelFg: string;
                export const CashOrTermfg: string;
                export const CheckQty: string;
                export const ChequeDate: string;
                export const ChequeNo: string;
                export const CreateBy: string;
                export const CreateDate: string;
                export const CreditNotetype: string;
                export const CurrencyAmt: string;
                export const CurrencyCode: string;
                export const CusCurrencyAmt: string;
                export const CusCurrencyCode: string;
                export const CusExchangeRate: string;
                export const CusNetAmt: string;
                export const CusNetAmtDiff: string;
                export const CusPurInvoiceAmt: string;
                export const CusVatAmt: string;
                export const CusVatDiff: string;
                export const DepositAmt: string;
                export const DiscAmt: string;
                export const DiscText: string;
                export const DocDate: string;
                export const DtList: string;
                export const DueDate: string;
                export const ErPfg: string;
                export const ExchangeRate: string;
                export const ExciseTaxAmt: string;
                export const Id: string;
                export const LastDateStatusChange: string;
                export const LastUpdate: string;
                export const NetAmt: string;
                export const NetExVat: string;
                export const NetTotalInVat: string;
                export const POTypeFg: string;
                export const PayTermCode: string;
                export const PaymentAmt: string;
                export const PaymentBeforeDisc: string;
                export const PaymentDicsAmt: string;
                export const PaymentDicsRemark: string;
                export const PaymentNetAmt: string;
                export const PaymentRefNo: string;
                export const PaymentType: string;
                export const PostDate: string;
                export const PostFg: string;
                export const Postby: string;
                export const PurInvoiceAmt: string;
                export const PurIvNo: string;
                export const ReceiptAmt: string;
                export const RefDocNo1: string;
                export const RefDocNo2: string;
                export const RefType: string;
                export const Refuse: string;
                export const RejectFg: string;
                export const Remark: string;
                export const SalesVatTypes: string;
                export const SendForAppfg: string;
                export const ShipDate: string;
                export const ShipId: string;
                export const ShopId: string;
                export const SupplierId: string;
                export const SysDocNo: string;
                export const TaxInvoiceDate: string;
                export const TaxInvoiceNo: string;
                export const TaxInvoiceRef: string;
                export const TotalAmt: string;
                export const UpdateBy: string;
                export const UseFg: string;
                export const VatAmt: string;
                export const VatCode: string;
                export const VatFg: string;
                export const VatRate: string;
                export const WhsId: string;
                export const WhtAmt: string;
            }

            namespace PoCreditNoteDt {
                export const AlocalteDiscAmt: string;
                export const BeforeDiscAmt: string;
                export const DiscAmt: string;
                export const DiscText: string;
                export const ExpDate: string;
                export const Id: string;
                export const ItemAmt: string;
                export const ItemExVatAmt: string;
                export const ItemExciseTaxAmt: string;
                export const ItemNetAmt: string;
                export const ItemNetCostValue: string;
                export const ItemVatAmt: string;
                export const LastPurUnitPrice: string;
                export const LineItemNo: string;
                export const PiLineId: string;
                export const PiRefDocNo: string;
                export const PurUnit: string;
                export const PurUnitPrice: string;
                export const PurUnitRatio: string;
                export const Qty: string;
                export const QtyUse: string;
                export const Remark: string;
                export const SalesVatTypes: string;
                export const ShopId: string;
                export const SkuCode: string;
                export const SkuDesc: string;
                export const StkQty: string;
                export const SupplierId: string;
                export const SysDocNo: string;
                export const UnitChange: string;
                export const UnitCost: string;
                export const UseFg: string;
                export const VatCode: string;
                export const VatRate: string;
                export const VatType: string;
                export const WhsId: string;
            }

            namespace PoInvoiceReceive {
                export const ApproveBy: string;
                export const ApproveDate: string;
                export const ApproveFg: string;
                export const ApproveLv: string;
                export const BalanceAmt: string;
                export const BankId: string;
                export const BranchCode: string;
                export const CancelFg: string;
                export const CashOrTermfg: string;
                export const CheckQty: string;
                export const ChequeDate: string;
                export const ChequeNo: string;
                export const ConcatRefDocNo1: string;
                export const CreateBy: string;
                export const CreateDate: string;
                export const CurrencyAmt: string;
                export const CurrencyCode: string;
                export const CusCurrencyAmt: string;
                export const CusCurrencyCode: string;
                export const CusExchangeRate: string;
                export const CusNetAmt: string;
                export const CusNetAmtDiff: string;
                export const CusPurInvoiceAmt: string;
                export const CusVatAmt: string;
                export const CusVatDiff: string;
                export const DepositAmt: string;
                export const DiscAmt: string;
                export const DiscText: string;
                export const DocDate: string;
                export const DtList: string;
                export const DueDate: string;
                export const ErPfg: string;
                export const ExchangeRate: string;
                export const ExciseTaxAmt: string;
                export const Id: string;
                export const LastDateStatusChange: string;
                export const LastUpdate: string;
                export const NetAmt: string;
                export const NetExVat: string;
                export const NetTotalInVat: string;
                export const POTypeFg: string;
                export const PayTermCode: string;
                export const PaymentAmt: string;
                export const PaymentBeforeDisc: string;
                export const PaymentDicsAmt: string;
                export const PaymentDicsRemark: string;
                export const PaymentNetAmt: string;
                export const PaymentRefNo: string;
                export const PaymentType: string;
                export const PostDate: string;
                export const PostFg: string;
                export const PurInvoiceAmt: string;
                export const PurIvNo: string;
                export const ReceiptAmt: string;
                export const RefDocNo1: string;
                export const RefDocNo2: string;
                export const RefType: string;
                export const Refuse: string;
                export const RejectFg: string;
                export const Remark: string;
                export const SalesVatTypes: string;
                export const SendForAppfg: string;
                export const ShipDate: string;
                export const ShipId: string;
                export const ShopId: string;
                export const SupplName: string;
                export const SupplierId: string;
                export const SysDocNo: string;
                export const TaxInvoiceDate: string;
                export const TaxInvoiceNo: string;
                export const TotalAmt: string;
                export const UpdateBy: string;
                export const UseFg: string;
                export const VatAmt: string;
                export const VatCode: string;
                export const VatFg: string;
                export const VatRate: string;
                export const WhsId: string;
                export const WhtAmt: string;
            }

            namespace PoInvoiceReceiveApp {
                export const AppList: string;
                export const ApproveBy: string;
                export const ApproveDate: string;
                export const ApproveFg: string;
                export const ApproveLv: string;
                export const BalanceAmt: string;
                export const BankId: string;
                export const CancelFg: string;
                export const CashOrTermfg: string;
                export const CheckQty: string;
                export const ChequeDate: string;
                export const ChequeNo: string;
                export const CreateBy: string;
                export const CreateDate: string;
                export const CurrencyAmt: string;
                export const CurrencyCode: string;
                export const CusCurrencyAmt: string;
                export const CusCurrencyCode: string;
                export const CusExchangeRate: string;
                export const CusNetAmt: string;
                export const CusNetAmtDiff: string;
                export const CusPurInvoiceAmt: string;
                export const CusVatAmt: string;
                export const CusVatDiff: string;
                export const DepositAmt: string;
                export const DiscAmt: string;
                export const DiscText: string;
                export const DocDate: string;
                export const DtList: string;
                export const DueDate: string;
                export const ErPfg: string;
                export const ExchangeRate: string;
                export const ExciseTaxAmt: string;
                export const Id: string;
                export const LastDateStatusChange: string;
                export const LastUpdate: string;
                export const NetAmt: string;
                export const NetExVat: string;
                export const NetTotalInVat: string;
                export const POTypeFg: string;
                export const PayTermCode: string;
                export const PaymentAmt: string;
                export const PaymentBeforeDisc: string;
                export const PaymentDicsAmt: string;
                export const PaymentDicsRemark: string;
                export const PaymentNetAmt: string;
                export const PaymentRefNo: string;
                export const PaymentType: string;
                export const PostDate: string;
                export const PostFg: string;
                export const PurInvoiceAmt: string;
                export const PurIvNo: string;
                export const ReceiptAmt: string;
                export const RefDocNo1: string;
                export const RefDocNo2: string;
                export const RefType: string;
                export const Refuse: string;
                export const RejectFg: string;
                export const Remark: string;
                export const SalesVatTypes: string;
                export const SendForAppfg: string;
                export const ShipDate: string;
                export const ShipId: string;
                export const ShopId: string;
                export const SupplierId: string;
                export const SysDocNo: string;
                export const TaxInvoiceDate: string;
                export const TaxInvoiceNo: string;
                export const TotalAmt: string;
                export const UpdateBy: string;
                export const UseFg: string;
                export const VatAmt: string;
                export const VatCode: string;
                export const VatFg: string;
                export const VatRate: string;
                export const WhsId: string;
                export const WhtAmt: string;
            }

            namespace PoInvoiceReceiveDt {
                export const AlocalteDiscAmt: string;
                export const BeforeDiscAmt: string;
                export const DiscAmt: string;
                export const DiscText: string;
                export const ExpDate: string;
                export const Id: string;
                export const ItemAmt: string;
                export const ItemExVatAmt: string;
                export const ItemExciseTaxAmt: string;
                export const ItemNetAmt: string;
                export const ItemNetCostValue: string;
                export const ItemVatAmt: string;
                export const LastPurUnitPrice: string;
                export const LineItemNo: string;
                export const PiLineId: string;
                export const PiRefDocNo: string;
                export const PurUnit: string;
                export const PurUnitPrice: string;
                export const PurUnitRatio: string;
                export const Qty: string;
                export const QtyUse: string;
                export const Remark: string;
                export const SalesVatTypes: string;
                export const ShopId: string;
                export const SkuCode: string;
                export const SkuDesc: string;
                export const StkQty: string;
                export const SupplierId: string;
                export const SysDocNo: string;
                export const UnitChange: string;
                export const UnitCost: string;
                export const UseFg: string;
                export const VatCode: string;
                export const VatRate: string;
                export const VatType: string;
                export const WhsId: string;
            }

            namespace PoPara {
                export const CreateBy: string;
                export const CreateDate: string;
                export const Id: string;
                export const LastUpdate: string;
                export const ToleranceTotal: string;
                export const ToleranceVat: string;
                export const UpdateBy: string;
            }

            namespace PoPayTermCode {
                export const CreateBy: string;
                export const CreateDate: string;
                export const CreditTerm: string;
                export const Id: string;
                export const LastUpdate: string;
                export const LookupName: string;
                export const PayTermCode: string;
                export const PayTermDesc: string;
                export const UpdateBy: string;
            }

            namespace PoPo05DtPendingPIforIr {
                export const DiscAmt: string;
                export const Id: string;
                export const ItemAmt: string;
                export const LineItemNo: string;
                export const PurUnit: string;
                export const PurUnitPrice: string;
                export const Qty: string;
                export const Remark: string;
                export const SkuCode: string;
                export const SkuDesc: string;
                export const SysDocNo: string;
                export const UseFg: string;
                export const WhsId: string;
            }

            namespace PoPo05PendingPIforIr {
                export const DocDate: string;
                export const DtList: string;
                export const PayTermCode: string;
                export const PurIvNo: string;
                export const ReceiptAmt: string;
                export const RefDocNo1: string;
                export const RefDocNo2: string;
                export const Remark: string;
                export const ShipDate: string;
                export const ShipId: string;
                export const SupplName: string;
                export const SupplierId: string;
                export const SysDocNo: string;
                export const UseFg: string;
                export const WhsId: string;
            }

            namespace PoPo06DtPendingCNforCnrtv {
                export const DiscAmt: string;
                export const Id: string;
                export const ItemAmt: string;
                export const LineItemNo: string;
                export const PurUnit: string;
                export const PurUnitPrice: string;
                export const Qty: string;
                export const Remark: string;
                export const SkuCode: string;
                export const SkuDesc: string;
                export const SysDocNo: string;
                export const UseFg: string;
                export const WhsId: string;
            }

            namespace PoPo06PendingCNforCnrtv {
                export const CreditNoteNo: string;
                export const DocDate: string;
                export const DtList: string;
                export const PayTermCode: string;
                export const ReceiptAmt: string;
                export const RefDocNo1: string;
                export const RefDocNo2: string;
                export const Remark: string;
                export const ShipDate: string;
                export const ShipId: string;
                export const SupplName: string;
                export const SupplierId: string;
                export const SysDocNo: string;
                export const TaxInvoiceRef: string;
                export const UseFg: string;
                export const WhsId: string;
            }

            namespace PoPurInvoice {
                export const ApproveBy: string;
                export const ApproveDate: string;
                export const ApproveFg: string;
                export const ApproveLv: string;
                export const BalanceAmt: string;
                export const BankId: string;
                export const BranchCode: string;
                export const CancelFg: string;
                export const CashOrTermfg: string;
                export const CheckQty: string;
                export const ChequeDate: string;
                export const ChequeNo: string;
                export const ConcatRefDocNo1: string;
                export const CreateBy: string;
                export const CreateDate: string;
                export const CurrencyAmt: string;
                export const CurrencyCode: string;
                export const CusCurrencyAmt: string;
                export const CusCurrencyCode: string;
                export const CusExchangeRate: string;
                export const CusNetAmt: string;
                export const CusNetAmtDiff: string;
                export const CusPurInvoiceAmt: string;
                export const CusVatAmt: string;
                export const CusVatDiff: string;
                export const DepositAmt: string;
                export const DiscAmt: string;
                export const DiscText: string;
                export const DocDate: string;
                export const DtList: string;
                export const DueDate: string;
                export const ErPfg: string;
                export const ExchangeRate: string;
                export const ExciseTaxAmt: string;
                export const Id: string;
                export const LastDateStatusChange: string;
                export const LastUpdate: string;
                export const NetAmt: string;
                export const NetExVat: string;
                export const NetTotalInVat: string;
                export const POTypeFg: string;
                export const PayTermCode: string;
                export const PaymentAmt: string;
                export const PaymentBeforeDisc: string;
                export const PaymentDicsAmt: string;
                export const PaymentDicsRemark: string;
                export const PaymentNetAmt: string;
                export const PaymentRefNo: string;
                export const PaymentType: string;
                export const PostDate: string;
                export const PostFg: string;
                export const PurInvoiceAmt: string;
                export const PurIvNo: string;
                export const ReceiptAmt: string;
                export const RefDocNo1: string;
                export const RefDocNo2: string;
                export const RefType: string;
                export const Refuse: string;
                export const RejectFg: string;
                export const Remark: string;
                export const SalesVatTypes: string;
                export const SendForAppfg: string;
                export const ShipDate: string;
                export const ShipId: string;
                export const ShopId: string;
                export const SupplName: string;
                export const SupplierId: string;
                export const SysDocNo: string;
                export const TaxInvoiceDate: string;
                export const TaxInvoiceNo: string;
                export const TotalAmt: string;
                export const UpdateBy: string;
                export const UseFg: string;
                export const VatAmt: string;
                export const VatCode: string;
                export const VatFg: string;
                export const VatRate: string;
                export const WhsId: string;
                export const WhtAmt: string;
            }

            namespace PoPurInvoiceApp {
                export const AppList: string;
                export const ApproveBy: string;
                export const ApproveDate: string;
                export const ApproveFg: string;
                export const ApproveLv: string;
                export const BalanceAmt: string;
                export const BankId: string;
                export const CancelFg: string;
                export const CashOrTermfg: string;
                export const CheckQty: string;
                export const ChequeDate: string;
                export const ChequeNo: string;
                export const CreateBy: string;
                export const CreateDate: string;
                export const CurrencyAmt: string;
                export const CurrencyCode: string;
                export const CusCurrencyAmt: string;
                export const CusCurrencyCode: string;
                export const CusExchangeRate: string;
                export const CusNetAmt: string;
                export const CusNetAmtDiff: string;
                export const CusPurInvoiceAmt: string;
                export const CusVatAmt: string;
                export const CusVatDiff: string;
                export const DepositAmt: string;
                export const DiscAmt: string;
                export const DiscText: string;
                export const DocDate: string;
                export const DtList: string;
                export const DueDate: string;
                export const ErPfg: string;
                export const ExchangeRate: string;
                export const ExciseTaxAmt: string;
                export const Id: string;
                export const LastDateStatusChange: string;
                export const LastUpdate: string;
                export const NetAmt: string;
                export const NetExVat: string;
                export const NetTotalInVat: string;
                export const POTypeFg: string;
                export const PayTermCode: string;
                export const PaymentAmt: string;
                export const PaymentBeforeDisc: string;
                export const PaymentDicsAmt: string;
                export const PaymentDicsRemark: string;
                export const PaymentNetAmt: string;
                export const PaymentRefNo: string;
                export const PaymentType: string;
                export const PostDate: string;
                export const PostFg: string;
                export const PurInvoiceAmt: string;
                export const PurIvNo: string;
                export const ReceiptAmt: string;
                export const RefDocNo1: string;
                export const RefDocNo2: string;
                export const RefType: string;
                export const Refuse: string;
                export const RejectFg: string;
                export const Remark: string;
                export const SalesVatTypes: string;
                export const SendForAppfg: string;
                export const ShipDate: string;
                export const ShipId: string;
                export const ShopId: string;
                export const SupplierId: string;
                export const SysDocNo: string;
                export const TaxInvoiceDate: string;
                export const TaxInvoiceNo: string;
                export const TotalAmt: string;
                export const UpdateBy: string;
                export const UseFg: string;
                export const VatAmt: string;
                export const VatCode: string;
                export const VatFg: string;
                export const VatRate: string;
                export const WhsId: string;
                export const WhtAmt: string;
            }

            namespace PoPurInvoiceDt {
                export const AlocalteDiscAmt: string;
                export const BeforeDiscAmt: string;
                export const DiscAmt: string;
                export const DiscText: string;
                export const ExpDate: string;
                export const Id: string;
                export const ItemAmt: string;
                export const ItemExVatAmt: string;
                export const ItemExciseTaxAmt: string;
                export const ItemNetAmt: string;
                export const ItemNetCostValue: string;
                export const ItemVatAmt: string;
                export const LastPurUnitPrice: string;
                export const LineItemNo: string;
                export const PrLineId: string;
                export const PrRefDocNo: string;
                export const PurUnit: string;
                export const PurUnitPrice: string;
                export const PurUnitRatio: string;
                export const Qty: string;
                export const QtyUse: string;
                export const Remark: string;
                export const SalesVatTypes: string;
                export const ShopId: string;
                export const SkuCode: string;
                export const SkuDesc: string;
                export const StkQty: string;
                export const SupplierId: string;
                export const SysDocNo: string;
                export const UnitChange: string;
                export const UnitCost: string;
                export const UseFg: string;
                export const VatCode: string;
                export const VatRate: string;
                export const VatType: string;
                export const WhsId: string;
            }

            namespace PoPurOrder {
                export const ApproveBy: string;
                export const ApproveDate: string;
                export const ApproveFg: string;
                export const ApproveLv: string;
                export const BranchCode: string;
                export const CancelFg: string;
                export const CashOrTermfg: string;
                export const CheckQty: string;
                export const ConcatRefDocNo1: string;
                export const CreateBy: string;
                export const CreateDate: string;
                export const DepositAmt: string;
                export const DiscAmt: string;
                export const DiscText: string;
                export const DocDate: string;
                export const DocNo: string;
                export const DtList: string;
                export const Id: string;
                export const LastDateStatusChange: string;
                export const LastUpdate: string;
                export const NetAmt: string;
                export const NetExVat: string;
                export const NetTotalInVat: string;
                export const POTypeFg: string;
                export const PayTermCode: string;
                export const PurDocNo: string;
                export const PurOrderAmt: string;
                export const RefDocNo1: string;
                export const RefDocNo2: string;
                export const Refuse: string;
                export const RejectFg: string;
                export const Remark: string;
                export const SalesVatTypes: string;
                export const SendForAppfg: string;
                export const ShipDate: string;
                export const ShipId: string;
                export const ShipLineAddress1: string;
                export const ShipLineAddress2: string;
                export const ShipLineAddress3: string;
                export const ShipName: string;
                export const ShopId: string;
                export const SupplName: string;
                export const SupplierId: string;
                export const SysDocNo: string;
                export const TotalAmt: string;
                export const UpdateBy: string;
                export const UseFg: string;
                export const VatAmt: string;
                export const VatCode: string;
                export const VatFg: string;
                export const VatRate: string;
                export const WhsId: string;
            }

            namespace PoPurOrderApp {
                export const AppList: string;
                export const ApproveBy: string;
                export const ApproveDate: string;
                export const ApproveFg: string;
                export const ApproveLv: string;
                export const CancelFg: string;
                export const CreateBy: string;
                export const CreateDate: string;
                export const DiscAmt: string;
                export const DiscText: string;
                export const DocDate: string;
                export const DocNo: string;
                export const DtList: string;
                export const Id: string;
                export const LastDateStatusChange: string;
                export const LastUpdate: string;
                export const NetAmt: string;
                export const NetExVat: string;
                export const NetTotalInVat: string;
                export const POTypeFg: string;
                export const PayTermCode: string;
                export const PurDocNo: string;
                export const PurOrderAmt: string;
                export const RefDocNo1: string;
                export const RefDocNo2: string;
                export const Refuse: string;
                export const RejectFg: string;
                export const Remark: string;
                export const SalesVatTypes: string;
                export const SendForAppfg: string;
                export const ShipDate: string;
                export const ShipId: string;
                export const ShipLineAddress1: string;
                export const ShipLineAddress2: string;
                export const ShipLineAddress3: string;
                export const ShipName: string;
                export const ShopId: string;
                export const SupplierId: string;
                export const SysDocNo: string;
                export const TotalAmt: string;
                export const UpdateBy: string;
                export const UseFg: string;
                export const VatAmt: string;
                export const VatCode: string;
                export const VatFg: string;
                export const VatRate: string;
                export const WhsId: string;
            }

            namespace PoPurOrderDt {
                export const AlocalteDiscAmt: string;
                export const BeforeDiscAmt: string;
                export const DiscAmt: string;
                export const DiscText: string;
                export const ExpDate: string;
                export const Id: string;
                export const ItemAmt: string;
                export const ItemExVatAmt: string;
                export const ItemNetAmt: string;
                export const ItemNetCostValue: string;
                export const ItemVatAmt: string;
                export const LastPurUnitPrice: string;
                export const LineItemNo: string;
                export const PrLineId: string;
                export const PrRefDocNo: string;
                export const PurUnit: string;
                export const PurUnitPrice: string;
                export const PurUnitRatio: string;
                export const Qty: string;
                export const QtyUse: string;
                export const Remark: string;
                export const SalesVatTypes: string;
                export const ShopId: string;
                export const SkuCode: string;
                export const SkuDesc: string;
                export const StkQty: string;
                export const SupplItemCode: string;
                export const SupplierId: string;
                export const SysDocNo: string;
                export const UnitChange: string;
                export const UnitCost: string;
                export const UseFg: string;
                export const VatCode: string;
                export const VatRate: string;
                export const VatType: string;
                export const WhsId: string;
            }

            namespace PoPurRequest {
                export const ApproveBy: string;
                export const ApproveDate: string;
                export const ApproveFg: string;
                export const ApproveLv: string;
                export const BranchCode: string;
                export const CancelFg: string;
                export const CreateBy: string;
                export const CreateDate: string;
                export const DiscAmt: string;
                export const DiscText: string;
                export const DocDate: string;
                export const DocNo: string;
                export const DtList: string;
                export const Id: string;
                export const LastDateStatusChange: string;
                export const LastUpdate: string;
                export const NetAmt: string;
                export const NetExVat: string;
                export const NetTotalInVat: string;
                export const POTypeFg: string;
                export const PayTermCode: string;
                export const PurDocNo: string;
                export const PurOrderAmt: string;
                export const RefDocNo1: string;
                export const RefDocNo2: string;
                export const Refuse: string;
                export const RejectFg: string;
                export const Remark: string;
                export const SalesVatTypes: string;
                export const SendForAppfg: string;
                export const ShipDate: string;
                export const ShipId: string;
                export const ShipLineAddress1: string;
                export const ShipLineAddress2: string;
                export const ShipLineAddress3: string;
                export const ShipName: string;
                export const ShopId: string;
                export const SupplName: string;
                export const SupplierId: string;
                export const SysDocNo: string;
                export const TotalAmt: string;
                export const UpdateBy: string;
                export const UseFg: string;
                export const VatAmt: string;
                export const VatCode: string;
                export const VatFg: string;
                export const VatRate: string;
                export const WhsId: string;
            }

            namespace PoPurRequestApp {
                export const AppList: string;
                export const ApproveBy: string;
                export const ApproveDate: string;
                export const ApproveFg: string;
                export const ApproveLv: string;
                export const CancelFg: string;
                export const CreateBy: string;
                export const CreateDate: string;
                export const DiscAmt: string;
                export const DiscText: string;
                export const DocDate: string;
                export const DocNo: string;
                export const DtList: string;
                export const Id: string;
                export const LastDateStatusChange: string;
                export const LastUpdate: string;
                export const NetAmt: string;
                export const NetExVat: string;
                export const NetTotalInVat: string;
                export const POTypeFg: string;
                export const PayTermCode: string;
                export const PurDocNo: string;
                export const PurOrderAmt: string;
                export const RefDocNo1: string;
                export const RefDocNo2: string;
                export const Refuse: string;
                export const RejectFg: string;
                export const Remark: string;
                export const SalesVatTypes: string;
                export const SendForAppfg: string;
                export const ShipDate: string;
                export const ShipId: string;
                export const ShipLineAddress1: string;
                export const ShipLineAddress2: string;
                export const ShipLineAddress3: string;
                export const ShipName: string;
                export const SupplierId: string;
                export const SysDocNo: string;
                export const TotalAmt: string;
                export const UpdateBy: string;
                export const UseFg: string;
                export const VatAmt: string;
                export const VatCode: string;
                export const VatFg: string;
                export const VatRate: string;
                export const WhsId: string;
            }

            namespace PoPurRequestDt {
                export const AlocalteDiscAmt: string;
                export const BeforeDiscAmt: string;
                export const DiscAmt: string;
                export const DiscText: string;
                export const ExpDate: string;
                export const Id: string;
                export const ItemAmt: string;
                export const ItemExVatAmt: string;
                export const ItemNetAmt: string;
                export const ItemNetCostValue: string;
                export const ItemVatAmt: string;
                export const LastPurUnitPrice: string;
                export const LineItemNo: string;
                export const PoRefDocNo: string;
                export const PurUnit: string;
                export const PurUnitPrice: string;
                export const PurUnitRatio: string;
                export const Qty: string;
                export const QtyUse: string;
                export const Remark: string;
                export const SalesVatTypes: string;
                export const ShopId: string;
                export const SkuCode: string;
                export const SkuDesc: string;
                export const StkQty: string;
                export const SupplierId: string;
                export const SysDocNo: string;
                export const UnitChange: string;
                export const UnitCost: string;
                export const UseFg: string;
                export const VatCode: string;
                export const VatRate: string;
                export const VatType: string;
                export const WhsId: string;
            }

            namespace PoShipAddress {
                export const CreateBy: string;
                export const CreateDate: string;
                export const Id: string;
                export const LastUpdate: string;
                export const LookupName: string;
                export const ShipId: string;
                export const ShipLineAddress1: string;
                export const ShipLineAddress2: string;
                export const ShipLineAddress3: string;
                export const ShipName: string;
                export const ShopId: string;
                export const UpdateBy: string;
                export const WhsId: string;
            }

            namespace PoSupplier {
                export const AuthEmail: string;
                export const AuthMobile: string;
                export const AuthPerson: string;
                export const AuthTel: string;
                export const AuthTelExt: string;
                export const BranchCode: string;
                export const BranchName: string;
                export const CompanyCode: string;
                export const ConsignFg: string;
                export const ConsignGp: string;
                export const ContactName: string;
                export const CreateBy: string;
                export const CreateDate: string;
                export const CreditTerm: string;
                export const Ctaxtype: string;
                export const CustBranch: string;
                export const ErpSreachName: string;
                export const ErpVenderCode: string;
                export const ErpVendorBlock: string;
                export const ErpVendorType: string;
                export const FaxExt: string;
                export const FaxNo: string;
                export const Id: string;
                export const LastUpdate: string;
                export const PayMethod: string;
                export const PurVatCode: string;
                export const PurVatRate: string;
                export const PurVatType: string;
                export const Remark: string;
                export const ReturnOutRemark: string;
                export const SaleEmail: string;
                export const SaleMobile: string;
                export const SalePerson: string;
                export const SaleTel: string;
                export const SaleTelExt: string;
                export const Status: string;
                export const SupEmail: string;
                export const SupTelNo: string;
                export const SupplAddress: string;
                export const SupplId: string;
                export const SupplName: string;
                export const SupplRegAddress: string;
                export const SupplRegName: string;
                export const SupplTaxId: string;
                export const SupplType: string;
                export const SupplierShortName: string;
                export const TelMobile: string;
                export const TelNoExt: string;
                export const TradeTerm: string;
                export const UpdateBy: string;
            }

            namespace ReportDailyCN {
                export const CreditNoteAmt: string;
                export const CreditNoteNo: string;
                export const DepositAmt: string;
                export const DiscAmt: string;
                export const DocDate: string;
                export const DueDate: string;
                export const ExciseTaxAmt: string;
                export const Id: string;
                export const NetAmt: string;
                export const PayTermCode: string;
                export const RefDocNo1: string;
                export const SupplName: string;
                export const SupplierId: string;
                export const SysDocNo: string;
                export const TotalAmt: string;
                export const VatAmt: string;
                export const WhsId: string;
            }

            namespace ReportDailyPI {
                export const DepositAmt: string;
                export const DiscAmt: string;
                export const DocDate: string;
                export const DtList: string;
                export const DueDate: string;
                export const ExciseTaxAmt: string;
                export const Id: string;
                export const NetAmt: string;
                export const PayTermCode: string;
                export const PurInvoiceAmt: string;
                export const PurIvNo: string;
                export const RefDocNo1: string;
                export const SupplName: string;
                export const SupplierId: string;
                export const SysDocNo: string;
                export const TotalAmt: string;
                export const VatAmt: string;
                export const WhsId: string;
            }

            namespace ReportPendingPO {
                export const DocDate: string;
                export const DocNo: string;
                export const DtList: string;
                export const PayTermCode: string;
                export const PurOrderAmt: string;
                export const RefDocNo1: string;
                export const RefDocNo2: string;
                export const Remark: string;
                export const ShipDate: string;
                export const ShipId: string;
                export const ShipName: string;
                export const SupplName: string;
                export const SupplierId: string;
                export const SysDocNo: string;
                export const UseFg: string;
                export const WhsId: string;
            }

            namespace ReportPendingPODt {
                export const Id: string;
                export const LessCost: string;
                export const LessQty: string;
                export const LineItemNo: string;
                export const PrRefDocNo: string;
                export const PurUnit: string;
                export const Qty: string;
                export const QtyUse: string;
                export const Remark: string;
                export const SkuCode: string;
                export const SkuDesc: string;
                export const StkQty: string;
                export const StkUnit: string;
                export const SysDocNo: string;
                export const UnitCost: string;
                export const UnitQty: string;
                export const UseFg: string;
            }

            namespace ReportPendingPR {
                export const DocDate: string;
                export const DocNo: string;
                export const DtList: string;
                export const PayTermCode: string;
                export const PurOrderAmt: string;
                export const RefDocNo1: string;
                export const RefDocNo2: string;
                export const Remark: string;
                export const ShipDate: string;
                export const ShipId: string;
                export const ShipName: string;
                export const SupplName: string;
                export const SupplierId: string;
                export const SysDocNo: string;
                export const UseFg: string;
                export const WhsId: string;
            }

            namespace ReportPendingPRDt {
                export const Id: string;
                export const LessCost: string;
                export const LessQty: string;
                export const LineItemNo: string;
                export const PoRefDocNo: string;
                export const PurUnit: string;
                export const Qty: string;
                export const QtyUse: string;
                export const Remark: string;
                export const SkuCode: string;
                export const SkuDesc: string;
                export const StkQty: string;
                export const StkUnit: string;
                export const SysDocNo: string;
                export const UnitCost: string;
                export const UnitQty: string;
                export const UseFg: string;
            }

            namespace ReportPurTax {
                export const Id: string;
                export const Lineitemno: string;
                export const NetAmt: string;
                export const SupplName: string;
                export const SupplTaxId: string;
                export const TaxInvoiceDate: string;
                export const TaxInvoiceNo: string;
                export const TotalAmt: string;
                export const VatAmt: string;
            }

            namespace ReportPurTaxLong {
                export const DocDate: string;
                export const Id: string;
                export const Lineitemno: string;
                export const NetAmt: string;
                export const RefDocNo1: string;
                export const SupplName: string;
                export const SupplTaxId: string;
                export const TaxInvoiceDate: string;
                export const TaxInvoiceNo: string;
                export const TotalAmt: string;
                export const VatAmt: string;
            }

            namespace SysTender {
                export const TenderCode: string;
                export const TenderName: string;
                export const TenderType: string;
            }

            namespace VwPaytermCodeLookup {
                export const CreateBy: string;
                export const CreateDate: string;
                export const CreditTerm: string;
                export const Id: string;
                export const LastUpdate: string;
                export const LookupName: string;
                export const PayTermCode: string;
                export const PayTermDesc: string;
                export const UpdateBy: string;
            }
        }

        namespace QRreport {

            namespace QDayData {
                export const Day: string;
                export const DayName: string;
                export const DayNameEn: string;
                export const Id: string;
            }

            namespace QHourTime {
                export const HourTime: string;
                export const HourTimeName: string;
                export const HourTimeNameEn: string;
                export const Id: string;
            }

            namespace QMonth {
                export const FullName: string;
                export const Id: string;
                export const Month: string;
                export const MonthName: string;
                export const MonthNameEn: string;
                export const Months: string;
            }

            namespace QRyStockcard {
                export const CreateBy: string;
                export const DateEnd: string;
                export const Id: string;
                export const ListFg: string;
                export const PluCode: string;
                export const PostSequenceFg: string;
                export const ShopId: string;
                export const SkuCode: string;
                export const SumWhsFg: string;
                export const WhsFg: string;
                export const WhsId: string;
            }

            namespace QRyreport {
                export const CreateBy: string;
                export const CreateDate: string;
                export const DataStructureName: string;
                export const FullName: string;
                export const Id: string;
                export const QRFunctionsGroupby_A: string;
                export const QRFunctionsLength_B: string;
                export const QRSubViewName: string;
                export const QrViewName: string;
                export const RemarkNote: string;
                export const ReportId: string;
                export const ReportName: string;
                export const UrlReport: string;
            }

            namespace QRywcSpec {
                export const BrandCode: string;
                export const CashierId: string;
                export const CatCode: string;
                export const ColorId: string;
                export const ConsignFg: string;
                export const CreateBy: string;
                export const CreateDate: string;
                export const DataStructureName: string;
                export const DateBegin: string;
                export const DateEnd: string;
                export const DayOfWeek: string;
                export const DiscCouponType: string;
                export const DocMonth: string;
                export const DocMonthEnd: string;
                export const DocTime: string;
                export const DocTimeEnd: string;
                export const DocTimeStart: string;
                export const DocYear: string;
                export const DocYearEnd: string;
                export const GruopType: string;
                export const Id: string;
                export const LineItemType: string;
                export const LineNo: string;
                export const MatTypeId: string;
                export const MbId: string;
                export const MbType: string;
                export const PaymentType: string;
                export const PluCode: string;
                export const PmGroupFg: string;
                export const PmGroupId: string;
                export const PmType: string;
                export const PmTypeFg: string;
                export const PosId: string;
                export const PromoCampaign: string;
                export const PromoId: string;
                export const Qty_AmtFg: string;
                export const ReportId: string;
                export const ReportName: string;
                export const SalemanId: string;
                export const ShopFg: string;
                export const ShopGroupId: string;
                export const ShopId: string;
                export const ShopTypeId: string;
                export const SizeId: string;
                export const SkuCode: string;
                export const StyleId: string;
                export const SubCat1Code: string;
                export const SubCat2Code: string;
                export const SupplId: string;
                export const TasteId: string;
                export const UrlReport: string;
                export const WcNumberic: string;
                export const WcText: string;
                export const WhsId: string;
                export const pSequenFg: string;
            }
        }

        namespace RefundReasonReport {

            namespace ReportRefundReasonByBill {
                export const AllItemDiscount: string;
                export const AppRefund: string;
                export const BillCharge: string;
                export const CashierId: string;
                export const CashierName: string;
                export const DocDate: string;
                export const DocNo: string;
                export const DocTime: string;
                export const GrossSales: string;
                export const Id: string;
                export const MbId: string;
                export const MbNameT: string;
                export const NetSales: string;
                export const NetSalesExVat: string;
                export const PosId: string;
                export const RefundId: string;
                export const RefundReason: string;
                export const SalesmanId: string;
                export const SalesmanName: string;
                export const ShopId: string;
                export const ShopName: string;
                export const VatOfCharge: string;
                export const VatOfNetSales: string;
            }

            namespace ReportRefundReasonByItem {
                export const AppRefund: string;
                export const CashierId: string;
                export const DocDate: string;
                export const DocNo: string;
                export const Id: string;
                export const ItemDesc: string;
                export const PluCode: string;
                export const PosId: string;
                export const Price: string;
                export const Qty: string;
                export const RefDate: string;
                export const RefDoc: string;
                export const RefundId: string;
                export const RefundReason: string;
            }

            namespace ReportRefundReasonSumBill {
                export const AllItemCharge: string;
                export const AllItemDiscount: string;
                export const BillQty: string;
                export const DtList: string;
                export const GrossSales: string;
                export const Id: string;
                export const NetSales: string;
                export const NetSalesExVat: string;
                export const RefundId: string;
                export const RefundReason: string;
                export const VatOfCharge: string;
                export const VatOfNetSales: string;
            }

            namespace ReportRefundReasonSumBillDt {
                export const AllItemDiscount: string;
                export const BillCharge: string;
                export const CashierId: string;
                export const CashierName: string;
                export const DocDate: string;
                export const DocNo: string;
                export const DocTime: string;
                export const GrossSales: string;
                export const Id: string;
                export const MbId: string;
                export const MbNameT: string;
                export const NetSales: string;
                export const NetSalesExVat: string;
                export const NetSalesNonVat: string;
                export const PosId: string;
                export const RefundId: string;
                export const RefundReason: string;
                export const SalesmanId: string;
                export const SalesmanName: string;
                export const ShopId: string;
                export const ShopName: string;
                export const VatOfCharge: string;
                export const VatOfNetSales: string;
            }
        }

        namespace ReportMasterData {

            namespace Report1332ShopPaymentTypeRefType {
                export const CurrencyAmt: string;
                export const DocDate: string;
                export const ExchangeRate: string;
                export const Id: string;
                export const PaymentName: string;
                export const PaymentType: string;
                export const ReceiptAmt: string;
                export const ReceiptInAmt: string;
                export const ReceiptOutAmt: string;
                export const RefName: string;
                export const RefType: string;
                export const ShopId: string;
                export const ShopName: string;
            }

            namespace Report_1101 {
                export const ActiveFg: string;
                export const BrandCode: string;
                export const BrandName: string;
                export const CatCode: string;
                export const CatName: string;
                export const ColorId: string;
                export const ColorName: string;
                export const CreateBy: string;
                export const CreateDate: string;
                export const MatTypeId: string;
                export const MatTypeName: string;
                export const MaxStockQty: string;
                export const MinStockQty: string;
                export const PluCode: string;
                export const PluDesc: string;
                export const ProductType: string;
                export const PurLeadTime: string;
                export const PurUnit: string;
                export const PurUnitPrice: string;
                export const PurUnitRatio: string;
                export const SellUnit: string;
                export const SellUnitPrice1: string;
                export const SellUnitPrice2: string;
                export const SellUnitPrice3: string;
                export const SellUnitPrice4: string;
                export const SellUnitPrice5: string;
                export const SellUnitPrice6: string;
                export const SellUnitRatio: string;
                export const SizeId: string;
                export const SizeName: string;
                export const SkuCode: string;
                export const StkUnit: string;
                export const StyleId: string;
                export const StyleName: string;
                export const SubCat1Code: string;
                export const SubCat1Name: string;
                export const SubCat2Code: string;
                export const SubCat2Name: string;
                export const SupplItemCode: string;
                export const SupplName: string;
                export const SupplierId: string;
                export const TasteId: string;
                export const TasteName: string;
                export const VatCode: string;
                export const VatType: string;
            }

            namespace Report_1102 {
                export const BrandCode: string;
                export const BrandName: string;
                export const CatCode: string;
                export const CatName: string;
                export const ColorId: string;
                export const ColorName: string;
                export const PluCode: string;
                export const PluDesc: string;
                export const SellUnit: string;
                export const SellUnitPrice1: string;
                export const SellUnitPrice2: string;
                export const SellUnitPrice3: string;
                export const SellUnitPrice4: string;
                export const SellUnitPrice5: string;
                export const SellUnitPrice6: string;
                export const SizeId: string;
                export const SizeName: string;
                export const SkuCode: string;
                export const StyleId: string;
                export const StyleName: string;
                export const SubCat1Code: string;
                export const SubCat1Name: string;
                export const SubCat2Code: string;
                export const SubCat2Name: string;
                export const SupplName: string;
                export const SupplierId: string;
                export const VatCode: string;
                export const VatType: string;
            }

            namespace Report_1103 {
                export const BrandCode: string;
                export const BrandName: string;
                export const CatCode: string;
                export const CatName: string;
                export const CostPrice: string;
                export const PluCode: string;
                export const PluDesc: string;
                export const SellUnit: string;
                export const SellUnitPrice1: string;
                export const SellUnitPrice2: string;
                export const SellUnitPrice3: string;
                export const SellUnitPrice4: string;
                export const SellUnitPrice5: string;
                export const SellUnitPrice6: string;
                export const SkuCode: string;
                export const SubCat1Code: string;
                export const SubCat1Name: string;
                export const SubCat2Code: string;
                export const SubCat2Name: string;
                export const SupplName: string;
                export const SupplierId: string;
                export const VatCode: string;
                export const VatType: string;
            }

            namespace Report_1104 {
                export const ConsignFg: string;
                export const ContactName: string;
                export const ShortName: string;
                export const SupTelNo: string;
                export const SupplAddress: string;
                export const SupplId: string;
                export const SupplName: string;
                export const SupplRegName: string;
                export const SupplTaxId: string;
                export const SupplType: string;
            }

            namespace Report_1105 {
                export const MbAccumPoint: string;
                export const MbAmphur: string;
                export const MbCardStatus: string;
                export const MbExpireDate: string;
                export const MbExpirePointDate: string;
                export const MbId: string;
                export const MbNameT: string;
                export const MbNearlyExpirePoint: string;
                export const MbProvince: string;
                export const MbTumbol: string;
                export const MbType: string;
            }

            namespace Report_1201 {
                export const AdvDiscount: string;
                export const AllItemCharge: string;
                export const AllItemDiscount: string;
                export const BillCharge: string;
                export const BillDiscount: string;
                export const CashierId: string;
                export const CashierName: string;
                export const CreateBy: string;
                export const CreateDate: string;
                export const DiscList: string;
                export const DocAmt: string;
                export const DocDate: string;
                export const DocNo: string;
                export const DocTime: string;
                export const DtList: string;
                export const Factor: string;
                export const GrossSales: string;
                export const Id: string;
                export const LastUpdate: string;
                export const MbId: string;
                export const MbNameT: string;
                export const NetSales: string;
                export const NetSalesExVat: string;
                export const NetSalesNonVat: string;
                export const NetSalesNormal: string;
                export const NetSalesPromo: string;
                export const PosId: string;
                export const ReceiveCash: string;
                export const ReceiveCashCd: string;
                export const ReceiveCoupon: string;
                export const ReceiveCreditCd: string;
                export const ReceiveDebitCd: string;
                export const ReceiveNet: string;
                export const ReceiveOthers: string;
                export const ReceivePoint: string;
                export const RecvList: string;
                export const RefDocNo: string;
                export const RoundAdjust: string;
                export const SalesVatType: string;
                export const SalesmanId: string;
                export const SalesmanName: string;
                export const ShopGroupId: string;
                export const ShopGroupName: string;
                export const ShopId: string;
                export const ShopName: string;
                export const ShopTypeId: string;
                export const ShopTypeName: string;
                export const TotalItem: string;
                export const TotalQty: string;
                export const UpdateBy: string;
                export const Vat: string;
                export const VatOfCharge: string;
                export const VatOfNetSales: string;
            }

            namespace Report_1201_Disc {
                export const ChargeAmt: string;
                export const ChargePc: string;
                export const CreateBy: string;
                export const CreateDate: string;
                export const DiscCouponNo: string;
                export const DiscCouponType: string;
                export const DiscPc: string;
                export const Discamt: string;
                export const DocNo: string;
                export const Id: string;
                export const ItemDesc: string;
                export const LastUpdate: string;
                export const LineItemNo: string;
                export const LineItemType: string;
                export const PromoId: string;
                export const UpdateBy: string;
            }

            namespace Report_1201_Dt {
                export const AllocatedBillDiscount: string;
                export const ChargeAmt: string;
                export const ChargePc: string;
                export const CreateBy: string;
                export const CreateDate: string;
                export const DiscCouponNo: string;
                export const DiscCouponType: string;
                export const DiscPc: string;
                export const Discamt: string;
                export const DocNo: string;
                export const ExPrice: string;
                export const Id: string;
                export const ItemCharge: string;
                export const ItemDesc: string;
                export const ItemDiscount: string;
                export const ItemNetExprice: string;
                export const ItemNetSales: string;
                export const ItemPromoFg: string;
                export const ItemPromoId: string;
                export const ItemVat: string;
                export const ItemVatRate: string;
                export const ItemVatType: string;
                export const LastUpdate: string;
                export const LineItemNo: string;
                export const LineItemType: string;
                export const PluCode: string;
                export const PosFg: string;
                export const PromoId: string;
                export const Qty: string;
                export const QtyRefund: string;
                export const RefLineItemNo: string;
                export const SellUnit: string;
                export const SerialNo: string;
                export const UnitPrice: string;
                export const UpdateBy: string;
            }

            namespace Report_1201_Recv {
                export const ApprovalCode: string;
                export const CreateBy: string;
                export const CreateDate: string;
                export const Currency: string;
                export const CurrencyAmt: string;
                export const CurrencyCode: string;
                export const DocNo: string;
                export const ExchangeRate: string;
                export const Id: string;
                export const InvoiceNo: string;
                export const LastUpdate: string;
                export const LineItemNo: string;
                export const LineItemType: string;
                export const PaymentName: string;
                export const PaymentType: string;
                export const PointBurn: string;
                export const ReceiptAmt: string;
                export const RefNo: string;
                export const RefType: string;
                export const UpdateBy: string;
            }

            namespace Report_1301 {
                export const AllItemCharge: string;
                export const AllItemDiscount: string;
                export const DocDate: string;
                export const FullName: string;
                export const GrossSales: string;
                export const Id: string;
                export const NetSales: string;
                export const NetSalesExVat: string;
                export const ShopId: string;
                export const ShopName: string;
                export const VatOfCharge: string;
                export const VatOfNetSales: string;
            }

            namespace Report_1302 {
                export const AllItemCharge: string;
                export const AllItemDiscount: string;
                export const DocDate: string;
                export const FullName: string;
                export const GrossSales: string;
                export const Id: string;
                export const NetSales: string;
                export const NetSalesExVat: string;
                export const PosId: string;
                export const ShopId: string;
                export const ShopName: string;
                export const VatOfCharge: string;
                export const VatOfNetSales: string;
            }

            namespace Report_1303 {
                export const AllItemCharge: string;
                export const AllItemDiscount: string;
                export const CashierId: string;
                export const CashierName: string;
                export const DocDate: string;
                export const FullName: string;
                export const FullName2: string;
                export const GrossSales: string;
                export const Id: string;
                export const NetSales: string;
                export const NetSalesExVat: string;
                export const ShopId: string;
                export const ShopName: string;
                export const VatOfCharge: string;
                export const VatOfNetSales: string;
            }

            namespace Report_1308 {
                export const AllItemCharge: string;
                export const AllItemDiscount: string;
                export const DocDate: string;
                export const DocDates: string;
                export const FullName: string;
                export const GrossSales: string;
                export const Id: string;
                export const NetSales: string;
                export const NetSalesExVat: string;
                export const ShopId: string;
                export const ShopName: string;
                export const VatOfCharge: string;
                export const VatOfNetSales: string;
            }

            namespace Report_1309 {
                export const AllItemCharge: string;
                export const AllItemDiscount: string;
                export const DayOfWeek: string;
                export const DocDate: string;
                export const FullName: string;
                export const GrossSales: string;
                export const ID: string;
                export const NetSales: string;
                export const NetSalesExVat: string;
                export const ShopId: string;
                export const ShopName: string;
                export const VatOfCharge: string;
                export const VatOfNetSales: string;
            }

            namespace Report_1310 {
                export const AllItemCharge: string;
                export const AllItemDiscount: string;
                export const DocDate: string;
                export const DocTime: string;
                export const FullName: string;
                export const GrossSales: string;
                export const Id: string;
                export const NetSales: string;
                export const NetSalesExVat: string;
                export const ShopId: string;
                export const ShopName: string;
                export const VatOfCharge: string;
                export const VatOfNetSales: string;
            }

            namespace Report_1311 {
                export const AllItemDiscount: string;
                export const CatCode: string;
                export const CatName: string;
                export const DocDate: string;
                export const FullName: string;
                export const FullName1: string;
                export const GrossSales: string;
                export const Id: string;
                export const NetSales: string;
                export const NetSalesExVat: string;
                export const Qty: string;
                export const ShopId: string;
                export const ShopName: string;
                export const VatOfNetSales: string;
            }

            namespace Report_1312 {
                export const AllItemDiscount: string;
                export const DocDate: string;
                export const FullName: string;
                export const FullName2: string;
                export const GrossSales: string;
                export const Id: string;
                export const NetSales: string;
                export const NetSalesExVat: string;
                export const Qty: string;
                export const ShopId: string;
                export const ShopName: string;
                export const SubCat1Code: string;
                export const SubCat1Name: string;
                export const VatOfNetSales: string;
            }

            namespace Report_1313 {
                export const AllItemDiscount: string;
                export const DocDate: string;
                export const FullName: string;
                export const FullName3: string;
                export const GrossSales: string;
                export const Id: string;
                export const NetSales: string;
                export const NetSalesExVat: string;
                export const Qty: string;
                export const ShopId: string;
                export const ShopName: string;
                export const SubCat2Code: string;
                export const SubCat2Name: string;
                export const VatOfNetSales: string;
            }

            namespace Report_1314 {
                export const AllItemDiscount: string;
                export const BrandCode: string;
                export const BrandName: string;
                export const CatCode: string;
                export const CatName: string;
                export const ColorId: string;
                export const ColorName: string;
                export const DocDate: string;
                export const FullName: string;
                export const GrossSales: string;
                export const Id: string;
                export const MatTypeId: string;
                export const MatTypeName: string;
                export const NetSales: string;
                export const NetSalesExVat: string;
                export const PluCode: string;
                export const PluDesc: string;
                export const PluShortDesc: string;
                export const Qty: string;
                export const ShopId: string;
                export const ShopName: string;
                export const SizeId: string;
                export const SizeName: string;
                export const StyleId: string;
                export const StyleName: string;
                export const SubCat1Code: string;
                export const SubCat1Name: string;
                export const SubCat2Code: string;
                export const SubCat2Name: string;
                export const SupplId: string;
                export const SupplName: string;
                export const TasteId: string;
                export const TasteName: string;
                export const VatOfNetSales: string;
            }

            namespace Report_1315 {
                export const AllItemDiscount: string;
                export const DocDate: string;
                export const FullName: string;
                export const FullName1: string;
                export const GrossSales: string;
                export const Id: string;
                export const NetSales: string;
                export const NetSalesExVat: string;
                export const Qty: string;
                export const ShopId: string;
                export const ShopName: string;
                export const SupplId: string;
                export const SupplName: string;
                export const VatOfNetSales: string;
            }

            namespace Report_1316 {
                export const AllItemCharge: string;
                export const AllItemDiscount: string;
                export const DocDate: string;
                export const FullName: string;
                export const FullName1: string;
                export const GrossSales: string;
                export const Id: string;
                export const NetSales: string;
                export const NetSalesExVat: string;
                export const SalemanId: string;
                export const SalesmanName: string;
                export const ShopId: string;
                export const ShopName: string;
                export const VatOfCharge: string;
                export const VatOfNetSales: string;
            }

            namespace Report_1317 {
                export const AllItemCharge: string;
                export const AllItemDiscount: string;
                export const DocDate: string;
                export const FullName: string;
                export const FullName1: string;
                export const GrossSales: string;
                export const Id: string;
                export const MbId: string;
                export const MbNameT: string;
                export const NetSales: string;
                export const NetSalesExVat: string;
                export const ShopId: string;
                export const ShopName: string;
                export const VatOfCharge: string;
                export const VatOfNetSales: string;
            }

            namespace Report_1318 {
                export const AllItemDiscount: string;
                export const BrandCode: string;
                export const BrandName: string;
                export const CatCode: string;
                export const CatName: string;
                export const ColorId: string;
                export const ColorName: string;
                export const DocDate: string;
                export const FullName: string;
                export const FullName1: string;
                export const GrossSales: string;
                export const Id: string;
                export const MatTypeId: string;
                export const MatTypeName: string;
                export const NetSales: string;
                export const NetSalesExVat: string;
                export const PluCode: string;
                export const PluDesc: string;
                export const PluShortDesc: string;
                export const Qty: string;
                export const ShopId: string;
                export const ShopName: string;
                export const SizeId: string;
                export const SizeName: string;
                export const StyleId: string;
                export const StyleName: string;
                export const SubCat1Code: string;
                export const SubCat1Name: string;
                export const SubCat2Code: string;
                export const SubCat2Name: string;
                export const SupplId: string;
                export const SupplName: string;
                export const TasteId: string;
                export const TasteName: string;
                export const VatOfNetSales: string;
            }

            namespace Report_1319 {
                export const AllItemDiscount: string;
                export const BasePrice: string;
                export const DocDate: string;
                export const GrossSales: string;
                export const Id: string;
                export const NetSales: string;
                export const NetSalesExVat: string;
                export const PromoCampaign: string;
                export const PromoDics: string;
                export const Qty: string;
                export const ShopId: string;
                export const ShopName: string;
                export const VatOfNetSales: string;
            }

            namespace Report_1320 {
                export const AllItemDiscount: string;
                export const BasePrice: string;
                export const BrandCode: string;
                export const BrandName: string;
                export const CatCode: string;
                export const CatName: string;
                export const ColorId: string;
                export const ColorName: string;
                export const DocDate: string;
                export const GrossSales: string;
                export const Id: string;
                export const MatTypeId: string;
                export const MatTypeName: string;
                export const NetSales: string;
                export const NetSalesExVat: string;
                export const PluCode: string;
                export const PluDesc: string;
                export const PluShortDesc: string;
                export const PromoCampaign: string;
                export const PromoDesc: string;
                export const PromoDics: string;
                export const PromoId: string;
                export const PromoName: string;
                export const Qty: string;
                export const ShopId: string;
                export const ShopName: string;
                export const SizeId: string;
                export const SizeName: string;
                export const StyleId: string;
                export const StyleName: string;
                export const SubCat1Code: string;
                export const SubCat1Name: string;
                export const SubCat2Code: string;
                export const SubCat2Name: string;
                export const SupplId: string;
                export const SupplName: string;
                export const TasteId: string;
                export const TasteName: string;
                export const VatOfNetSales: string;
            }

            namespace Report_1321 {
                export const AllItemDiscount: string;
                export const BrandCode: string;
                export const BrandName: string;
                export const DocDate: string;
                export const FullName: string;
                export const GrossSales: string;
                export const Id: string;
                export const NetSales: string;
                export const NetSalesExVat: string;
                export const Qty: string;
                export const ShopId: string;
                export const ShopName: string;
                export const VatOfNetSales: string;
            }

            namespace Report_1333 {
                export const DocDate: string;
                export const FullName: string;
                export const GrossSales: string;
                export const Id: string;
                export const PaymentName: string;
                export const PaymentType: string;
                export const ShopId: string;
                export const ShopName: string;
            }

            namespace Report_1334 {
                export const DocDate: string;
                export const DocNo: string;
                export const FullName: string;
                export const GrossSales: string;
                export const Id: string;
                export const ShopId: string;
                export const ShopName: string;
            }

            namespace Report_1335 {
                export const DocDate: string;
                export const DocNo: string;
                export const FullName: string;
                export const GrossSales: string;
                export const Id: string;
                export const ShopId: string;
                export const ShopName: string;
            }

            namespace Report_1336 {
                export const DocDate: string;
                export const DocNo: string;
                export const FullName: string;
                export const GrossSales: string;
                export const Id: string;
                export const ShopId: string;
                export const ShopName: string;
            }

            namespace Report_1337 {
                export const DocDate: string;
                export const DocNo: string;
                export const FullName: string;
                export const GrossSales: string;
                export const Id: string;
                export const ShopId: string;
                export const ShopName: string;
            }

            namespace Report_1401 {
                export const AllItemCharge: string;
                export const AllItemDiscount: string;
                export const DocDate: string;
                export const GrossSales: string;
                export const Id: string;
                export const NetSales: string;
                export const NetSalesExVat: string;
                export const VatOfCharge: string;
                export const VatOfNetSales: string;
            }

            namespace Report_1402 {
                export const AllItemCharge: string;
                export const AllItemDiscount: string;
                export const DayOfWeek: string;
                export const DocDate: string;
                export const GrossSales: string;
                export const Id: string;
                export const NetSales: string;
                export const NetSalesExVat: string;
                export const VatOfCharge: string;
                export const VatOfNetSales: string;
            }

            namespace Report_1403 {
                export const AllItemCharge: string;
                export const AllItemDiscount: string;
                export const DocDate: string;
                export const DocTime: string;
                export const GrossSales: string;
                export const Id: string;
                export const NetSales: string;
                export const NetSalesExVat: string;
                export const VatOfCharge: string;
                export const VatOfNetSales: string;
            }

            namespace Report_1404 {
                export const AllItemDiscount: string;
                export const CatCode: string;
                export const CatName: string;
                export const DocDate: string;
                export const GrossSales: string;
                export const Id: string;
                export const NetSales: string;
                export const NetSalesExVat: string;
                export const Qty: string;
                export const VatOfNetSales: string;
            }

            namespace Report_1405 {
                export const AllItemDiscount: string;
                export const DocDate: string;
                export const GrossSales: string;
                export const Id: string;
                export const NetSales: string;
                export const NetSalesExVat: string;
                export const Qty: string;
                export const SubCat1Code: string;
                export const SubCat1Name: string;
                export const VatOfNetSales: string;
            }

            namespace Report_1406 {
                export const AllItemDiscount: string;
                export const DocDate: string;
                export const GrossSales: string;
                export const Id: string;
                export const NetSales: string;
                export const NetSalesExVat: string;
                export const Qty: string;
                export const SubCat2Code: string;
                export const SubCat2Name: string;
                export const VatOfNetSales: string;
            }

            namespace Report_1407 {
                export const AllItemDiscount: string;
                export const BrandCode: string;
                export const BrandName: string;
                export const CatCode: string;
                export const CatName: string;
                export const ColorId: string;
                export const ColorName: string;
                export const DocDate: string;
                export const GrossSales: string;
                export const Id: string;
                export const MatTypeId: string;
                export const MatTypeName: string;
                export const NetSales: string;
                export const NetSalesExVat: string;
                export const PluCode: string;
                export const PluDesc: string;
                export const PluShortDesc: string;
                export const Qty: string;
                export const SizeId: string;
                export const SizeName: string;
                export const StyleId: string;
                export const StyleName: string;
                export const SubCat1Code: string;
                export const SubCat1Name: string;
                export const SubCat2Code: string;
                export const SubCat2Name: string;
                export const SupplId: string;
                export const SupplName: string;
                export const TasteId: string;
                export const TasteName: string;
                export const VatOfNetSales: string;
            }

            namespace Report_1408 {
                export const AllItemDiscount: string;
                export const DocDate: string;
                export const GrossSales: string;
                export const Id: string;
                export const NetSales: string;
                export const NetSalesExVat: string;
                export const Qty: string;
                export const SupplId: string;
                export const SupplName: string;
                export const VatOfNetSales: string;
            }

            namespace Report_1409 {
                export const AllItemCharge: string;
                export const AllItemDiscount: string;
                export const DocDate: string;
                export const GrossSales: string;
                export const Id: string;
                export const NetSales: string;
                export const NetSalesExVat: string;
                export const SalemanId: string;
                export const SalesmanName: string;
                export const VatOfCharge: string;
                export const VatOfNetSales: string;
            }

            namespace Report_1410 {
                export const AllItemCharge: string;
                export const AllItemDiscount: string;
                export const DocDate: string;
                export const FullName1: string;
                export const GrossSales: string;
                export const Id: string;
                export const MbId: string;
                export const MbNameT: string;
                export const NetSales: string;
                export const NetSalesExVat: string;
                export const VatOfCharge: string;
                export const VatOfNetSales: string;
            }

            namespace Report_1411 {
                export const AllItemDiscount: string;
                export const BrandCode: string;
                export const BrandName: string;
                export const CatCode: string;
                export const CatName: string;
                export const ColorId: string;
                export const ColorName: string;
                export const DocDate: string;
                export const GrossSales: string;
                export const Id: string;
                export const MatTypeId: string;
                export const MatTypeName: string;
                export const NetSales: string;
                export const NetSalesExVat: string;
                export const PluCode: string;
                export const PluDesc: string;
                export const PluShortDesc: string;
                export const Qty: string;
                export const SizeId: string;
                export const SizeName: string;
                export const StyleId: string;
                export const StyleName: string;
                export const SubCat1Code: string;
                export const SubCat1Name: string;
                export const SubCat2Code: string;
                export const SubCat2Name: string;
                export const SupplId: string;
                export const SupplName: string;
                export const TasteId: string;
                export const TasteName: string;
                export const VatOfNetSales: string;
            }

            namespace Report_1412 {
                export const AllItemDiscount: string;
                export const BasePrice: string;
                export const DocDate: string;
                export const GrossSales: string;
                export const Id: string;
                export const NetSales: string;
                export const NetSalesExVat: string;
                export const PromoCampaign: string;
                export const PromoDics: string;
                export const Qty: string;
                export const VatOfNetSales: string;
            }

            namespace Report_1413 {
                export const AllItemDiscount: string;
                export const BasePrice: string;
                export const BrandCode: string;
                export const BrandName: string;
                export const CatCode: string;
                export const CatName: string;
                export const ColorId: string;
                export const ColorName: string;
                export const DocDate: string;
                export const GrossSales: string;
                export const Id: string;
                export const MatTypeId: string;
                export const MatTypeName: string;
                export const NetSales: string;
                export const NetSalesExVat: string;
                export const PluCode: string;
                export const PluDesc: string;
                export const PluShortDesc: string;
                export const PromoCampaign: string;
                export const PromoDesc: string;
                export const PromoDics: string;
                export const PromoId: string;
                export const PromoName: string;
                export const Qty: string;
                export const SizeId: string;
                export const SizeName: string;
                export const StyleId: string;
                export const StyleName: string;
                export const SubCat1Code: string;
                export const SubCat1Name: string;
                export const SubCat2Code: string;
                export const SubCat2Name: string;
                export const SupplId: string;
                export const SupplName: string;
                export const TasteId: string;
                export const TasteName: string;
                export const VatOfNetSales: string;
            }

            namespace Report_1414 {
                export const AllItemDiscount: string;
                export const BrandCode: string;
                export const BrandName: string;
                export const DocDate: string;
                export const FullName: string;
                export const GrossSales: string;
                export const Id: string;
                export const NetSales: string;
                export const NetSalesExVat: string;
                export const Qty: string;
                export const VatOfNetSales: string;
            }

            namespace Report_1501 {
                export const AllItemDiscount: string;
                export const CatCode: string;
                export const CatName: string;
                export const DocDate: string;
                export const DocDateEn: string;
                export const GrossSales: string;
                export const Id: string;
                export const NetSales: string;
                export const NetSalesExVat: string;
                export const Qty: string;
                export const VatOfNetSales: string;
                export const Year: string;
            }

            namespace Report_1501_N {
                export const April: string;
                export const August: string;
                export const CatCode: string;
                export const CatName: string;
                export const December: string;
                export const February: string;
                export const Id: string;
                export const January: string;
                export const July: string;
                export const June: string;
                export const March: string;
                export const May: string;
                export const November: string;
                export const October: string;
                export const September: string;
                export const TypeSum: string;
                export const Year: string;
            }

            namespace Report_1502 {
                export const AllItemDiscount: string;
                export const DocDate: string;
                export const DocDateEn: string;
                export const GrossSales: string;
                export const Id: string;
                export const NetSales: string;
                export const NetSalesExVat: string;
                export const Qty: string;
                export const SubCat1Code: string;
                export const SubCat1Name: string;
                export const VatOfNetSales: string;
                export const Year: string;
            }

            namespace Report_1502_N {
                export const April: string;
                export const August: string;
                export const December: string;
                export const February: string;
                export const Id: string;
                export const January: string;
                export const July: string;
                export const June: string;
                export const March: string;
                export const May: string;
                export const November: string;
                export const October: string;
                export const September: string;
                export const SubCat1Code: string;
                export const SubCat1Name: string;
                export const TypeSum: string;
                export const Year: string;
            }

            namespace Report_1503 {
                export const AllItemDiscount: string;
                export const DocDate: string;
                export const DocDateEn: string;
                export const GrossSales: string;
                export const Id: string;
                export const NetSales: string;
                export const NetSalesExVat: string;
                export const Qty: string;
                export const SubCat2Code: string;
                export const SubCat2Name: string;
                export const VatOfNetSales: string;
                export const Year: string;
            }

            namespace Report_1503_N {
                export const April: string;
                export const August: string;
                export const December: string;
                export const February: string;
                export const Id: string;
                export const January: string;
                export const July: string;
                export const June: string;
                export const March: string;
                export const May: string;
                export const November: string;
                export const October: string;
                export const September: string;
                export const SubCat2Code: string;
                export const SubCat2Name: string;
                export const TypeSum: string;
                export const Year: string;
            }

            namespace Report_1504 {
                export const AllItemDiscount: string;
                export const BrandCode: string;
                export const BrandName: string;
                export const CatCode: string;
                export const CatName: string;
                export const ColorId: string;
                export const ColorName: string;
                export const DocDate: string;
                export const DocDateEn: string;
                export const GrossSales: string;
                export const Id: string;
                export const MatTypeId: string;
                export const MatTypeName: string;
                export const NetSales: string;
                export const NetSalesExVat: string;
                export const PluCode: string;
                export const PluDesc: string;
                export const PluShortDesc: string;
                export const Qty: string;
                export const SizeId: string;
                export const SizeName: string;
                export const StyleId: string;
                export const StyleName: string;
                export const SubCat1Code: string;
                export const SubCat1Name: string;
                export const SubCat2Code: string;
                export const SubCat2Name: string;
                export const SupplId: string;
                export const SupplName: string;
                export const TasteId: string;
                export const TasteName: string;
                export const VatOfNetSales: string;
                export const Year: string;
            }

            namespace Report_1504_N {
                export const April: string;
                export const August: string;
                export const BrandCode: string;
                export const BrandName: string;
                export const CatCode: string;
                export const CatName: string;
                export const ColorId: string;
                export const ColorName: string;
                export const December: string;
                export const February: string;
                export const Id: string;
                export const January: string;
                export const July: string;
                export const June: string;
                export const March: string;
                export const MatTypeId: string;
                export const MatTypeName: string;
                export const May: string;
                export const November: string;
                export const October: string;
                export const PluCode: string;
                export const PluDesc: string;
                export const PluShortDesc: string;
                export const September: string;
                export const SizeId: string;
                export const SizeName: string;
                export const StyleId: string;
                export const StyleName: string;
                export const SubCat1Code: string;
                export const SubCat1Name: string;
                export const SubCat2Code: string;
                export const SubCat2Name: string;
                export const SupplId: string;
                export const SupplName: string;
                export const TasteId: string;
                export const TasteName: string;
                export const TypeSum: string;
                export const Year: string;
            }

            namespace Report_1505 {
                export const AllItemDiscount: string;
                export const BrandCode: string;
                export const BrandName: string;
                export const DocDate: string;
                export const DocDateEn: string;
                export const GrossSales: string;
                export const Id: string;
                export const NetSales: string;
                export const NetSalesExVat: string;
                export const Qty: string;
                export const VatOfNetSales: string;
                export const Year: string;
            }

            namespace Report_1505_N {
                export const April: string;
                export const August: string;
                export const BrandCode: string;
                export const BrandName: string;
                export const December: string;
                export const February: string;
                export const Id: string;
                export const January: string;
                export const July: string;
                export const June: string;
                export const March: string;
                export const May: string;
                export const November: string;
                export const October: string;
                export const September: string;
                export const TypeSum: string;
                export const Year: string;
            }

            namespace Report_1601 {
                export const BrandCode: string;
                export const BrandName: string;
                export const CatCode: string;
                export const CatName: string;
                export const ColorId: string;
                export const ColorName: string;
                export const GpPc: string;
                export const Gpamt: string;
                export const GrossSales: string;
                export const Id: string;
                export const ItemPromoId: string;
                export const MatTypeId: string;
                export const MatTypeName: string;
                export const NetsalesafterGp: string;
                export const PluCode: string;
                export const PluFullName: string;
                export const PluShortDesc: string;
                export const Qty: string;
                export const ShopFullName: string;
                export const ShopId: string;
                export const ShopName: string;
                export const SizeId: string;
                export const SizeName: string;
                export const StyleId: string;
                export const StyleName: string;
                export const SubCat1Code: string;
                export const SubCat1Name: string;
                export const SubCat2Code: string;
                export const SubCat2Name: string;
                export const SupplFullName: string;
                export const SupplId: string;
                export const SupplName: string;
                export const TasteId: string;
                export const TasteName: string;
                export const UnitPrice: string;
            }

            namespace Report_1602 {
                export const BrandCode: string;
                export const BrandName: string;
                export const CatCode: string;
                export const CatName: string;
                export const ColorId: string;
                export const ColorName: string;
                export const GpPc: string;
                export const Gpamt: string;
                export const GrossSales: string;
                export const Id: string;
                export const ItemPromoId: string;
                export const MatTypeId: string;
                export const MatTypeName: string;
                export const NetsalesafterGp: string;
                export const PluCode: string;
                export const PluFullName: string;
                export const PluShortDesc: string;
                export const Qty: string;
                export const SizeId: string;
                export const SizeName: string;
                export const StyleId: string;
                export const StyleName: string;
                export const SubCat1Code: string;
                export const SubCat1Name: string;
                export const SubCat2Code: string;
                export const SubCat2Name: string;
                export const SupplFullName: string;
                export const SupplId: string;
                export const SupplName: string;
                export const TasteId: string;
                export const TasteName: string;
                export const UnitPrice: string;
            }
        }

        namespace SalePromoCamp {

            namespace LookupItemCode {
                export const IDName: string;
                export const ItemCode: string;
                export const ItemDesc: string;
                export const ItemId: string;
                export const ItemType: string;
            }

            namespace PromoDay {
                export const Id: string;
                export const PromoDay: string;
                export const PromoDayName: string;
            }

            namespace PsPromoActiveHd {
                export const ActiveBy: string;
                export const Activedate: string;
                export const ApproveBy: string;
                export const Approvedate: string;
                export const CreateBy: string;
                export const CreateDate: string;
                export const EndPromoDate: string;
                export const EndPromoTime: string;
                export const Id: string;
                export const LastUpdate: string;
                export const PromoApDetailList: string;
                export const PromoApproveFg: string;
                export const PromoCampaign: string;
                export const PromoCustFg: string;
                export const PromoDay: string;
                export const PromoDayFg: string;
                export const PromoDesc: string;
                export const PromoId: string;
                export const PromoMb: string;
                export const PromoName: string;
                export const PromoShop: string;
                export const PromoShopFg: string;
                export const PromoStatus: string;
                export const PromoTimeFg: string;
                export const StartPromoDate: string;
                export const StartPromoTime: string;
                export const UpdateBy: string;
                export const VenderSharing: string;
            }

            namespace PsPromoApDt {
                export const CreateBy: string;
                export const CreateDate: string;
                export const DescItem: string;
                export const GpNormal: string;
                export const GpPromo: string;
                export const GroupCode1: string;
                export const GroupCode2: string;
                export const Id: string;
                export const ItemCode: string;
                export const ItemType: string;
                export const LastUpdate: string;
                export const PromoDiscPc: string;
                export const PromoId: string;
                export const PromoPrice: string;
                export const PromoType: string;
                export const UpdateBy: string;
            }

            namespace PsPromoApHd {
                export const ActiveBy: string;
                export const Activedate: string;
                export const ApproveBy: string;
                export const Approvedate: string;
                export const CreateBy: string;
                export const CreateDate: string;
                export const EndPromoDate: string;
                export const EndPromoTime: string;
                export const Id: string;
                export const LastUpdate: string;
                export const PromoApDetailList: string;
                export const PromoApproveFg: string;
                export const PromoCampaign: string;
                export const PromoCustFg: string;
                export const PromoDay: string;
                export const PromoDayFg: string;
                export const PromoDesc: string;
                export const PromoId: string;
                export const PromoMb: string;
                export const PromoName: string;
                export const PromoShop: string;
                export const PromoShopFg: string;
                export const PromoStatus: string;
                export const PromoTimeFg: string;
                export const StartPromoDate: string;
                export const StartPromoTime: string;
                export const UpdateBy: string;
                export const VenderSharing: string;
            }

            namespace PsPromoCampaign {
                export const FullName: string;
                export const Id: string;
                export const PromoCampName: string;
                export const PromoCampaign: string;
            }

            namespace PsPromoDays {
                export const Id: string;
                export const PromoDay: string;
                export const PromoId: string;
            }

            namespace PsPromoDt {
                export const CreateBy: string;
                export const CreateDate: string;
                export const DescItem: string;
                export const GpNormal: string;
                export const GpPromo: string;
                export const GroupCode1: string;
                export const GroupCode2: string;
                export const Id: string;
                export const ItemCode: string;
                export const ItemId: string;
                export const ItemType: string;
                export const LastUpdate: string;
                export const PromoDiscPc: string;
                export const PromoId: string;
                export const PromoPrice: string;
                export const PromoType: string;
                export const UpdateBy: string;
            }

            namespace PsPromoHd {
                export const CreateBy: string;
                export const CreateDate: string;
                export const EndPromoDate: string;
                export const EndPromoTime: string;
                export const Id: string;
                export const LastUpdate: string;
                export const PromoApproveFg: string;
                export const PromoCampaign: string;
                export const PromoCustFg: string;
                export const PromoDay: string;
                export const PromoDayFg: string;
                export const PromoDesc: string;
                export const PromoDetailList: string;
                export const PromoId: string;
                export const PromoMb: string;
                export const PromoName: string;
                export const PromoShop: string;
                export const PromoShopFg: string;
                export const PromoStatus: string;
                export const PromoTimeFg: string;
                export const StartPromoDate: string;
                export const StartPromoTime: string;
                export const UpdateBy: string;
                export const VenderSharing: string;
            }

            namespace PsPromoMb {
                export const Id: string;
                export const MbType: string;
                export const PromoId: string;
            }

            namespace PsPromoShop {
                export const Id: string;
                export const PromoId: string;
                export const ShopId: string;
            }
        }

        namespace Supplier {

            namespace CsSupplType {
                export const CreateBy: string;
                export const CreateDate: string;
                export const FullName: string;
                export const Id: string;
                export const LastUpdate: string;
                export const SupplType: string;
                export const SupplTypeName: string;
                export const UpdateBy: string;
            }

            namespace CsSupplier {
                export const AuthEmail: string;
                export const AuthMobile: string;
                export const AuthPerson: string;
                export const AuthTel: string;
                export const AuthTelExt: string;
                export const BranchCode: string;
                export const BranchName: string;
                export const CompanyCode: string;
                export const ConsignFg: string;
                export const ConsignGp: string;
                export const ContactName: string;
                export const CreateBy: string;
                export const CreateDate: string;
                export const CreditTerm: string;
                export const Ctaxtype: string;
                export const CustBranch: string;
                export const ErpSreachName: string;
                export const ErpVenderCode: string;
                export const ErpVendorBlock: string;
                export const ErpVendorType: string;
                export const FaxExt: string;
                export const FaxNo: string;
                export const FullName: string;
                export const Id: string;
                export const LastUpdate: string;
                export const PayMethod: string;
                export const PurVatCode: string;
                export const PurVatRate: string;
                export const PurVatType: string;
                export const Remark: string;
                export const ReturnOutRemark: string;
                export const SaleEmail: string;
                export const SaleMobile: string;
                export const SalePerson: string;
                export const SaleTel: string;
                export const SaleTelExt: string;
                export const Status: string;
                export const SupEmail: string;
                export const SupTelNo: string;
                export const SupplAddress: string;
                export const SupplId: string;
                export const SupplName: string;
                export const SupplRegAddress: string;
                export const SupplRegName: string;
                export const SupplTaxId: string;
                export const SupplType: string;
                export const SupplierShortName: string;
                export const TelMobile: string;
                export const TelNoExt: string;
                export const TradeTerm: string;
                export const UpdateBy: string;
            }
        }
    }

    declare namespace Forms {

        namespace Membership {

            namespace ChangePassword {
                export const FormTitle: string;
                export const SubmitButton: string;
                export const Success: string;
            }

            namespace ForgotPassword {
                export const BackToLogin: string;
                export const FormInfo: string;
                export const FormTitle: string;
                export const SubmitButton: string;
                export const Success: string;
            }

            namespace Login {
                export const FacebookButton: string;
                export const ForgotPassword: string;
                export const GoogleButton: string;
                export const LoginToYourAccount: string;
                export const OR: string;
                export const RememberMe: string;
                export const SignInButton: string;
                export const SignUpButton: string;
            }

            namespace ResetPassword {
                export const BackToLogin: string;
                export const EmailSubject: string;
                export const FormTitle: string;
                export const SubmitButton: string;
                export const Success: string;
            }

            namespace SignUp {
                export const AcceptTerms: string;
                export const ActivateEmailSubject: string;
                export const ActivationCompleteMessage: string;
                export const BackToLogin: string;
                export const ConfirmEmail: string;
                export const ConfirmPassword: string;
                export const DisplayName: string;
                export const Email: string;
                export const FormInfo: string;
                export const FormTitle: string;
                export const Password: string;
                export const SubmitButton: string;
                export const Success: string;
            }
        }
    }

    declare namespace Inventory {

        namespace Report {
            export const AdjIn1: string;
            export const AdjIn2: string;
            export const AdjInFoottersign1: string;
            export const AdjInFoottersign1head: string;
            export const AdjInFoottersign2: string;
            export const AdjInFoottersign2head: string;
            export const AdjInFoottersign3: string;
            export const AdjInFoottersign3head: string;
            export const AdjOut1: string;
            export const AdjOut2: string;
            export const AdjOutFoottersign1: string;
            export const AdjOutFoottersign1head: string;
            export const AdjOutFoottersign2: string;
            export const AdjOutFoottersign2head: string;
            export const AdjOutFoottersign3: string;
            export const AdjOutFoottersign3head: string;
            export const CN1: string;
            export const CN2: string;
            export const CNFoottersign1: string;
            export const CNFoottersign1head: string;
            export const CNFoottersign2: string;
            export const CNFoottersign2head: string;
            export const CNFoottersign3: string;
            export const CNFoottersign3head: string;
            export const Count1: string;
            export const Count2: string;
            export const CountFoottersign1: string;
            export const CountFoottersign1head: string;
            export const CountFoottersign2: string;
            export const CountFoottersign2head: string;
            export const CountFoottersign3: string;
            export const CountFoottersign3head: string;
            export const Receive1: string;
            export const Receive2: string;
            export const ReceiveFoottersign1: string;
            export const ReceiveFoottersign1head: string;
            export const ReceiveFoottersign2: string;
            export const ReceiveFoottersign2head: string;
            export const ReceiveFoottersign3: string;
            export const ReceiveFoottersign3head: string;
            export const ReturnIn1: string;
            export const ReturnIn2: string;
            export const ReturnInFoottersign1: string;
            export const ReturnInFoottersign1head: string;
            export const ReturnInFoottersign2: string;
            export const ReturnInFoottersign2head: string;
            export const ReturnInFoottersign3: string;
            export const ReturnInFoottersign3head: string;
            export const ReturnOut1: string;
            export const ReturnOut2: string;
            export const ReturnOutFoottersign1: string;
            export const ReturnOutFoottersign1head: string;
            export const ReturnOutFoottersign2: string;
            export const ReturnOutFoottersign2head: string;
            export const ReturnOutFoottersign3: string;
            export const ReturnOutFoottersign3head: string;
            export const Sold1: string;
            export const Sold2: string;
            export const SoldFoottersign1: string;
            export const SoldFoottersign1head: string;
            export const SoldFoottersign2: string;
            export const SoldFoottersign2head: string;
            export const SoldFoottersign3: string;
            export const SoldFoottersign3head: string;
            export const Tranfer1: string;
            export const Tranfer2: string;
            export const TranferFoottersign1: string;
            export const TranferFoottersign1head: string;
            export const TranferFoottersign2: string;
            export const TranferFoottersign2head: string;
            export const TranferFoottersign3: string;
            export const TranferFoottersign3head: string;
        }
    }

    declare namespace Navigation {
        export const LogoutLink: string;
        export const SitePoint: string;
        export const SiteTitle: string;
        export const Versions: string;
    }

    declare namespace PosShift {

        namespace Report {
            export const FooterText: string;
            export const FooterText2: string;
            export const FooterText3: string;
            export const Footersign1: string;
            export const Footersign1head: string;
            export const Footersign2: string;
            export const Footersign2head: string;
            export const Footersign3: string;
            export const Footersign3head: string;
            export const Title1: string;
            export const Title2: string;
            export const Title3: string;
            export const Title4: string;
            export const Title5: string;
        }
    }

    declare namespace Purchase {

        namespace Report {
            export const Approvebutton: string;
            export const CN1: string;
            export const CN2: string;
            export const CNFootter1: string;
            export const CNFoottersign1: string;
            export const CNFoottersign1head: string;
            export const CNFoottersign2: string;
            export const CNFoottersign2head: string;
            export const CNRTV1: string;
            export const CNRTV2: string;
            export const CNRTVFootter1: string;
            export const CNRTVFoottersign1: string;
            export const CNRTVFoottersign1head: string;
            export const CNRTVFoottersign2: string;
            export const CNRTVFoottersign2head: string;
            export const CNRTVFoottersign3: string;
            export const CNRTVFoottersign3head: string;
            export const IR1: string;
            export const IR2: string;
            export const IRFootter1: string;
            export const IRFoottersign1: string;
            export const IRFoottersign1head: string;
            export const IRFoottersign2: string;
            export const IRFoottersign2head: string;
            export const IRFoottersign3: string;
            export const IRFoottersign3head: string;
            export const PI1: string;
            export const PI2: string;
            export const PIFootter1: string;
            export const PIFoottersign1: string;
            export const PIFoottersign1head: string;
            export const PIFoottersign2: string;
            export const PIFoottersign2head: string;
            export const POFootter1: string;
            export const POFootter2: string;
            export const POFootter3: string;
            export const POFoottersign1: string;
            export const POFoottersign1head: string;
            export const POFoottersign2: string;
            export const POFoottersign2head: string;
            export const ShipName: string;
            export const poPurOrder: string;
            export const poPurOrder2: string;
        }
    }

    declare namespace Site {

        namespace AccessDenied {
            export const ClickToChangeUser: string;
            export const ClickToLogin: string;
            export const LackPermissions: string;
            export const NotLoggedIn: string;
            export const PageTitle: string;
        }

        namespace BasicProgressDialog {
            export const CancelTitle: string;
            export const PleaseWait: string;
        }

        namespace BulkServiceAction {
            export const AllHadErrorsFormat: string;
            export const AllSuccessFormat: string;
            export const ConfirmationFormat: string;
            export const ErrorCount: string;
            export const NothingToProcess: string;
            export const SomeHadErrorsFormat: string;
            export const SuccessCount: string;
        }

        namespace Dashboard {
            export const ContenDescritptionShop: string;
            export const ContentDescription: string;
        }

        namespace Dialogs {
            export const PendingChangesConfirmation: string;
        }

        namespace Layout {
            export const FooterCopyright: string;
            export const FooterInfo: string;
            export const FooterRights: string;
            export const GeneralSettings: string;
            export const Language: string;
            export const Theme: string;
            export const ThemeAzure: string;
            export const ThemeAzureLight: string;
            export const ThemeBlack: string;
            export const ThemeBlackLight: string;
            export const ThemeBlue: string;
            export const ThemeBlueLight: string;
            export const ThemeCosmos: string;
            export const ThemeCosmosLight: string;
            export const ThemeGlassy: string;
            export const ThemeGlassyLight: string;
            export const ThemeGreen: string;
            export const ThemeGreenLight: string;
            export const ThemePurple: string;
            export const ThemePurpleLight: string;
            export const ThemeRed: string;
            export const ThemeRedLight: string;
            export const ThemeYellow: string;
            export const ThemeYellowLight: string;
        }

        namespace RolePermissionDialog {
            export const DialogTitle: string;
            export const EditButton: string;
            export const SaveSuccess: string;
        }

        namespace UserDialog {
            export const EditPermissionsButton: string;
            export const EditRolesButton: string;
        }

        namespace UserPermissionDialog {
            export const DialogTitle: string;
            export const Grant: string;
            export const Permission: string;
            export const Revoke: string;
            export const SaveSuccess: string;
        }

        namespace UserRoleDialog {
            export const DialogTitle: string;
            export const SaveSuccess: string;
        }

        namespace ValidationError {
            export const Title: string;
        }
    }

    declare namespace Validation {
        export const AccountLoginPasswordError: string;
        export const AuthenticationError: string;
        export const CantFindUserWithEmail: string;
        export const CharacterinPassword: string;
        export const CurrentPasswordMismatch: string;
        export const DeleteForeignKeyError: string;
        export const EmailConfirm: string;
        export const EmailInUse: string;
        export const EnforecPasswordHistory: string;
        export const InvalidActivateToken: string;
        export const InvalidResetToken: string;
        export const MinRequiredPasswordLength: string;
        export const SavePrimaryKeyError: string;
        export const UserChangePassword: string;
        export const UserChangePasswordAge: string;
        export const UserLock: string;
    }

    GeniuzPOS['Texts'] = Q.proxyTexts(Texts, '', {Db:{Administration:{CsPara:{BizAddressLine1:1,BizAddressLine2:1,BizAddressLine3:1,BizName:1,BizNameEn:1,BizType:1,BranchNameDesc:1,BranchNameDescEn:1,BranchNo:1,BuildingName:1,BuildingNameEn:1,BuildingNo:1,BuildingNoEn:1,City:1,CityEn:1,CountryCode:1,CreateBy:1,CreateDate:1,District:1,DistrictEn:1,Email:1,ErpCompCode:1,FaxId:1,Id:1,LastUpdate:1,PostalCode:1,Province:1,ProvinceEn:1,RegId:1,SlowMoveItenDate:1,StreetName:1,StreetNameEn:1,TaxId:1,TaxInvAddrLine1:1,TaxInvAddrLine2:1,TaxInvAddrLine3:1,TaxInvName:1,TelId:1,UpdateBy:1,VatFg:1},CsVatCode:{FullName:1,Id:1,VatCode:1,VatRate:1},CsVatType:{FullName:1,Id:1,VatType:1,VatTypeDesc:1},Language:{Id:1,LanguageId:1,LanguageName:1},PoApprovalGroup:{ApprGroupCode:1,ApprGroupName:1,CreateBy:1,CreateDate:1,Id:1,LastUpdate:1,UpdateBy:1},PsBizTypes:{BizType:1,BizTypeName:1,Id:1},PsConfig:{ConfigCode:1,ConfigDate:1,ConfigId:1,ConfigTypeId:1,Description:1,IsActive:1,LastUpdate:1,ShopId:1,UpdateBy:1},PsConfigType:{ConfigTypeId:1,ConfigTypeName:1,Description:1,IsActive:1},PsFuncKbMapKeyCode:{Id:1,KbMapKeyCode:1,KbMapKeyName:1},PsFuncKbMapShiftCode:{Id:1,KbMapShiftCode:1,KbMapShiftName:1},PsFuncLevel:{FunLevel:1,FunLevelName:1,Id:1},PsPara:{AllowSaleOverStock:1,BackOfficeUpLoadURL:1,BranchName:1,ChargeVatRate:1,CountLockSignInWrongPassInDay:1,CreateBy:1,CreateDate:1,DiscRoundMethod:1,EjournalFg:1,Id:1,ItemOnRecptMethod:1,LastUpdate:1,NoOfRecptCopy:1,PointRedeemOneBaht:1,PosProcessMode:1,PosScreenType:1,PrintOrderFg:1,PrintQueueFg:1,PromptPayLink:1,PsParaDefault1:1,PsParaDefault2:1,PsParaFullName:1,QRCodeAccount:1,ReceiptPrinterType:1,RecptFootMesg1:1,RecptFootMesg10:1,RecptFootMesg2:1,RecptFootMesg3:1,RecptFootMesg4:1,RecptFootMesg5:1,RecptFootMesg6:1,RecptFootMesg7:1,RecptFootMesg8:1,RecptFootMesg9:1,RecptFootMesgFontSize:1,RecptFootMesgTextAlign:1,RecptHeadMesg1:1,RecptHeadMesg2:1,RecptHeadMesg3:1,RecptHeadMesg4:1,RecptHeadMesg5:1,RecptHeadMesg6:1,RecptHeadMesgFontSize:1,RecptHeadMesgTextAlign:1,RecptNoBarcodeFg:1,RecptSumItemQtyFg:1,SalesDocFg:1,SalesVatType:1,SelectSellingPriceFg:1,ShopAddress:1,ShopLogoOnFrontScreen:1,ShopLogoOnReceipt:1,ShopName:1,ShopRegAddressLine1:1,ShopRegAddressLine2:1,ShopRegAddressLine3:1,ShopRegId:1,ShopRegName:1,ShopTaxId:1,TaxInvoiceDateFg:1,UpdateBy:1,WeightBarcodePrefix:1},PsPosFunc:{CreateBy:1,CreateDate:1,FunLevel:1,FuncDesc:1,FuncId:1,FuncKeyLable:1,FuncUsage:1,Id:1,KbMapKeyCode:1,KbMapShiftCode:1,LastUpdate:1,RowNumber:1,UpdateBy:1},PsPosProcessMode:{Id:1,PosProcessMode:1,PosProcessModeName:1},PsPosScreenType:{Id:1,PosScreenType:1,PosScreenTypeName:1},PsSalesVatTypes:{Id:1,SalesVatType:1,SalesVatTypeName:1},Role:{RoleId:1,RoleKey:1,RoleName:1},RolePermission:{PermissionKey:1,RoleId:1,RolePermissionId:1,RoleRoleName:1},SysGroup:{CreateBy:1,CreateDate:1,Id:1,LastUpdate:1,SysGroup:1,SysGroupDesc:1,UpdateBy:1},SysPara:{CreateBy:1,CreateDate:1,Id:1,LastUpdate:1,SysDesc:1,SysFg:1,SysFgDesc:1,SysGroup:1,SysGroup1:1,SysGroupCreateBy:1,SysGroupCreateDate:1,SysGroupLastUpdate:1,SysGroupSysGroupDesc:1,SysGroupUpdateBy:1,SysName:1,UpdateBy:1},Translation:{CustomText:1,EntityPlural:1,Key:1,OverrideConfirmation:1,SaveChangesButton:1,SourceLanguage:1,SourceText:1,TargetLanguage:1,TargetText:1},User:{ApprGroupCode:1,CheckPasswordUpdate:1,DisplayName:1,Email:1,ImpersonationToken:1,InsertDate:1,InsertUserId:1,IsActive:1,LastDirectoryUpdate:1,MobilePhoneNumber:1,MobilePhoneVerified:1,Password:1,PasswordChangeDate:1,PasswordConfirm:1,PasswordHash:1,PasswordSalt:1,Roles:1,ShopId:1,Source:1,TwoFactorAuth:1,UpdateDate:1,UpdateUserId:1,UserActive:1,UserErrorStampFg:1,UserId:1,UserImage:1,Username:1},UserApprovalRole:{ApprGroupCode:1,Id:1,UserId:1},UserPermission:{Granted:1,PermissionKey:1,User:1,UserId:1,UserPermissionId:1,Username:1},UserRole:{RoleId:1,User:1,UserId:1,UserRoleId:1,Username:1}},AdvPromo:{Adv05Hd:{EndPromoDate:1,EndPromoTime:1,ItemExList:1,ItemList:1,PPtype:1,PmDesc:1,PmExtCode:1,PmGroupDesc:1,PmGroupId:1,PmId:1,PmType:1,PmTypeDesc:1,PromoApproveFg:1,PromoCampName:1,PromoCampaign:1,PromoCust:1,PromoCustFg:1,PromoDay:1,PromoDayFg:1,PromoShop:1,PromoShopFg:1,PromoStatus:1,PromoTimeFg:1,StartPromoDate:1,StartPromoTime:1,VenderSharing:1},Adv05ItemDetail:{AssortFg:1,BrandCode:1,BrandName:1,CatCode:1,CatName:1,DiscPc:1,EndPromoDate:1,Id:1,ItemType:1,Normalprice:1,PPtype:1,PluCode:1,PluShortDesc:1,PmGroupId:1,PmId:1,PmType:1,PmTypeDesc:1,PromotionPrice:1,Remark:1,SkuCode:1,StartPromoDate:1,StyleId:1,StyleName:1,SubCat1Code:1,SubCat1Name:1,SubCat2Code:1,SubCat2Name:1,SupplCode:1,SupplName:1},Adv05ItemDetails:{AssortFg:1,BrandCode:1,BrandName:1,CatCode:1,CatName:1,DiscPc:1,EndPromoDate:1,Id:1,ItemType:1,ListFg:1,Normalprice:1,PPtype:1,PluCode:1,PluShortDesc:1,PmDesc:1,PmExtCode:1,PmGroupId:1,PmId:1,PmStepNo:1,PmType:1,PmTypeDesc:1,PromotionPrice:1,Remark:1,SkuCode:1,StartPromoDate:1,StyleCode:1,StyleName:1,SubCat1Code:1,SubCat1Name:1,SubCat2Code:1,SubCat2Name:1,SupplCode:1,SupplName:1},Adv05ItemDt:{AssortFg:1,BrandCode:1,BrandName:1,CatCode:1,CatName:1,DiscPc:1,Id:1,ItemType:1,Normalprice:1,PPtype:1,PluCode:1,PluShortDesc:1,PmGroupId:1,PmId:1,PmType:1,PmTypeDesc:1,PromotionPrice:1,Remark:1,SkuCode:1,StyleId:1,StyleName:1,SubCat1Code:1,SubCat1Name:1,SubCat2Code:1,SubCat2Name:1,SupplCode:1,SupplName:1},Adv05ItemExDTs:{BrandCode:1,BrandName:1,CatCode:1,CatName:1,EndPromoDate:1,Id:1,PluCode:1,PluShortDesc:1,PmGroupId:1,PmId:1,PmType:1,SellUnitPrice1:1,SkuCode:1,StartPromoDate:1,StyleCode:1,StyleName:1,SubCat1Code:1,SubCat1Name:1,SubCat2Code:1,SubCat2Name:1,SupplCode:1,SupplName:1},Adv05ItemExDt:{BrandCode:1,BrandName:1,CatCode:1,CatName:1,EndPromoDate:1,Id:1,ItemType:1,PluCode:1,PluShortDesc:1,PmGroupId:1,PmId:1,PmType:1,SellUnitPrice1:1,SkuCode:1,StartPromoDate:1,StyleId:1,StyleName:1,SubCat1Code:1,SubCat1Name:1,SubCat2Code:1,SubCat2Name:1,SupplCode:1,SupplName:1},AdvancedPromoReport:{EndPromoDate:1,EndPromoTime:1,ItemExList:1,ItemList:1,PPtype:1,PmDesc:1,PmExtCode:1,PmGroupDesc:1,PmGroupId:1,PmId:1,PmType:1,PmTypeDesc:1,PromoApproveFg:1,PromoCampName:1,PromoCampaign:1,PromoCust:1,PromoCustFg:1,PromoDay:1,PromoDayFg:1,PromoShop:1,PromoShopFg:1,PromoStatus:1,PromoTimeFg:1,StartPromoDate:1,StartPromoTime:1,VenderSharing:1},LookupAvPromoCouponTypes:{CouponType:1,CouponTypeLookup:1,CpName:1,CpNameF:1,EndBillPmType:1,Id:1},LookupPromoId:{PmId:1},PsAdvPromoHd:{ActiveBy:1,Activedate:1,ApproveBy:1,Approvedate:1,CreateBy:1,CreateDate:1,EndPromoDate:1,EndPromoTime:1,Id:1,PmGroupDesc:1,PmGroupId:1,PromoApproveFg:1,PromoCampName:1,PromoCampaign:1,PromoCustFg:1,PromoDay:1,PromoDayFg:1,PromoMb:1,PromoShop:1,PromoShopFg:1,PromoStatus:1,PromoTimeFg:1,StartPromoDate:1,StartPromoTime:1,UpdateBy:1,UpdateDate:1,VenderSharing:1},PsAdvPromoHd1:{ActiveBy:1,Activedate:1,ApproveBy:1,Approvedate:1,CreateBy:1,CreateDate:1,EndPromoDate:1,EndPromoTime:1,Id:1,ItemExList:1,ItemList:1,PmGroupDesc:1,PmGroupId:1,PromoApproveFg:1,PromoCampName:1,PromoCampaign:1,PromoCustFg:1,PromoDay:1,PromoDayFg:1,PromoMb:1,PromoShop:1,PromoShopFg:1,PromoStatus:1,PromoTimeFg:1,StartPromoDate:1,StartPromoTime:1,UpdateBy:1,UpdateDate:1,VenderSharing:1},PsAdvPromoHd2:{ActiveBy:1,Activedate:1,ApproveBy:1,Approvedate:1,CreateBy:1,CreateDate:1,EndPromoDate:1,EndPromoTime:1,Id:1,Item2ExList:1,Item2List:1,PmGroupDesc:1,PmGroupId:1,PromoApproveFg:1,PromoCampName:1,PromoCampaign:1,PromoCustFg:1,PromoDay:1,PromoDayFg:1,PromoMb:1,PromoShop:1,PromoShopFg:1,PromoStatus:1,PromoTimeFg:1,StartPromoDate:1,StartPromoTime:1,UpdateBy:1,UpdateDate:1,VenderSharing:1},PsAdvPromoHd3:{ActiveBy:1,Activedate:1,ApproveBy:1,Approvedate:1,CreateBy:1,CreateDate:1,EndPromoDate:1,EndPromoTime:1,Id:1,Item3ExList:1,Item3List:1,PmGroupDesc:1,PmGroupId:1,PromoApproveFg:1,PromoCampName:1,PromoCampaign:1,PromoCustFg:1,PromoDay:1,PromoDayFg:1,PromoMb:1,PromoShop:1,PromoShopFg:1,PromoStatus:1,PromoTimeFg:1,StartPromoDate:1,StartPromoTime:1,UpdateBy:1,UpdateDate:1,VenderSharing:1},PsAdvPromoHd4:{ActiveBy:1,Activedate:1,ApproveBy:1,Approvedate:1,CreateBy:1,CreateDate:1,EndPromoDate:1,EndPromoTime:1,Id:1,Item4ExList:1,Item4List:1,PmGroupDesc:1,PmGroupId:1,PromoApproveFg:1,PromoCampName:1,PromoCampaign:1,PromoCustFg:1,PromoDay:1,PromoDayFg:1,PromoMb:1,PromoShop:1,PromoShopFg:1,PromoStatus:1,PromoTimeFg:1,StartPromoDate:1,StartPromoTime:1,UpdateBy:1,UpdateDate:1,VenderSharing:1},PsAdvPromoHd5:{ActiveBy:1,Activedate:1,ApproveBy:1,Approvedate:1,CreateBy:1,CreateDate:1,EndPromoDate:1,EndPromoTime:1,Id:1,Item5ExList:1,Item5List:1,PmGroupDesc:1,PmGroupId:1,PromoApproveFg:1,PromoCampName:1,PromoCampaign:1,PromoCustFg:1,PromoDay:1,PromoDayFg:1,PromoMb:1,PromoShop:1,PromoShopFg:1,PromoStatus:1,PromoTimeFg:1,StartPromoDate:1,StartPromoTime:1,UpdateBy:1,UpdateDate:1,VenderSharing:1},PsAdvPromoHd6:{ActiveBy:1,Activedate:1,ApproveBy:1,Approvedate:1,CreateBy:1,CreateDate:1,EndPromoDate:1,EndPromoTime:1,Id:1,Item6ExList:1,Item6List:1,PmGroupDesc:1,PmGroupId:1,PromoApproveFg:1,PromoCampName:1,PromoCampaign:1,PromoCustFg:1,PromoDay:1,PromoDayFg:1,PromoMb:1,PromoShop:1,PromoShopFg:1,PromoStatus:1,PromoTimeFg:1,StartPromoDate:1,StartPromoTime:1,UpdateBy:1,UpdateDate:1,VenderSharing:1},PsAdvPromoHd9:{ActiveBy:1,Activedate:1,ApproveBy:1,Approvedate:1,CreateBy:1,CreateDate:1,EndPromoDate:1,EndPromoTime:1,Id:1,Item9ExList:1,Item9List:1,PmGroupDesc:1,PmGroupId:1,PromoApproveFg:1,PromoCampName:1,PromoCampaign:1,PromoCustFg:1,PromoDay:1,PromoDayFg:1,PromoMb:1,PromoShop:1,PromoShopFg:1,PromoStatus:1,PromoTimeFg:1,StartPromoDate:1,StartPromoTime:1,UpdateBy:1,UpdateDate:1,VenderSharing:1},PsAdvPromoHdAct:{ActiveBy:1,Activedate:1,ApproveBy:1,Approvedate:1,CreateBy:1,CreateDate:1,EndPromoDate:1,EndPromoTime:1,Id:1,Item2ExList:1,Item2List:1,Item3ExList:1,Item3List:1,Item4ExList:1,Item4List:1,Item5ExList:1,Item5List:1,Item6ExList:1,Item6List:1,Item9ExList:1,Item9List:1,ItemExList:1,ItemList:1,PmGroupDesc:1,PmGroupId:1,PromoApproveFg:1,PromoCampName:1,PromoCampaign:1,PromoCustFg:1,PromoDay:1,PromoDayFg:1,PromoMb:1,PromoShop:1,PromoShopFg:1,PromoStatus:1,PromoTimeFg:1,StartPromoDate:1,StartPromoTime:1,UpdateBy:1,UpdateDate:1,VenderSharing:1},PsAdvPromoHdApp:{ActiveBy:1,Activedate:1,ApproveBy:1,Approvedate:1,CreateBy:1,CreateDate:1,EndPromoDate:1,EndPromoTime:1,Id:1,Item2ExList:1,Item2List:1,Item3ExList:1,Item3List:1,Item4ExList:1,Item4List:1,Item5ExList:1,Item5List:1,Item6ExList:1,Item6List:1,Item9ExList:1,Item9List:1,ItemExList:1,ItemList:1,PmGroupDesc:1,PmGroupId:1,PromoApproveFg:1,PromoCampName:1,PromoCampaign:1,PromoCustFg:1,PromoDay:1,PromoDayFg:1,PromoMb:1,PromoShop:1,PromoShopFg:1,PromoStatus:1,PromoTimeFg:1,StartPromoDate:1,StartPromoTime:1,UpdateBy:1,UpdateDate:1,VenderSharing:1},PsAdvPromoItem:{Amt:1,AssortFg:1,BrandCode:1,BuncleQty:1,BundleExPrice:1,BundleItemNo:1,BundleUnitPrice:1,CatCode:1,CouponAgeDay:1,CouponGiftDesc:1,CouponType:1,CreateBy:1,CreateDate:1,DiscAmt:1,DiscPc:1,DiscPc1:1,DiscPc2:1,DiscPc3:1,DiscPc4:1,EndBillPmType:1,FreeLpFg:1,FreeQty:1,Id:1,ItemType:1,LineItemNo:1,ListFg:1,LpPrice:1,NpcsOrBundlePrice:1,PluCode:1,PmDesc:1,PmExtCode:1,PmGroupId:1,PmId:1,PmOrder:1,PmStepNo:1,PmType:1,Price1:1,Price2:1,Price3:1,Price4:1,Qty:1,StyleCode:1,SubCat1Code:1,SubCat2Code:1,SupplCode:1,UpdateBy:1,UpdateDate:1},PsAdvPromoItem2:{Amt:1,AssortFg:1,BrandCode:1,BuncleQty:1,BundleExPrice:1,BundleItemNo:1,BundleUnitPrice:1,CatCode:1,CouponAgeDay:1,CouponGiftDesc:1,CouponType:1,CreateBy:1,CreateDate:1,DiscAmt:1,DiscPc:1,DiscPc1:1,DiscPc2:1,DiscPc3:1,DiscPc4:1,EndBillPmType:1,FreeLpFg:1,FreeQty:1,Id:1,ItemType:1,LineItemNo:1,ListFg:1,LpPrice:1,NpcsOrBundlePrice:1,PluCode:1,PmDesc:1,PmExtCode:1,PmGroupId:1,PmId:1,PmOrder:1,PmStepNo:1,PmType:1,Price1:1,Price2:1,Price3:1,Price4:1,Qty:1,StyleCode:1,SubCat1Code:1,SubCat2Code:1,SupplCode:1,UpdateBy:1,UpdateDate:1},PsAdvPromoItem2Exempt:{BrandCode:1,CatCode:1,CreateBy:1,CreateDate:1,Id:1,ItemType:1,LineItemNo:1,ListFg:1,PluCode:1,PmDesc:1,PmExtCode:1,PmGroupId:1,PmId:1,PmOrder:1,PmStepNo:1,PmType:1,StyleCode:1,SubCat1Code:1,SubCat2Code:1,SupplCode:1,UpdateBy:1,UpdateDate:1},PsAdvPromoItem3:{Amt:1,AssortFg:1,BrandCode:1,BuncleQty:1,BundleExPrice:1,BundleItemNo:1,BundleUnitPrice:1,CatCode:1,CouponAgeDay:1,CouponGiftDesc:1,CouponType:1,CreateBy:1,CreateDate:1,DiscAmt:1,DiscPc:1,DiscPc1:1,DiscPc2:1,DiscPc3:1,DiscPc4:1,EndBillPmType:1,FreeLpFg:1,FreeQty:1,Id:1,ItemType:1,LineItemNo:1,ListFg:1,LpPrice:1,NpcsOrBundlePrice:1,PluCode:1,PmDesc:1,PmExtCode:1,PmGroupId:1,PmId:1,PmOrder:1,PmStepNo:1,PmType:1,Price1:1,Price2:1,Price3:1,Price4:1,Qty:1,StyleCode:1,SubCat1Code:1,SubCat2Code:1,SupplCode:1,UpdateBy:1,UpdateDate:1},PsAdvPromoItem3Exempt:{BrandCode:1,CatCode:1,CreateBy:1,CreateDate:1,Id:1,ItemType:1,LineItemNo:1,ListFg:1,PluCode:1,PmDesc:1,PmExtCode:1,PmGroupId:1,PmId:1,PmOrder:1,PmStepNo:1,PmType:1,StyleCode:1,SubCat1Code:1,SubCat2Code:1,SupplCode:1,UpdateBy:1,UpdateDate:1},PsAdvPromoItem4:{Amt:1,AssortFg:1,BrandCode:1,BuncleQty:1,BundleExPrice:1,BundleItemNo:1,BundleUnitPrice:1,CatCode:1,CouponAgeDay:1,CouponGiftDesc:1,CouponType:1,CreateBy:1,CreateDate:1,DiscAmt:1,DiscPc:1,DiscPc1:1,DiscPc2:1,DiscPc3:1,DiscPc4:1,EndBillPmType:1,FreeLpFg:1,FreeQty:1,Id:1,ItemType:1,LineItemNo:1,ListFg:1,LpPrice:1,NpcsOrBundlePrice:1,PluCode:1,PmDesc:1,PmExtCode:1,PmGroupId:1,PmId:1,PmOrder:1,PmStepNo:1,PmType:1,Price1:1,Price2:1,Price3:1,Price4:1,Qty:1,StyleCode:1,SubCat1Code:1,SubCat2Code:1,SupplCode:1,UpdateBy:1,UpdateDate:1},PsAdvPromoItem4Exempt:{BrandCode:1,CatCode:1,CreateBy:1,CreateDate:1,Id:1,ItemType:1,LineItemNo:1,ListFg:1,PluCode:1,PmDesc:1,PmExtCode:1,PmGroupId:1,PmId:1,PmOrder:1,PmStepNo:1,PmType:1,StyleCode:1,SubCat1Code:1,SubCat2Code:1,SupplCode:1,UpdateBy:1,UpdateDate:1},PsAdvPromoItem5:{Amt:1,AssortFg:1,BrandCode:1,BuncleQty:1,BundleExPrice:1,BundleItemNo:1,BundleUnitPrice:1,CatCode:1,CouponAgeDay:1,CouponGiftDesc:1,CouponType:1,CreateBy:1,CreateDate:1,DiscAmt:1,DiscPc:1,DiscPc1:1,DiscPc2:1,DiscPc3:1,DiscPc4:1,EndBillPmType:1,FreeLpFg:1,FreeQty:1,Id:1,ItemType:1,LineItemNo:1,ListFg:1,LpPrice:1,NpcsOrBundlePrice:1,PluCode:1,PmDesc:1,PmExtCode:1,PmGroupId:1,PmId:1,PmOrder:1,PmStepNo:1,PmType:1,Price1:1,Price2:1,Price3:1,Price4:1,Qty:1,StyleCode:1,SubCat1Code:1,SubCat2Code:1,SupplCode:1,UpdateBy:1,UpdateDate:1},PsAdvPromoItem5Exempt:{BrandCode:1,CatCode:1,CreateBy:1,CreateDate:1,Id:1,ItemType:1,LineItemNo:1,ListFg:1,PluCode:1,PmDesc:1,PmExtCode:1,PmGroupId:1,PmId:1,PmOrder:1,PmStepNo:1,PmType:1,StyleCode:1,SubCat1Code:1,SubCat2Code:1,SupplCode:1,UpdateBy:1,UpdateDate:1},PsAdvPromoItem6:{Amt:1,AssortFg:1,BrandCode:1,BuncleQty:1,BundleExPrice:1,BundleItemNo:1,BundleUnitPrice:1,CatCode:1,CouponAgeDay:1,CouponGiftDesc:1,CouponType:1,CreateBy:1,CreateDate:1,DiscAmt:1,DiscPc:1,DiscPc1:1,DiscPc2:1,DiscPc3:1,DiscPc4:1,EndBillPmType:1,FreeLpFg:1,FreeQty:1,Id:1,ItemType:1,LineItemNo:1,ListFg:1,LpPrice:1,NpcsOrBundlePrice:1,PluCode:1,PmDesc:1,PmExtCode:1,PmGroupId:1,PmId:1,PmOrder:1,PmStepNo:1,PmType:1,Price1:1,Price2:1,Price3:1,Price4:1,Qty:1,StyleCode:1,SubCat1Code:1,SubCat2Code:1,SupplCode:1,UpdateBy:1,UpdateDate:1},PsAdvPromoItem6Exempt:{BrandCode:1,CatCode:1,CreateBy:1,CreateDate:1,Id:1,ItemType:1,LineItemNo:1,ListFg:1,PluCode:1,PmDesc:1,PmExtCode:1,PmGroupId:1,PmId:1,PmOrder:1,PmStepNo:1,PmType:1,StyleCode:1,SubCat1Code:1,SubCat2Code:1,SupplCode:1,UpdateBy:1,UpdateDate:1},PsAdvPromoItem9:{Amt:1,AssortFg:1,BrandCode:1,BuncleQty:1,BundleExPrice:1,BundleItemNo:1,BundleUnitPrice:1,CatCode:1,CouponAgeDay:1,CouponGiftDesc:1,CouponType:1,CouponTypeLookup:1,CreateBy:1,CreateDate:1,DiscAmt:1,DiscPc:1,DiscPc1:1,DiscPc2:1,DiscPc3:1,DiscPc4:1,EndBillPmType:1,FreeLpFg:1,FreeQty:1,Id:1,ItemType:1,LineItemNo:1,ListFg:1,LpPrice:1,NpcsOrBundlePrice:1,PluCode:1,PmDesc:1,PmExtCode:1,PmGroupId:1,PmId:1,PmOrder:1,PmStepNo:1,PmType:1,Price1:1,Price2:1,Price3:1,Price4:1,Qty:1,StyleCode:1,SubCat1Code:1,SubCat2Code:1,SupplCode:1,UpdateBy:1,UpdateDate:1},PsAdvPromoItem9Exempt:{BrandCode:1,CatCode:1,CreateBy:1,CreateDate:1,Id:1,ItemType:1,LineItemNo:1,ListFg:1,PluCode:1,PmDesc:1,PmExtCode:1,PmGroupId:1,PmId:1,PmOrder:1,PmStepNo:1,PmType:1,StyleCode:1,SubCat1Code:1,SubCat2Code:1,SupplCode:1,UpdateBy:1,UpdateDate:1},PsAdvPromoItemExempt:{BrandCode:1,CatCode:1,CreateBy:1,CreateDate:1,Id:1,ItemType:1,LineItemNo:1,ListFg:1,PluCode:1,PmDesc:1,PmExtCode:1,PmGroupId:1,PmId:1,PmOrder:1,PmStepNo:1,PmType:1,StyleCode:1,SubCat1Code:1,SubCat2Code:1,SupplCode:1,UpdateBy:1,UpdateDate:1},PsAdvPromoType:{CreateBy:1,CreateDate:1,Id:1,PmType:1,PmTypeDesc:1,PmTypeOrder:1,UpdateBy:1,UpdateDate:1},PsPromoAvDays:{Id:1,PmGroupId:1,PromoDay:1},PsPromoAvMb:{Id:1,MbType:1,PmGroupId:1},PsPromoAvShop:{Id:1,PmGroupId:1,ShopId:1},PsPromoCampaign:{CreateBy:1,CreateDate:1,FullName:1,Id:1,PromoCampName:1,PromoCampaign:1,UpdateBy:1,UpdateDate:1},PsPromoType:{Condition:1,CreateBy:1,CreateDate:1,Id:1,PPtype:1,PmType:1,PmTypeDesc:1,UpdateBy:1,UpdateDate:1},Report_Adv01:{FullName:1,PluCode:1,PluShortDesc:1,PmGroupId:1,PmId:1,PromoCampaign:1,PromoDisc:1,SalesAmtAfterPromo:1,SalesAmtBeforePromo:1,SalesQty:1,ShopFullName:1,ShopId:1,ShopName:1},Report_Adv02:{FullName:1,PluCode:1,PluShortDesc:1,PmGroupId:1,PmId:1,PromoCampaign:1,PromoDisc:1,SalesAmtAfterPromo:1,SalesAmtBeforePromo:1,SalesQty:1},Report_Adv03:{PmGroupId:1,PmId:1,PromoCampaign:1,PromoDisc:1,SalesAmtAfterPromo:1,SalesAmtBeforePromo:1,SalesQty:1,ShopFullName:1,ShopId:1,ShopName:1},Report_Adv04:{PmGroupId:1,PmId:1,PromoCampaign:1,PromoDisc:1,SalesAmtAfterPromo:1,SalesAmtBeforePromo:1,SalesQty:1},VwAdvPromoBasicAndAdvActiveByPlu:{EndPromoDate:1,EndPromoTime:1,Id:1,PluCode:1,PmGroupDesc:1,PmGroupId:1,PmId:1,PmType:1,PromoCampaign:1,PromoCust:1,PromoCustFg:1,PromoDay:1,PromoDayFg:1,PromoShop:1,PromoShopFg:1,PromoStatus:1,PromoTimeFg:1,PromoType:1,StartPromoDate:1,StartPromoTime:1,VenderSharing:1}},CustomReport:{ReportCusAging:{AvgSaleAmt:1,BrandName:1,Category1:1,Category2:1,Category3:1,CostPriceExVat:1,HistorySaleAmt:1,Id:1,P1CostValue:1,P1Qty:1,P1TotalToStock:1,P2CostValue:1,P2Qty:1,P2TotalToStock:1,P3CostValue:1,P3Qty:1,P3TotalToStock:1,P4CostValue:1,P4Qty:1,P4TotalToStock:1,P5CostValue:1,P5Qty:1,P5TotalToStock:1,PluCode:1,RetailPrice:1,SkuCode:1,SkuDesc:1,SumCostValue:1,SumOnHandQty:1,SumRetailPrice:1,SuplierName:1,SupplierId:1},ReportCusPromotionSale:{Category1:1,Category2:1,Category3:1,DateMonth:1,DateSale:1,DateYear:1,Id:1,ItemName:1,NetSaleExVat:1,OnHandQty:1,PluCode:1,PromoId:1,PromoName:1,PromoperiodFrom:1,PromoperiodTo:1,SalesQty:1,SkuCode:1,SupplierCode:1,SupplierName:1},ReportCusSaleComparison:{BrandName:1,Category1:1,Category2:1,Category3:1,Id:1,LwNetGpAmount:1,LwNetGr:1,LwNetSalesExVat:1,LwQtySold:1,PcVarianceNetGpAmount:1,PcVarianceNetSalesExVat:1,PcVarianceQtySold:1,PluCode:1,PluDesc:1,ShopName:1,SupPlierName:1,SupplierId:1,TwNetGpAmount:1,TwNetGr:1,TwNetSalesExVat:1,TwQtySold:1,VarianceNetGpAmount:1,VarianceNetGr:1,VarianceNetSalesExVat:1,VarianceQtySold:1},ReportCusSaleReport:{AvgPrice:1,BrandName:1,Category1:1,Category2:1,Category3:1,CostOfGoods:1,DisCount:1,DiscountBill:1,DiscountCom:1,DiscountMb:1,DiscountSum:1,DiscountSup:1,ExPrice:1,GrossMargin:1,GrossPc:1,Id:1,NetGp:1,NetGpVender:1,NetMargin:1,NetSale:1,NetSalesExVat:1,OnHandQty:1,PluCode:1,QtySold:1,SkuCode:1,SkuDesc:1,SupplierId:1,SupplierName:1,VatAmt:1},ReportCusStockOnHand:{AvgSaleAmt:1,BrandName:1,Category1:1,Category2:1,Category3:1,CostAmount:1,HistorySaleAmt:1,Id:1,OnHandQty:1,PluCode:1,SellPrice1:1,SkuCode:1,SkuDesc:1,StkUnit:1,SuplierName:1,SupplierId:1},ReportCustomerSurvey:{Choice:1,ChoiceId:1,DtList:1,Id:1,Qty:1,Question:1,SurveyCode:1},ReportCustomerSurveyTranDt:{Choice:1,ChoiceId:1,CreateBy:1,DocNo:1,MbId:1,PosId:1,ShopId:1,SurveyCode:1}},Customer:{CsCustGroup:{CreateBy:1,CreateDate:1,CustGroupCode:1,CustGroupName:1,FullName:1,Id:1,LastUpdate:1,UpdateBy:1},CsCustomer:{Address:1,Amphur:1,ContactName:1,Country:1,CreateBy:1,CreateDate:1,CusRemark:1,CusTel:1,CustCode:1,CustGroupCode:1,CustGroupName:1,CustName:1,CustRegAdd1:1,CustRegAdd2:1,CustRegAdd3:1,CustRegAddress:1,CustRegAmphur:1,CustRegCountry:1,CustRegName:1,CustRegProvince:1,CustRegTumbol:1,CustRegZipCode:1,CustTaxId:1,Email:1,Id:1,LastUpdate:1,Province:1,SaleMemo:1,SalesmanId:1,SalesmanName:1,ShipAddLine1:1,ShipAddLine2:1,ShipAddLine3:1,ShipAddress:1,ShipAmphur:1,ShipCountry:1,ShipName:1,ShipProvince:1,ShipTumbol:1,ShipZipCode:1,Tumbol:1,UpdateBy:1,ZipCode:1},Report_1106Customer:{Address:1,Amphur:1,ContactName:1,Country:1,CreateBy:1,CreateDate:1,CusRemark:1,CusTel:1,CustCode:1,CustGroupCode:1,CustGroupName:1,CustName:1,CustRegAdd1:1,CustRegAdd2:1,CustRegAdd3:1,CustRegAddress:1,CustRegAmphur:1,CustRegCountry:1,CustRegName:1,CustRegProvince:1,CustRegTumbol:1,CustRegZipCode:1,CustTaxId:1,Email:1,Id:1,LastUpdate:1,Province:1,SaleMemo:1,SalesmanId:1,SalesmanName:1,ShipAddLine1:1,ShipAddLine2:1,ShipAddLine3:1,ShipAddress:1,ShipAmphur:1,ShipCountry:1,ShipName:1,ShipProvince:1,ShipTumbol:1,ShipZipCode:1,Tumbol:1,UpdateBy:1,ZipCode:1}},InitialData:{IcWhs:{CreateBy:1,CreateDate:1,FullName:1,Id:1,LastUpdate:1,ShopFullName:1,ShopId:1,UpdateBy:1,WhsId:1,WhsName:1,WhsType:1},PsCashCouponType:{CashCouponName:1,CashCouponType:1,CashCouponValue:1,CashCouponValueType:1,CreateBy:1,CreateDate:1,EndDate:1,Id:1,IsActive:1,LastUpdate:1,PartnerCompensateAmt:1,PartnerCompensatePc:1,ProdImageLink:1,StartDate:1,UpdateBy:1},PsCashCouponTypeSerial:{CashCouponType:1,CreateBy:1,CreateDate:1,Id:1,IsActive:1,Serial:1,Used:1},PsCashier:{CashierId:1,CashierLevel:1,CashierName:1,CashierPassword:1,CreateBy:1,CreateDate:1,Id:1,LastUpdate:1,UpdateBy:1},PsConnectEdcBank:{CreateBy:1,CreateDate:1,EdcBank:1,EdcBankName:1,Id:1,LastUpdate:1,Remark:1,UpdateBy:1},PsConnectEdcPort:{ConnectEdcPort:1,CreateBy:1,CreateDate:1,Id:1,LastUpdate:1,Remark:1,UpdateBy:1},PsCorperateMessage:{ActiveBy:1,Activedate:1,CreateBy:1,CreateDate:1,Desc:1,EndDate:1,EndTime:1,Id:1,StartDate:1,StartTime:1,Status:1,TimeFg:1,Topic:1,UpdateBy:1,UpdateDate:1},PsCorperateMessageReciept:{ActiveBy:1,Activedate:1,CreateBy:1,CreateDate:1,Desc:1,EndDate:1,EndTime:1,FontSize:1,Id:1,Image:1,StartDate:1,StartTime:1,Status:1,TextAlign:1,TimeFg:1,UpdateBy:1,UpdateDate:1},PsCreditCard:{CreateBy:1,CreateDate:1,CreditCardName:1,CreditCardType:1,Id:1,IsActive:1,LastUpdate:1,ProdImageLink:1,UpdateBy:1},PsCurrency:{CreateBy:1,CreateDate:1,CurrencyCode:1,CurrencyName:1,Id:1,IsActive:1,LastUpdate:1,ProdImageLink:1,UpdateBy:1},PsCustomerSurvey:{ActiveBy:1,Activedate:1,CreateBy:1,CreateDate:1,DtList:1,EndDate:1,EndTime:1,Id:1,PosFg:1,PosId:1,Question:1,StartDate:1,StartTime:1,Status:1,SurveyCode:1,TimeFg:1,UpdateBy:1,UpdateDate:1},PsCustomerSurveyDt:{Choice:1,ChoiceId:1,CreateBy:1,CreateDate:1,LineNo:1,Status:1,SurveyCode:1,UpdateBy:1,UpdateDate:1},PsCustomerSurveyPos:{Id:1,PosId:1,SurveyCode:1},PsDebitCard:{CreateBy:1,CreateDate:1,DebitCardName:1,DebitCardType:1,Id:1,IsActive:1,LastUpdate:1,ProdImageLink:1,UpdateBy:1},PsDiscCouponType:{CreateBy:1,CreateDate:1,CustFg:1,DayFg:1,DiscCouponName:1,DiscCouponType:1,DiscCouponValue:1,DiscCouponValueType:1,EndDate:1,Id:1,IsActive:1,ItemOrBillFg:1,LastUpdate:1,PartnerCompensatePc:1,ProdImageLink:1,PromoDay:1,PromoMb:1,PromoShop:1,ShopFg:1,StartDate:1,UpdateBy:1},PsDiscCouponTypeDays:{DiscCouponType:1,Id:1,PromoDay:1},PsDiscCouponTypeItem:{BrandCode:1,CatCode:1,CreateBy:1,CreateDate:1,DiscCouponType:1,Id:1,ListFg:1,PluCode:1,StyleCode:1,SubCat1Code:1,SubCat2Code:1,SupplCode:1,UpdateBy:1,UpdateDate:1},PsDiscCouponTypeItemExt:{BrandCode:1,CatCode:1,CreateBy:1,CreateDate:1,DiscCouponType:1,Id:1,ListFg:1,PluCode:1,StyleCode:1,SubCat1Code:1,SubCat2Code:1,SupplCode:1,UpdateBy:1,UpdateDate:1},PsDiscCouponTypeMb:{DiscCouponType:1,Id:1,MbType:1},PsDiscCouponTypeSerial:{CreateBy:1,CreateDate:1,DiscCouponType:1,Id:1,IsActive:1,Serial:1,Used:1},PsDiscCouponTypeShop:{DiscCouponType:1,Id:1,ShopId:1},PsExchangeRate:{CreateBy:1,CreateDate:1,CurrencyCode:1,EffectiveDate:1,ExchangeRate:1,Id:1,LastUpdate:1,UpdateBy:1},PsOtherPayment:{CreateBy:1,CreateDate:1,Id:1,IsActive:1,LastUpdate:1,OtherPaymentName:1,OtherPaymentType:1,ProdImageLink:1,UpdateBy:1},PsPanelGroupButton:{BgColor:1,CreateBy:1,CreateDate:1,DtList:1,GroupButtonId:1,GroupButtonImage:1,GroupButtonLabel:1,Id:1,LastUpdate:1,TouchPanelType:1,TxtColor:1,TxtFontSize:1,UpdateBy:1},PsPanelItemButton:{BgColor:1,CreateBy:1,CreateDate:1,GroupButtonId:1,Id:1,ItemButtonId:1,ItemButtonImage:1,ItemButtonLabel:1,LastUpdate:1,LinkCode:1,LinkCodeFg:1,TouchPanelType:1,TxtColor:1,TxtFontSize:1,UpdateBy:1,UrlUpload:1},PsPosPrinter:{CreateBy:1,CreateDate:1,Id:1,LastUpdate:1,PrinterId:1,PrinterName:1,UpdateBy:1},PsPosStation:{AutoChargeFg:1,AutoChargeRate:1,CashierPosFg:1,Connect2ndDispFg:1,ConnectDrawerFg:1,ConnectEdcFg:1,ConnectEdcPort:1,ConnectPrinterFg:1,ConnectRfidReaderFg:1,ConnectVfdFg:1,CreateBy:1,CreateDate:1,EdcBank:1,EjournalFg:1,Id:1,ItemOnRecptMethod:1,LastReceiptRunNo:1,LastRefundRunNo:1,LastUpdate:1,MandatoryMemberFg:1,MandatorySalesmanFg:1,MaxCashInDrawer:1,NoOfRecptCopy:1,PosId:1,PosPermitNo:1,PosScreenType:1,PosTouchPanelId:1,PrintOrderFg:1,PrintQueueFg:1,PromptPayLink:1,PsParaDefault1:1,PsParaDefault2:1,QRCodeAccount:1,ReceiptPrinterType:1,RecptFootMesg1:1,RecptFootMesg10:1,RecptFootMesg2:1,RecptFootMesg3:1,RecptFootMesg4:1,RecptFootMesg5:1,RecptFootMesg6:1,RecptFootMesg7:1,RecptFootMesg8:1,RecptFootMesg9:1,RecptFootMesgFontSize:1,RecptFootMesgTextAlign:1,RecptHeadMesg1:1,RecptHeadMesg2:1,RecptHeadMesg3:1,RecptHeadMesg4:1,RecptHeadMesg5:1,RecptHeadMesg6:1,RecptHeadMesgFontSize:1,RecptHeadMesgTextAlign:1,RecptNoBarcodeFg:1,RecptSumItemQtyFg:1,SalesDocFg:1,SalesVatType:1,SelectSellingPriceFg:1,SellingPriceNo:1,ShopFullName:1,ShopId:1,ShopLogoOnFrontScreen:1,ShopLogoOnReceipt:1,UpdateBy:1,WhsId:1},PsPosTouchPanelType:{CreateBy:1,CreateDate:1,Id:1,LastUpdate:1,POSScreenType:1,TouchPanelDesc:1,TouchPanelType:1,UpdateBy:1},PsPriceOverrideReason:{CreateBy:1,CreateDate:1,Id:1,IsActive:1,LastUpdate:1,PriceOverrideId:1,PriceOverrideReason:1,Remark:1,UpdateBy:1},PsPurposeReason:{CreateBy:1,CreateDate:1,DocType:1,FullName:1,Id:1,LastUpdate:1,Purpose:1,PurposeCode:1,Remark:1,UpdateBy:1},PsQRPromptPay:{CreateBy:1,CreateDate:1,Id:1,IsActive:1,LastUpdate:1,ProdImageLink:1,QRPromptPayName:1,QRPromptPayType:1,UpdateBy:1,paymentChannel:1},PsRefundReason:{CreateBy:1,CreateDate:1,Id:1,LastUpdate:1,PurposeCode:1,RefundFg:1,RefundId:1,RefundReason:1,Remark:1,TaxRefundReasonId:1,UpdateBy:1},PsSalesman:{CreateBy:1,CreateDate:1,Id:1,LastUpdate:1,SalesmanGroup:1,SalesmanGroupDesc:1,SalesmanIDName:1,SalesmanId:1,SalesmanName:1,UpdateBy:1},PsSalesmanGroup:{CreateBy:1,CreateDate:1,Id:1,LastUpdate:1,SalesmanGroup:1,SalesmanGroupDesc:1,UpdateBy:1},PsShop:{BranchName:1,BranchNameDesc:1,BranchNameDescEn:1,BranchNameEN:1,BranchTaxCode:1,CreateBy:1,CreateDate:1,Email:1,ErpChannel:1,ErpStore:1,Id:1,LastUpdate:1,PromptPayLink:1,QRCodeAccount:1,ShopAddress:1,ShopAddressEN:1,ShopBuildingName:1,ShopBuildingNameEn:1,ShopBuildingNo:1,ShopBuildingNoEn:1,ShopCity:1,ShopCityEn:1,ShopCountryCode:1,ShopDistrict:1,ShopDistrictEn:1,ShopFullName:1,ShopGroupId:1,ShopGroupName:1,ShopId:1,ShopName:1,ShopNameEN:1,ShopPostalCode:1,ShopProvince:1,ShopProvinceEn:1,ShopRegAddressLine1:1,ShopRegAddressLine2:1,ShopRegAddressLine3:1,ShopRegId:1,ShopRegName:1,ShopStreetName:1,ShopStreetNameEn:1,ShopTaxId:1,ShopTypeId:1,ShopTypeName:1,TelId:1,UpdateBy:1},PsShopGroup:{CreateBy:1,CreateDate:1,Id:1,LastUpdate:1,ShopGroupFullName:1,ShopGroupId:1,ShopGroupName:1,UpdateBy:1},PsShopType:{CreateBy:1,CreateDate:1,Id:1,LastUpdate:1,ShopTypeFullName:1,ShopTypeId:1,ShopTypeName:1,UpdateBy:1},Vexchange:{CurrencyCode:1,EffectiveDate:1,ExchangeRate:1,Id:1}},Inventory:{IcPara:{Cus_CostCenter:1,Cus_ProfitCenter:1,IcFg:1,Id:1,PostSequenceFg:1,Stkmedthod:1},IcStkAdjCode:{Id:1,StkAdjCode:1,StkAdjDesc:1,StkAdjType:1,StkAdjcodeName:1},IcStkmedthod:{Id:1,Stkmedthod:1,StkmedthodName:1},IcStockAdjustIn:{AdjFg:1,AdjustInDtList:1,CancelFg:1,CreateBy:1,CreateDate:1,DocDate:1,DocNo:1,Id:1,LastUpdate:1,PostFg:1,RefDocNo1:1,RefDocNo2:1,Remark:1,StkAdjCode:1,StkAdjcodeName:1,StockFrom:1,SysDocNo:1,UpdateBy:1,WhsId:1,WhsName:1},IcStockAdjustInDt:{AdjFg:1,CostValue:1,ExpDate:1,Id:1,ItemRemark:1,LineItemNo:1,PurUnit:1,PurUnitPrice:1,PurUnitRatio:1,Qty:1,Remark:1,SkuCode:1,SysDocNo:1,UnitChange:1,UnitCost:1},IcStockAdjustOut:{AdjFg:1,AdjustOutDtList:1,CancelFg:1,CreateBy:1,CreateDate:1,DocDate:1,DocNo:1,Id:1,LastUpdate:1,PostFg:1,RefDocNo1:1,RefDocNo2:1,Remark:1,StkAdjCode:1,StkAdjcodeName:1,StockTo:1,SysDocNo:1,UpdateBy:1,WhsId:1,WhsName:1},IcStockAdjustOutDt:{AdjFg:1,CostValue:1,ExpDate:1,Id:1,ItemRemark:1,LineItemNo:1,PurUnit:1,PurUnitPrice:1,PurUnitRatio:1,Qty:1,Remark:1,SkuCode:1,SysDocNo:1,UnitChange:1,UnitCost:1},IcStockApproveDisassemble:{ApproveBy:1,ApproveDate:1,ApproveFg:1,CalDtQtyFg:1,CallAssemDocFg:1,CancelFg:1,CreateBy:1,CreateDate:1,DocDate:1,DocNo:1,ExpDate:1,IcStockApproveDisassembleDtList:1,Id:1,LastUpdate:1,PostDate:1,PostFg:1,RefDocNo1:1,RefDocNo2:1,Remark:1,SetItemCode:1,SetQty:1,SysDocNo:1,UpdateBy:1,WhsItem:1,WhsSet:1},IcStockApproveDisassembleDt:{CostValue:1,ExpDate:1,Id:1,LineItemNo:1,PluCode:1,PluDesc:1,Qty:1,QtyUse:1,Remark:1,SellUnitRatio:1,SetItemQty:1,SetQty:1,SkuCode:1,SkuQty:1,SysDocNo:1,UnitCost:1},IcStockApproveDt:{CostValue:1,QtyCount:1,QtyDif:1,QtyOnhand:1,SkuCode:1,SkuDesc:1,StkUnit:1,SysDocNo:1,UnitCost:1,WhsId:1},IcStockApproveHd:{ApproveBy:1,ApproveDate:1,ApproveFg:1,CancelFg:1,CreateBy:1,CreateDate:1,IcStockCountTranList:1,Id:1,LastUpdate:1,PostDate:1,PostFg:1,RefDocNo:1,Remark:1,StockCountCode:1,StockCountDate:1,StockCountDesc:1,SysDocNo:1,UpdateBy:1,WhsId:1,WhsName:1},IcStockApproveSetAssemble:{ApproveBy:1,ApproveDate:1,ApproveFg:1,CalDtQtyFg:1,CallSetItemFg:1,CancelFg:1,CreateBy:1,CreateDate:1,DocDate:1,DocNo:1,ExpDate:1,IcStockApproveSetAssembleDtList:1,Id:1,LastUpdate:1,PostDate:1,PostFg:1,RefDocNo1:1,RefDocNo2:1,Remark:1,SetItemCode:1,SetQty:1,SysDocNo:1,UpdateBy:1,UseFg:1,WhsItem:1,WhsSet:1},IcStockApproveSetAssembleDt:{CostValue:1,ExpDate:1,Id:1,LineItemNo:1,PluCode:1,PluDesc:1,Qty:1,Remark:1,SellUnitRatio:1,SetItemQty:1,SetQty:1,SkuCode:1,SkuQty:1,SysDocNo:1,UnitCost:1},IcStockBacProcessing:{CreateBy:1,CreateDate:1,FinishDate:1,Id:1,PosOrIcProcessing:1,PostFg:1,PostSequenceFg:1,ProcessedTranCount:1,TotalDocCount:1,TotalTranCount:1},IcStockCountCode:{ApproveBy:1,ApproveDate:1,ApproveFg:1,CancelFg:1,CreateBy:1,CreateDate:1,IcStockCountTranList:1,Id:1,LastUpdate:1,PostDate:1,PostFg:1,RefDocNo:1,Remark:1,StockCountCode:1,StockCountDate:1,StockCountDesc:1,SysDocNo:1,UpdateBy:1,WhsId:1,WhsName:1},IcStockCountTran:{CreateBy:1,CreateDate:1,Id:1,ItemRemark:1,LastUpdate:1,LineItemNo:1,PluCode:1,PurUnitPrice:1,PurUnitRatio:1,QtyCount:1,QtyOnhand:1,SellUnit:1,SellUnitRatio:1,SkuCode:1,StkCostValue:1,StkQtyCount:1,SysDocNo:1,UnitCost:1,UpdateBy:1},IcStockDisassemble:{ApproveBy:1,ApproveDate:1,ApproveFg:1,CalDtQtyFg:1,CallAssemDocFg:1,CancelFg:1,CreateBy:1,CreateDate:1,DocDate:1,DocNo:1,ExpDate:1,IcStockDisassembleDtList:1,Id:1,LastUpdate:1,PostDate:1,PostFg:1,RefDocNo1:1,RefDocNo2:1,Remark:1,SetItemCode:1,SetQty:1,SysDocNo:1,UpdateBy:1,WhsItem:1,WhsSet:1},IcStockDisassembleDt:{CostValue:1,ExpDate:1,Id:1,LineItemNo:1,PluCode:1,PluDesc:1,Qty:1,QtyUse:1,Remark:1,SellUnitRatio:1,SetItemQty:1,SetQty:1,SkuCode:1,SkuQty:1,SysDocNo:1,UnitCost:1},IcStockEomProcessing:{CostCount:1,CreateBy:1,CreateDate:1,EndDate:1,EndId:1,FinishDate:1,Id:1,LastMonthEomId:1,LineNoProcess:1,MonthProcess:1,PostFg:1,PostSequenceFg:1,QtyCount:1,SkuCount:1,StartDate:1,StartId:1,TranCount:1,UseFg:1,YearProcess:1},IcStockReceive:{CancelFg:1,CreateBy:1,CreateDate:1,DocDate:1,DocNo:1,Id:1,LastUpdate:1,PostFg:1,ReceiveDtList:1,RefDocNo1:1,RefDocNo2:1,Remark:1,StockFrom:1,SupplName:1,SysDocNo:1,UpdateBy:1,WhsId:1,WhsName:1},IcStockReceiveDt:{CostValue:1,ExpDate:1,Id:1,ItemRemark:1,LastPurPrice:1,LineItemNo:1,PILineId:1,PIRefFg:1,PurUnit:1,PurUnitPrice:1,PurUnitRatio:1,Qty:1,QtyUse:1,Remark:1,SkuCode:1,StkQty:1,SysDocNo:1,UnitChange:1,UnitCost:1,UseFg:1},IcStockReturnIn:{CancelFg:1,CheckQty:1,CreateBy:1,CreateDate:1,CustName:1,DocDate:1,DocNo:1,Id:1,LastUpdate:1,PostFg:1,RefDocNo1:1,RefDocNo2:1,Remark:1,ReturnInDtList:1,StockFrom:1,SysDocNo:1,UpdateBy:1,WhsId:1,WhsName:1},IcStockReturnInDt:{CostValue:1,ExpDate:1,GRLineId:1,GRRefFg:1,Id:1,ItemRemark:1,LineItemNo:1,PurUnit:1,PurUnitPrice:1,PurUnitRatio:1,Qty:1,Remark:1,SkuCode:1,StkQty:1,SysDocNo:1,UnitChange:1,UnitCost:1},IcStockReturnOut:{CancelFg:1,CheckQty:1,CreateBy:1,CreateDate:1,DocDate:1,DocNo:1,Id:1,LastUpdate:1,PostFg:1,RefDocNo1:1,RefDocNo2:1,Remark:1,ReturnOutDtList:1,StockTo:1,SupplName:1,SysDocNo:1,UpdateBy:1,WhsId:1,WhsName:1},IcStockReturnOutDt:{CostValue:1,ExpDate:1,GRLineId:1,GRRefFg:1,Id:1,ItemRemark:1,LineItemNo:1,PurUnit:1,PurUnitPrice:1,PurUnitRatio:1,Qty:1,QtyUse:1,Remark:1,SkuCode:1,StkQty:1,SysDocNo:1,UnitChange:1,UnitCost:1},IcStockSetAssemble:{ApproveBy:1,ApproveDate:1,ApproveFg:1,CalDtQtyFg:1,CallSetItemFg:1,CancelFg:1,CreateBy:1,CreateDate:1,DocDate:1,DocNo:1,ExpDate:1,IcStockSetAssembleDtList:1,Id:1,LastUpdate:1,PostDate:1,PostFg:1,QtyUse:1,RefDocNo1:1,RefDocNo2:1,Remark:1,SetItemCode:1,SetName:1,SetQty:1,SysDocNo:1,UpdateBy:1,UseFg:1,WhsItem:1,WhsSet:1},IcStockSetAssembleDt:{CostValue:1,ExpDate:1,Id:1,LineItemNo:1,PluCode:1,PluDesc:1,Qty:1,QtyUse:1,Remark:1,SellUnitRatio:1,SetItemQty:1,SetQty:1,SkuCode:1,SkuQty:1,SysDocNo:1,UnitCost:1},IcStockSku:{CreateBy:1,CreateDate:1,Id:1,LastUpdate:1,QtyOnhand:1,SkuCode:1,StockCostValue:1,UpdateBy:1},IcStockSold:{CancelFg:1,CreateBy:1,CreateDate:1,CustName:1,DocDate:1,DocNo:1,Id:1,LastUpdate:1,PostFg:1,RefDocNo1:1,RefDocNo2:1,Remark:1,SoldDtList:1,StockTo:1,SysDocNo:1,UpdateBy:1,WhsId:1,WhsName:1},IcStockSoldDt:{CostValue:1,ExpDate:1,Id:1,ItemRemark:1,LineItemNo:1,PurUnit:1,PurUnitPrice:1,PurUnitRatio:1,Qty:1,QtyUse:1,Remark:1,SkuCode:1,StkQty:1,SysDocNo:1,UnitChange:1,UnitCost:1,UseFg:1},IcStockTran:{CostValue:1,CreateBy:1,CreateDate:1,DocDate:1,DocNo:1,Id:1,LastUpdate:1,PostFg:1,Qty:1,RefDocNo1:1,RefDocNo2:1,SkuCode:1,SysDocNo:1,TranDate:1,TranTime:1,TranType:1,TranTypeDesc:1,UpdateBy:1,WhsId:1},IcStockTransfer:{CancelFg:1,ConcatRefDocNo2:1,ConcatWhsIdFm:1,CreateBy:1,CreateDate:1,DocDate:1,DocNo:1,Id:1,LastUpdate:1,PostFg:1,RefDocNo1:1,RefDocNo2:1,Remark:1,SysDocNo:1,TransferDtList:1,UpdateBy:1,WhsIdFm:1,WhsIdTo:1},IcStockTransferDt:{CostValue:1,ExpDate:1,Id:1,ItemRemark:1,LineItemNo:1,PurUnit:1,PurUnitPrice:1,PurUnitRatio:1,Qty:1,Remark:1,SkuCode:1,SupplItemCode:1,SysDocNo:1,UnitChange:1,UnitCost:1},IcStockWhs:{CreateBy:1,CreateDate:1,Id:1,LastUpdate:1,QtyOnhand:1,SkuCode:1,SkuWhsIdCode:1,StockCostValue:1,UpdateBy:1},IcTranType:{Id:1,TranTypeDesc:1,TranTypeNo:1},LookupIcGrForTranferLookup:{DocNo:1,RefDocNo2:1,SysDocNo:1,WhsIdFm:1},LookupIcGrLookup:{DocNo:1,StockTo:1,SysDocNo:1},LookupIcSoLookup:{DocNo:1,StockFrom:1,SysDocNo:1}},InventoryReport:{IcReport01:{BrandCode:1,BrandName:1,CatCode:1,CatName:1,ColorId:1,ColorName:1,ConsignFg:1,Id:1,MatTypeId:1,MatTypeName:1,QtyOnHand:1,SizeId:1,SizeName:1,SkuCode:1,SkuDesc:1,SkuEnDesc:1,StkUnit:1,StockCostValue:1,StockFg:1,StyleId:1,StyleName:1,SubCat1Code:1,SubCat1Name:1,SubCat2Code:1,SubCat2Name:1,SupplId:1,SupplName:1,TasteId:1,TasteName:1},IcReport01_V:{BrandCode:1,BrandName:1,CatCode:1,CatName:1,ColorId:1,ColorName:1,ConsignFg:1,Id:1,MatTypeId:1,MatTypeName:1,QtyOnHand:1,SizeId:1,SizeName:1,SkuCode:1,SkuDesc:1,SkuEnDesc:1,StkUnit:1,StockCostValue:1,StockFg:1,StyleId:1,StyleName:1,SubCat1Code:1,SubCat1Name:1,SubCat2Code:1,SubCat2Name:1,SupplId:1,SupplName:1,TasteId:1,TasteName:1},IcReport02:{BrandCode:1,BrandName:1,CatCode:1,CatName:1,ColorId:1,ColorName:1,ConsignFg:1,Id:1,MatTypeId:1,MatTypeName:1,QtyOnhand:1,ShopGroupId:1,ShopId:1,ShopName:1,ShopTypeId:1,SizeId:1,SizeName:1,SkuCode:1,SkuDesc:1,SkuEnDesc:1,StkUnit:1,StockCostValue:1,StockFg:1,StyleId:1,StyleName:1,SubCat1Code:1,SubCat1Name:1,SubCat2Code:1,SubCat2Name:1,SupplId:1,SupplName:1,TasteId:1,TasteName:1,WhsId:1,WhsName:1,WhsType:1},IcReport02_V:{BrandCode:1,BrandName:1,CatCode:1,CatName:1,ColorId:1,ColorName:1,ConsignFg:1,Id:1,MatTypeId:1,MatTypeName:1,QtyOnhand:1,ShopGroupId:1,ShopId:1,ShopName:1,ShopTypeId:1,SizeId:1,SizeName:1,SkuCode:1,SkuDesc:1,SkuEnDesc:1,StkUnit:1,StockCostValue:1,StockFg:1,StyleId:1,StyleName:1,SubCat1Code:1,SubCat1Name:1,SubCat2Code:1,SubCat2Name:1,SupplId:1,SupplName:1,TasteId:1,TasteName:1,WhsId:1,WhsName:1,WhsType:1},IcReport04:{GroupCode:1,GroupName:1,Grouptype:1,Id:1,QtyOnHand:1,StockCostValue:1},IcReport04_V:{GroupCode:1,GroupName:1,Grouptype:1,Id:1,QtyOnHand:1,StockCostValue:1},IcReport05:{BrandCode:1,BrandName:1,CatCode:1,CatName:1,ColorId:1,ColorName:1,ConsignFg:1,DateMonth:1,DateYear:1,EomIn:1,GroupType:1,IcAdjIn:1,IcAdjOut:1,IcReceive:1,IcReturnIn:1,IcReturnOut:1,IcSold:1,IcTranIn:1,IcTranOut:1,Id:1,MatTypeId:1,MatTypeName:1,ShopGroupId:1,ShopGroupName:1,ShopId:1,ShopName:1,ShopTypeId:1,ShopTypeName:1,SizeId:1,SizeName:1,SkuCode:1,SkuDesc:1,StockFg:1,StyleId:1,StyleName:1,SubCat1Code:1,SubCat1Name:1,SubCat2Code:1,SubCat2Name:1,SumOut:1,SupplId:1,SupplName:1,TasteId:1,TasteName:1,WhsId:1,WhsName:1,WhsType:1},IcReport05All:{BrandCode:1,BrandName:1,CatCode:1,CatName:1,ColorId:1,ColorName:1,ConsignFg:1,DateMonth:1,DateYear:1,EomIn:1,GroupType:1,IcAdjIn:1,IcAdjOut:1,IcReceive:1,IcReturnIn:1,IcReturnOut:1,IcSold:1,Id:1,MatTypeId:1,MatTypeName:1,SizeId:1,SizeName:1,SkuCode:1,SkuDesc:1,StockFg:1,StyleId:1,StyleName:1,SubCat1Code:1,SubCat1Name:1,SubCat2Code:1,SubCat2Name:1,SumOut:1,SupplId:1,SupplName:1,TasteId:1,TasteName:1},IcReport06:{ArticleSeasonCode:1,ArticleSeasonName:1,BrandCode:1,BrandName:1,BrandTypeCode:1,BrandTypeName:1,CatCode:1,CatName:1,ColorId:1,ColorName:1,ConceptCode:1,ConceptName:1,ConsignFg:1,Id:1,MatTypeId:1,MatTypeName:1,MaxStockQty:1,MinStockQty:1,PurLeadTime:1,QtyOnhand:1,ReorderQty:1,SizeId:1,SizeName:1,SkuCode:1,SkuDesc:1,SkuEnDesc:1,StkUnit:1,StockFg:1,StyleId:1,StyleName:1,SubCat1Code:1,SubCat1Name:1,SubCat2Code:1,SubCat2Name:1,SupplId:1,SupplName:1,TasteId:1,TasteName:1},IcReport07Sku:{CostAdd:1,CostBalance:1,CostDel:1,DocDate:1,Id:1,QtyAdd:1,QtyBalance:1,QtyDel:1,RefDocNo1:1,RowRunNo:1,SkuCode:1,SysDocNo:1,TranDate:1,TranType:1},IcReport07SkuWhs:{CostAdd:1,CostBalance:1,CostDel:1,DocDate:1,Id:1,QtyAdd:1,QtyBalance:1,QtyDel:1,RefDocNo1:1,RowRunNo:1,ShopId:1,SkuCode:1,SysDocNo:1,TranDate:1,TranType:1,WhsId:1},IcReport08:{BrandCode:1,BrandName:1,CatCode:1,CatName:1,ColorId:1,ColorName:1,ConsignFg:1,Countt:1,DtList:1,Id:1,MatTypeId:1,MatTypeName:1,QtyOnhand:1,SizeId:1,SizeName:1,SkuCode:1,SkuDesc:1,SkuEnDesc:1,StyleId:1,StyleName:1,SubCat1Code:1,SubCat1Name:1,SubCat2Code:1,SubCat2Name:1,SupplId:1,SupplName:1,TasteId:1,TasteName:1},IcReport08Dt:{CreateBy:1,CreateDate:1,Id:1,LotNo:1,SerailNo:1,ShopGroupId:1,ShopId:1,ShopName:1,ShopTypeId:1,SkuCode:1,Status:1,WhsId:1,WhsName:1,WhsType:1},IcReportEom:{BrandCode:1,BrandName:1,CatCode:1,CatName:1,ColorId:1,ColorName:1,ConsignFg:1,CostOnhand:1,DateMonth:1,DateYear:1,DtList:1,EndDate:1,Id:1,MatTypeId:1,MatTypeName:1,QtyOnhand:1,SizeId:1,SizeName:1,SkuCode:1,SkuDesc:1,SkuEnDesc:1,StyleId:1,StyleName:1,SubCat1Code:1,SubCat1Name:1,SubCat2Code:1,SubCat2Name:1,SupplId:1,SupplName:1,TasteId:1,TasteName:1},IcReportWhsEom:{CostOnhand:1,EndDate:1,Id:1,QtyOnhand:1,ShopGroupId:1,ShopId:1,ShopName:1,ShopTypeId:1,SkuCode:1,WhsId:1,WhsName:1,WhsType:1}},LogManage:{LogApiPath:{ApiDesc:1,ApiPath:1,CreatedBy:1,CreatedDate:1,Id:1,Paramiter:1,Path:1,UpdateBy:1,UpdateDate:1},LogJson:{ApiPath:1,CreatedBy:1,CreatedDate:1,Id:1,LogData:1,LogMessage:1,LogType:1},LogRefund:{Cashier:1,CheckDoc:1,CreateDate:1,DocNo:1,FlagReceipt:1,Id:1,PosId:1,RefDocNo:1,ShiftId:1,ShopId:1},LogUserLockErrorPassword:{DisplayName:1,Email:1,ShopId:1,UserErrorStampFg:1,UserId:1,Username:1},LogUserPasswordChangeDate:{DisplayName:1,Email:1,PasswordChangeDate:1,ShopId:1,UserId:1,Username:1}},Lookups:{CusImportOrLocal:{CusImportOrLocal:1,LookupName:1},CusProductSalesBeforeFlag:{CusProductSalesBeforeFlag:1,LookupName:1},CusProductSalesBeforeReferFlag:{CusProductSalesBeforeReferFlag:1,LookupName:1},CusProductTypeNbp:{CusProductTypeNbp:1,NbpName:1},LookupBgColor:{BgColor:1,BgColorName:1,Id:1},LookupBrand:{BrandCode:1,BrandName:1,CreateBy:1,CreateDate:1,Id:1,LastUpdate:1,UpdateBy:1},LookupCategory:{CatCode:1,CatName:1},LookupIcStockSetAssemblePostedunuse:{Name:1,SysDocNo:1},LookupPostranHd:{AllItemCharge:1,AllItemDiscount:1,BillCharge:1,BillDiscount:1,CashierId:1,CreateBy:1,CreateDate:1,DocAmt:1,DocDate:1,DocNo:1,DocTime:1,Factor:1,GrossSales:1,Id:1,LastUpdate:1,MbId:1,NetSales:1,NetSalesExVat:1,NetSalesNonVat:1,NetSalesNormal:1,NetSalesPromo:1,PosId:1,ReceiveCash:1,ReceiveCashCd:1,ReceiveCoupon:1,ReceiveCreditCd:1,ReceiveDebitCd:1,ReceiveOthers:1,ReceivePoint:1,RefDocNo:1,RoundAdjust:1,SalesVatType:1,SalesmanId:1,UpdateBy:1,Vat:1,VatOfCharge:1,VatOfNetSales:1},LookupSubCategory1:{SubCat1Code:1,SubCat1Name:1},LookupSubCategory2:{SubCat2Code:1,SubCat2Name:1},LookupSupplier:{ConsignFg:1,ConsignGp:1,ContactName:1,CreateBy:1,CreateDate:1,Id:1,LastUpdate:1,SupplAddress:1,SupplId:1,SupplName:1,SupplRegAddress:1,SupplRegName:1,SupplTaxId:1,SupplType:1,SupplierShortName:1,UpdateBy:1},LookupTxtColor:{Id:1,TxtColor:1,TxtColorName:1},PsPosShiftStatus:{FullName:1,ShiftStatus:1,ShiftStatusDesc:1},SysCountry:{CounShowCode:1,CounTinent:1,CountryCode:1,CountryName:1,CreateBy:1,CreateDate:1,Id:1,LastUpdate:1,NationName:1,UpdateBy:1},SysPara:{CreateBy:1,CreateDate:1,Id:1,LastUpdate:1,SysDesc:1,SysFg:1,SysFgDesc:1,SysGroup:1,SysName:1,UpdateBy:1},VpoSparam:{AllowSaleOverStock:1,AutoChargeFg:1,AutoChargeRate:1,BizAddressLine1:1,BizAddressLine2:1,BizAddressLine3:1,BizName:1,BizType:1,BranchName:1,CashPayRoundMethod:1,CashierPosFg:1,ChargeVatRate:1,Connect2ndDispFg:1,ConnectDrawerFg:1,ConnectEdcFg:1,ConnectPrinterFg:1,ConnectRfidReaderFg:1,ConnectVfdFg:1,DiscRoundMethod:1,EjournalFg:1,Email:1,FaxId:1,Id:1,ItemOnRecptMethod:1,LastReceiptRunNo:1,LastRefundRunNo:1,MandatoryMemberFg:1,MandatorySalesmanFg:1,MaxCashInDrawer:1,MbDiscMethod:1,NoOfRecptCopy:1,PointRedeemOneBaht:1,PosId:1,PosPermitNo:1,PosProcessMode:1,PosScreenType:1,PosTouchPanelId:1,PrintOrderFg:1,PrintQueueFg:1,PromptPayLink:1,PsParaDefault1:1,PsParaDefault2:1,QrCodeAccount:1,ReceiptPrinterType:1,RecptFootMesg1:1,RecptFootMesg10:1,RecptFootMesg2:1,RecptFootMesg3:1,RecptFootMesg4:1,RecptFootMesg5:1,RecptFootMesg6:1,RecptFootMesg7:1,RecptFootMesg8:1,RecptFootMesg9:1,RecptHeadMesg1:1,RecptHeadMesg2:1,RecptHeadMesg3:1,RecptHeadMesg4:1,RecptHeadMesg5:1,RecptHeadMesg6:1,RecptNoBarcodeFg:1,RecptSumItemQtyFg:1,RegId:1,SalesDocFg:1,SalesVatType:1,SelectSellingPriceFg:1,SellingPriceNo:1,ShopAddress:1,ShopGroupId:1,ShopId:1,ShopLogoOnFrontScreen:1,ShopLogoOnReceipt:1,ShopName:1,ShopRegAddressLine1:1,ShopRegAddressLine2:1,ShopRegAddressLine3:1,ShopRegId:1,ShopRegName:1,ShopTaxId:1,ShopTypeId:1,TaxId:1,TaxInvAddrLine1:1,TaxInvAddrLine2:1,TaxInvAddrLine3:1,TaxInvName:1,TelId:1,VatFg:1,WeightBarcodePrefix:1,WhsId:1},VpsPaymenType:{Code:1,Detail:1,Name:1,Paytype:1,Pcamt:1,Pcpc:1,Value:1,Valuetype:1},VwApprovalGroup:{ApprGroupCode:1,ApprGroupName:1,CreateBy:1,CreateDate:1,Id:1,LastUpdate:1,UpdateBy:1},VwArticle:{ArticleSeasonCode:1,ArticleSeasonName:1,CreateBy:1,CreateDate:1,FullName:1,Id:1,LastUpdate:1,UpdateBy:1},VwBrandType:{BrandTypeCode:1,BrandTypeName:1,CreateBy:1,CreateDate:1,FullName:1,Id:1,IsActive:1,LastUpdate:1,UpdateBy:1},VwCashier:{CashierId:1,CashierName:1,FullName:1,Id:1},VwConcept:{ConceptCode:1,ConceptName:1,CreateBy:1,CreateDate:1,FullName:1,Id:1,IsActive:1,LastUpdate:1,UpdateBy:1},VwDashboardPage:{DayCount:1,DaynNetSale:1,LowStock:1,MonthCount:1,MonthNetSale:1,ShopId:1,SlowMoveAll:1},VwIcWhs:{CreateBy:1,CreateDate:1,Id:1,LastUpdate:1,NameProperty:1,ShopId:1,UpdateBy:1,WhsId:1,WhsName:1,WhsType:1},VwPluLookupSetItem:{PluCode:1,PluDesc:1,PluFullCode:1,PluShortDesc:1,SellUnit:1,SellUnitPrice1:1},VwPosFunc:{FullName:1,FunLevel:1,FuncDesc:1,FuncId:1,FuncUsage:1,Id:1},VwPosStation:{AutoChargeFg:1,AutoChargeRate:1,CashierPosFg:1,Connect2ndDispFg:1,ConnectDrawerFg:1,ConnectEdcFg:1,ConnectEdcPort:1,ConnectPrinterFg:1,ConnectRfidReaderFg:1,ConnectVfdFg:1,CreateBy:1,CreateDate:1,EdcBank:1,EjournalFg:1,Id:1,ItemOnRecptMethod:1,LastReceiptRunNo:1,LastRefundRunNo:1,LastUpdate:1,MandatoryMemberFg:1,MandatorySalesmanFg:1,MaxCashInDrawer:1,NoOfRecptCopy:1,PosId:1,PosPermitNo:1,PosScreenType:1,PosTouchPanelId:1,PrintOrderFg:1,PrintQueueFg:1,PromptPayLink:1,PsParaDefault1:1,PsParaDefault2:1,QrCodeAccount:1,ReceiptPrinterType:1,RecptFootMesg1:1,RecptFootMesg10:1,RecptFootMesg2:1,RecptFootMesg3:1,RecptFootMesg4:1,RecptFootMesg5:1,RecptFootMesg6:1,RecptFootMesg7:1,RecptFootMesg8:1,RecptFootMesg9:1,RecptFootMesgFontSize:1,RecptFootMesgTextAlign:1,RecptHeadMesg1:1,RecptHeadMesg2:1,RecptHeadMesg3:1,RecptHeadMesg4:1,RecptHeadMesg5:1,RecptHeadMesg6:1,RecptHeadMesgFontSize:1,RecptHeadMesgTextAlign:1,RecptNoBarcodeFg:1,RecptSumItemQtyFg:1,SalesDocFg:1,SalesVatType:1,SelectSellingPriceFg:1,SellingPriceNo:1,ShopId:1,ShopLogoOnFrontScreen:1,ShopLogoOnReceipt:1,UpdateBy:1,WhsId:1},VwPsPara:{AllowSaleOverStock:1,BackOfficeUpLoadUrl:1,BranchName:1,CashPayRoundMethod:1,ChargeVatRate:1,CreateBy:1,CreateDate:1,DiscRoundMethod:1,EjournalFg:1,Id:1,ItemOnRecptMethod:1,LastUpdate:1,MbDiscMethod:1,NoOfRecptCopy:1,PointRedeemOneBaht:1,PosProcessMode:1,PosScreenType:1,PrintOrderFg:1,PrintQueueFg:1,PromptPayLink:1,PsParaDefault1:1,PsParaDefault2:1,QrCodeAccount:1,ReceiptPrinterType:1,RecptFootMesg1:1,RecptFootMesg10:1,RecptFootMesg2:1,RecptFootMesg3:1,RecptFootMesg4:1,RecptFootMesg5:1,RecptFootMesg6:1,RecptFootMesg7:1,RecptFootMesg8:1,RecptFootMesg9:1,RecptFootMesgFontSize:1,RecptFootMesgTextAlign:1,RecptHeadMesg1:1,RecptHeadMesg2:1,RecptHeadMesg3:1,RecptHeadMesg4:1,RecptHeadMesg5:1,RecptHeadMesg6:1,RecptHeadMesgFontSize:1,RecptHeadMesgTextAlign:1,RecptNoBarcodeFg:1,RecptSumItemQtyFg:1,SalesDocFg:1,SalesVatType:1,SelectSellingPriceFg:1,ShopAddress:1,ShopLogoOnFrontScreen:1,ShopLogoOnReceipt:1,ShopName:1,ShopRegAddressLine1:1,ShopRegAddressLine2:1,ShopRegAddressLine3:1,ShopRegId:1,ShopRegName:1,ShopTaxId:1,TaxInvoiceDateFg:1,UpdateBy:1,WeightBarcodePrefix:1},VwSkuLookupPurchase:{ConsignFg:1,ConsignGp:1,FullName:1,LastPurPrice:1,MaxOrderQty:1,MinOrderQty:1,PurUnit:1,PurUnitPrice:1,PurUnitRatio:1,SkuCode:1,SkuDesc:1,StkUnit:1,SupplierId:1},VwSupplItem:{SupplItemCode:1},VwUser:{DisplayName:1,ShopId:1,UserId:1,Username:1},VwUsername:{CheckPasswordUpdate:1,DisplayName:1,Email:1,InsertDate:1,InsertUserId:1,IsActive:1,LastDirectoryUpdate:1,MobilePhoneNumber:1,MobilePhoneVerified:1,PasswordChangeDate:1,PasswordHash:1,PasswordSalt:1,ShopId:1,Source:1,SupplCode:1,TwoFactorAuth:1,UpdateDate:1,UpdateUserId:1,UserActive:1,UserErrorStampFg:1,UserId:1,UserImage:1,Username:1},VwcsPara:{BizAddressLine1:1,BizAddressLine2:1,BizAddressLine3:1,BizName:1,BizNameEn:1,BizType:1,BranchNameDesc:1,BranchNameDescEn:1,BranchNo:1,BuildingName:1,BuildingNameEn:1,BuildingNo:1,BuildingNoEn:1,City:1,CityEn:1,CountryCode:1,CreateBy:1,CreateDate:1,District:1,DistrictEn:1,Email:1,ErpCompCode:1,FaxId:1,Id:1,LastUpdate:1,PostalCode:1,Province:1,ProvinceEn:1,RegId:1,SlowMoveItenDate:1,StreetName:1,StreetNameEn:1,TaxId:1,TaxInvAddrLine1:1,TaxInvAddrLine2:1,TaxInvAddrLine3:1,TaxInvName:1,TelId:1,UpdateBy:1,VatFg:1},VwpsShop:{BranchName:1,BranchNameDesc:1,BranchNameDescEn:1,BranchNameEn:1,BranchTaxCode:1,CreateBy:1,CreateDate:1,Email:1,ErpChannel:1,ErpStore:1,Id:1,LastUpdate:1,PromptPayLink:1,QrCodeAccount:1,ShopAddress:1,ShopAddressEn:1,ShopBuildingName:1,ShopBuildingNameEn:1,ShopBuildingNo:1,ShopBuildingNoEn:1,ShopCity:1,ShopCityEn:1,ShopCountryCode:1,ShopDistrict:1,ShopDistrictEn:1,ShopFullName:1,ShopGroupId:1,ShopId:1,ShopName:1,ShopNameEn:1,ShopPostalCode:1,ShopProvince:1,ShopProvinceEn:1,ShopRegAddressLine1:1,ShopRegAddressLine2:1,ShopRegAddressLine3:1,ShopRegId:1,ShopRegName:1,ShopStreetName:1,ShopStreetNameEn:1,ShopTaxId:1,ShopTypeId:1,TelId:1,UpdateBy:1},VwpsShopGroup:{CreateBy:1,CreateDate:1,Id:1,LastUpdate:1,ShopGroupId:1,ShopGroupName:1,UpdateBy:1},VwpsShopType:{CreateBy:1,CreateDate:1,Id:1,LastUpdate:1,ShopTypeId:1,ShopTypeName:1,UpdateBy:1}},Member:{LookupMember:{ApplyShopId:1,CreateBy:1,CreateDate:1,Id:1,LastUpdate:1,MbAccumPoint:1,MbAddress:1,MbAmphur:1,MbApplyDate:1,MbBirthDay:1,MbCardStatus:1,MbCardType:1,MbEmail:1,MbExpireDate:1,MbExpirePointDate:1,MbGender:1,MbId:1,MbLineAddr1:1,MbLineAddr2:1,MbLineAddr3:1,MbMemo:1,MbNameE:1,MbNameT:1,MbNation:1,MbNearlyExpirePoint:1,MbOccupation:1,MbPhoto:1,MbPid:1,MbProvince:1,MbRace:1,MbTelNo:1,MbTumbol:1,MbType:1,MbZipCode:1,UpdateBy:1},MbAmphurLookup:{MbAmphur:1,MbProvince:1,MbTumbol:1},MbProvinceLookup:{MbAmphur:1,MbProvince:1,MbTumbol:1},MbReport01:{AllItemCharge:1,AllItemDiscount:1,DtList:1,GrossSales:1,Id:1,MbAccumPoint:1,MbAddress:1,MbAmphur:1,MbBirthDay:1,MbCardStatus:1,MbGender:1,MbId:1,MbMemo:1,MbNameE:1,MbNameT:1,MbNation:1,MbOccupation:1,MbProvince:1,MbRace:1,MbTumbol:1,MbType:1,MbZipCode:1,MemberTypeDesc:1,NetSales:1,NetSalesExVat:1,PluDtList:1,VatOfCharge:1,VatOfNetSales:1},MbReport01_Dt:{AllItemCharge:1,AllItemDiscount:1,DocDate:1,DocNo:1,GrossSales:1,Id:1,MbId:1,NetSales:1,NetSalesExVat:1,PluDtList:1,ReCash:1,ReCashCard:1,ReCoupon:1,ReCreditCd:1,ReCurrency:1,ReDebitCd:1,ReOther:1,RePoint:1,ReQr:1,ShopId:1,ShopName:1,VatOfCharge:1,VatOfNetSales:1},MbReport02_:{LastUpdate:1,MbAccumPoint:1,MbAddress:1,MbAmphur:1,MbApplyDate:1,MbBirthDay:1,MbCardStatus:1,MbCardType:1,MbEmail:1,MbExpireDate:1,MbExpirePointDate:1,MbGender:1,MbId:1,MbMemo:1,MbNameE:1,MbNameT:1,MbNation:1,MbNearlyExpirePoint:1,MbOccupation:1,MbPhoto:1,MbPid:1,MbProvince:1,MbRace:1,MbTelNo:1,MbTumbol:1,MbType:1,MbZipCode:1,UpdateBy:1},MbReportSaleByDate:{AllItemCharge:1,AllItemDiscount:1,CountDocNo:1,DocDate:1,GrossSales:1,Id:1,MbAccumPoint:1,MbAddress:1,MbAmphur:1,MbBirthDay:1,MbCardStatus:1,MbGender:1,MbId:1,MbMemo:1,MbNameE:1,MbNameT:1,MbNation:1,MbOccupation:1,MbProvince:1,MbRace:1,MbTumbol:1,MbType:1,MbZipCode:1,MemberTypeDesc:1,NetSales:1,NetSalesExVat:1,VatOfCharge:1,VatOfNetSales:1},MbReport_01_Dt_:{AllocatedBillDiscount:1,ChargeAmt:1,ChargePc:1,CreateBy:1,CreateDate:1,DiscCouponNo:1,DiscCouponType:1,DiscPc:1,Discamt:1,DocNo:1,ExPrice:1,Id:1,ItemCharge:1,ItemDesc:1,ItemDiscount:1,ItemNetExprice:1,ItemNetSales:1,ItemPromoFg:1,ItemPromoId:1,ItemVat:1,ItemVatRate:1,ItemVatType:1,LastUpdate:1,LineItemNo:1,LineItemType:1,PluCode:1,PosFg:1,PromoId:1,Qty:1,QtyRefund:1,RefLineItemNo:1,SellUnit:1,SerialNo:1,UnitPrice:1,UpdateBy:1},MbReport_01_Dt_Plu:{AllItemDiscount:1,DocDate:1,DocNo:1,DtList:1,GrossSales:1,Id:1,MbId:1,NetSales:1,NetSalesExVat:1,PluCode:1,PluDesc:1,Qty:1,ShopId:1,ShopName:1,VatOfNetSales:1},MbTumbolLookup:{MbAmphur:1,MbProvince:1,MbTumbol:1},PsMeberStatus:{Id:1,MbCardStatuName:1,MbCardStatus:1},PsMember:{ApplyShopId:1,CreateBy:1,CreateDate:1,FullNameMb:1,Id:1,LastUpdate:1,MbAccumPoint:1,MbAddress:1,MbAmphur:1,MbApplyDate:1,MbBirthDay:1,MbCardStatus:1,MbCardType:1,MbEmail:1,MbExpireDate:1,MbExpirePointDate:1,MbGender:1,MbId:1,MbLineAddr1:1,MbLineAddr2:1,MbLineAddr3:1,MbMemo:1,MbNameE:1,MbNameT:1,MbNation:1,MbNearlyExpirePoint:1,MbOccupation:1,MbPhoto:1,MbPid:1,MbProvince:1,MbRace:1,MbTelNo:1,MbTumbol:1,MbType:1,MbZipCode:1,UpdateBy:1},PsMemberGender:{Id:1,MbGender:1,MbGenderName:1},PsMemberType:{CreateBy:1,CreateDate:1,Id:1,LastUpdate:1,MbDiscPs:1,MbPriceFg:1,MemberType:1,MemberTypeDesc:1,SellUnitPriceNo:1,UpdateBy:1},ReportMemberCondition:{CreateBy:1,CreateDate:1,FullNameMb:1,Id:1,LastUpdate:1,MbAccumPoint:1,MbAddress:1,MbAmphur:1,MbApplyDate:1,MbBirthDay:1,MbCardStatus:1,MbCardType:1,MbEmail:1,MbExpireDate:1,MbExpirePointDate:1,MbGender:1,MbId:1,MbLineAddr1:1,MbLineAddr2:1,MbLineAddr3:1,MbMemo:1,MbNameE:1,MbNameT:1,MbNation:1,MbNearlyExpirePoint:1,MbOccupation:1,MbPhoto:1,MbPid:1,MbProvince:1,MbRace:1,MbTelNo:1,MbTumbol:1,MbType:1,MbZipCode:1,UpdateBy:1}},Points:{MemberType:{CreateBy:1,CreateDate:1,DtList:1,Id:1,LastUpdate:1,MbDiscPs:1,MbPriceFg:1,MemberType:1,MemberTypeDesc:1,SellUnitPriceNo:1,UpdateBy:1},PrPointCampaign:{CreateBy:1,CreateDate:1,DowId:1,DowName:1,Id:1,LastUpdate:1,MemberType:1,OnePointbyAmt:1,PointRedeemOneBaht:1,UpdateBy:1},PrPointRedeemItem:{CreateBy:1,CreateDate:1,EndDate:1,Id:1,LastUpdate:1,NoOfPoint:1,PluCode:1,PluName:1,StartDate:1,UpdateBy:1}},PosShift:{LogFuctionLvApp:{AppCashier:1,AppCashierLv:1,CashierLv:1,CreateBy:1,CreateDate:1,FuncId:1,Id:1,LastUpdate:1,PosId:1,Remark:1,ShiftId:1,UnlockFor:1,UpdateBy:1},LookupLastPassportDataforVatRefund:{Addressno:1,City:1,Country:1,District:1,Email:1,FristName:1,LastName:1,Nation:1,Passport:1,Province:1,Street:1,ZipCode:1},LookupPostrandtsale:{AllocatedBillDiscount:1,AllocatedBillDiscountVat:1,BasePrice:1,ChargeAmt:1,ChargePc:1,CreateBy:1,CreateDate:1,DiscCouponNo:1,DiscCouponType:1,DiscPc:1,Discamt:1,DocNo:1,ErpAutoGenStamp:1,ExPrice:1,GpPc:1,Id:1,ItemCharge:1,ItemDesc:1,ItemDiscount:1,ItemNetExprice:1,ItemNetSales:1,ItemPromoFg:1,ItemPromoId:1,ItemVat:1,ItemVatRate:1,ItemVatType:1,LastUpdate:1,LineItemNo:1,LineItemType:1,PluCode:1,PosFg:1,PromoId:1,Qty:1,QtyRefund:1,RefLineItemNo:1,SerialNo:1,UnitPrice:1,UpdateBy:1,VenderSharing:1},LookupPostranhdrefundtax:{AllItemCharge:1,AllItemDiscount:1,BillCharge:1,BillDiscount:1,CashierId:1,CreateBy:1,CreateDate:1,DocAmt:1,DocDate:1,DocNo:1,DocTime:1,DpType:1,ErpAutoGenStamp:1,Factor:1,GrossSales:1,Id:1,LastUpdate:1,MbId:1,NetSales:1,NetSalesExVat:1,NetSalesNonVat:1,NetSalesNormal:1,NetSalesPromo:1,PosId:1,PostFg:1,ReceiveCash:1,ReceiveCashCd:1,ReceiveCoupon:1,ReceiveCreditCd:1,ReceiveDebitCd:1,ReceiveOthers:1,ReceivePoint:1,RefDocNo:1,RefundFg:1,RoundAdjust:1,SalesVatType:1,SalesmanId:1,ShopId:1,UpdateBy:1,Vat:1,VatOfCharge:1,VatOfNetSales:1},LookupPostranhdsale:{CashierId:1,DocDate:1,DocNo:1,DocTime:1,Factor:1,Id:1,MbId:1,PosId:1,RefDocNo:1,SalesVatType:1,SalesmanId:1,ShopId:1},LookupRecieptforVatRefund:{DocNo:1,PropertyName:1,ShopId:1},LookupTaxInvoiceforVatRefund:{DocNo:1,PropertyName:1,RefDocNo:1,ShopId:1},PaymentType:{CreateBy:1,CreateDate:1,Id:1,LastUpdate:1,PaymentName:1,PaymentType:1,UpdateBy:1},PosTranDisc:{ChargeAmt:1,ChargePc:1,CreateBy:1,CreateDate:1,DiscCouponNo:1,DiscCouponType:1,DiscPc:1,Discamt:1,DocNo:1,Id:1,LastUpdate:1,LineItemNo:1,LineItemType:1,PromoId:1,UpdateBy:1},PosTranDt:{AllocatedBillDiscount:1,AllocatedBillDiscountVat:1,ChargeAmt:1,ChargePc:1,CreateBy:1,CreateDate:1,DiscCouponNo:1,DiscCouponType:1,DiscPc:1,Discamt:1,DocNo:1,ExPrice:1,GpPc:1,Id:1,ItemCharge:1,ItemDesc:1,ItemDiscount:1,ItemNetExprice:1,ItemNetSales:1,ItemPromoFg:1,ItemPromoId:1,ItemVat:1,ItemVatRate:1,ItemVatType:1,LastUpdate:1,LineItemNo:1,LineItemType:1,PluCode:1,PosFg:1,PromoId:1,Qty:1,QtyRefund:1,RefLineItemNo:1,SerialNo:1,UnitPrice:1,UpdateBy:1,VenderSharing:1},PosTranHd:{AllItemCharge:1,AllItemDiscount:1,BillCharge:1,BillDiscount:1,CashierId:1,CreateBy:1,CreateDate:1,DocAmt:1,DocDate:1,DocNo:1,DocTime:1,Factor:1,GrossSales:1,Id:1,LastUpdate:1,MbId:1,NetSales:1,NetSalesExVat:1,NetSalesNonVat:1,NetSalesNormal:1,NetSalesPromo:1,PosId:1,PostFg:1,ReceiveCash:1,ReceiveCashCd:1,ReceiveCoupon:1,ReceiveCreditCd:1,ReceiveDebitCd:1,ReceiveOthers:1,ReceivePoint:1,RefDocNo:1,RefundFg:1,RefundId:1,RoundAdjust:1,SalesVatType:1,SalesmanId:1,ShopId:1,UpdateBy:1,Vat:1,VatOfCharge:1,VatOfNetSales:1},PosTranRecv:{CreateBy:1,CreateDate:1,CurrencyAmt:1,CurrencyCode:1,DocNo:1,ExchangeRate:1,Id:1,LastUpdate:1,LineItemNo:1,LineItemType:1,PaymentType:1,PointBurn:1,ReceiptAmt:1,RefNo:1,RefType:1,UpdateBy:1},PsEndDayCashier:{Amt:1,CashBag:1,CashierId:1,CreateDate:1,EndCountId:1,EndShift:1,Id:1,ShopId:1,StartCountId:1,StartShift:1},PsPosMoneyCount:{BagCode:1,CashierId:1,CountDate:1,CountId:1,CountType:1,CreateBy:1,CreateDate:1,CusWsFlg:1,Id:1,InTime:1,LastUpdate:1,PosId:1,Remark:1,ShopId:1,TenderAmt:1,TenderCode:1,TenderName:1,TenderQty:1,TenderRate:1,TenderType:1,TypeCb:1,UpdateBy:1},PsPosShiftControl:{BegCash:1,CashBalance:1,CashIn:1,CashOut:1,CashSales:1,CashierId:1,Charge:1,CountCancel:1,CountCashIn:1,CountCashOut:1,CountOpenDrawer:1,CountRefund:1,CountVoid:1,CreateBy:1,CreateDate:1,Deiscount:1,EndReceiptNo:1,EndRefundNo:1,GrossAmt:1,Id:1,LastUpdate:1,NetSales:1,PosId:1,RecvByCash:1,RecvByCashCd:1,RecvByCoupon:1,RecvByCreditCd:1,RecvByDebitCd:1,RecvByOthers:1,RecvByPoint:1,RoundReceive:1,ShiftStatus:1,ShopFullName:1,ShopId:1,SingInDate:1,SingInTime:1,SingOutDate:1,SingOutTime:1,StartReceiptNo:1,StartRefundNo:1,TotalCashInAmt:1,TotalCashOutamt:1,TotalRefundAmt:1,TotalVoidAmt:1,UpdateBy:1},PsPosShiftControlView:{BegCash:1,CashBalance:1,CashIn:1,CashOut:1,CashSales:1,CashierId:1,Charge:1,CountCancel:1,CountCashIn:1,CountCashOut:1,CountOpenDrawer:1,CountRefund:1,CountVoid:1,CreateBy:1,CreateDate:1,Deiscount:1,EndReceiptNo:1,EndRefundNo:1,GrossAmt:1,Id:1,LastUpdate:1,NetSales:1,PosId:1,RecvByCash:1,RecvByCashCd:1,RecvByCoupon:1,RecvByCreditCd:1,RecvByCurrency:1,RecvByDebitCd:1,RecvByOthers:1,RecvByPoint:1,RecvByQr:1,RoundReceive:1,ShiftStatus:1,ShopFullName:1,ShopId:1,SingInDate:1,SingInTime:1,SingOutDate:1,SingOutTime:1,StartReceiptNo:1,StartRefundNo:1,TotalCashInAmt:1,TotalCashOutamt:1,TotalRefundAmt:1,TotalVoidAmt:1,UpdateBy:1},PsPriceOverrideTran:{CashierId:1,CreateBy:1,CreateDate:1,DocNo:1,Id:1,MgrCashierId:1,OverridePrice:1,PluCode:1,PluDesc:1,PosId:1,PriceOverrideId:1,Qty:1,UnitPrice:1},PsQueue:{Id:1,LastQueueNo:1,ShopId:1,TodayDate:1},PsTaxInvoiceAddress:{CreateBy:1,CreateDate:1,CusTaxTypeFg:1,Id:1,LastUpdate:1,LookupName:1,MbId:1,TaxBranchName:1,TaxBranchNo:1,TaxCountryCode:1,TaxEmail:1,TaxId:1,TaxInvAddressLine1:1,TaxInvAddressLine2:1,TaxInvAddressLine3:1,TaxInvName:1,TaxPostalCode:1,TelNo:1,UpdateBy:1},PsTaxInvoiceDt:{AllocatedBillDiscount:1,AllocatedBillDiscountVat:1,CreateBy:1,CreateDate:1,DocNo:1,DocType:1,ExPrice:1,Id:1,ItemCharge:1,ItemDescription:1,ItemDiscount:1,ItemExVat:1,ItemNetExprice:1,ItemNetSales:1,ItemNetSales2:1,ItemPromoFg:1,ItemVatAmt:1,ItemVatAmt2:1,LastUpdate:1,LineItemNo:1,PluCode:1,Qty:1,SalesVatType:1,SellUnit:1,SerialNo:1,UnitPrice:1,UpdateBy:1,VatRate:1,VatType:1},PsTaxInvoiceHd:{CancelFg:1,ChargeAmt:1,ConcatRefDocNo1:1,CreateBy:1,CreateDate:1,CusTaxTypeFg:1,DiscountAmt:1,DocDate:1,DocNo:1,DocType:1,DtList:1,ErpAutoGenStamp:1,GrossAmt:1,Id:1,LastUpdate:1,MbId:1,NetAmt:1,NetSalesExVat:1,NetSalesNonVat:1,NetSalesNormal:1,NewTaxInvoiceAmt:1,NoOfPrint:1,PostFg:1,PurposeCode:1,PurposeRemark:1,RefDocDate:1,RefDocNo:1,RefTaxInvoice:1,RefTaxInvoiceAmt:1,RefTaxInvoiceDate:1,RefundFg:1,RefundId:1,Remark:1,SalesVatType:1,ShopId:1,SumDisChargeAmt:1,TaxBranchName:1,TaxBranchNo:1,TaxCountryCode:1,TaxEmail:1,TaxId:1,TaxInvAddressLine1:1,TaxInvAddressLine2:1,TaxInvAddressLine3:1,TaxInvName:1,TaxInvNameId:1,TaxInvoiceAmt:1,TaxInvoiceAmtDiff:1,TaxPostalCode:1,TelNo:1,UpdateBy:1,VatAmt:1},PsVatRefund:{Addressno:1,ArriveDate:1,BookNo:1,City:1,ConfigPrint:1,Country:1,CreateBy:1,CreateDate:1,DepartureDate:1,District:1,DocDate:1,DocNo:1,DtList:1,Email:1,FlightNo:1,FristName:1,Id:1,IssueByDate:1,IssueName:1,LastName:1,LastUpdate:1,Nation:1,No:1,Offline:1,Passport:1,PayVatAmount:1,Province:1,RefFg:1,RefNo:1,Remark:1,RoundedVatRefund:1,ShopId:1,Status:1,Street:1,Total:1,UpdateBy:1,Vat:1,VatRateNo:1,ZipCode:1},PsVatRefundDt:{Amt:1,Cancel:1,DocNo:1,Id:1,ItemId:1,ItemNo:1,ItemVat:1,PluCode:1,PluDesc:1,Qty:1,RefInv:1,RefTaxNo:1},PsVatRefundPrintingPara:{CreateBy:1,CreateDate:1,FromCode:1,Id:1,LastUpdate:1,P1DetailAddressFontSize:1,P1DetailAddressPHeight:1,P1DetailAddressPaddingLeft:1,P1DetailAddressPaddingTop:1,P1DetailEmailFontSize:1,P1DetailEmailPHeight:1,P1DetailEmailPaddingLeft:1,P1DetailEmailPaddingTop:1,P1DetailLeftHeight:1,P1DetailLeftTableC1Width:1,P1DetailLeftTableC2Width:1,P1DetailLeftTableC3Width:1,P1DetailLeftTableC4Width:1,P1DetailLeftTableC5PeddingRight:1,P1DetailLeftTableC5Width:1,P1DetailLeftTablePaddingLeft:1,P1DetailLeftTablePaddingTop:1,P1DetailLeftTableRowHeight:1,P1DetailLeftWidth:1,P1DetailLine2CityPaddingLeft:1,P1DetailLine2CityPaddingWidth:1,P1DetailLine2CountyPaddingLeft:1,P1DetailLine2FontSize:1,P1DetailLine2PHeight:1,P1DetailLine2PaddingTop:1,P1DetailLine2PostcodePaddingLeft:1,P1DetailLine2PostcodePaddingWidth:1,P1DetailPhonenumberFontSize:1,P1DetailPhonenumberPHeight:1,P1DetailPhonenumberPaddingLeft:1,P1DetailPhonenumberPaddingTop:1,P1DetailRightPaddingTop:1,P1DetailRightWidth:1,P1FooterLeftHeight:1,P1FooterLeftWidth:1,P1FooterPageNext:1,P1FooterPagetoFontSize:1,P1FooterPagetoHeight:1,P1FooterPagetoPaddingButtom:1,P1FooterPagetoPaddingLeft:1,P1FooterPagetoWidth:1,P1FooterSumFontSize:1,P1FooterSumPeddingRight:1,P1FooterSumWidth:1,P1HeaderHeight:1,P1HeaderLeftAddNoFontSize:1,P1HeaderLeftAddNoHeight:1,P1HeaderLeftAddNoPaddingLeft:1,P1HeaderLeftAddNoWidth:1,P1HeaderLeftBranchFontSize:1,P1HeaderLeftBranchHeight:1,P1HeaderLeftBranchPaddingLeft:1,P1HeaderLeftBranchPaddingRight:1,P1HeaderLeftBranchSpacing:1,P1HeaderLeftCompanyNameFontSize:1,P1HeaderLeftCompanyNamePaddingLeft:1,P1HeaderLeftDistrictFontSize:1,P1HeaderLeftDistrictHeight:1,P1HeaderLeftDistrictPaddingLeft:1,P1HeaderLeftDistrictWidth:1,P1HeaderLeftProviceFontSize:1,P1HeaderLeftProvicePaddingLeft:1,P1HeaderLeftShopTaxIdFontSize:1,P1HeaderLeftShopTaxIdHeight:1,P1HeaderLeftShopTaxIdPaddingLeft:1,P1HeaderLeftShopTaxIdPaddingRight:1,P1HeaderLeftShopTaxIdSpacing:1,P1HeaderLeftStreetFontSize:1,P1HeaderLeftStreetPaddingLeft:1,P1HeaderLeftTelnoFontSize:1,P1HeaderLeftTelnoHeight:1,P1HeaderLeftTelnoPaddingLeft:1,P1HeaderLeftWidth:1,P1HeaderRightDateFontSize:1,P1HeaderRightDateHeight:1,P1HeaderRightDateLeftMmyyWidth:1,P1HeaderRightDateLeftPaddingLeft:1,P1HeaderRightDateLeftWidth:1,P1HeaderRightDatePaddingTop:1,P1HeaderRightDateRightMmyyWidth:1,P1HeaderRightDateRightPaddingLeft:1,P1HeaderRightDateRightWidth:1,P1HeaderRightNationFontSize:1,P1HeaderRightNationHeight:1,P1HeaderRightNationPaddingLeft:1,P1HeaderRightPaddingTop:1,P1HeaderRightPassnoFontSize:1,P1HeaderRightPassnoHeight:1,P1HeaderRightPassnoPaddingLeft:1,P1HeaderRightTNameFontSize:1,P1HeaderRightTNameHeight:1,P1HeaderRightTNamePaddingLeft:1,P1HeaderRightWidth:1,P1Height:1,P1PaddingLeft:1,P1PaddingTop:1,P1Width:1,P2DetailC1Width:1,P2DetailC2PaddingLeft:1,P2DetailC2Width:1,P2DetailC3PaddingLeft:1,P2DetailC3Width:1,P2DetailC4PaddingLeft:1,P2DetailC4Width:1,P2DetailC5PaddingRight:1,P2DetailC5Width:1,P2DetailHeight:1,P2DetailPaddingLeft:1,P2DetailPaddingRight:1,P2DetailPaddingTop:1,P2DetailRowHeight:1,P2DetailWidth:1,P2FooterHeight:1,P2FooterLeft:1,P2FooterPageNext:1,P2FooterSumPaddingRight:1,P2FooterWidth:1,P2HeaderBookNoHeight:1,P2HeaderBookNoPaddingButtom:1,P2HeaderBookNoPaddingLeft:1,P2HeaderBookNoWidth:1,P2HeaderBranchHeight:1,P2HeaderBranchPaddingLeft:1,P2HeaderBranchPaddingRigth:1,P2HeaderBranchSpacing:1,P2HeaderNoPaddingLeft:1,P2HeaderSaleFontSize:1,P2HeaderSaleHeight:1,P2HeaderSalePaddingButtom:1,P2HeaderSalePaddingLeft:1,P2HeaderTaxBranchFontSize:1,P2HeaderTaxBranchHeight:1,P2HeaderTaxHeight:1,P2HeaderTaxPaddingLeft:1,P2HeaderTaxPaddingRigth:1,P2HeaderTaxSpacing:1,P2Height:1,P2PaddingLeft:1,P2PaddingRight:1,P2PaddingTop:1,P2PageAllPaddingLeft:1,P2PageHeight:1,P2PageLeft:1,P2PageNoHeight:1,P2PageNowFontSize:1,P2PageNowPaddingLeft:1,P2PageNowWidth:1,P2StartHeight:1,P2Width:1,UpdateBy:1},PsVatRefundRate:{CreateBy:1,CreateDate:1,Id:1,LastUpdate:1,PurchaseFrom:1,PurchaseTo:1,RefundFg:1,RefundPc:1,RoundedRefund:1,UpdateBy:1,VatRateNo:1},ReportRecvbyCashierbyDate:{CashierId:1,CashierName:1,CountTime:1,CreateDate:1,CurrencyCode:1,Id:1,PaymentName:1,PaymentType:1,PointBurn:1,ReceiptAmt:1,RefType:1},ReportSaleTax:{DocDate:1,DocType:1,EndDocNo:1,ExVatAmt:1,Id:1,NonVatAmt:1,PosId:1,PosPermitNo:1,StartDocNo:1,TotalAmt:1,VatAmt:1},ReportSaleTaxTreeTax:{BranchName:1,BuyerName:1,DocAmt:1,DocDate:1,DocType:1,EndDocNo:1,ExVatAmt:1,HdDtFg:1,Id:1,NonVatAmt:1,PosId:1,PosPermitNo:1,RefRecieptNo:1,StartDocNo:1,TaxId:1,TaxInvoiceNo:1,TotalAmt:1,VatAmt:1},ReportVatRefund:{BookNo:1,DocDate:1,FristName:1,Id:1,No:1,Passport:1,PayVatAmount:1,Remark:1,RowNo:1,Total:1}},PriceChange:{ActivePriceChange:{ActiveBy:1,Activedate:1,ApproveBy:1,ApproveFg:1,Approvedate:1,BrandCode:1,CatCode:1,ColorId:1,CreateBy:1,CreateDate:1,EffectiveDate:1,Id:1,LastUpdate:1,MatTypeId:1,PluCode:1,PluName:1,PostFg:1,SellUnitPrice1:1,SellUnitPrice1Fg:1,SellUnitPrice2:1,SellUnitPrice2Fg:1,SellUnitPrice3:1,SellUnitPrice3Fg:1,SellUnitPrice4:1,SellUnitPrice4Fg:1,SellUnitPrice5:1,SellUnitPrice5Fg:1,SellUnitPrice6:1,SellUnitPrice6Fg:1,SizeId:1,SkuCode:1,StyleId:1,SubCat1Code:1,SubCat2Code:1,TasteId:1,UpdateBy:1},AddPriceChange:{ApproveFg:1,CreateBy:1,CreateDate:1,EffectiveDate:1,Id:1,LastUpdate:1,PluCode:1,PluName:1,PostFg:1,SellUnitPrice1:1,SellUnitPrice1Fg:1,SellUnitPrice2:1,SellUnitPrice2Fg:1,SellUnitPrice3:1,SellUnitPrice3Fg:1,SellUnitPrice4:1,SellUnitPrice4Fg:1,SellUnitPrice5:1,SellUnitPrice5Fg:1,SellUnitPrice6:1,SellUnitPrice6Fg:1,UpdateBy:1},ApprovePriceChange:{ActiveBy:1,Activedate:1,ApproveBy:1,ApproveFg:1,Approvedate:1,BrandCode:1,CatCode:1,ColorId:1,CreateBy:1,CreateDate:1,EffectiveDate:1,Id:1,LastUpdate:1,MatTypeId:1,PluCode:1,PluName:1,PostFg:1,SellUnitPrice1:1,SellUnitPrice1Fg:1,SellUnitPrice2:1,SellUnitPrice2Fg:1,SellUnitPrice3:1,SellUnitPrice3Fg:1,SellUnitPrice4:1,SellUnitPrice4Fg:1,SellUnitPrice5:1,SellUnitPrice5Fg:1,SellUnitPrice6:1,SellUnitPrice6Fg:1,SizeId:1,SkuCode:1,StyleId:1,SubCat1Code:1,SubCat2Code:1,SupplierId:1,TasteId:1,UpdateBy:1}},Product:{CsArticleSeason:{ArticleSeasonCode:1,ArticleSeasonName:1,CreateBy:1,CreateDate:1,FullName:1,Id:1,LastUpdate:1,UpdateBy:1},CsBrand:{BrandCode:1,BrandName:1,CreateBy:1,CreateDate:1,FullName:1,Id:1,LastUpdate:1,UpdateBy:1},CsBrandType:{BrandTypeCode:1,BrandTypeName:1,CreateBy:1,CreateDate:1,FullName:1,Id:1,IsActive:1,LastUpdate:1,UpdateBy:1},CsCategory:{CatCode:1,CatName:1,CreateBy:1,CreateDate:1,FullCatName:1,Id:1,LastUpdate:1,UpdateBy:1},CsColor:{ColorId:1,ColorName:1,CreateBy:1,CreateDate:1,FullName:1,Id:1,LastUpdate:1,UpdateBy:1},CsConcept:{ConceptCode:1,ConceptName:1,CreateBy:1,CreateDate:1,FullName:1,Id:1,IsActive:1,LastUpdate:1,UpdateBy:1},CsDocType:{CODE:1,CreateBy:1,CreateDate:1,DocGroup:1,DocName:1,DocPrefix:1,DocType:1,FullName:1,Id:1,LastUpdate:1,UpdateBy:1},CsMatType:{CreateBy:1,CreateDate:1,FullName:1,Id:1,LastUpdate:1,MatTypeId:1,MatTypeName:1,UpdateBy:1},CsPlu:{ActiveRepFg:1,ActiveSellFg:1,ColorId:1,ColorName:1,ConceptCode:1,CreateBy:1,CreateDate:1,DeliverCost:1,Id:1,IsActive:1,LastUpdate:1,MatTypeId:1,MatTypeName:1,PluCode:1,PluDesc:1,PluName:1,PluShortDesc:1,PluType:1,SellUnit:1,SellUnitPrice1:1,SellUnitPrice2:1,SellUnitPrice3:1,SellUnitPrice4:1,SellUnitPrice5:1,SellUnitPrice6:1,SellUnitRatio:1,SizeId:1,SizeName:1,SkuCode:1,SkuDesc:1,StyleId:1,StyleName:1,TasteId:1,TasteName:1,UpdateBy:1},CsSize:{CreateBy:1,CreateDate:1,FullName:1,Id:1,LastUpdate:1,SizeId:1,SizeName:1,UpdateBy:1},CsSku:{ActiveFg:1,ActivePurFg:1,ActiveRepFg:1,ActiveSellFg:1,ArticleSeasonCode:1,BrandCode:1,BrandName:1,BrandTypeCode:1,CatCode:1,CatName:1,ColorId:1,ColorName:1,ConceptCode:1,ConsignFg:1,ConsignGp:1,CreateBy:1,CreateDate:1,CusImportOrLocal:1,CusProductSalesBeforeFlag:1,CusProductSalesBeforeRefer:1,CusProductSalesBeforeReferFlag:1,CusProductTypeNbp:1,ExpDate:1,Id:1,LastPurPrice:1,LastStockCostUnit:1,LastUpdate:1,MarketDate:1,MatTypeId:1,MatTypeName:1,MaxOrderQty:1,MaxStockQty:1,MinOrderQty:1,MinStockQty:1,NonAllowtoDiscountFg:1,PluDtList:1,ProdImageLink:1,ProductCpComponent:1,ProductCpDesc1:1,ProductCpDesc2:1,ProductCpHowToUse:1,ProductCpWarning:1,ProductType:1,PurLeadTime:1,PurUnit:1,PurUnitPrice:1,PurUnitRatio:1,PurVatCode:1,PurVatType:1,QtyOnhand:1,SetItemFg:1,ShelfLifeTime:1,SizeId:1,SizeName:1,SkuCode:1,SkuDesc:1,SkuEnDesc:1,SkuName:1,StkUnit:1,StockCostValue:1,StockFg:1,StyleId:1,StyleName:1,SubCat1Code:1,SubCat1Name:1,SubCat2Code:1,SubCat2Name:1,SupplItemCode:1,SupplName:1,SupplierId:1,TasteId:1,TasteName:1,UnitList:1,UpdateBy:1,VatCode:1,VatRate:1,VatType:1,VatTypeDesc:1},CsStyle:{CreateBy:1,CreateDate:1,FullName:1,Id:1,LastUpdate:1,StyleId:1,StyleName:1,UpdateBy:1},CsSubCategory1:{CatCode:1,CreateBy:1,CreateDate:1,FullName:1,Id:1,LastUpdate:1,SubCat1Code:1,SubCat1Name:1,UpdateBy:1},CsSubCategory2:{CatCode:1,CreateBy:1,CreateDate:1,FullName:1,Id:1,LastUpdate:1,SubCat1Code:1,SubCat2Code:1,SubCat2Name:1,UpdateBy:1},CsTaste:{CreateBy:1,CreateDate:1,FullName:1,Id:1,LastUpdate:1,TasteId:1,TasteName:1,UpdateBy:1},CsUnit:{CreateBy:1,CreateDate:1,FullName:1,Id:1,LastUpdate:1,UnitId:1,UnitName:1,UpdateBy:1},PluDt:{ActiveRepFg:1,ActiveSellFg:1,ColorId:1,ColorName:1,ConceptCode:1,CreateBy:1,CreateDate:1,DeliverCost:1,Id:1,IsActive:1,LastUpdate:1,MatTypeId:1,MatTypeName:1,PluCode:1,PluDesc:1,PluName:1,PluShortDesc:1,PluType:1,SellUnit:1,SellUnitPrice1:1,SellUnitPrice2:1,SellUnitPrice3:1,SellUnitPrice4:1,SellUnitPrice5:1,SellUnitPrice6:1,SellUnitRatio:1,SizeId:1,SizeName:1,SkuCode:1,StyleId:1,StyleName:1,TasteId:1,TasteName:1,UpdateBy:1},PsSetItem:{CalDtFg:1,CreateBy:1,CreateDate:1,FinishDate:1,Id:1,LastUpdate:1,PsSetItemDtList:1,SetItemCode:1,SetItemName:1,SetItemShortName:1,SetItemUnit:1,SetName:1,SetPrice:1,StartDate:1,UpdateBy:1},PsSetItemDt:{CreateBy:1,CreateDate:1,Id:1,LastUpdate:1,LineItemNo:1,NormalUnitPrice:1,PluCode:1,PluDesc:1,Qty:1,SetItemCode:1,SetPrice:1,SetUnitPrice:1,Unit:1,UpdateBy:1},QryMaster:{BrandCode:1,CatCode:1,ColorId:1,ConsignFg:1,Id:1,MatTypeId:1,SizeId:1,SkuCode:1,SkuDesc:1,SkuEnDesc:1,StockFg:1,StyleId:1,SubCat1Code:1,SubCat2Code:1,SupplierId:1,TasteId:1,UrlReport:1,VatType:1},ReportExportV1:{BrandId:1,Category:1,ColorId:1,ConsignFg:1,ConsignGp:1,CreateBy:1,CreateDate:1,CusProductSalesBeforeFlag:1,CusProductSalesBeforeRefer:1,CusProductSalesBeforeReferFlag:1,CusProductTypeNbp:1,DeliverCost:1,Id:1,MatTypeId:1,MaxStockQty:1,MinStockQty:1,NonAllowtoDiscountFg:1,PluDesc:1,ProductCpComponent:1,ProductCpDesc1:1,ProductCpDesc2:1,ProductCpHowToUse:1,ProductCpWarning:1,PurLeadTime:1,PurUnit:1,PurUnitPrice:1,PurUnitRatio:1,SellUnitPrice1:1,SellUnitPrice2:1,SellUnitPrice3:1,SellUnitPrice4:1,SellUnitPrice5:1,SellUnitPrice6:1,SetItemFg:1,SizeId:1,SkuCode:1,SkuDesc:1,StkUnit:1,StockFg:1,StyleId:1,Subcategory1:1,Subcategory2:1,SupplId:1,SupplItemCode:1,TasteId:1,VatCode:1,VatType:1},SkuHd:{ActiveFg:1,ActivePurFg:1,ActiveRepFg:1,ActiveSellFg:1,ArticleSeasonCode:1,BrandCode:1,BrandName:1,BrandTypeCode:1,CatCode:1,CatName:1,ColorId:1,ColorName:1,ConceptCode:1,ConsignFg:1,ConsignGp:1,CreateBy:1,CreateDate:1,CusImportOrLocal:1,CusProductSalesBeforeFlag:1,CusProductSalesBeforeRefer:1,CusProductSalesBeforeReferFlag:1,CusProductTypeNbp:1,ExpDate:1,Id:1,LastPurPrice:1,LastStockCostUnit:1,LastUpdate:1,MarketDate:1,MatTypeId:1,MatTypeName:1,MaxOrderQty:1,MaxStockQty:1,MinOrderQty:1,MinStockQty:1,NonAllowtoDiscountFg:1,PluDtList:1,ProdImageLink:1,ProductCpComponent:1,ProductCpDesc1:1,ProductCpDesc2:1,ProductCpHowToUse:1,ProductCpWarning:1,ProductType:1,PurLeadTime:1,PurUnit:1,PurUnitPrice:1,PurUnitRatio:1,PurVatCode:1,PurVatType:1,QtyOnhand:1,SetItemFg:1,ShelfLifeTime:1,SizeId:1,SizeName:1,SkuCode:1,SkuDesc:1,SkuEnDesc:1,SkuName:1,StkUnit:1,StockCostValue:1,StockFg:1,StyleId:1,StyleName:1,SubCat1Code:1,SubCat1Name:1,SubCat2Code:1,SubCat2Name:1,SupplItemCode:1,SupplName:1,SupplierId:1,TasteId:1,TasteName:1,UpdateBy:1,VatCode:1,VatRate:1,VatType:1,VatTypeDesc:1}},Purchase:{ListAppCnrtv:{ApproveDate:1,CreditNoteNo:1,DocDate:1,ItemTypeFg:1,LastApprove:1,NetTotalInVat:1,RefDocNo1:1,RefDocNo2:1,Remark:1,SendForAppfg:1,ShipId:1,SupplierId:1,SysDocNo:1,WaitApprove:1,WaitLv:1},ListAppCreditNote:{ApproveDate:1,CreditNoteNo:1,DocDate:1,ItemTypeFg:1,LastApprove:1,NetTotalInVat:1,RefDocNo1:1,RefDocNo2:1,Remark:1,SendForAppfg:1,ShipId:1,SupplierId:1,SysDocNo:1,WaitApprove:1,WaitLv:1},ListAppInvoiceReceive:{ApproveDate:1,DocDate:1,ItemTypeFg:1,LastApprove:1,NetTotalInVat:1,PurIvNo:1,RefDocNo1:1,RefDocNo2:1,Remark:1,SendForAppfg:1,ShipId:1,SupplierId:1,SysDocNo:1,WaitApprove:1,WaitLv:1},ListAppPurInvoice:{ApproveDate:1,DocDate:1,ItemTypeFg:1,LastApprove:1,NetTotalInVat:1,PurIvNo:1,RefDocNo1:1,RefDocNo2:1,Remark:1,SendForAppfg:1,ShipId:1,SupplierId:1,SysDocNo:1,WaitApprove:1,WaitLv:1},ListAppPurOrder:{ApproveDate:1,DocDate:1,DocNo:1,LastApprove:1,NetTotalInVat:1,PoTypeFg:1,RefDocNo1:1,RefDocNo2:1,Remark:1,SendForAppfg:1,ShipId:1,SupplierId:1,SysDocNo:1,WaitApprove:1,WaitLv:1},ListAppPurRequest:{ApproveDate:1,DocDate:1,DocNo:1,LastApprove:1,NetTotalInVat:1,PrTypeFg:1,RefDocNo1:1,RefDocNo2:1,Remark:1,SendForAppfg:1,ShipId:1,SupplierId:1,SysDocNo:1,WaitApprove:1,WaitLv:1},ListLastAppPurOrder:{AppDate:1,ApproveBy:1,DisplayName:1,SysDocNo:1},LookupCnforCnrtv:{SupplierId:1,SysDocNo:1},LookupPIforIr:{SupplierId:1,SysDocNo:1},PoApproval:{ApprGroupCode:1,CreateBy:1,CreateDate:1,DocName:1,DocType:1,Id:1,LastUpdate:1,Level:1,Mininum:1,UpdateBy:1},PoApprovalTran:{AppActiveFg:1,ApprGroupCode:1,ApprGroupName:1,ApproveBy:1,ApproveDate:1,ApproveFg:1,DocAmt:1,DocType:1,Id:1,Level:1,SysDocNo:1},PoBank:{BankAccount:1,BankId:1,BankName:1,BankShortName:1,CreateBy:1,CreateDate:1,Id:1,LastUpdate:1,UpdateBy:1},PoCNRTV:{ApproveBy:1,ApproveDate:1,ApproveFg:1,ApproveLv:1,BalanceAmt:1,BankId:1,BranchCode:1,CancelFg:1,CashOrTermfg:1,CheckQty:1,ChequeDate:1,ChequeNo:1,ConcatRefDocNo1:1,CreateBy:1,CreateDate:1,CreditNotetype:1,CreditTerm:1,CurrencyAmt:1,CurrencyCode:1,CusCurrencyAmt:1,CusCurrencyCode:1,CusExchangeRate:1,CusNetAmt:1,CusNetAmtDiff:1,CusPurInvoiceAmt:1,CusVatAmt:1,CusVatDiff:1,DepositAmt:1,DiscAmt:1,DiscText:1,DocDate:1,DtList:1,DueDate:1,ErPfg:1,ExchangeRate:1,ExciseTaxAmt:1,Id:1,LastDateStatusChange:1,LastUpdate:1,NetAmt:1,NetExVat:1,NetTotalInVat:1,POTypeFg:1,PayTermCode:1,PaymentAmt:1,PaymentBeforeDisc:1,PaymentDicsAmt:1,PaymentDicsRemark:1,PaymentNetAmt:1,PaymentRefNo:1,PaymentType:1,PostDate:1,PostFg:1,Postby:1,PurInvoiceAmt:1,PurIvNo:1,ReceiptAmt:1,RefDocNo1:1,RefDocNo2:1,RefType:1,Refuse:1,RejectFg:1,Remark:1,SalesVatTypes:1,SendForAppfg:1,ShipDate:1,ShipId:1,ShopId:1,SupplName:1,SupplierId:1,SysDocNo:1,TaxInvoiceDate:1,TaxInvoiceNo:1,TaxInvoiceRef:1,TotalAmt:1,UpdateBy:1,UseFg:1,VatAmt:1,VatCode:1,VatFg:1,VatRate:1,WhsId:1,WhtAmt:1},PoCNRTVApp:{AppList:1,ApproveBy:1,ApproveDate:1,ApproveFg:1,ApproveLv:1,BalanceAmt:1,BankId:1,CancelFg:1,CashOrTermfg:1,CheckQty:1,ChequeDate:1,ChequeNo:1,CreateBy:1,CreateDate:1,CreditNotetype:1,CurrencyAmt:1,CurrencyCode:1,CusCurrencyAmt:1,CusCurrencyCode:1,CusExchangeRate:1,CusNetAmt:1,CusNetAmtDiff:1,CusPurInvoiceAmt:1,CusVatAmt:1,CusVatDiff:1,DepositAmt:1,DiscAmt:1,DiscText:1,DocDate:1,DtList:1,DueDate:1,ErPfg:1,ExchangeRate:1,ExciseTaxAmt:1,Id:1,LastDateStatusChange:1,LastUpdate:1,NetAmt:1,NetExVat:1,NetTotalInVat:1,POTypeFg:1,PayTermCode:1,PaymentAmt:1,PaymentBeforeDisc:1,PaymentDicsAmt:1,PaymentDicsRemark:1,PaymentNetAmt:1,PaymentRefNo:1,PaymentType:1,PostDate:1,PostFg:1,Postby:1,PurInvoiceAmt:1,PurIvNo:1,ReceiptAmt:1,RefDocNo1:1,RefDocNo2:1,RefType:1,Refuse:1,RejectFg:1,Remark:1,SalesVatTypes:1,SendForAppfg:1,ShipDate:1,ShipId:1,ShopId:1,SupplierId:1,SysDocNo:1,TaxInvoiceDate:1,TaxInvoiceNo:1,TaxInvoiceRef:1,TotalAmt:1,UpdateBy:1,UseFg:1,VatAmt:1,VatCode:1,VatFg:1,VatRate:1,WhsId:1,WhtAmt:1},PoCNRTVDt:{AlocalteDiscAmt:1,BeforeDiscAmt:1,DiscAmt:1,DiscText:1,ExpDate:1,Id:1,ItemAmt:1,ItemExVatAmt:1,ItemExciseTaxAmt:1,ItemNetAmt:1,ItemNetCostValue:1,ItemVatAmt:1,LastPurUnitPrice:1,LineItemNo:1,PiLineId:1,PiRefDocNo:1,PurUnit:1,PurUnitPrice:1,PurUnitRatio:1,Qty:1,QtyUse:1,Remark:1,SalesVatTypes:1,ShopId:1,SkuCode:1,SkuDesc:1,StkQty:1,SupplierId:1,SysDocNo:1,UnitChange:1,UnitCost:1,UseFg:1,VatCode:1,VatRate:1,VatType:1,WhsId:1},PoCreditNote:{ApproveBy:1,ApproveDate:1,ApproveFg:1,ApproveLv:1,BalanceAmt:1,BankId:1,BranchCode:1,CancelFg:1,CashOrTermfg:1,CheckQty:1,ChequeDate:1,ChequeNo:1,ConcatRefDocNo1:1,CreateBy:1,CreateDate:1,CreditNotetype:1,CreditTerm:1,CurrencyAmt:1,CurrencyCode:1,CusCurrencyAmt:1,CusCurrencyCode:1,CusExchangeRate:1,CusNetAmt:1,CusNetAmtDiff:1,CusPurInvoiceAmt:1,CusVatAmt:1,CusVatDiff:1,DepositAmt:1,DiscAmt:1,DiscText:1,DocDate:1,DtList:1,DueDate:1,ErPfg:1,ExchangeRate:1,ExciseTaxAmt:1,Id:1,LastDateStatusChange:1,LastUpdate:1,NetAmt:1,NetExVat:1,NetTotalInVat:1,POTypeFg:1,PayTermCode:1,PaymentAmt:1,PaymentBeforeDisc:1,PaymentDicsAmt:1,PaymentDicsRemark:1,PaymentNetAmt:1,PaymentRefNo:1,PaymentType:1,PostDate:1,PostFg:1,Postby:1,PurInvoiceAmt:1,PurIvNo:1,ReceiptAmt:1,RefDocNo1:1,RefDocNo2:1,RefInvoiceAmt:1,RefType:1,Refuse:1,RejectFg:1,Remark:1,SalesVatTypes:1,SendForAppfg:1,ShipDate:1,ShipId:1,ShopId:1,SupplName:1,SupplierId:1,SysDocNo:1,TaxInvoiceDate:1,TaxInvoiceNo:1,TaxInvoiceRef:1,TotalAmt:1,UpdateBy:1,UseFg:1,VatAmt:1,VatCode:1,VatFg:1,VatRate:1,WhsId:1,WhtAmt:1},PoCreditNoteApp:{AppList:1,ApproveBy:1,ApproveDate:1,ApproveFg:1,ApproveLv:1,BalanceAmt:1,BankId:1,CancelFg:1,CashOrTermfg:1,CheckQty:1,ChequeDate:1,ChequeNo:1,CreateBy:1,CreateDate:1,CreditNotetype:1,CurrencyAmt:1,CurrencyCode:1,CusCurrencyAmt:1,CusCurrencyCode:1,CusExchangeRate:1,CusNetAmt:1,CusNetAmtDiff:1,CusPurInvoiceAmt:1,CusVatAmt:1,CusVatDiff:1,DepositAmt:1,DiscAmt:1,DiscText:1,DocDate:1,DtList:1,DueDate:1,ErPfg:1,ExchangeRate:1,ExciseTaxAmt:1,Id:1,LastDateStatusChange:1,LastUpdate:1,NetAmt:1,NetExVat:1,NetTotalInVat:1,POTypeFg:1,PayTermCode:1,PaymentAmt:1,PaymentBeforeDisc:1,PaymentDicsAmt:1,PaymentDicsRemark:1,PaymentNetAmt:1,PaymentRefNo:1,PaymentType:1,PostDate:1,PostFg:1,Postby:1,PurInvoiceAmt:1,PurIvNo:1,ReceiptAmt:1,RefDocNo1:1,RefDocNo2:1,RefType:1,Refuse:1,RejectFg:1,Remark:1,SalesVatTypes:1,SendForAppfg:1,ShipDate:1,ShipId:1,ShopId:1,SupplierId:1,SysDocNo:1,TaxInvoiceDate:1,TaxInvoiceNo:1,TaxInvoiceRef:1,TotalAmt:1,UpdateBy:1,UseFg:1,VatAmt:1,VatCode:1,VatFg:1,VatRate:1,WhsId:1,WhtAmt:1},PoCreditNoteDt:{AlocalteDiscAmt:1,BeforeDiscAmt:1,DiscAmt:1,DiscText:1,ExpDate:1,Id:1,ItemAmt:1,ItemExVatAmt:1,ItemExciseTaxAmt:1,ItemNetAmt:1,ItemNetCostValue:1,ItemVatAmt:1,LastPurUnitPrice:1,LineItemNo:1,PiLineId:1,PiRefDocNo:1,PurUnit:1,PurUnitPrice:1,PurUnitRatio:1,Qty:1,QtyUse:1,Remark:1,SalesVatTypes:1,ShopId:1,SkuCode:1,SkuDesc:1,StkQty:1,SupplierId:1,SysDocNo:1,UnitChange:1,UnitCost:1,UseFg:1,VatCode:1,VatRate:1,VatType:1,WhsId:1},PoInvoiceReceive:{ApproveBy:1,ApproveDate:1,ApproveFg:1,ApproveLv:1,BalanceAmt:1,BankId:1,BranchCode:1,CancelFg:1,CashOrTermfg:1,CheckQty:1,ChequeDate:1,ChequeNo:1,ConcatRefDocNo1:1,CreateBy:1,CreateDate:1,CurrencyAmt:1,CurrencyCode:1,CusCurrencyAmt:1,CusCurrencyCode:1,CusExchangeRate:1,CusNetAmt:1,CusNetAmtDiff:1,CusPurInvoiceAmt:1,CusVatAmt:1,CusVatDiff:1,DepositAmt:1,DiscAmt:1,DiscText:1,DocDate:1,DtList:1,DueDate:1,ErPfg:1,ExchangeRate:1,ExciseTaxAmt:1,Id:1,LastDateStatusChange:1,LastUpdate:1,NetAmt:1,NetExVat:1,NetTotalInVat:1,POTypeFg:1,PayTermCode:1,PaymentAmt:1,PaymentBeforeDisc:1,PaymentDicsAmt:1,PaymentDicsRemark:1,PaymentNetAmt:1,PaymentRefNo:1,PaymentType:1,PostDate:1,PostFg:1,PurInvoiceAmt:1,PurIvNo:1,ReceiptAmt:1,RefDocNo1:1,RefDocNo2:1,RefType:1,Refuse:1,RejectFg:1,Remark:1,SalesVatTypes:1,SendForAppfg:1,ShipDate:1,ShipId:1,ShopId:1,SupplName:1,SupplierId:1,SysDocNo:1,TaxInvoiceDate:1,TaxInvoiceNo:1,TotalAmt:1,UpdateBy:1,UseFg:1,VatAmt:1,VatCode:1,VatFg:1,VatRate:1,WhsId:1,WhtAmt:1},PoInvoiceReceiveApp:{AppList:1,ApproveBy:1,ApproveDate:1,ApproveFg:1,ApproveLv:1,BalanceAmt:1,BankId:1,CancelFg:1,CashOrTermfg:1,CheckQty:1,ChequeDate:1,ChequeNo:1,CreateBy:1,CreateDate:1,CurrencyAmt:1,CurrencyCode:1,CusCurrencyAmt:1,CusCurrencyCode:1,CusExchangeRate:1,CusNetAmt:1,CusNetAmtDiff:1,CusPurInvoiceAmt:1,CusVatAmt:1,CusVatDiff:1,DepositAmt:1,DiscAmt:1,DiscText:1,DocDate:1,DtList:1,DueDate:1,ErPfg:1,ExchangeRate:1,ExciseTaxAmt:1,Id:1,LastDateStatusChange:1,LastUpdate:1,NetAmt:1,NetExVat:1,NetTotalInVat:1,POTypeFg:1,PayTermCode:1,PaymentAmt:1,PaymentBeforeDisc:1,PaymentDicsAmt:1,PaymentDicsRemark:1,PaymentNetAmt:1,PaymentRefNo:1,PaymentType:1,PostDate:1,PostFg:1,PurInvoiceAmt:1,PurIvNo:1,ReceiptAmt:1,RefDocNo1:1,RefDocNo2:1,RefType:1,Refuse:1,RejectFg:1,Remark:1,SalesVatTypes:1,SendForAppfg:1,ShipDate:1,ShipId:1,ShopId:1,SupplierId:1,SysDocNo:1,TaxInvoiceDate:1,TaxInvoiceNo:1,TotalAmt:1,UpdateBy:1,UseFg:1,VatAmt:1,VatCode:1,VatFg:1,VatRate:1,WhsId:1,WhtAmt:1},PoInvoiceReceiveDt:{AlocalteDiscAmt:1,BeforeDiscAmt:1,DiscAmt:1,DiscText:1,ExpDate:1,Id:1,ItemAmt:1,ItemExVatAmt:1,ItemExciseTaxAmt:1,ItemNetAmt:1,ItemNetCostValue:1,ItemVatAmt:1,LastPurUnitPrice:1,LineItemNo:1,PiLineId:1,PiRefDocNo:1,PurUnit:1,PurUnitPrice:1,PurUnitRatio:1,Qty:1,QtyUse:1,Remark:1,SalesVatTypes:1,ShopId:1,SkuCode:1,SkuDesc:1,StkQty:1,SupplierId:1,SysDocNo:1,UnitChange:1,UnitCost:1,UseFg:1,VatCode:1,VatRate:1,VatType:1,WhsId:1},PoPara:{CreateBy:1,CreateDate:1,Id:1,LastUpdate:1,ToleranceTotal:1,ToleranceVat:1,UpdateBy:1},PoPayTermCode:{CreateBy:1,CreateDate:1,CreditTerm:1,Id:1,LastUpdate:1,LookupName:1,PayTermCode:1,PayTermDesc:1,UpdateBy:1},PoPo05DtPendingPIforIr:{DiscAmt:1,Id:1,ItemAmt:1,LineItemNo:1,PurUnit:1,PurUnitPrice:1,Qty:1,Remark:1,SkuCode:1,SkuDesc:1,SysDocNo:1,UseFg:1,WhsId:1},PoPo05PendingPIforIr:{DocDate:1,DtList:1,PayTermCode:1,PurIvNo:1,ReceiptAmt:1,RefDocNo1:1,RefDocNo2:1,Remark:1,ShipDate:1,ShipId:1,SupplName:1,SupplierId:1,SysDocNo:1,UseFg:1,WhsId:1},PoPo06DtPendingCNforCnrtv:{DiscAmt:1,Id:1,ItemAmt:1,LineItemNo:1,PurUnit:1,PurUnitPrice:1,Qty:1,Remark:1,SkuCode:1,SkuDesc:1,SysDocNo:1,UseFg:1,WhsId:1},PoPo06PendingCNforCnrtv:{CreditNoteNo:1,DocDate:1,DtList:1,PayTermCode:1,ReceiptAmt:1,RefDocNo1:1,RefDocNo2:1,Remark:1,ShipDate:1,ShipId:1,SupplName:1,SupplierId:1,SysDocNo:1,TaxInvoiceRef:1,UseFg:1,WhsId:1},PoPurInvoice:{ApproveBy:1,ApproveDate:1,ApproveFg:1,ApproveLv:1,BalanceAmt:1,BankId:1,BranchCode:1,CancelFg:1,CashOrTermfg:1,CheckQty:1,ChequeDate:1,ChequeNo:1,ConcatRefDocNo1:1,CreateBy:1,CreateDate:1,CurrencyAmt:1,CurrencyCode:1,CusCurrencyAmt:1,CusCurrencyCode:1,CusExchangeRate:1,CusNetAmt:1,CusNetAmtDiff:1,CusPurInvoiceAmt:1,CusVatAmt:1,CusVatDiff:1,DepositAmt:1,DiscAmt:1,DiscText:1,DocDate:1,DtList:1,DueDate:1,ErPfg:1,ExchangeRate:1,ExciseTaxAmt:1,Id:1,LastDateStatusChange:1,LastUpdate:1,NetAmt:1,NetExVat:1,NetTotalInVat:1,POTypeFg:1,PayTermCode:1,PaymentAmt:1,PaymentBeforeDisc:1,PaymentDicsAmt:1,PaymentDicsRemark:1,PaymentNetAmt:1,PaymentRefNo:1,PaymentType:1,PostDate:1,PostFg:1,PurInvoiceAmt:1,PurIvNo:1,ReceiptAmt:1,RefDocNo1:1,RefDocNo2:1,RefType:1,Refuse:1,RejectFg:1,Remark:1,SalesVatTypes:1,SendForAppfg:1,ShipDate:1,ShipId:1,ShopId:1,SupplName:1,SupplierId:1,SysDocNo:1,TaxInvoiceDate:1,TaxInvoiceNo:1,TotalAmt:1,UpdateBy:1,UseFg:1,VatAmt:1,VatCode:1,VatFg:1,VatRate:1,WhsId:1,WhtAmt:1},PoPurInvoiceApp:{AppList:1,ApproveBy:1,ApproveDate:1,ApproveFg:1,ApproveLv:1,BalanceAmt:1,BankId:1,CancelFg:1,CashOrTermfg:1,CheckQty:1,ChequeDate:1,ChequeNo:1,CreateBy:1,CreateDate:1,CurrencyAmt:1,CurrencyCode:1,CusCurrencyAmt:1,CusCurrencyCode:1,CusExchangeRate:1,CusNetAmt:1,CusNetAmtDiff:1,CusPurInvoiceAmt:1,CusVatAmt:1,CusVatDiff:1,DepositAmt:1,DiscAmt:1,DiscText:1,DocDate:1,DtList:1,DueDate:1,ErPfg:1,ExchangeRate:1,ExciseTaxAmt:1,Id:1,LastDateStatusChange:1,LastUpdate:1,NetAmt:1,NetExVat:1,NetTotalInVat:1,POTypeFg:1,PayTermCode:1,PaymentAmt:1,PaymentBeforeDisc:1,PaymentDicsAmt:1,PaymentDicsRemark:1,PaymentNetAmt:1,PaymentRefNo:1,PaymentType:1,PostDate:1,PostFg:1,PurInvoiceAmt:1,PurIvNo:1,ReceiptAmt:1,RefDocNo1:1,RefDocNo2:1,RefType:1,Refuse:1,RejectFg:1,Remark:1,SalesVatTypes:1,SendForAppfg:1,ShipDate:1,ShipId:1,ShopId:1,SupplierId:1,SysDocNo:1,TaxInvoiceDate:1,TaxInvoiceNo:1,TotalAmt:1,UpdateBy:1,UseFg:1,VatAmt:1,VatCode:1,VatFg:1,VatRate:1,WhsId:1,WhtAmt:1},PoPurInvoiceDt:{AlocalteDiscAmt:1,BeforeDiscAmt:1,DiscAmt:1,DiscText:1,ExpDate:1,Id:1,ItemAmt:1,ItemExVatAmt:1,ItemExciseTaxAmt:1,ItemNetAmt:1,ItemNetCostValue:1,ItemVatAmt:1,LastPurUnitPrice:1,LineItemNo:1,PrLineId:1,PrRefDocNo:1,PurUnit:1,PurUnitPrice:1,PurUnitRatio:1,Qty:1,QtyUse:1,Remark:1,SalesVatTypes:1,ShopId:1,SkuCode:1,SkuDesc:1,StkQty:1,SupplierId:1,SysDocNo:1,UnitChange:1,UnitCost:1,UseFg:1,VatCode:1,VatRate:1,VatType:1,WhsId:1},PoPurOrder:{ApproveBy:1,ApproveDate:1,ApproveFg:1,ApproveLv:1,BranchCode:1,CancelFg:1,CashOrTermfg:1,CheckQty:1,ConcatRefDocNo1:1,CreateBy:1,CreateDate:1,DepositAmt:1,DiscAmt:1,DiscText:1,DocDate:1,DocNo:1,DtList:1,Id:1,LastDateStatusChange:1,LastUpdate:1,NetAmt:1,NetExVat:1,NetTotalInVat:1,POTypeFg:1,PayTermCode:1,PurDocNo:1,PurOrderAmt:1,RefDocNo1:1,RefDocNo2:1,Refuse:1,RejectFg:1,Remark:1,SalesVatTypes:1,SendForAppfg:1,ShipDate:1,ShipId:1,ShipLineAddress1:1,ShipLineAddress2:1,ShipLineAddress3:1,ShipName:1,ShopId:1,SupplName:1,SupplierId:1,SysDocNo:1,TotalAmt:1,UpdateBy:1,UseFg:1,VatAmt:1,VatCode:1,VatFg:1,VatRate:1,WhsId:1},PoPurOrderApp:{AppList:1,ApproveBy:1,ApproveDate:1,ApproveFg:1,ApproveLv:1,CancelFg:1,CreateBy:1,CreateDate:1,DiscAmt:1,DiscText:1,DocDate:1,DocNo:1,DtList:1,Id:1,LastDateStatusChange:1,LastUpdate:1,NetAmt:1,NetExVat:1,NetTotalInVat:1,POTypeFg:1,PayTermCode:1,PurDocNo:1,PurOrderAmt:1,RefDocNo1:1,RefDocNo2:1,Refuse:1,RejectFg:1,Remark:1,SalesVatTypes:1,SendForAppfg:1,ShipDate:1,ShipId:1,ShipLineAddress1:1,ShipLineAddress2:1,ShipLineAddress3:1,ShipName:1,ShopId:1,SupplierId:1,SysDocNo:1,TotalAmt:1,UpdateBy:1,UseFg:1,VatAmt:1,VatCode:1,VatFg:1,VatRate:1,WhsId:1},PoPurOrderDt:{AlocalteDiscAmt:1,BeforeDiscAmt:1,DiscAmt:1,DiscText:1,ExpDate:1,Id:1,ItemAmt:1,ItemExVatAmt:1,ItemNetAmt:1,ItemNetCostValue:1,ItemVatAmt:1,LastPurUnitPrice:1,LineItemNo:1,PrLineId:1,PrRefDocNo:1,PurUnit:1,PurUnitPrice:1,PurUnitRatio:1,Qty:1,QtyUse:1,Remark:1,SalesVatTypes:1,ShopId:1,SkuCode:1,SkuDesc:1,StkQty:1,SupplItemCode:1,SupplierId:1,SysDocNo:1,UnitChange:1,UnitCost:1,UseFg:1,VatCode:1,VatRate:1,VatType:1,WhsId:1},PoPurRequest:{ApproveBy:1,ApproveDate:1,ApproveFg:1,ApproveLv:1,BranchCode:1,CancelFg:1,CreateBy:1,CreateDate:1,DiscAmt:1,DiscText:1,DocDate:1,DocNo:1,DtList:1,Id:1,LastDateStatusChange:1,LastUpdate:1,NetAmt:1,NetExVat:1,NetTotalInVat:1,POTypeFg:1,PayTermCode:1,PurDocNo:1,PurOrderAmt:1,RefDocNo1:1,RefDocNo2:1,Refuse:1,RejectFg:1,Remark:1,SalesVatTypes:1,SendForAppfg:1,ShipDate:1,ShipId:1,ShipLineAddress1:1,ShipLineAddress2:1,ShipLineAddress3:1,ShipName:1,ShopId:1,SupplName:1,SupplierId:1,SysDocNo:1,TotalAmt:1,UpdateBy:1,UseFg:1,VatAmt:1,VatCode:1,VatFg:1,VatRate:1,WhsId:1},PoPurRequestApp:{AppList:1,ApproveBy:1,ApproveDate:1,ApproveFg:1,ApproveLv:1,CancelFg:1,CreateBy:1,CreateDate:1,DiscAmt:1,DiscText:1,DocDate:1,DocNo:1,DtList:1,Id:1,LastDateStatusChange:1,LastUpdate:1,NetAmt:1,NetExVat:1,NetTotalInVat:1,POTypeFg:1,PayTermCode:1,PurDocNo:1,PurOrderAmt:1,RefDocNo1:1,RefDocNo2:1,Refuse:1,RejectFg:1,Remark:1,SalesVatTypes:1,SendForAppfg:1,ShipDate:1,ShipId:1,ShipLineAddress1:1,ShipLineAddress2:1,ShipLineAddress3:1,ShipName:1,SupplierId:1,SysDocNo:1,TotalAmt:1,UpdateBy:1,UseFg:1,VatAmt:1,VatCode:1,VatFg:1,VatRate:1,WhsId:1},PoPurRequestDt:{AlocalteDiscAmt:1,BeforeDiscAmt:1,DiscAmt:1,DiscText:1,ExpDate:1,Id:1,ItemAmt:1,ItemExVatAmt:1,ItemNetAmt:1,ItemNetCostValue:1,ItemVatAmt:1,LastPurUnitPrice:1,LineItemNo:1,PoRefDocNo:1,PurUnit:1,PurUnitPrice:1,PurUnitRatio:1,Qty:1,QtyUse:1,Remark:1,SalesVatTypes:1,ShopId:1,SkuCode:1,SkuDesc:1,StkQty:1,SupplierId:1,SysDocNo:1,UnitChange:1,UnitCost:1,UseFg:1,VatCode:1,VatRate:1,VatType:1,WhsId:1},PoShipAddress:{CreateBy:1,CreateDate:1,Id:1,LastUpdate:1,LookupName:1,ShipId:1,ShipLineAddress1:1,ShipLineAddress2:1,ShipLineAddress3:1,ShipName:1,ShopId:1,UpdateBy:1,WhsId:1},PoSupplier:{AuthEmail:1,AuthMobile:1,AuthPerson:1,AuthTel:1,AuthTelExt:1,BranchCode:1,BranchName:1,CompanyCode:1,ConsignFg:1,ConsignGp:1,ContactName:1,CreateBy:1,CreateDate:1,CreditTerm:1,Ctaxtype:1,CustBranch:1,ErpSreachName:1,ErpVenderCode:1,ErpVendorBlock:1,ErpVendorType:1,FaxExt:1,FaxNo:1,Id:1,LastUpdate:1,PayMethod:1,PurVatCode:1,PurVatRate:1,PurVatType:1,Remark:1,ReturnOutRemark:1,SaleEmail:1,SaleMobile:1,SalePerson:1,SaleTel:1,SaleTelExt:1,Status:1,SupEmail:1,SupTelNo:1,SupplAddress:1,SupplId:1,SupplName:1,SupplRegAddress:1,SupplRegName:1,SupplTaxId:1,SupplType:1,SupplierShortName:1,TelMobile:1,TelNoExt:1,TradeTerm:1,UpdateBy:1},ReportDailyCN:{CreditNoteAmt:1,CreditNoteNo:1,DepositAmt:1,DiscAmt:1,DocDate:1,DueDate:1,ExciseTaxAmt:1,Id:1,NetAmt:1,PayTermCode:1,RefDocNo1:1,SupplName:1,SupplierId:1,SysDocNo:1,TotalAmt:1,VatAmt:1,WhsId:1},ReportDailyPI:{DepositAmt:1,DiscAmt:1,DocDate:1,DtList:1,DueDate:1,ExciseTaxAmt:1,Id:1,NetAmt:1,PayTermCode:1,PurInvoiceAmt:1,PurIvNo:1,RefDocNo1:1,SupplName:1,SupplierId:1,SysDocNo:1,TotalAmt:1,VatAmt:1,WhsId:1},ReportPendingPO:{DocDate:1,DocNo:1,DtList:1,PayTermCode:1,PurOrderAmt:1,RefDocNo1:1,RefDocNo2:1,Remark:1,ShipDate:1,ShipId:1,ShipName:1,SupplName:1,SupplierId:1,SysDocNo:1,UseFg:1,WhsId:1},ReportPendingPODt:{Id:1,LessCost:1,LessQty:1,LineItemNo:1,PrRefDocNo:1,PurUnit:1,Qty:1,QtyUse:1,Remark:1,SkuCode:1,SkuDesc:1,StkQty:1,StkUnit:1,SysDocNo:1,UnitCost:1,UnitQty:1,UseFg:1},ReportPendingPR:{DocDate:1,DocNo:1,DtList:1,PayTermCode:1,PurOrderAmt:1,RefDocNo1:1,RefDocNo2:1,Remark:1,ShipDate:1,ShipId:1,ShipName:1,SupplName:1,SupplierId:1,SysDocNo:1,UseFg:1,WhsId:1},ReportPendingPRDt:{Id:1,LessCost:1,LessQty:1,LineItemNo:1,PoRefDocNo:1,PurUnit:1,Qty:1,QtyUse:1,Remark:1,SkuCode:1,SkuDesc:1,StkQty:1,StkUnit:1,SysDocNo:1,UnitCost:1,UnitQty:1,UseFg:1},ReportPurTax:{Id:1,Lineitemno:1,NetAmt:1,SupplName:1,SupplTaxId:1,TaxInvoiceDate:1,TaxInvoiceNo:1,TotalAmt:1,VatAmt:1},ReportPurTaxLong:{DocDate:1,Id:1,Lineitemno:1,NetAmt:1,RefDocNo1:1,SupplName:1,SupplTaxId:1,TaxInvoiceDate:1,TaxInvoiceNo:1,TotalAmt:1,VatAmt:1},SysTender:{TenderCode:1,TenderName:1,TenderType:1},VwPaytermCodeLookup:{CreateBy:1,CreateDate:1,CreditTerm:1,Id:1,LastUpdate:1,LookupName:1,PayTermCode:1,PayTermDesc:1,UpdateBy:1}},QRreport:{QDayData:{Day:1,DayName:1,DayNameEn:1,Id:1},QHourTime:{HourTime:1,HourTimeName:1,HourTimeNameEn:1,Id:1},QMonth:{FullName:1,Id:1,Month:1,MonthName:1,MonthNameEn:1,Months:1},QRyStockcard:{CreateBy:1,DateEnd:1,Id:1,ListFg:1,PluCode:1,PostSequenceFg:1,ShopId:1,SkuCode:1,SumWhsFg:1,WhsFg:1,WhsId:1},QRyreport:{CreateBy:1,CreateDate:1,DataStructureName:1,FullName:1,Id:1,QRFunctionsGroupby_A:1,QRFunctionsLength_B:1,QRSubViewName:1,QrViewName:1,RemarkNote:1,ReportId:1,ReportName:1,UrlReport:1},QRywcSpec:{BrandCode:1,CashierId:1,CatCode:1,ColorId:1,ConsignFg:1,CreateBy:1,CreateDate:1,DataStructureName:1,DateBegin:1,DateEnd:1,DayOfWeek:1,DiscCouponType:1,DocMonth:1,DocMonthEnd:1,DocTime:1,DocTimeEnd:1,DocTimeStart:1,DocYear:1,DocYearEnd:1,GruopType:1,Id:1,LineItemType:1,LineNo:1,MatTypeId:1,MbId:1,MbType:1,PaymentType:1,PluCode:1,PmGroupFg:1,PmGroupId:1,PmType:1,PmTypeFg:1,PosId:1,PromoCampaign:1,PromoId:1,Qty_AmtFg:1,ReportId:1,ReportName:1,SalemanId:1,ShopFg:1,ShopGroupId:1,ShopId:1,ShopTypeId:1,SizeId:1,SkuCode:1,StyleId:1,SubCat1Code:1,SubCat2Code:1,SupplId:1,TasteId:1,UrlReport:1,WcNumberic:1,WcText:1,WhsId:1,pSequenFg:1}},RefundReasonReport:{ReportRefundReasonByBill:{AllItemDiscount:1,AppRefund:1,BillCharge:1,CashierId:1,CashierName:1,DocDate:1,DocNo:1,DocTime:1,GrossSales:1,Id:1,MbId:1,MbNameT:1,NetSales:1,NetSalesExVat:1,PosId:1,RefundId:1,RefundReason:1,SalesmanId:1,SalesmanName:1,ShopId:1,ShopName:1,VatOfCharge:1,VatOfNetSales:1},ReportRefundReasonByItem:{AppRefund:1,CashierId:1,DocDate:1,DocNo:1,Id:1,ItemDesc:1,PluCode:1,PosId:1,Price:1,Qty:1,RefDate:1,RefDoc:1,RefundId:1,RefundReason:1},ReportRefundReasonSumBill:{AllItemCharge:1,AllItemDiscount:1,BillQty:1,DtList:1,GrossSales:1,Id:1,NetSales:1,NetSalesExVat:1,RefundId:1,RefundReason:1,VatOfCharge:1,VatOfNetSales:1},ReportRefundReasonSumBillDt:{AllItemDiscount:1,BillCharge:1,CashierId:1,CashierName:1,DocDate:1,DocNo:1,DocTime:1,GrossSales:1,Id:1,MbId:1,MbNameT:1,NetSales:1,NetSalesExVat:1,NetSalesNonVat:1,PosId:1,RefundId:1,RefundReason:1,SalesmanId:1,SalesmanName:1,ShopId:1,ShopName:1,VatOfCharge:1,VatOfNetSales:1}},ReportMasterData:{Report1332ShopPaymentTypeRefType:{CurrencyAmt:1,DocDate:1,ExchangeRate:1,Id:1,PaymentName:1,PaymentType:1,ReceiptAmt:1,ReceiptInAmt:1,ReceiptOutAmt:1,RefName:1,RefType:1,ShopId:1,ShopName:1},Report_1101:{ActiveFg:1,BrandCode:1,BrandName:1,CatCode:1,CatName:1,ColorId:1,ColorName:1,CreateBy:1,CreateDate:1,MatTypeId:1,MatTypeName:1,MaxStockQty:1,MinStockQty:1,PluCode:1,PluDesc:1,ProductType:1,PurLeadTime:1,PurUnit:1,PurUnitPrice:1,PurUnitRatio:1,SellUnit:1,SellUnitPrice1:1,SellUnitPrice2:1,SellUnitPrice3:1,SellUnitPrice4:1,SellUnitPrice5:1,SellUnitPrice6:1,SellUnitRatio:1,SizeId:1,SizeName:1,SkuCode:1,StkUnit:1,StyleId:1,StyleName:1,SubCat1Code:1,SubCat1Name:1,SubCat2Code:1,SubCat2Name:1,SupplItemCode:1,SupplName:1,SupplierId:1,TasteId:1,TasteName:1,VatCode:1,VatType:1},Report_1102:{BrandCode:1,BrandName:1,CatCode:1,CatName:1,ColorId:1,ColorName:1,PluCode:1,PluDesc:1,SellUnit:1,SellUnitPrice1:1,SellUnitPrice2:1,SellUnitPrice3:1,SellUnitPrice4:1,SellUnitPrice5:1,SellUnitPrice6:1,SizeId:1,SizeName:1,SkuCode:1,StyleId:1,StyleName:1,SubCat1Code:1,SubCat1Name:1,SubCat2Code:1,SubCat2Name:1,SupplName:1,SupplierId:1,VatCode:1,VatType:1},Report_1103:{BrandCode:1,BrandName:1,CatCode:1,CatName:1,CostPrice:1,PluCode:1,PluDesc:1,SellUnit:1,SellUnitPrice1:1,SellUnitPrice2:1,SellUnitPrice3:1,SellUnitPrice4:1,SellUnitPrice5:1,SellUnitPrice6:1,SkuCode:1,SubCat1Code:1,SubCat1Name:1,SubCat2Code:1,SubCat2Name:1,SupplName:1,SupplierId:1,VatCode:1,VatType:1},Report_1104:{ConsignFg:1,ContactName:1,ShortName:1,SupTelNo:1,SupplAddress:1,SupplId:1,SupplName:1,SupplRegName:1,SupplTaxId:1,SupplType:1},Report_1105:{MbAccumPoint:1,MbAmphur:1,MbCardStatus:1,MbExpireDate:1,MbExpirePointDate:1,MbId:1,MbNameT:1,MbNearlyExpirePoint:1,MbProvince:1,MbTumbol:1,MbType:1},Report_1201:{AdvDiscount:1,AllItemCharge:1,AllItemDiscount:1,BillCharge:1,BillDiscount:1,CashierId:1,CashierName:1,CreateBy:1,CreateDate:1,DiscList:1,DocAmt:1,DocDate:1,DocNo:1,DocTime:1,DtList:1,Factor:1,GrossSales:1,Id:1,LastUpdate:1,MbId:1,MbNameT:1,NetSales:1,NetSalesExVat:1,NetSalesNonVat:1,NetSalesNormal:1,NetSalesPromo:1,PosId:1,ReceiveCash:1,ReceiveCashCd:1,ReceiveCoupon:1,ReceiveCreditCd:1,ReceiveDebitCd:1,ReceiveNet:1,ReceiveOthers:1,ReceivePoint:1,RecvList:1,RefDocNo:1,RoundAdjust:1,SalesVatType:1,SalesmanId:1,SalesmanName:1,ShopGroupId:1,ShopGroupName:1,ShopId:1,ShopName:1,ShopTypeId:1,ShopTypeName:1,TotalItem:1,TotalQty:1,UpdateBy:1,Vat:1,VatOfCharge:1,VatOfNetSales:1},Report_1201_Disc:{ChargeAmt:1,ChargePc:1,CreateBy:1,CreateDate:1,DiscCouponNo:1,DiscCouponType:1,DiscPc:1,Discamt:1,DocNo:1,Id:1,ItemDesc:1,LastUpdate:1,LineItemNo:1,LineItemType:1,PromoId:1,UpdateBy:1},Report_1201_Dt:{AllocatedBillDiscount:1,ChargeAmt:1,ChargePc:1,CreateBy:1,CreateDate:1,DiscCouponNo:1,DiscCouponType:1,DiscPc:1,Discamt:1,DocNo:1,ExPrice:1,Id:1,ItemCharge:1,ItemDesc:1,ItemDiscount:1,ItemNetExprice:1,ItemNetSales:1,ItemPromoFg:1,ItemPromoId:1,ItemVat:1,ItemVatRate:1,ItemVatType:1,LastUpdate:1,LineItemNo:1,LineItemType:1,PluCode:1,PosFg:1,PromoId:1,Qty:1,QtyRefund:1,RefLineItemNo:1,SellUnit:1,SerialNo:1,UnitPrice:1,UpdateBy:1},Report_1201_Recv:{ApprovalCode:1,CreateBy:1,CreateDate:1,Currency:1,CurrencyAmt:1,CurrencyCode:1,DocNo:1,ExchangeRate:1,Id:1,InvoiceNo:1,LastUpdate:1,LineItemNo:1,LineItemType:1,PaymentName:1,PaymentType:1,PointBurn:1,ReceiptAmt:1,RefNo:1,RefType:1,UpdateBy:1},Report_1301:{AllItemCharge:1,AllItemDiscount:1,DocDate:1,FullName:1,GrossSales:1,Id:1,NetSales:1,NetSalesExVat:1,ShopId:1,ShopName:1,VatOfCharge:1,VatOfNetSales:1},Report_1302:{AllItemCharge:1,AllItemDiscount:1,DocDate:1,FullName:1,GrossSales:1,Id:1,NetSales:1,NetSalesExVat:1,PosId:1,ShopId:1,ShopName:1,VatOfCharge:1,VatOfNetSales:1},Report_1303:{AllItemCharge:1,AllItemDiscount:1,CashierId:1,CashierName:1,DocDate:1,FullName:1,FullName2:1,GrossSales:1,Id:1,NetSales:1,NetSalesExVat:1,ShopId:1,ShopName:1,VatOfCharge:1,VatOfNetSales:1},Report_1308:{AllItemCharge:1,AllItemDiscount:1,DocDate:1,DocDates:1,FullName:1,GrossSales:1,Id:1,NetSales:1,NetSalesExVat:1,ShopId:1,ShopName:1,VatOfCharge:1,VatOfNetSales:1},Report_1309:{AllItemCharge:1,AllItemDiscount:1,DayOfWeek:1,DocDate:1,FullName:1,GrossSales:1,ID:1,NetSales:1,NetSalesExVat:1,ShopId:1,ShopName:1,VatOfCharge:1,VatOfNetSales:1},Report_1310:{AllItemCharge:1,AllItemDiscount:1,DocDate:1,DocTime:1,FullName:1,GrossSales:1,Id:1,NetSales:1,NetSalesExVat:1,ShopId:1,ShopName:1,VatOfCharge:1,VatOfNetSales:1},Report_1311:{AllItemDiscount:1,CatCode:1,CatName:1,DocDate:1,FullName:1,FullName1:1,GrossSales:1,Id:1,NetSales:1,NetSalesExVat:1,Qty:1,ShopId:1,ShopName:1,VatOfNetSales:1},Report_1312:{AllItemDiscount:1,DocDate:1,FullName:1,FullName2:1,GrossSales:1,Id:1,NetSales:1,NetSalesExVat:1,Qty:1,ShopId:1,ShopName:1,SubCat1Code:1,SubCat1Name:1,VatOfNetSales:1},Report_1313:{AllItemDiscount:1,DocDate:1,FullName:1,FullName3:1,GrossSales:1,Id:1,NetSales:1,NetSalesExVat:1,Qty:1,ShopId:1,ShopName:1,SubCat2Code:1,SubCat2Name:1,VatOfNetSales:1},Report_1314:{AllItemDiscount:1,BrandCode:1,BrandName:1,CatCode:1,CatName:1,ColorId:1,ColorName:1,DocDate:1,FullName:1,GrossSales:1,Id:1,MatTypeId:1,MatTypeName:1,NetSales:1,NetSalesExVat:1,PluCode:1,PluDesc:1,PluShortDesc:1,Qty:1,ShopId:1,ShopName:1,SizeId:1,SizeName:1,StyleId:1,StyleName:1,SubCat1Code:1,SubCat1Name:1,SubCat2Code:1,SubCat2Name:1,SupplId:1,SupplName:1,TasteId:1,TasteName:1,VatOfNetSales:1},Report_1315:{AllItemDiscount:1,DocDate:1,FullName:1,FullName1:1,GrossSales:1,Id:1,NetSales:1,NetSalesExVat:1,Qty:1,ShopId:1,ShopName:1,SupplId:1,SupplName:1,VatOfNetSales:1},Report_1316:{AllItemCharge:1,AllItemDiscount:1,DocDate:1,FullName:1,FullName1:1,GrossSales:1,Id:1,NetSales:1,NetSalesExVat:1,SalemanId:1,SalesmanName:1,ShopId:1,ShopName:1,VatOfCharge:1,VatOfNetSales:1},Report_1317:{AllItemCharge:1,AllItemDiscount:1,DocDate:1,FullName:1,FullName1:1,GrossSales:1,Id:1,MbId:1,MbNameT:1,NetSales:1,NetSalesExVat:1,ShopId:1,ShopName:1,VatOfCharge:1,VatOfNetSales:1},Report_1318:{AllItemDiscount:1,BrandCode:1,BrandName:1,CatCode:1,CatName:1,ColorId:1,ColorName:1,DocDate:1,FullName:1,FullName1:1,GrossSales:1,Id:1,MatTypeId:1,MatTypeName:1,NetSales:1,NetSalesExVat:1,PluCode:1,PluDesc:1,PluShortDesc:1,Qty:1,ShopId:1,ShopName:1,SizeId:1,SizeName:1,StyleId:1,StyleName:1,SubCat1Code:1,SubCat1Name:1,SubCat2Code:1,SubCat2Name:1,SupplId:1,SupplName:1,TasteId:1,TasteName:1,VatOfNetSales:1},Report_1319:{AllItemDiscount:1,BasePrice:1,DocDate:1,GrossSales:1,Id:1,NetSales:1,NetSalesExVat:1,PromoCampaign:1,PromoDics:1,Qty:1,ShopId:1,ShopName:1,VatOfNetSales:1},Report_1320:{AllItemDiscount:1,BasePrice:1,BrandCode:1,BrandName:1,CatCode:1,CatName:1,ColorId:1,ColorName:1,DocDate:1,GrossSales:1,Id:1,MatTypeId:1,MatTypeName:1,NetSales:1,NetSalesExVat:1,PluCode:1,PluDesc:1,PluShortDesc:1,PromoCampaign:1,PromoDesc:1,PromoDics:1,PromoId:1,PromoName:1,Qty:1,ShopId:1,ShopName:1,SizeId:1,SizeName:1,StyleId:1,StyleName:1,SubCat1Code:1,SubCat1Name:1,SubCat2Code:1,SubCat2Name:1,SupplId:1,SupplName:1,TasteId:1,TasteName:1,VatOfNetSales:1},Report_1321:{AllItemDiscount:1,BrandCode:1,BrandName:1,DocDate:1,FullName:1,GrossSales:1,Id:1,NetSales:1,NetSalesExVat:1,Qty:1,ShopId:1,ShopName:1,VatOfNetSales:1},Report_1333:{DocDate:1,FullName:1,GrossSales:1,Id:1,PaymentName:1,PaymentType:1,ShopId:1,ShopName:1},Report_1334:{DocDate:1,DocNo:1,FullName:1,GrossSales:1,Id:1,ShopId:1,ShopName:1},Report_1335:{DocDate:1,DocNo:1,FullName:1,GrossSales:1,Id:1,ShopId:1,ShopName:1},Report_1336:{DocDate:1,DocNo:1,FullName:1,GrossSales:1,Id:1,ShopId:1,ShopName:1},Report_1337:{DocDate:1,DocNo:1,FullName:1,GrossSales:1,Id:1,ShopId:1,ShopName:1},Report_1401:{AllItemCharge:1,AllItemDiscount:1,DocDate:1,GrossSales:1,Id:1,NetSales:1,NetSalesExVat:1,VatOfCharge:1,VatOfNetSales:1},Report_1402:{AllItemCharge:1,AllItemDiscount:1,DayOfWeek:1,DocDate:1,GrossSales:1,Id:1,NetSales:1,NetSalesExVat:1,VatOfCharge:1,VatOfNetSales:1},Report_1403:{AllItemCharge:1,AllItemDiscount:1,DocDate:1,DocTime:1,GrossSales:1,Id:1,NetSales:1,NetSalesExVat:1,VatOfCharge:1,VatOfNetSales:1},Report_1404:{AllItemDiscount:1,CatCode:1,CatName:1,DocDate:1,GrossSales:1,Id:1,NetSales:1,NetSalesExVat:1,Qty:1,VatOfNetSales:1},Report_1405:{AllItemDiscount:1,DocDate:1,GrossSales:1,Id:1,NetSales:1,NetSalesExVat:1,Qty:1,SubCat1Code:1,SubCat1Name:1,VatOfNetSales:1},Report_1406:{AllItemDiscount:1,DocDate:1,GrossSales:1,Id:1,NetSales:1,NetSalesExVat:1,Qty:1,SubCat2Code:1,SubCat2Name:1,VatOfNetSales:1},Report_1407:{AllItemDiscount:1,BrandCode:1,BrandName:1,CatCode:1,CatName:1,ColorId:1,ColorName:1,DocDate:1,GrossSales:1,Id:1,MatTypeId:1,MatTypeName:1,NetSales:1,NetSalesExVat:1,PluCode:1,PluDesc:1,PluShortDesc:1,Qty:1,SizeId:1,SizeName:1,StyleId:1,StyleName:1,SubCat1Code:1,SubCat1Name:1,SubCat2Code:1,SubCat2Name:1,SupplId:1,SupplName:1,TasteId:1,TasteName:1,VatOfNetSales:1},Report_1408:{AllItemDiscount:1,DocDate:1,GrossSales:1,Id:1,NetSales:1,NetSalesExVat:1,Qty:1,SupplId:1,SupplName:1,VatOfNetSales:1},Report_1409:{AllItemCharge:1,AllItemDiscount:1,DocDate:1,GrossSales:1,Id:1,NetSales:1,NetSalesExVat:1,SalemanId:1,SalesmanName:1,VatOfCharge:1,VatOfNetSales:1},Report_1410:{AllItemCharge:1,AllItemDiscount:1,DocDate:1,FullName1:1,GrossSales:1,Id:1,MbId:1,MbNameT:1,NetSales:1,NetSalesExVat:1,VatOfCharge:1,VatOfNetSales:1},Report_1411:{AllItemDiscount:1,BrandCode:1,BrandName:1,CatCode:1,CatName:1,ColorId:1,ColorName:1,DocDate:1,GrossSales:1,Id:1,MatTypeId:1,MatTypeName:1,NetSales:1,NetSalesExVat:1,PluCode:1,PluDesc:1,PluShortDesc:1,Qty:1,SizeId:1,SizeName:1,StyleId:1,StyleName:1,SubCat1Code:1,SubCat1Name:1,SubCat2Code:1,SubCat2Name:1,SupplId:1,SupplName:1,TasteId:1,TasteName:1,VatOfNetSales:1},Report_1412:{AllItemDiscount:1,BasePrice:1,DocDate:1,GrossSales:1,Id:1,NetSales:1,NetSalesExVat:1,PromoCampaign:1,PromoDics:1,Qty:1,VatOfNetSales:1},Report_1413:{AllItemDiscount:1,BasePrice:1,BrandCode:1,BrandName:1,CatCode:1,CatName:1,ColorId:1,ColorName:1,DocDate:1,GrossSales:1,Id:1,MatTypeId:1,MatTypeName:1,NetSales:1,NetSalesExVat:1,PluCode:1,PluDesc:1,PluShortDesc:1,PromoCampaign:1,PromoDesc:1,PromoDics:1,PromoId:1,PromoName:1,Qty:1,SizeId:1,SizeName:1,StyleId:1,StyleName:1,SubCat1Code:1,SubCat1Name:1,SubCat2Code:1,SubCat2Name:1,SupplId:1,SupplName:1,TasteId:1,TasteName:1,VatOfNetSales:1},Report_1414:{AllItemDiscount:1,BrandCode:1,BrandName:1,DocDate:1,FullName:1,GrossSales:1,Id:1,NetSales:1,NetSalesExVat:1,Qty:1,VatOfNetSales:1},Report_1501:{AllItemDiscount:1,CatCode:1,CatName:1,DocDate:1,DocDateEn:1,GrossSales:1,Id:1,NetSales:1,NetSalesExVat:1,Qty:1,VatOfNetSales:1,Year:1},Report_1501_N:{April:1,August:1,CatCode:1,CatName:1,December:1,February:1,Id:1,January:1,July:1,June:1,March:1,May:1,November:1,October:1,September:1,TypeSum:1,Year:1},Report_1502:{AllItemDiscount:1,DocDate:1,DocDateEn:1,GrossSales:1,Id:1,NetSales:1,NetSalesExVat:1,Qty:1,SubCat1Code:1,SubCat1Name:1,VatOfNetSales:1,Year:1},Report_1502_N:{April:1,August:1,December:1,February:1,Id:1,January:1,July:1,June:1,March:1,May:1,November:1,October:1,September:1,SubCat1Code:1,SubCat1Name:1,TypeSum:1,Year:1},Report_1503:{AllItemDiscount:1,DocDate:1,DocDateEn:1,GrossSales:1,Id:1,NetSales:1,NetSalesExVat:1,Qty:1,SubCat2Code:1,SubCat2Name:1,VatOfNetSales:1,Year:1},Report_1503_N:{April:1,August:1,December:1,February:1,Id:1,January:1,July:1,June:1,March:1,May:1,November:1,October:1,September:1,SubCat2Code:1,SubCat2Name:1,TypeSum:1,Year:1},Report_1504:{AllItemDiscount:1,BrandCode:1,BrandName:1,CatCode:1,CatName:1,ColorId:1,ColorName:1,DocDate:1,DocDateEn:1,GrossSales:1,Id:1,MatTypeId:1,MatTypeName:1,NetSales:1,NetSalesExVat:1,PluCode:1,PluDesc:1,PluShortDesc:1,Qty:1,SizeId:1,SizeName:1,StyleId:1,StyleName:1,SubCat1Code:1,SubCat1Name:1,SubCat2Code:1,SubCat2Name:1,SupplId:1,SupplName:1,TasteId:1,TasteName:1,VatOfNetSales:1,Year:1},Report_1504_N:{April:1,August:1,BrandCode:1,BrandName:1,CatCode:1,CatName:1,ColorId:1,ColorName:1,December:1,February:1,Id:1,January:1,July:1,June:1,March:1,MatTypeId:1,MatTypeName:1,May:1,November:1,October:1,PluCode:1,PluDesc:1,PluShortDesc:1,September:1,SizeId:1,SizeName:1,StyleId:1,StyleName:1,SubCat1Code:1,SubCat1Name:1,SubCat2Code:1,SubCat2Name:1,SupplId:1,SupplName:1,TasteId:1,TasteName:1,TypeSum:1,Year:1},Report_1505:{AllItemDiscount:1,BrandCode:1,BrandName:1,DocDate:1,DocDateEn:1,GrossSales:1,Id:1,NetSales:1,NetSalesExVat:1,Qty:1,VatOfNetSales:1,Year:1},Report_1505_N:{April:1,August:1,BrandCode:1,BrandName:1,December:1,February:1,Id:1,January:1,July:1,June:1,March:1,May:1,November:1,October:1,September:1,TypeSum:1,Year:1},Report_1601:{BrandCode:1,BrandName:1,CatCode:1,CatName:1,ColorId:1,ColorName:1,GpPc:1,Gpamt:1,GrossSales:1,Id:1,ItemPromoId:1,MatTypeId:1,MatTypeName:1,NetsalesafterGp:1,PluCode:1,PluFullName:1,PluShortDesc:1,Qty:1,ShopFullName:1,ShopId:1,ShopName:1,SizeId:1,SizeName:1,StyleId:1,StyleName:1,SubCat1Code:1,SubCat1Name:1,SubCat2Code:1,SubCat2Name:1,SupplFullName:1,SupplId:1,SupplName:1,TasteId:1,TasteName:1,UnitPrice:1},Report_1602:{BrandCode:1,BrandName:1,CatCode:1,CatName:1,ColorId:1,ColorName:1,GpPc:1,Gpamt:1,GrossSales:1,Id:1,ItemPromoId:1,MatTypeId:1,MatTypeName:1,NetsalesafterGp:1,PluCode:1,PluFullName:1,PluShortDesc:1,Qty:1,SizeId:1,SizeName:1,StyleId:1,StyleName:1,SubCat1Code:1,SubCat1Name:1,SubCat2Code:1,SubCat2Name:1,SupplFullName:1,SupplId:1,SupplName:1,TasteId:1,TasteName:1,UnitPrice:1}},SalePromoCamp:{LookupItemCode:{IDName:1,ItemCode:1,ItemDesc:1,ItemId:1,ItemType:1},PromoDay:{Id:1,PromoDay:1,PromoDayName:1},PsPromoActiveHd:{ActiveBy:1,Activedate:1,ApproveBy:1,Approvedate:1,CreateBy:1,CreateDate:1,EndPromoDate:1,EndPromoTime:1,Id:1,LastUpdate:1,PromoApDetailList:1,PromoApproveFg:1,PromoCampaign:1,PromoCustFg:1,PromoDay:1,PromoDayFg:1,PromoDesc:1,PromoId:1,PromoMb:1,PromoName:1,PromoShop:1,PromoShopFg:1,PromoStatus:1,PromoTimeFg:1,StartPromoDate:1,StartPromoTime:1,UpdateBy:1,VenderSharing:1},PsPromoApDt:{CreateBy:1,CreateDate:1,DescItem:1,GpNormal:1,GpPromo:1,GroupCode1:1,GroupCode2:1,Id:1,ItemCode:1,ItemType:1,LastUpdate:1,PromoDiscPc:1,PromoId:1,PromoPrice:1,PromoType:1,UpdateBy:1},PsPromoApHd:{ActiveBy:1,Activedate:1,ApproveBy:1,Approvedate:1,CreateBy:1,CreateDate:1,EndPromoDate:1,EndPromoTime:1,Id:1,LastUpdate:1,PromoApDetailList:1,PromoApproveFg:1,PromoCampaign:1,PromoCustFg:1,PromoDay:1,PromoDayFg:1,PromoDesc:1,PromoId:1,PromoMb:1,PromoName:1,PromoShop:1,PromoShopFg:1,PromoStatus:1,PromoTimeFg:1,StartPromoDate:1,StartPromoTime:1,UpdateBy:1,VenderSharing:1},PsPromoCampaign:{FullName:1,Id:1,PromoCampName:1,PromoCampaign:1},PsPromoDays:{Id:1,PromoDay:1,PromoId:1},PsPromoDt:{CreateBy:1,CreateDate:1,DescItem:1,GpNormal:1,GpPromo:1,GroupCode1:1,GroupCode2:1,Id:1,ItemCode:1,ItemId:1,ItemType:1,LastUpdate:1,PromoDiscPc:1,PromoId:1,PromoPrice:1,PromoType:1,UpdateBy:1},PsPromoHd:{CreateBy:1,CreateDate:1,EndPromoDate:1,EndPromoTime:1,Id:1,LastUpdate:1,PromoApproveFg:1,PromoCampaign:1,PromoCustFg:1,PromoDay:1,PromoDayFg:1,PromoDesc:1,PromoDetailList:1,PromoId:1,PromoMb:1,PromoName:1,PromoShop:1,PromoShopFg:1,PromoStatus:1,PromoTimeFg:1,StartPromoDate:1,StartPromoTime:1,UpdateBy:1,VenderSharing:1},PsPromoMb:{Id:1,MbType:1,PromoId:1},PsPromoShop:{Id:1,PromoId:1,ShopId:1}},Supplier:{CsSupplType:{CreateBy:1,CreateDate:1,FullName:1,Id:1,LastUpdate:1,SupplType:1,SupplTypeName:1,UpdateBy:1},CsSupplier:{AuthEmail:1,AuthMobile:1,AuthPerson:1,AuthTel:1,AuthTelExt:1,BranchCode:1,BranchName:1,CompanyCode:1,ConsignFg:1,ConsignGp:1,ContactName:1,CreateBy:1,CreateDate:1,CreditTerm:1,Ctaxtype:1,CustBranch:1,ErpSreachName:1,ErpVenderCode:1,ErpVendorBlock:1,ErpVendorType:1,FaxExt:1,FaxNo:1,FullName:1,Id:1,LastUpdate:1,PayMethod:1,PurVatCode:1,PurVatRate:1,PurVatType:1,Remark:1,ReturnOutRemark:1,SaleEmail:1,SaleMobile:1,SalePerson:1,SaleTel:1,SaleTelExt:1,Status:1,SupEmail:1,SupTelNo:1,SupplAddress:1,SupplId:1,SupplName:1,SupplRegAddress:1,SupplRegName:1,SupplTaxId:1,SupplType:1,SupplierShortName:1,TelMobile:1,TelNoExt:1,TradeTerm:1,UpdateBy:1}}},Forms:{Membership:{ChangePassword:{FormTitle:1,SubmitButton:1,Success:1},ForgotPassword:{BackToLogin:1,FormInfo:1,FormTitle:1,SubmitButton:1,Success:1},Login:{FacebookButton:1,ForgotPassword:1,GoogleButton:1,LoginToYourAccount:1,OR:1,RememberMe:1,SignInButton:1,SignUpButton:1},ResetPassword:{BackToLogin:1,EmailSubject:1,FormTitle:1,SubmitButton:1,Success:1},SignUp:{AcceptTerms:1,ActivateEmailSubject:1,ActivationCompleteMessage:1,BackToLogin:1,ConfirmEmail:1,ConfirmPassword:1,DisplayName:1,Email:1,FormInfo:1,FormTitle:1,Password:1,SubmitButton:1,Success:1}}},Inventory:{Report:{AdjIn1:1,AdjIn2:1,AdjInFoottersign1:1,AdjInFoottersign1head:1,AdjInFoottersign2:1,AdjInFoottersign2head:1,AdjInFoottersign3:1,AdjInFoottersign3head:1,AdjOut1:1,AdjOut2:1,AdjOutFoottersign1:1,AdjOutFoottersign1head:1,AdjOutFoottersign2:1,AdjOutFoottersign2head:1,AdjOutFoottersign3:1,AdjOutFoottersign3head:1,CN1:1,CN2:1,CNFoottersign1:1,CNFoottersign1head:1,CNFoottersign2:1,CNFoottersign2head:1,CNFoottersign3:1,CNFoottersign3head:1,Count1:1,Count2:1,CountFoottersign1:1,CountFoottersign1head:1,CountFoottersign2:1,CountFoottersign2head:1,CountFoottersign3:1,CountFoottersign3head:1,Receive1:1,Receive2:1,ReceiveFoottersign1:1,ReceiveFoottersign1head:1,ReceiveFoottersign2:1,ReceiveFoottersign2head:1,ReceiveFoottersign3:1,ReceiveFoottersign3head:1,ReturnIn1:1,ReturnIn2:1,ReturnInFoottersign1:1,ReturnInFoottersign1head:1,ReturnInFoottersign2:1,ReturnInFoottersign2head:1,ReturnInFoottersign3:1,ReturnInFoottersign3head:1,ReturnOut1:1,ReturnOut2:1,ReturnOutFoottersign1:1,ReturnOutFoottersign1head:1,ReturnOutFoottersign2:1,ReturnOutFoottersign2head:1,ReturnOutFoottersign3:1,ReturnOutFoottersign3head:1,Sold1:1,Sold2:1,SoldFoottersign1:1,SoldFoottersign1head:1,SoldFoottersign2:1,SoldFoottersign2head:1,SoldFoottersign3:1,SoldFoottersign3head:1,Tranfer1:1,Tranfer2:1,TranferFoottersign1:1,TranferFoottersign1head:1,TranferFoottersign2:1,TranferFoottersign2head:1,TranferFoottersign3:1,TranferFoottersign3head:1}},Navigation:{LogoutLink:1,SitePoint:1,SiteTitle:1,Versions:1},PosShift:{Report:{FooterText:1,FooterText2:1,FooterText3:1,Footersign1:1,Footersign1head:1,Footersign2:1,Footersign2head:1,Footersign3:1,Footersign3head:1,Title1:1,Title2:1,Title3:1,Title4:1,Title5:1}},Purchase:{Report:{Approvebutton:1,CN1:1,CN2:1,CNFootter1:1,CNFoottersign1:1,CNFoottersign1head:1,CNFoottersign2:1,CNFoottersign2head:1,CNRTV1:1,CNRTV2:1,CNRTVFootter1:1,CNRTVFoottersign1:1,CNRTVFoottersign1head:1,CNRTVFoottersign2:1,CNRTVFoottersign2head:1,CNRTVFoottersign3:1,CNRTVFoottersign3head:1,IR1:1,IR2:1,IRFootter1:1,IRFoottersign1:1,IRFoottersign1head:1,IRFoottersign2:1,IRFoottersign2head:1,IRFoottersign3:1,IRFoottersign3head:1,PI1:1,PI2:1,PIFootter1:1,PIFoottersign1:1,PIFoottersign1head:1,PIFoottersign2:1,PIFoottersign2head:1,POFootter1:1,POFootter2:1,POFootter3:1,POFoottersign1:1,POFoottersign1head:1,POFoottersign2:1,POFoottersign2head:1,ShipName:1,poPurOrder:1,poPurOrder2:1}},Site:{AccessDenied:{ClickToChangeUser:1,ClickToLogin:1,LackPermissions:1,NotLoggedIn:1,PageTitle:1},BasicProgressDialog:{CancelTitle:1,PleaseWait:1},BulkServiceAction:{AllHadErrorsFormat:1,AllSuccessFormat:1,ConfirmationFormat:1,ErrorCount:1,NothingToProcess:1,SomeHadErrorsFormat:1,SuccessCount:1},Dashboard:{ContenDescritptionShop:1,ContentDescription:1},Dialogs:{PendingChangesConfirmation:1},Layout:{FooterCopyright:1,FooterInfo:1,FooterRights:1,GeneralSettings:1,Language:1,Theme:1,ThemeAzure:1,ThemeAzureLight:1,ThemeBlack:1,ThemeBlackLight:1,ThemeBlue:1,ThemeBlueLight:1,ThemeCosmos:1,ThemeCosmosLight:1,ThemeGlassy:1,ThemeGlassyLight:1,ThemeGreen:1,ThemeGreenLight:1,ThemePurple:1,ThemePurpleLight:1,ThemeRed:1,ThemeRedLight:1,ThemeYellow:1,ThemeYellowLight:1},RolePermissionDialog:{DialogTitle:1,EditButton:1,SaveSuccess:1},UserDialog:{EditPermissionsButton:1,EditRolesButton:1},UserPermissionDialog:{DialogTitle:1,Grant:1,Permission:1,Revoke:1,SaveSuccess:1},UserRoleDialog:{DialogTitle:1,SaveSuccess:1},ValidationError:{Title:1}},Validation:{AccountLoginPasswordError:1,AuthenticationError:1,CantFindUserWithEmail:1,CharacterinPassword:1,CurrentPasswordMismatch:1,DeleteForeignKeyError:1,EmailConfirm:1,EmailInUse:1,EnforecPasswordHistory:1,InvalidActivateToken:1,InvalidResetToken:1,MinRequiredPasswordLength:1,SavePrimaryKeyError:1,UserChangePassword:1,UserChangePasswordAge:1,UserLock:1}});
}
